webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(512);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(58);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	__webpack_require__(310);
	
	var _toast = __webpack_require__(321);
	
	var _toast2 = _interopRequireDefault(_toast);
	
	var _vueGoogleAdsense = __webpack_require__(511);
	
	var _vueGoogleAdsense2 = _interopRequireDefault(_vueGoogleAdsense);
	
	__webpack_require__(308);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueGoogleAdsense2.default.Adsense);
	_vue2.default.use(_vueGoogleAdsense2.default.InArticleAdsense);
	_vue2.default.use(_vueGoogleAdsense2.default.InFeedAdsense);
	
	window.Toast = _toast2.default;
	_vue2.default.component('PageHeader', __webpack_require__(570));
	_vue2.default.component('Help', __webpack_require__(574));
	_vue2.default.component('Panel', __webpack_require__(575));
	_vue2.default.component('PanelHeading', __webpack_require__(573));
	_vue2.default.component('PanelBody', __webpack_require__(572));
	_vue2.default.component('LoadingIndicator', __webpack_require__(184));
	_vue2.default.component('DynamicTable', __webpack_require__(576));
	
	new _vue2.default({
	  router: _router2.default,
	  store: _store2.default,
	  el: '#app',
	  template: '<App />',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(30);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(726);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(553);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Auth = __webpack_require__(554);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Home = __webpack_require__(555);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _SubjectShelf = __webpack_require__(580);
	
	var _SubjectShelf2 = _interopRequireDefault(_SubjectShelf);
	
	var _FileImporter = __webpack_require__(539);
	
	var _FileImporter2 = _interopRequireDefault(_FileImporter);
	
	var _FileExporter = __webpack_require__(537);
	
	var _FileExporter2 = _interopRequireDefault(_FileExporter);
	
	var _FileProcessing = __webpack_require__(540);
	
	var _FileProcessing2 = _interopRequireDefault(_FileProcessing);
	
	var _MicroNoteImportSuccess = __webpack_require__(541);
	
	var _MicroNoteImportSuccess2 = _interopRequireDefault(_MicroNoteImportSuccess);
	
	var _HomePage = __webpack_require__(550);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _FeaturesPage = __webpack_require__(547);
	
	var _FeaturesPage2 = _interopRequireDefault(_FeaturesPage);
	
	var _AboutUsPage = __webpack_require__(542);
	
	var _AboutUsPage2 = _interopRequireDefault(_AboutUsPage);
	
	var _ContactUsPage = __webpack_require__(546);
	
	var _ContactUsPage2 = _interopRequireDefault(_ContactUsPage);
	
	var _FeedbackFormPage = __webpack_require__(548);
	
	var _FeedbackFormPage2 = _interopRequireDefault(_FeedbackFormPage);
	
	var _AdvertisePage = __webpack_require__(543);
	
	var _AdvertisePage2 = _interopRequireDefault(_AdvertisePage);
	
	var _BlogPage = __webpack_require__(545);
	
	var _BlogPage2 = _interopRequireDefault(_BlogPage);
	
	var _BlogArticlePage = __webpack_require__(544);
	
	var _BlogArticlePage2 = _interopRequireDefault(_BlogArticlePage);
	
	var _TermsConditionsPage = __webpack_require__(552);
	
	var _TermsConditionsPage2 = _interopRequireDefault(_TermsConditionsPage);
	
	var _PrivacyPolicyPage = __webpack_require__(551);
	
	var _PrivacyPolicyPage2 = _interopRequireDefault(_PrivacyPolicyPage);
	
	var _MicroNoteEditor = __webpack_require__(564);
	
	var _MicroNoteEditor2 = _interopRequireDefault(_MicroNoteEditor);
	
	var _MicroNoteCreator = __webpack_require__(563);
	
	var _MicroNoteCreator2 = _interopRequireDefault(_MicroNoteCreator);
	
	var _MicroNoteList = __webpack_require__(566);
	
	var _MicroNoteList2 = _interopRequireDefault(_MicroNoteList);
	
	var _LectureNoteEditor = __webpack_require__(556);
	
	var _LectureNoteEditor2 = _interopRequireDefault(_LectureNoteEditor);
	
	var _LectureNoteList = __webpack_require__(557);
	
	var _LectureNoteList2 = _interopRequireDefault(_LectureNoteList);
	
	var _ChapterStudier = __webpack_require__(526);
	
	var _ChapterStudier2 = _interopRequireDefault(_ChapterStudier);
	
	var _ChapterSharer = __webpack_require__(522);
	
	var _ChapterSharer2 = _interopRequireDefault(_ChapterSharer);
	
	var _ReceiveChapter = __webpack_require__(523);
	
	var _ReceiveChapter2 = _interopRequireDefault(_ReceiveChapter);
	
	var _settings = __webpack_require__(610);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _account = __webpack_require__(609);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _admanager = __webpack_require__(514);
	
	var _admanager2 = _interopRequireDefault(_admanager);
	
	var _blogmanager = __webpack_require__(515);
	
	var _blogmanager2 = _interopRequireDefault(_blogmanager);
	
	var _posteditor = __webpack_require__(516);
	
	var _posteditor2 = _interopRequireDefault(_posteditor);
	
	var _usermanager = __webpack_require__(518);
	
	var _usermanager2 = _interopRequireDefault(_usermanager);
	
	var _useractivityreport = __webpack_require__(517);
	
	var _useractivityreport2 = _interopRequireDefault(_useractivityreport);
	
	var _Signup = __webpack_require__(578);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _Success = __webpack_require__(579);
	
	var _Success2 = _interopRequireDefault(_Success);
	
	var _Login = __webpack_require__(559);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _ForgotPassword = __webpack_require__(558);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _ResetPassword = __webpack_require__(561);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _Subscribe = __webpack_require__(569);
	
	var _Subscribe2 = _interopRequireDefault(_Subscribe);
	
	var _store = __webpack_require__(58);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _mutationTypes = __webpack_require__(20);
	
	var _NotFound = __webpack_require__(513);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _Home3 = __webpack_require__(596);
	
	var _Home4 = _interopRequireDefault(_Home3);
	
	var _HomePage3 = __webpack_require__(595);
	
	var _HomePage4 = _interopRequireDefault(_HomePage3);
	
	var _FeaturesPage3 = __webpack_require__(592);
	
	var _FeaturesPage4 = _interopRequireDefault(_FeaturesPage3);
	
	var _AboutUsPage3 = __webpack_require__(587);
	
	var _AboutUsPage4 = _interopRequireDefault(_AboutUsPage3);
	
	var _ContactUsPage3 = __webpack_require__(591);
	
	var _ContactUsPage4 = _interopRequireDefault(_ContactUsPage3);
	
	var _FeedbackFormPage3 = __webpack_require__(593);
	
	var _FeedbackFormPage4 = _interopRequireDefault(_FeedbackFormPage3);
	
	var _AdvertisePage3 = __webpack_require__(588);
	
	var _AdvertisePage4 = _interopRequireDefault(_AdvertisePage3);
	
	var _BlogPage3 = __webpack_require__(590);
	
	var _BlogPage4 = _interopRequireDefault(_BlogPage3);
	
	var _BlogArticlePage3 = __webpack_require__(589);
	
	var _BlogArticlePage4 = _interopRequireDefault(_BlogArticlePage3);
	
	var _Signup3 = __webpack_require__(607);
	
	var _Signup4 = _interopRequireDefault(_Signup3);
	
	var _Success3 = __webpack_require__(608);
	
	var _Success4 = _interopRequireDefault(_Success3);
	
	var _Login3 = __webpack_require__(598);
	
	var _Login4 = _interopRequireDefault(_Login3);
	
	var _ForgotPassword3 = __webpack_require__(597);
	
	var _ForgotPassword4 = _interopRequireDefault(_ForgotPassword3);
	
	var _ResetPassword3 = __webpack_require__(600);
	
	var _ResetPassword4 = _interopRequireDefault(_ResetPassword3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var routes = [{
	  path: '/',
	  component: _Home2.default,
	  children: [{ name: 'home-page', path: '/', component: _HomePage2.default, meta: { title: 'Contextual Learning Experience', auth: false, sidebar: false, publicNav: true, description: 'CLEX helps improve grades by organizing notes to prioritize and focus studying. This simple, easy-to-use software provides a flexible approach to learning', keywords: '' } }, { name: 'features', path: '/features', component: _FeaturesPage2.default, meta: { title: 'Features', auth: false, sidebar: false, publicNav: true, adArea: 'public', description: 'We believe learning should be an engaging and rewarding experience. CLEX is designed with your brain in mind.' } }, { name: 'about-us', path: '/about-us', component: _AboutUsPage2.default, meta: { title: 'About CLEX', auth: false, sidebar: false, publicNav: true, description: 'We\'re an educational company offering study tools for students in university, collage, high school, and skilled training centers.' } }, { name: 'contact-us', path: '/contact-us', component: _ContactUsPage2.default, meta: { title: 'Contact us', auth: false, sidebar: false, publicNav: true, adArea: 'public', description: 'Questions about how CLEX works? Send us an email and we\'ll get back to you as soon as possible.' } }, { name: 'feedback-form', path: '/feedback-form', component: _FeedbackFormPage2.default, meta: { title: 'Feedback form', auth: false, sidebar: false, publicNav: true, adArea: 'public', description: 'We would love to hear about your experiences while studying with CLEX. Please get in touch and tell us how we\'re doing' } }, { name: 'advertise', path: '/advertise', component: _AdvertisePage2.default, meta: { title: 'Advertise', auth: false, sidebar: false, publicNav: true, description: 'Interested in advertising your products or service to our community of students? Get in touch for more information.' } }, { name: 'blog', path: '/blog', component: _BlogPage2.default, meta: { title: 'CLEX Blog', auth: false, sidebar: false, publicNav: true, adArea: 'public', description: 'Read the latest articles from the CLEX blog and stay up-to-date with the best studying methods and learning techniques' } }, { name: 'blog-article', path: '/blog/article/:id', component: _BlogArticlePage2.default, meta: { title: 'Blog Article', auth: false, sidebar: false, publicNav: true, adArea: 'public' } }, { name: 'signup-success', path: '/signup-success', component: _Success2.default, meta: { title: 'Signup Success', publicNav: true, description: '' } }, { name: 'signup', path: '/signup', component: _Signup2.default, meta: { title: 'Signup', publicNav: true, description: 'Create a CLEX account to join our community of students. Store your lecture notes in one place and streamline your studies' } }, { name: 'login', path: '/login', component: _Login2.default, meta: { title: 'Login', publicNav: true, description: 'Login to your CLEX account to start importing your lecture notes. Study your subjects in a way that suits you.' } }, { name: 'forgot-password', path: '/forgot-password', component: _ForgotPassword2.default, meta: { title: 'Forgot Password', publicNav: true } }, { name: 'reset-password', path: '/reset-password', component: _ResetPassword2.default, meta: { title: 'Reset Password', publicNav: true } }, { name: 'newsletter-subscribe', path: '/newsletter-subscribe', component: _Subscribe2.default, meta: { title: 'Newsletter Signup', publicNav: true, description: 'Joing the CLEX mailing list for exclusive offers and the latest news.' } }]
	}, {
	  path: '/',
	  component: _App2.default,
	  meta: { auth: true },
	  children: [{ name: 'importer', path: 'import', component: _FileImporter2.default, meta: { title: 'Import Lecture Notes', auth: true, adArea: 'dashboard' } }, { name: 'processing', path: 'processing/:id', component: _FileProcessing2.default, meta: { title: 'Processing Lecture Notes', auth: true, adArea: 'dashboard' } }, { name: 'exporter', path: 'export', component: _FileExporter2.default, meta: { title: 'Export Lecture Notes', auth: true, adArea: 'dashboard' } }, { name: 'micronote-import-success', path: 'micronote-import-success', component: _MicroNoteImportSuccess2.default, meta: { title: 'MicroNotes imported', auth: true, adArea: 'dashboard' } }, { name: 'share-chapter', path: 'share-chapter', component: _ChapterSharer2.default, meta: { title: 'Share chapter', auth: true, adArea: 'dashboard' } }, { name: 'receive-chapter', path: 'receive-chapter', component: _ReceiveChapter2.default, meta: { title: 'Receive study notes', auth: true, adArea: 'dashboard' } }, { name: 'subject-shelf', path: 'subject-shelf', component: _SubjectShelf2.default, meta: { title: 'Subject Shelf', auth: true, adArea: 'dashboard' } }, { name: 'lecture-notes', path: '/lecture-notes', component: _LectureNoteList2.default, meta: { title: 'My Lecture Notes', auth: true, adArea: 'dashboard' } }, { name: 'lecture-note-editor', path: '/lecture-notes/:id/edit', component: _LectureNoteEditor2.default, meta: { title: 'Lecture Note Editor', auth: true, adArea: 'dashboard', sidebar: false } }, { name: 'micro-notes', path: '/chapters/:chapterId/micro-notes', component: _MicroNoteList2.default, meta: { title: 'Micro Notes', auth: true, adArea: 'dashboard' } }, { name: 'micro-note-editor', path: '/chapters/:chapterId/micro-notes/edit', component: _MicroNoteEditor2.default, meta: { title: 'Edit Micro Note', auth: true, sidebar: false, adArea: 'studier' } }, { name: 'micro-note-creator', path: '/chapters/:chapterId/micro-notes/create', component: _MicroNoteCreator2.default, meta: { title: 'Create Micro Notes', auth: true, sidebar: false, adArea: 'studier' } }, { name: 'chapter-studier', path: '/chapters/:chapterId/study', component: _ChapterStudier2.default, meta: { title: 'Chapter Studier', auth: true, sidebar: false, adArea: 'studier' } }, { name: 'user-settings', path: '/user/settings', component: _settings2.default, meta: { title: 'Settings', auth: true, adArea: 'dashboard' } }, { name: 'user-account', path: '/user/account', component: _account2.default, meta: { title: 'Account', auth: true, adArea: 'dashboard' } }, { name: 'ad-manager', path: '/admin/ad-manager', component: _admanager2.default, meta: { title: 'Ad Manager', auth: true, sidebar: true, admin: true } }, { name: 'blog-manager', path: '/admin/blog-manager', component: _blogmanager2.default, meta: { title: 'Blog Post Manager', auth: true, sidebar: true, admin: true } }, { name: 'blog-post-edit', path: '/admin/blog-manager/edit/:id?', component: _posteditor2.default, meta: { title: 'Edit Blog Post', auth: true, sidebar: true, admin: true } }, { name: 'user-manager', path: '/admin/user-manager', component: _usermanager2.default, meta: { title: 'User Manager', auth: true, sidebar: true, admin: true } }, { name: 'user-activity-report', path: '/admin/user-activity-report', component: _useractivityreport2.default, meta: { title: 'User Activity Report', auth: true, sidebar: true, admin: true } }]
	}, { path: '*', component: _NotFound2.default, meta: { title: 'Page Not Found' } }];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes,
	  linkActiveClass: 'active'
	});
	
	router.afterEach(function (to, from) {
	  window.scrollTo(0, 0);
	});
	
	router.beforeEach(function (to, from, next) {
	  var loggedIn = _store2.default.state.currentUser.loggedIn;
	
	  if (to.meta.admin && _store2.default.state.currentUser.role !== 'admin' && from && from.name) next('/page-not-found');
	
	  if (to.name === 'login') return next();
	  if ((loggedIn || !to.meta.auth) && from && from.name) return next();
	
	  if (localStorage.getItem('access-token')) {
	    _store2.default.dispatch('validateToken').then(function () {
	      next();
	    }, function () {
	      console.log('Error: Invalid token');
	      next('/login');
	    });
	  } else {
	    if (to.meta.auth) {
	      next('/login');
	    } else {
	      return next();
	    }
	  }
	});
	
	router.beforeEach(function (to, from, next) {
	  _store2.default.commit(_mutationTypes.SET_PAGE_TITLE, { title: to.meta.title });
	  _store2.default.commit(_mutationTypes.SET_PAGE_DESCRIPTION, { description: to.meta.description });
	  _store2.default.commit(_mutationTypes.SET_PAGE_KEYWORDS, { keywords: to.meta.keywords });
	  next();
	});
	
	router.beforeEach(function (to, from, next) {
	  var adArea = _lodash2.default.isUndefined(to.meta.adArea) ? '' : to.meta.adArea;
	
	  _store2.default.commit(_mutationTypes.SET_AD_AREA, { adArea: adArea });
	  next();
	});
	
	router.beforeEach(function (to, from, next) {
	  var sidebarOpen = _lodash2.default.isUndefined(to.meta.sidebar) ? true : to.meta.sidebar;
	  if (sidebarOpen) {
	    _store2.default.commit('OPEN_SIDEBAR');
	  } else {
	    _store2.default.commit('CLOSE_SIDEBAR');
	  }
	
	  var publicNav = _lodash2.default.isUndefined(to.meta.publicNav) ? false : to.meta.publicNav;
	  if (publicNav) {
	    _store2.default.commit('SHOW_PUBLIC_ELEMS');
	  } else {
	    _store2.default.commit('HIDE_PUBLIC_ELEMS');
	  }
	
	  next();
	});
	
	exports.default = router;

/***/ },
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var chapter = _vue2.default.resource('chapters{/id}');
	
	exports.default = chapter;

/***/ },
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(461)
	
	/* script */
	__vue_exports__ = __webpack_require__(257)
	
	/* template */
	var __vue_template__ = __webpack_require__(683)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-70ce9fb2"
	
	module.exports = __vue_exports__


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(395)
	
	/* script */
	__vue_exports__ = __webpack_require__(258)
	
	/* template */
	var __vue_template__ = __webpack_require__(618)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-09bd8ff9"
	
	module.exports = __vue_exports__


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var microNote = _vue2.default.resource('micro_notes{/id}', {}, {}, { emulateJSON: true });exports.default = microNote;

/***/ },
/* 20 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var REGISTER_SUCCESS = exports.REGISTER_SUCCESS = 'REGISTER_SUCCESS';
	var REGISTER_FAILURE = exports.REGISTER_FAILURE = 'REGISTER_FAILURE';
	var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
	var LOGOUT_FAILURE = exports.LOGOUT_FAILURE = 'LOGOUT_FAILURE';
	var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
	var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'LOGIN_FAILURE';
	var SET_USER = exports.SET_USER = 'SET_USER';
	var TOKEN_INVALID = exports.TOKEN_INVALID = 'TOKEN_INVALID';
	var USER_UPDATE_SUCCESS = exports.USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS';
	var USER_UPDATE_FAILURE = exports.USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE';
	var FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
	var FORGOT_PASSWORD_FAILURE = exports.FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';
	var RESET_PASSWORD_SUCCESS = exports.RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
	var RESET_PASSWORD_FAILURE = exports.RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
	
	var SET_PAGE_TITLE = exports.SET_PAGE_TITLE = 'SET_PAGE_TITLE';
	var SET_PAGE_DESCRIPTION = exports.SET_PAGE_DESCRIPTION = 'SET_PAGE_DESCRIPTION';
	var SET_PAGE_KEYWORDS = exports.SET_PAGE_KEYWORDS = 'SET_PAGE_KEYWORDS';
	var OPEN_SIDEBAR = exports.OPEN_SIDEBAR = 'OPEN_SIDEBAR';
	var CLOSE_SIDEBAR = exports.CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
	var SHOW_PUBLIC_ELEMS = exports.SHOW_PUBLIC_ELEMS = 'SHOW_PUBLIC_ELEMS';
	var HIDE_PUBLIC_ELEMS = exports.HIDE_PUBLIC_ELEMS = 'HIDE_PUBLIC_ELEMS';
	var SET_AD_AREA = exports.SET_AD_AREA = 'SET_AD_AREA';
	var CONTACT_US_SUCCESS = exports.CONTACT_US_SUCCESS = 'CONTACT_US_SUCCESS';
	
	var RETRIEVE_SUBJECTS_SUCCESS = exports.RETRIEVE_SUBJECTS_SUCCESS = 'RETRIEVE_SUBJECTS_SUCCESS';
	var CREATE_SUBJECT_SUCCESS = exports.CREATE_SUBJECT_SUCCESS = 'CREATE_SUBJECT_SUCCESS';
	var DELETE_SUBJECT_SUCCESS = exports.DELETE_SUBJECT_SUCCESS = 'DELETE_SUBJECT_SUCCESS';
	
	var CREATE_CHAPTER_SUCCESS = exports.CREATE_CHAPTER_SUCCESS = 'CREATE_CHAPTER_SUCCESS';
	var UPDATE_CHAPTER_SUCCESS = exports.UPDATE_CHAPTER_SUCCESS = 'UPDATE_CHAPTER_SUCCESS';
	var DELETE_CHAPTER_SUCCESS = exports.DELETE_CHAPTER_SUCCESS = 'DELETE_CHAPTER_SUCCESS';
	
	var CREATE_LECTURE_NOTE_SUCCESS = exports.CREATE_LECTURE_NOTE_SUCCESS = 'CREATE_LECTURE_NOTE_SUCCESS';
	var RETRIEVE_LECTURE_NOTES_SUCCESS = exports.RETRIEVE_LECTURE_NOTES_SUCCESS = 'RETRIEVE_LECTURE_NOTES_SUCCESS';
	var UPDATE_LECTURE_NOTE_HTML = exports.UPDATE_LECTURE_NOTE_HTML = 'UPDATE_LECTURE_NOTE_HTML';
	var UPDATE_LECTURE_NOTE_SUCCESS = exports.UPDATE_LECTURE_NOTE_SUCCESS = 'UPDATE_LECTURE_NOTE_SUCCESS';
	
	var CREATE_AD_SUCCESS = exports.CREATE_AD_SUCCESS = 'CREATE_AD_SUCCESS';
	var UPDATE_AD_SUCCESS = exports.UPDATE_AD_SUCCESS = 'UPDATE_AD_SUCCESS';
	var DELETE_AD_SUCCESS = exports.DELETE_AD_SUCCESS = 'DELETE_AD_SUCCESS';
	
	var CREATE_COURSE_SUCCESS = exports.CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS';
	var UPDATE_COURSE_SUCCESS = exports.UPDATE_COURSE_SUCCESS = 'UPDATE_COURSE_SUCCESS';
	var DELETE_COURSE_SUCCESS = exports.DELETE_COURSE_SUCCESS = 'DELETE_COURSE_SUCCESS';
	
	var EXPORT_MICRONOTES_SUCCESS = exports.EXPORT_MICRONOTES_SUCCESS = 'EXPORT_MICRONOTES_SUCCESS';
	var ADD_MICRONOTES_TO_EXPORT = exports.ADD_MICRONOTES_TO_EXPORT = 'ADD_CHAPTERS_TO_EXPORT';
	var REMOVE_MICRONOTES_FROM_EXPORT = exports.REMOVE_MICRONOTES_FROM_EXPORT = 'REMOVE_CHAPTERS_FROM_EXPORT';
	var SET_INCLUDE_INACTIVE_MICRONOTES = exports.SET_INCLUDE_INACTIVE_MICRONOTES = 'SET_INCLUDE_INACTIVE_MICRONOTES';
	
	var IMPORT_MICRONOTES_SUCCESS = exports.IMPORT_MICRONOTES_SUCCESS = 'IMPORT_MICRONOTES_SUCCESS';
	
	var ADD_NOTIFICATION = exports.ADD_NOTIFICATION = 'ADD_NOTIFICATION';
	var REMOVE_NOTIFICATION = exports.REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
	var REMOVE_ALL_NOTIFICATIONS = exports.REMOVE_ALL_NOTIFICATIONS = 'REMOVE_ALL_NOTIFICATIONS';
	var REMOVE_NOTIFICATION_WITH_ITEM = exports.REMOVE_NOTIFICATION_WITH_ITEM = 'REMOVE_NOTIFICATION_WITH_ITEM';

/***/ },
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(436)
	
	/* script */
	__vue_exports__ = __webpack_require__(222)
	
	/* template */
	var __vue_template__ = __webpack_require__(658)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(477)
	
	/* script */
	__vue_exports__ = __webpack_require__(244)
	
	/* template */
	var __vue_template__ = __webpack_require__(699)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(439)
	
	/* script */
	__vue_exports__ = __webpack_require__(251)
	
	/* template */
	var __vue_template__ = __webpack_require__(661)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4aa608f4"
	
	module.exports = __vue_exports__


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(450)
	
	/* script */
	__vue_exports__ = __webpack_require__(259)
	
	/* template */
	var __vue_template__ = __webpack_require__(672)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-65e79c46"
	
	module.exports = __vue_exports__


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var blog = _vue2.default.resource('blogs{/id}');
	
	exports.default = blog;

/***/ },
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var toolbarButtons = ['CLEX_Keyword', 'CLEX_InsertDivider', '|', 'paragraphFormat', 'bold', 'italic', 'underline', '|', 'formatOL', 'formatUL', '|', 'undo', 'redo', 'html', 'insertImage'];
	
	var config = {
	  toolbarButtons: toolbarButtons,
	  toolbarButtonsMD: toolbarButtons,
	  toolbarButtonsSM: toolbarButtons,
	  toolbarButtonsXS: toolbarButtons,
	  paragraphFormat: { h2: 'Heading 1', h3: 'Heading 2', n: 'Normal' },
	  htmlExecuteScripts: false,
	  pastePlain: true,
	
	  htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
	  htmlAllowedEmptyTags: ['object', 'video'],
	  htmlDoNotWrapTags: ['script', 'style'],
	  htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'alt', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'width', 'wrap'],
	  pasteDeniedTags: ['sup'],
	  shortcutsEnabled: ['show', 'bold', 'italic', 'underline', 'strikeThrough', 'indent', 'outdent', 'undo', 'redo', 'insertImage', 'CLEX_InsertDivider', 'CLEX_Keyword'],
	
	  imageEditButtons: ['CLEX_ConvertImageToMicroNote', '|', 'imageAlign', 'imageDisplay', 'imageRemove', '|']
	
	};
	
	config.htmlAllowedTags = config.htmlAllowedTags.concat(['keyword']);
	config.htmlAllowedEmptyTags = config.htmlAllowedEmptyTags.concat([]);
	config.htmlDoNotWrapTags = config.htmlDoNotWrapTags.concat(['keyword']);
	config.htmlAllowedAttrs = config.htmlAllowedAttrs.concat(['is']);exports.default = config;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var ad = _vue2.default.resource('admin/ads{/id}');
	
	exports.default = ad;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var comment = _vue2.default.resource('comments{/id}');
	
	exports.default = comment;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var exportUsers = _vue2.default.resource('admin/dashboard/export_users{/id}');
	
	exports.default = exportUsers;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var lectureNote = _vue2.default.resource('lecture_notes{/id}', {}, {}, { emulateJSON: true, timeout: 99999999 });exports.default = lectureNote;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var subject = _vue2.default.resource('subjects{/id}');
	
	exports.default = subject;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var exportUsers = _vue2.default.resource('admin/reports/download{/id}');
	
	exports.default = exportUsers;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authService = exports.authHeaders = undefined;
	
	var _promise = __webpack_require__(59);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authHeaders = exports.authHeaders = ['access-token', 'client', 'uid'];
	
	var authService = exports.authService = {
	  validateToken: function validateToken() {
	    return _vue2.default.http.get('auth/validate_token').then(function (res) {
	      var user = res.body.data;
	      return _promise2.default.resolve(user);
	    }, function (res) {
	      console.log('SERVER SAYS INVALID TOKEN', res);
	      return _promise2.default.reject();
	    });
	  },
	  login: function login(credentials) {
	    return _vue2.default.http.post('auth/sign_in', credentials).then(function (res) {
	      var user = res.body.data;
	      return _promise2.default.resolve(user);
	    }, function (res) {
	      var errors = ['Login failed'];
	      try {
	        errors = res.body.errors;
	      } catch (e) {}
	      return _promise2.default.reject(errors);
	    });
	  },
	  logout: function logout() {
	    return _vue2.default.http.delete('auth/sign_out');
	  },
	  register: function register(userData) {
	    return _vue2.default.http.post('auth', userData).then(function (res) {
	      var user = res.body.data;
	      return _promise2.default.resolve(user);
	    }, function (res) {
	      var errors = ['Failed to register'];
	      try {
	        errors = res.body.errors.full_messages;
	      } catch (e) {}
	      return _promise2.default.reject(errors);
	    });
	  },
	  update: function update(userData) {
	    return _vue2.default.http.patch('auth', userData).then(function (res) {
	      var user = res.body.data;
	      return _promise2.default.resolve(user);
	    }, function (res) {
	      var errors = ['Failed to update settings'];
	      try {
	        errors = res.body.errors.full_messages;
	      } catch (e) {}
	      return _promise2.default.reject(errors);
	    });
	  },
	  forgotPassword: function forgotPassword(payload) {
	    return _vue2.default.http.post('auth/password', payload).then(function (res) {
	      var user = res.body.data;
	      return _promise2.default.resolve(user);
	    }, function (res) {
	      var errors = ['Password reset failed'];
	      try {
	        errors = res.body.errors;
	      } catch (e) {}
	      return _promise2.default.reject(errors);
	    });
	  },
	  resetPassword: function resetPassword(payload) {
	    var headers = {
	      'Access-Token': payload.accessToken,
	      'Client': payload.clientId,
	      'uid': payload.uid
	    };
	
	    return _vue2.default.http.put('auth/password', payload.credentials, { headers: headers }).then(function (res) {
	      var user = res.body.data;
	      return _promise2.default.resolve(user);
	    }, function (res) {
	      var errors = ['Password reset failed'];
	      try {
	        errors = res.body.errors;
	      } catch (e) {}
	      return _promise2.default.reject(errors);
	    });
	  }
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(2);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _actions = __webpack_require__(322);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _getters = __webpack_require__(323);
	
	var _getters2 = _interopRequireDefault(_getters);
	
	var _user = __webpack_require__(341);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _page = __webpack_require__(335);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _subjects = __webpack_require__(337);
	
	var _subjects2 = _interopRequireDefault(_subjects);
	
	var _chapters = __webpack_require__(327);
	
	var _chapters2 = _interopRequireDefault(_chapters);
	
	var _lectureNotes = __webpack_require__(330);
	
	var _lectureNotes2 = _interopRequireDefault(_lectureNotes);
	
	var _microNotes = __webpack_require__(332);
	
	var _microNotes2 = _interopRequireDefault(_microNotes);
	
	var _microNoteExporter = __webpack_require__(331);
	
	var _microNoteExporter2 = _interopRequireDefault(_microNoteExporter);
	
	var _studier = __webpack_require__(336);
	
	var _studier2 = _interopRequireDefault(_studier);
	
	var _ads = __webpack_require__(324);
	
	var _ads2 = _interopRequireDefault(_ads);
	
	var _courses = __webpack_require__(329);
	
	var _courses2 = _interopRequireDefault(_courses);
	
	var _blogs = __webpack_require__(325);
	
	var _blogs2 = _interopRequireDefault(_blogs);
	
	var _comments = __webpack_require__(328);
	
	var _comments2 = _interopRequireDefault(_comments);
	
	var _userSearch = __webpack_require__(340);
	
	var _userSearch2 = _interopRequireDefault(_userSearch);
	
	var _chapterSharing = __webpack_require__(326);
	
	var _chapterSharing2 = _interopRequireDefault(_chapterSharing);
	
	var _notifications = __webpack_require__(334);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _userExporter = __webpack_require__(339);
	
	var _userExporter2 = _interopRequireDefault(_userExporter);
	
	var _newsletterSubs = __webpack_require__(333);
	
	var _newsletterSubs2 = _interopRequireDefault(_newsletterSubs);
	
	var _userActivityReport = __webpack_require__(338);
	
	var _userActivityReport2 = _interopRequireDefault(_userActivityReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  actions: _actions2.default,
	  getters: _getters2.default,
	  modules: {
	    currentUser: _user2.default,
	    studier: _studier2.default,
	    page: _page2.default,
	    subjects: _subjects2.default,
	    chapters: _chapters2.default,
	    microNotes: _microNotes2.default,
	    microNoteExporter: _microNoteExporter2.default,
	    lectureNotes: _lectureNotes2.default,
	    ads: _ads2.default,
	    courses: _courses2.default,
	    blogs: _blogs2.default,
	    comments: _comments2.default,
	    userSearch: _userSearch2.default,
	    chapterSharer: _chapterSharing2.default,
	    notifications: _notifications2.default,
	    userExporter: _userExporter2.default,
	    newsletterSubs: _newsletterSubs2.default,
	    userActivityReport: _userActivityReport2.default
	  },
	
	  strict: true
	});

/***/ },
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(469)
	
	/* script */
	__vue_exports__ = __webpack_require__(199)
	
	/* template */
	var __vue_template__ = __webpack_require__(691)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-801e1e50"
	
	module.exports = __vue_exports__


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(424)
	__webpack_require__(423)
	
	/* template */
	var __vue_template__ = __webpack_require__(646)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-39d4fd98"
	
	module.exports = __vue_exports__


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(391)
	
	/* script */
	__vue_exports__ = __webpack_require__(253)
	
	/* template */
	var __vue_template__ = __webpack_require__(614)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-04f91bde"
	
	module.exports = __vue_exports__


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(468)
	
	/* script */
	__vue_exports__ = __webpack_require__(254)
	
	/* template */
	var __vue_template__ = __webpack_require__(690)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7d1f45a9"
	
	module.exports = __vue_exports__


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(437)
	
	/* script */
	__vue_exports__ = __webpack_require__(255)
	
	/* template */
	var __vue_template__ = __webpack_require__(659)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-49eb1f74"
	
	module.exports = __vue_exports__


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(457)
	
	/* script */
	__vue_exports__ = __webpack_require__(261)
	
	/* template */
	var __vue_template__ = __webpack_require__(679)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6d45beca"
	
	module.exports = __vue_exports__


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(472)
	
	/* script */
	__vue_exports__ = __webpack_require__(262)
	
	/* template */
	var __vue_template__ = __webpack_require__(694)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-86668ac0"
	
	module.exports = __vue_exports__


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(504)
	__webpack_require__(503)
	
	/* script */
	__vue_exports__ = __webpack_require__(287)
	
	/* template */
	var __vue_template__ = __webpack_require__(723)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f8650ea6"
	
	module.exports = __vue_exports__


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(397)
	
	/* script */
	__vue_exports__ = __webpack_require__(299)
	
	/* template */
	var __vue_template__ = __webpack_require__(620)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0db491b1"
	
	module.exports = __vue_exports__


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(435)
	
	/* script */
	__vue_exports__ = __webpack_require__(304)
	
	/* template */
	var __vue_template__ = __webpack_require__(657)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 190 */,
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueAnalytics = __webpack_require__(509);
	
	var _vueAnalytics2 = _interopRequireDefault(_vueAnalytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueAnalytics2.default, {
	  id: 'UA-118069539-1',
	  router: _router2.default
	});
	
	exports.default = {};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__(33);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Navbar: _Navbar2.default
	  }
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vuex = __webpack_require__(2);
	
	var _ad = __webpack_require__(51);
	
	var _ad2 = _interopRequireDefault(_ad);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuejsDatepicker = __webpack_require__(190);
	
	var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);
	
	var _index = __webpack_require__(189);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Datepicker: _vuejsDatepicker2.default,
	    Dropzone: _index2.default
	  },
	
	  created: function created() {
	    this.$store.dispatch('getAds');
	  },
	
	
	  methods: {
	    openCreateModal: function openCreateModal() {
	      this.selectedAd = (0, _assign2.default)({}, this.adTemplate);
	    },
	
	
	    editRecord: function editRecord(id) {
	      var ad = _underscore2.default.find(this.ads, function (d) {
	        return d.id === id;
	      });
	      if (ad) {
	        this.selectedAd = (0, _assign2.default)({}, ad);
	        $('#createModal').modal();
	      }
	    },
	
	    imageAdded: function imageAdded($event) {
	      this.selectedImage = $event.target.files[0];
	
	      if (!this.validate(this.selectedImage)) return;
	
	      var form = new FormData();
	      form.append('file', this.selectedImage);
	
	      this.imageLoading = true;
	
	      $.ajax((0, _assign2.default)({}, this.fileUploadOptions, { data: form })).then(this.createImage).catch(this.onImageError);
	    },
	    onImageError: function onImageError(err) {
	      Toast.error(err);
	      this.imageLoading = false;
	    },
	    validate: function validate(image) {
	      if (image) {
	        if (!this.allowableTypes.includes(image.name.split(".").pop().toLowerCase())) {
	          Toast.error('Sorry you can only upload ' + this.allowableTypes.join("|").toUpperCase() + ' files.');
	          return false;
	        }
	
	        if (image.size > this.maximumSize) {
	          Toast.error("File size must not exceed 5 Mb");
	          return false;
	        }
	      }
	      return true;
	    },
	    createImage: function createImage() {
	      var _this2 = this;
	
	      this.imageLoading = false;
	      if (this.selectedImage) {
	        var image = new Image();
	        var reader = new FileReader();
	        reader.onload = function (e) {
	          _this2.selectedAd.image = e.target.result;
	          _this2.$forceUpdate();
	        };
	        reader.readAsDataURL(this.selectedImage);
	      }
	    },
	    save: function save() {
	      if (this.imageLoading) {
	        Toast.error("Please wait for image to finish loading");
	        return;
	      }
	
	      if (!this.isValid()) {
	        return;
	      }
	
	      var _this = this;
	
	      if (this.selectedAd.id > 0) {
	        var changes = {
	          start: this.selectedAd.start,
	          end: this.selectedAd.end,
	          company: this.selectedAd.company,
	          status: this.selectedAd.status,
	          slotID: this.selectedAd.slotID,
	          displayPage: this.selectedAd.displayPage,
	          title: this.selectedAd.title,
	          url: this.selectedAd.url
	        };
	
	        if (this.selectedAd.image.startsWith('data')) {
	          console.log('updating image');
	          changes.image = this.selectedAd.image;
	        }
	        this.$store.dispatch('updateAd', { id: this.selectedAd.id, changes: changes }).then(function () {});
	      } else {
	        this.$store.dispatch('createAd', { ad: this.selectedAd }).then(function () {});
	      }
	      $('#createModal').modal('hide');
	    },
	    isValid: function isValid() {
	      this.errors = [];
	      if (new Date(this.selectedAd.start) > new Date(this.selectedAd.end)) {
	        this.errors.push('Start date must be before end date');
	      }
	
	      if (!this.selectedAd.company) {
	        this.errors.push('Company is a required field');
	      }
	
	      if (!this.selectedAd.title) {
	        this.errors.push('Title is a required field');
	      }
	
	      if (!this.selectedAd.url) {
	        this.errors.push('URL is a required field');
	      }
	
	      if (!this.selectedAd.image) {
	        this.errors.push('Must select an image');
	      }
	
	      if (!this.selectedAd.status) {
	        this.errors.push('Status is a required field');
	      }
	
	      if (!this.selectedAd.displayPage) {
	        this.errors.push('Display page is a required field');
	      }
	
	      return this.errors.length <= 0;
	    },
	    deleteAd: function deleteAd() {
	      var ad = this.selectedAd;
	
	      if (!confirm('Are you sure you want to delete \'' + ad.title + '?\'')) return;
	      this.$store.dispatch('deleteAd', { ad: ad });
	
	      $('#createModal').modal('hide');
	    },
	    refreshFilters: function refreshFilters(ads) {
	      for (var i = 0; i < ads.length; i++) {
	        var ad = ads[i];
	
	        if (_underscore2.default.every(this.companyFilters, function (a) {
	          return a !== ad.company;
	        })) {
	          this.companyFilters.push(ad.company);
	        }
	      }
	    },
	    companyChanged: function companyChanged() {
	      this.selectedAd.company = this.companySelect;
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), {
	    ads: function ads() {
	      var ads = this.$store.getters.allAds;
	      this.refreshFilters(ads);
	      return ads;
	    },
	    filteredData: function filteredData() {
	      var f = {};
	
	      if (this.selectedStatus) {
	        f.status = this.selectedStatus;
	      }
	      if (this.selectedCompany) {
	        f.company = this.selectedCompany;
	      }
	      if (this.selectedPage) {
	        f.displayPage = this.selectedPage;
	      }
	
	      var filtered = _underscore2.default.where(this.ads, f);
	
	      if (this.searchTerm) {
	        var searched = [];
	        for (var i = 0; i < filtered.length; i++) {
	          if (filtered[i].title.toLowerCase().match(this.searchTerm.toLowerCase() + '.*')) {
	            searched.push(filtered[i]);
	          }
	        }
	
	        return searched;
	      } else {
	        return filtered;
	      }
	    },
	    imageSize: function imageSize() {
	      var size = '';
	      switch (this.selectedAd.displayPage) {
	        case 'public':
	          if (this.selectedAd.slotID === 1) {
	            size = '728 wide x 90 high';
	          } else if (this.selectedAd.slotID >= 2) {
	            size = '300 wide x 250 high';
	          }
	          break;
	        case 'dashboard':
	          if (this.selectedAd.slotID === 1) {
	            size = '728 wide x 90 high';
	          } else if (this.selectedAd.slotID === 2) {
	            size = '160 wide x 600 high';
	          } else if (this.selectedAd.slotID >= 3) {
	            size = '300 wide x 250 high';
	          }
	          break;
	        case 'studier':
	          if (this.selectedAd.slotID === 1) {
	            size = '728 wide x 90 high';
	          } else if (this.selectedAd.slotID >= 2) {
	            size = '160 wide x 600 high';
	          }
	          break;
	      }
	
	      return size;
	    }
	  }),
	
	  data: function data() {
	    return {
	      allowableTypes: ['jpg', 'jpeg', 'png', 'gif'],
	      maximumSize: 5000000,
	      selectedImage: null,
	      fields: ['title', 'company', 'displayPage', 'slotID', 'start', 'end', 'status'],
	      statusFilters: ['', 'active', 'pending', 'expired', 'inactive'],
	      companyFilters: [''],
	      pageFilters: ['', 'public', 'dashboard', 'studier'],
	      disabledDates: {
	        to: new Date()
	      },
	      searchTerm: '',
	      selectedStatus: '',
	      selectedCompany: '',
	      selectedPage: '',
	      selectedAd: null,
	      errors: [],
	      adTemplate: {
	        id: null,
	        start: new Date(),
	        end: new Date().setMonth(new Date().getMonth() + 1),
	        company: '',
	        status: 'active',
	        slotID: 1,
	        displayPage: 'dashboard',
	        title: 'New ad',
	        url: '',
	        image: ''
	      },
	      companySelect: '',
	      fileUploadOptions: {
	        url: 'https://httpbin.org/post',
	        type: "POST",
	        processData: false,
	        contentType: false
	      },
	      imageLoading: false
	    };
	  }
	};

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _blog = __webpack_require__(35);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	
	  created: function created() {
	    this.$store.dispatch('getBlogPosts');
	  },
	
	
	  methods: {
	
	    editRecord: function editRecord(id) {
	      var post = _underscore2.default.find(this.blogPosts, function (d) {
	        return d.id === id;
	      });
	      if (post) {
	        this.$router.push({ name: 'blog-post-edit', params: { id: post.id } });
	      }
	    },
	
	    deletePost: function deletePost(post) {
	      if (!confirm('Are you sure you want to delete \'' + post.title + '?\'')) return;
	      this.$store.dispatch('deleteBlogPost', { blogPost: post });
	    },
	    refreshFilters: function refreshFilters(posts) {
	      for (var i = 0; i < posts.length; i++) {
	        var p = posts[i];
	
	        if (_underscore2.default.every(this.authorFilters, function (a) {
	          return a !== p.author;
	        })) {
	          this.authorFilters.push(p.author);
	        }
	      }
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([]), {
	    blogPosts: function blogPosts() {
	      var posts = this.$store.getters.allBlogPosts;
	      this.refreshFilters(posts);
	      return posts;
	    },
	    filteredData: function filteredData() {
	      var f = {};
	
	      if (this.selectedAuthor) {
	        f.author = this.selectedAuthor;
	      }
	
	      var filtered = _underscore2.default.where(this.blogPosts, f);
	
	      if (this.searchTerm) {
	        var searched = [];
	        for (var i = 0; i < filtered.length; i++) {
	          if (filtered[i].title.toLowerCase().match(this.searchTerm.toLowerCase() + '.*')) {
	            searched.push(filtered[i]);
	          }
	        }
	
	        return searched;
	      } else {
	        return filtered;
	      }
	    }
	  }),
	
	  data: function data() {
	    return {
	      fields: ['title', 'author', 'created_at_formatted'],
	      authorFilters: [''],
	      searchTerm: '',
	      selectedAuthor: '',
	      errors: []
	    };
	  }
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _blog = __webpack_require__(35);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	var _comment = __webpack_require__(52);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _FroalaEditor = __webpack_require__(31);
	
	var _FroalaEditor2 = _interopRequireDefault(_FroalaEditor);
	
	var _blogArticleEditor = __webpack_require__(305);
	
	var _blogArticleEditor2 = _interopRequireDefault(_blogArticleEditor);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _BlogCommentsList = __webpack_require__(180);
	
	var _BlogCommentsList2 = _interopRequireDefault(_BlogCommentsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FroalaEditor: _FroalaEditor2.default,
	    BlogCommentsList: _BlogCommentsList2.default
	  },
	
	  created: function created() {
	    this.$store.dispatch('getBlogPosts');
	
	    if (this.$route.params.id) {
	      this.postId = this.$route.params.id;
	    }
	
	    if (this.blogArticle) {
	      this.articleDetails = {
	        title: this.blogArticle.title,
	        author: this.blogArticle.author,
	        notify: this.blogArticle.notify,
	        content: this.blogArticle.content,
	        meta_title: this.blogArticle.meta_title,
	        meta_desc: this.blogArticle.meta_desc
	      };
	      this.comments = this.blogArticle.comments;
	    }
	  },
	
	
	  methods: {
	    save: function save() {
	      var _this = this;
	
	      if (this.valid) {
	
	        this.status = 'saving';
	        if (this.postId > 0) {
	          var edit = {
	            id: this.postId,
	            changes: this.articleDetails,
	            callback: function callback(err) {
	              _this.status = '';
	              if (err) {
	                Toast.error(err);
	              } else {
	                Toast.success('Blog post updated');
	              }
	            }
	          };
	          this.$store.dispatch('updateBlogPost', edit);
	        } else {
	          var create = {
	            blogPost: this.articleDetails,
	            callback: function callback(newPost) {
	              _this.status = '';
	              _this.postId = newPost.id;
	              _this.$store.dispatch('getBlogPosts');
	              Toast.success('Blog post created');
	            }
	          };
	          this.$store.dispatch('createBlogPost', create);
	        }
	      }
	    },
	    deletePost: function deletePost() {
	      var _this2 = this;
	
	      if (this.blogArticle && this.blogArticle.id > 0 && confirm('Are you sure you want to delete this blog post?')) {
	        this.status = 'deleting';
	        this.$store.dispatch('deleteBlogPost', {
	          blogPost: this.blogArticle,
	          callback: function callback(err) {
	            _this2.status = '';
	            _router2.default.push({ name: 'blog-manager' });
	            Toast.success('Blog post deleted');
	          } });
	      }
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([]), (0, _vuex.mapGetters)({
	    allBlogPosts: 'allBlogPosts'
	  }), {
	    blogArticle: function blogArticle() {
	      if (!this.postId || this.postId <= 0) return null;
	      return _underscore2.default.first(_underscore2.default.where(this.allBlogPosts, { id: this.postId }));
	    },
	    valid: function valid() {
	      if (this.articleDetails.title === '' || this.articleDetails.author === '' || this.articleDetails.content === '') {
	        return false;
	      }
	
	      return true;
	    }
	  }),
	
	  data: function data() {
	    return {
	      status: '',
	      postId: 0,
	      articleDetails: {
	        title: '',
	        author: '',
	        notify: true,
	        content: '',
	        meta_title: '',
	        meta_desc: ''
	      },
	      comments: [],
	
	      froalaConfig: (0, _assign2.default)({}, _blogArticleEditor2.default, {
	        height: '400px'
	      })
	    };
	  }
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _userActivityExport = __webpack_require__(56);
	
	var _userActivityExport2 = _interopRequireDefault(_userActivityExport);
	
	var _vuejsDatepicker = __webpack_require__(190);
	
	var _vuejsDatepicker2 = _interopRequireDefault(_vuejsDatepicker);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Datepicker: _vuejsDatepicker2.default
	  },
	
	  created: function created() {
	    var date = new Date();
	    this.startDate = date.getFullYear() + '-' + (date.getMonth() == 0 ? 12 : date.getMonth()) + '-' + date.getDate();
	    this.endDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
	  },
	
	
	  methods: {
	    downloadReport: function downloadReport() {
	      if (this.startDate && this.endDate && new Date(this.startDate) < new Date(this.endDate)) {
	
	        this.saving = true;
	        var self = this;
	
	        this.$store.dispatch('getUserActivityExport', {
	          callback: function callback(result) {
	            self.saving = false;
	
	            var file = new Blob([result], { type: '.zip' });
	            if (window.navigator.msSaveOrOpenBlob) window.navigator.msSaveOrOpenBlob(file, 'user-activity.zip');else {
	              var a = document.createElement("a"),
	                  url = URL.createObjectURL(file);
	              a.href = url;
	              a.download = 'user-activity.zip';
	              document.body.appendChild(a);
	              a.click();
	              setTimeout(function () {
	                document.body.removeChild(a);
	                window.URL.revokeObjectURL(url);
	              }, 0);
	            }
	          },
	          failedCallback: function failedCallback(result) {
	            self.saving = false;
	          },
	          model: {
	            start: this.startDate,
	            stop: this.endDate
	          }
	        });
	      } else {
	        Toast.error('Invalid date selection');
	      }
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([])),
	
	  data: function data() {
	    return {
	      saving: false,
	      startDate: '',
	      endDate: ''
	    };
	  }
	};

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _exportUsers = __webpack_require__(53);
	
	var _exportUsers2 = _interopRequireDefault(_exportUsers);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	
	  created: function created() {},
	
	
	  methods: {
	    downloadUsers: function downloadUsers() {
	      this.saving = true;
	      var self = this;
	
	      this.$store.dispatch('exportUsers', {
	        callback: function callback(result) {
	          self.saving = false;
	
	          var file = new Blob([result], { type: '.csv' });
	          if (window.navigator.msSaveOrOpenBlob) window.navigator.msSaveOrOpenBlob(file, 'user-export.csv');else {
	            var a = document.createElement("a"),
	                url = URL.createObjectURL(file);
	            a.href = url;
	            a.download = 'user-export.csv';
	            document.body.appendChild(a);
	            a.click();
	            setTimeout(function () {
	              document.body.removeChild(a);
	              window.URL.revokeObjectURL(url);
	            }, 0);
	          }
	        }
	      });
	    },
	    downloadSubs: function downloadSubs() {
	      this.saving = true;
	      var self = this;
	
	      this.$store.dispatch('exportSubscribers', {
	        callback: function callback(result) {
	          self.saving = false;
	
	          var file = new Blob([result], { type: '.csv' });
	          if (window.navigator.msSaveOrOpenBlob) window.navigator.msSaveOrOpenBlob(file, 'newsletter-export.csv');else {
	            var a = document.createElement("a"),
	                url = URL.createObjectURL(file);
	            a.href = url;
	            a.download = 'newsletter-export.csv';
	            document.body.appendChild(a);
	            a.click();
	            setTimeout(function () {
	              document.body.removeChild(a);
	              window.URL.revokeObjectURL(url);
	            }, 0);
	          }
	        }
	      });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([])),
	
	  data: function data() {
	    return {
	      saving: false
	    };
	  }
	};

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    comment: Object,
	    showDelete: Boolean,
	    blogArticleId: Number
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)({
	    allBlogPosts: 'allBlogPosts'
	  }), {
	    friendlyDate: function friendlyDate() {
	      var d = new Date(this.comment.created_at);
	
	      return d.toLocaleDateString() + ' - ' + d.getHours() + ':' + d.getMinutes();
	    }
	  }),
	  methods: {
	    deleteComment: function deleteComment() {
	      var self = this;
	      this.$store.dispatch('deleteComment', {
	        comment: this.comment, callback: function callback(obj) {
	          self.deleted = true;
	          Toast.success('Comment deleted');
	        }
	      });
	    }
	  },
	
	  data: function data() {
	    return {
	      deleted: false
	    };
	  }
	};

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _BlogComment = __webpack_require__(519);
	
	var _BlogComment2 = _interopRequireDefault(_BlogComment);
	
	var _Editable = __webpack_require__(571);
	
	var _Editable2 = _interopRequireDefault(_Editable);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    comments: Array,
	    articleId: Number,
	    showDelete: Boolean
	  },
	  components: {
	    BlogComment: _BlogComment2.default,
	    Editable: _Editable2.default
	  },
	
	  created: function created() {},
	
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      if (this.commentText) {
	        this.status = 'Submitting...';
	        var create = {
	          comment: {
	            blog_id: this.articleId,
	            body: this.commentText
	          },
	          callback: function callback(comment) {
	            _this.status = '';
	            _this.newComments.push(comment);
	            Toast.success('Comment created');
	          }
	        };
	        this.$store.dispatch('createComment', create);
	      }
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), {
	    filteredComments: function filteredComments() {
	      var com = this.comments.concat(this.newComments);
	      return _underscore2.default.sortBy(com, function (c) {
	        var d = new Date(c.created_at);
	        return d;
	      }).reverse();
	    }
	  }),
	
	  data: function data() {
	    return {
	      commentText: '',
	      newComments: [],
	      status: ''
	    };
	  }
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _BlogListArticle = __webpack_require__(521);
	
	var _BlogListArticle2 = _interopRequireDefault(_BlogListArticle);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BlogListArticle: _BlogListArticle2.default
	  },
	
	  created: function created() {
	    this.$store.dispatch('getBlogPosts');
	  },
	
	
	  methods: {
	    loadMore: function loadMore() {
	      this.showCount += 10;
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([]), {
	    heroPost: function heroPost() {
	      var posts = this.blogPosts;
	      if (posts.length > 0) {
	        return posts[0];
	      } else {
	        return null;
	      }
	    },
	    heroImg: function heroImg() {
	      if (!this.heroPost || this.heroPost.blog_images.length <= 0) {
	        return null;
	      } else {
	        return this.heroPost.blog_images[0].image_url;
	      }
	    },
	    heroContent: function heroContent() {
	      if (!this.heroPost) {
	        return '';
	      } else {
	        var html = this.heroPost.content;
	        var div = document.createElement("div");
	        div.innerHTML = html;
	        var text = div.textContent || div.innerText || "";
	        return text;
	      }
	    },
	    blogPosts: function blogPosts() {
	      var posts = this.$store.getters.allBlogPosts;
	      return posts;
	    },
	    showList: function showList() {
	      return this.blogPosts.slice(1, this.showCount);
	    }
	  }),
	
	  data: function data() {
	    return {
	      showCount: 10
	    };
	  }
	};

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    article: Object
	  },
	
	  components: {},
	
	  created: function created() {},
	
	
	  methods: {},
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([]), {
	    content: function content() {
	      var html = this.article.content;
	      var div = document.createElement("div");
	      div.innerHTML = html;
	      var text = div.textContent || div.innerText || "";
	      return text;
	    },
	    image: function image() {
	      if (this.article.blog_images.length > 0) {
	        return this.article.blog_images[0].image_url;
	      }
	      return null;
	    }
	  }),
	
	  data: function data() {
	    return {};
	  }
	};

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(21);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  created: function created() {
	    this.getChapters();
	    this.$store.dispatch('clearSearch');
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getChapters']), {
	    addEmail: function addEmail(user) {
	      var current = _underscore2.default.where(this.sharingEmails, { email: user.email });
	
	      if (current.length > 0) {
	        Toast.error('User is already in share list.');
	        return;
	      }
	
	      if (!user.AllowSharing) {
	        Toast.error('User has sharing turned off. Cannot share with this user.');
	        return;
	      }
	
	      this.sharingEmails.push(user);
	      this.searchEmail = '';
	      this.$store.dispatch('clearSearch');
	    },
	    removeEmail: function removeEmail(user) {
	      for (var i = 0; i < this.sharingEmails.length; i++) {
	        if (this.sharingEmails[i].email == user.email) {
	          this.sharingEmails.splice(i, 1);
	          break;
	        }
	      }
	    },
	    searchUser: function searchUser() {
	      this.searching = true;
	      this.$store.dispatch('searchUsers', { searchTerm: this.searchEmail, callback: this.searchComplete });
	    },
	    searchComplete: function searchComplete() {
	      this.searching = false;
	    },
	    share: function share() {
	      if (this.sharingEmails.length > 0) {
	        this.leftToShare = this.sharingEmails.length;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.sharingEmails), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var u = _step.value;
	
	            var share = { recipient_uid: u.uid, chapter_id: this.chapter.id };
	            this.$store.dispatch('shareChapter', { share: share, callback: this.shareComplete });
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    },
	    shareComplete: function shareComplete() {
	      this.leftToShare -= 1;
	      if (this.leftToShare <= 0) {
	        Toast.success('Chapter shared with users.');
	        this.sharingEmails = [];
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      searchEmail: '',
	      sharingEmails: [],
	      searching: false,
	      leftToShare: 0
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    userSearchResults: 'userSearchResults',
	    showNoResultsMessage: 'showNoResultsMessage'
	  }), (0, _vuex.mapState)(['currentUser']), {
	    chapter: function chapter() {
	      return this.$store.state.chapters[this.$route.params.chapterId];
	    },
	    emailValid: function emailValid() {
	      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return re.test(String(this.searchEmail).toLowerCase());
	    }
	  })
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(21);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _ReceiveChapterRow = __webpack_require__(524);
	
	var _ReceiveChapterRow2 = _interopRequireDefault(_ReceiveChapterRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    ReceiveChapterRow: _ReceiveChapterRow2.default
	  },
	  created: function created() {
	    this.getAllReceivedShares();
	    this.getSubjects();
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getAllReceivedShares', 'getSubjects']), {
	    importSelected: function importSelected() {
	      if (this.selectedShareImportIds.length > 0 && this.validSubject) {
	        if (this.newSubjectTitle) {
	          var self = this;
	          this.$store.dispatch('createSubject', {
	            subject: { title: this.newSubjectTitle },
	            callback: function callback(error, obj) {
	              self.acceptSelected(obj);
	            }
	          });
	        } else {
	          this.acceptSelected();
	        }
	      }
	    },
	    acceptSelected: function acceptSelected(subject) {
	      var _this = this;
	
	      if (subject) {
	        this.selectedSubjectId = subject.id;
	      }
	
	      if (this.selectedSubjectId) {
	        this.saving = true;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var id = _step.value;
	
	            _this.$http.post('shares/' + id + '/accept', { subject_id: _this.selectedSubjectId }, {}).then(function (res) {
	              if (res.body.success) {
	                _this.$store.commit('REMOVE_RECEIVED_SHARE', { id: id });
	                _this.$store.commit('REMOVE_NOTIFICATION_WITH_ITEM', { itemId: id, itemType: 'share' });
	                Toast.success('Lecture notes imported');
	              }
	              _this.saving = false;
	            }, function (res) {
	              Toast.error('Failed to accept share request');
	              _this.saving = false;
	            });
	          };
	
	          for (var _iterator = (0, _getIterator3.default)(this.selectedShareImportIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    },
	    declineSelected: function declineSelected() {
	      if (confirm('Are you sure you want to decline ' + this.selectedShareImportIds.length + ' share requests?')) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(this.selectedShareImportIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _id = _step2.value;
	
	            this.$store.dispatch('deleteShare', {
	              id: _id
	            });
	            this.$store.commit('REMOVE_NOTIFICATION_WITH_ITEM', { itemId: _id, itemType: 'share' });
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    },
	    updateSelected: function updateSelected(share) {
	      if (share.selected) {
	        share.selected = false;
	      } else {
	        share.selected = true;
	      }
	    }
	  }),
	  data: function data() {
	    return {
	      selectedSubjectId: null,
	      newSubjectTitle: null,
	      saving: false
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    receivedShares: 'receivedShares',
	    subjects: 'allSubjects',
	    selectedShareImportIds: 'selectedShareImportIds'
	  }), (0, _vuex.mapState)([]), {
	    validSubject: function validSubject() {
	      if (this.selectedSubjectId || this.newSubjectTitle) return true;
	    }
	  })
	};

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    share: Object
	  },
	
	  components: {},
	
	  created: function created() {},
	
	
	  methods: {
	    updateSelected: function updateSelected() {
	      if (!this.selected) {
	        this.$store.dispatch('addShareToSelected', { share: this.share });
	      } else {
	        this.$store.dispatch('removeShareFromSelected', { share: this.share });
	      }
	    }
	  },
	
	  data: function data() {
	    return {};
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    selectedShareImportIds: 'selectedShareImportIds'
	  }), {
	    selected: function selected() {
	      return _underscore2.default.contains(this.selectedShareImportIds, this.share.id);
	    }
	  })
	};

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vuex = __webpack_require__(2);
	
	var _Wordbank = __webpack_require__(534);
	
	var _Wordbank2 = _interopRequireDefault(_Wordbank);
	
	var _StudyIntervalButtons = __webpack_require__(533);
	
	var _StudyIntervalButtons2 = _interopRequireDefault(_StudyIntervalButtons);
	
	var _MicroNoteScore = __webpack_require__(531);
	
	var _MicroNoteScore2 = _interopRequireDefault(_MicroNoteScore);
	
	var _BoolSwitch = __webpack_require__(34);
	
	var _BoolSwitch2 = _interopRequireDefault(_BoolSwitch);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['microNote', 'chapter'],
	
	  components: {
	    Wordbank: _Wordbank2.default,
	    StudyIntervalButtons: _StudyIntervalButtons2.default,
	    MicroNoteScore: _MicroNoteScore2.default,
	    BoolSwitch: _BoolSwitch2.default
	  },
	
	  beforeMount: function beforeMount() {
	    this.wordbankVisible = this.chapter && this.chapter.WordbankVisible != null ? this.chapter.WordbankVisible : true;
	  },
	
	
	  methods: {
	    toggleWordbank: function toggleWordbank(value) {
	      this.wordbankVisible = value;
	      if (this.chapter) {
	        var changes = (0, _assign2.default)({}, this.chapter, { WordbankVisible: this.wordbankVisible });
	        this.$store.dispatch('updateChapter', {
	          id: this.chapter.id,
	          changes: changes,
	          callback: function callback(err) {}
	        });
	      }
	    },
	    nextMicroNote: function nextMicroNote() {
	      this.$store.dispatch('studier/nextMicroNote');
	    },
	    previousMicroNote: function previousMicroNote() {
	      this.$store.dispatch('studier/previousMicroNote');
	    }
	  },
	
	  data: function data() {
	    return {
	      wordbankVisible: true
	    };
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    wordbankWords: 'studier/wordbankWords',
	    microNoteIsCompleted: 'studier/microNoteIsCompleted'
	  }), {
	    showButtons: function showButtons() {
	      return _underscore2.default.values(this.$store.state.studier.keywords).length > 0;
	    }
	  })
	};

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	var _microNote = __webpack_require__(19);
	
	var _microNote2 = _interopRequireDefault(_microNote);
	
	var _BottomShelf = __webpack_require__(525);
	
	var _BottomShelf2 = _interopRequireDefault(_BottomShelf);
	
	var _MicroNoteStudier = __webpack_require__(532);
	
	var _MicroNoteStudier2 = _interopRequireDefault(_MicroNoteStudier);
	
	var _MicroNoteImageStudier = __webpack_require__(530);
	
	var _MicroNoteImageStudier2 = _interopRequireDefault(_MicroNoteImageStudier);
	
	var _KeywordSettings = __webpack_require__(32);
	
	var _KeywordSettings2 = _interopRequireDefault(_KeywordSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BottomShelf: _BottomShelf2.default,
	    MicroNoteStudier: _MicroNoteStudier2.default,
	    MicroNoteImageStudier: _MicroNoteImageStudier2.default,
	    KeywordSettings: _KeywordSettings2.default
	  },
	
	  beforeCreate: function beforeCreate() {
	    this.$store.dispatch('getChapters');
	    this.$store.dispatch('getMicroNotes');
	    this.$store.commit('studier/LOAD_CHAPTER', { chapterId: this.$route.params.chapterId });
	  },
	  created: function created() {
	    $(window).on('keypress.chapterStudier', this.handleKeypress);
	    $(window).on('keydown.chapterStudier', this.handleKeydown);
	
	    this.successImageUrl = _underscore2.default.sample(this.successGifs);
	  },
	  beforeDestroy: function beforeDestroy() {
	    $(window).off('keypress.chapterStudier');
	    $(window).off('keydown.chapterStudier');
	  },
	
	
	  methods: {
	    nextMicroNote: function nextMicroNote() {
	      this.$store.dispatch('studier/nextMicroNote');
	    },
	    previousMicroNote: function previousMicroNote() {
	      this.$store.dispatch('studier/previousMicroNote');
	    },
	    handleKeydown: function handleKeydown(e) {
	      var key = e.key.toLowerCase();
	      switch (key) {
	        case 'enter':
	          this.$store.dispatch('studier/nextKeyword');
	          break;
	
	        case 'backspace':
	          var answer = this.currentKeyword.answer || '';
	          answer = answer.substring(0, answer.length - 1);
	          this.updateCurrentKeyword({
	            answer: answer,
	            answered: false
	          });
	          break;
	      }
	    },
	    handleKeypress: function handleKeypress(e) {
	      if (e.keyCode === 32) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      var char = e.which !== 0 ? String.fromCharCode(e.which) : null;
	      if (!this.currentKeyword) return;
	      if (!char || _underscore2.default.contains([13], e.keyCode)) {
	        return;
	      }
	
	      var answer = this.currentKeyword.answer || '';
	      answer = answer + char;
	      this.updateCurrentKeyword({ answer: answer, answered: false });
	    },
	    updateCurrentKeyword: function updateCurrentKeyword(changes) {
	      var _uid = this.$store.state.studier.currentKeywordUID;
	      this.$store.commit('studier/UPDATE_KEYWORD', { _uid: _uid, changes: changes });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    currentMicroNoteIndex: function currentMicroNoteIndex(state) {
	      return state.studier.currentMicroNoteIndex;
	    }
	  }), (0, _vuex.mapGetters)({
	    chapter: 'studier/chapter',
	    microNotes: 'studier/microNotes',
	    microNote: 'studier/currentMicroNote',
	    currentKeyword: 'studier/currentKeyword'
	  })),
	
	  data: function data() {
	    return {
	      successImageUrl: null,
	      successGifs: ['https://media2.giphy.com/media/l3q2Z6S6n38zjPswo/200.gif', 'https://media2.giphy.com/media/l0MYxef0mpdcnQnvi/200.gif', 'https://media2.giphy.com/media/nXxOjZrbnbRxS/200w.gif', 'https://media1.giphy.com/media/xNBcChLQt7s9a/200w.gif', 'https://media0.giphy.com/media/13MCWeJPQtkdVe/200.gif', 'https://media2.giphy.com/media/b09xElu8in7Lq/200.gif', 'https://media3.giphy.com/media/rypyVNU547qrC/200.gif']
	    };
	  },
	
	
	  watch: {
	    'microNote.id': function microNoteId(newVal, oldVal) {
	      if (newVal != oldVal) {
	        this.$store.commit('studier/RESET_KEYWORDS');
	      }
	    }
	  }
	};

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Keyword = __webpack_require__(529);
	
	var _Keyword2 = _interopRequireDefault(_Keyword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['html'],
	
	  render: function render(createElement) {
	    return createElement({
	      template: '<div>' + this.html + '</div>',
	      components: {
	        Keyword: _Keyword2.default
	      }
	    });
	  }
	};

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(21);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: ['keywordId', 'scale'],
	
	  methods: {
	    select: function select() {
	      this.$store.dispatch('studier/setActiveKeyword', { keyword: this.keyword });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    revealAnswers: 'studier/microNoteIsCompleted',
	    chapter: 'studier/chapter'
	  }), {
	    keyword: function keyword() {
	      return this.$store.state.studier.keywords[this.keywordId];
	    },
	    style: function style() {
	      var style = {
	        left: this.keyword.x,
	        top: this.keyword.y,
	        width: this.keyword.width,
	        height: this.keyword.height,
	        lineHeight: this.keyword.height
	      };
	
	      for (var prop in style) {
	        style[prop] = style[prop] * this.scale + 'px';
	      }return style;
	    },
	    visibleContent: function visibleContent() {
	      if (this.answer) {
	        return this.answer;
	      }
	
	      var a = '';
	      if (!this.chapter || !this.chapter.KeywordDifficulty || this.chapter.KeywordDifficulty == 1) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.realAnswer), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var char = _step.value;
	
	            a += char === ' ' ? ' ' : '*';
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else if (this.chapter.KeywordDifficulty == 2) {
	        a = "----- ".repeat(this.realAnswer.split(' ').length).trim();
	      } else {
	        a = " ? ";
	      }
	      return a;
	    },
	    answerDiff: function answerDiff() {
	      if (!this.answer || !this.realAnswer) return '';
	      var answer = this.answer.trim().toLowerCase();
	      var realAnswer = this.realAnswer.trim().toLowerCase();
	
	      if (answer === realAnswer) return '<span>' + this.answer + '</span>';
	      var html = '';
	
	      var answerArr = answer.split('');
	      var realAnswerArr = realAnswer.trim().split('');
	
	      while (realAnswerArr.length || answerArr.length) {
	        var x = answerArr.shift() || '';
	        var y = realAnswerArr.shift() || '';
	        var char = y || x;
	
	        if (x === y) {
	          html = html + char;
	        } else {
	          html = html + ('<span class="mistake">' + char + '</span>');
	        }
	      }
	
	      return html;
	    },
	    answerIsCorrect: function answerIsCorrect() {
	      return this.keyword ? this.keyword.correct : false;
	    },
	    answered: function answered() {
	      return this.keyword ? this.keyword.answered : false;
	    },
	    answer: function answer() {
	      return this.keyword ? this.keyword.answer : null;
	    },
	    realAnswer: function realAnswer() {
	      return this.keyword ? this.keyword.realAnswer : null;
	    },
	    placeholder: function placeholder() {
	      return this.keyword ? this.keyword.placeholder : null;
	    },
	    active: function active() {
	      if (this.keywordId === this.$store.state.studier.currentKeywordUID) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  })
	
	};

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(21);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  beforeMount: function beforeMount() {
	    var realAnswer = this.$slots.default[0].text;
	    var length = realAnswer.length;
	    var placeholder = "*".repeat(length);
	
	    var keywordData = {
	      _uid: this._uid,
	      placeholder: placeholder,
	      realAnswer: realAnswer,
	      answer: null,
	      answered: false,
	      correct: false
	    };
	
	    this.$store.commit('studier/REGISTER_KEYWORD', {
	      keyword: keywordData
	    });
	  },
	
	
	  methods: {
	    select: function select() {
	      this.$store.dispatch('studier/setActiveKeyword', { keyword: this.keyword });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    revealAnswers: 'studier/microNoteIsCompleted',
	    chapter: 'studier/chapter'
	  }), (0, _vuex.mapState)({
	    keywords: function keywords(state) {
	      return state.studier.keywords;
	    }
	  }), {
	    visibleContent: function visibleContent() {
	      if (this.answer) {
	        return this.answer;
	      }
	
	      var a = '';
	      if (!this.chapter || !this.chapter.KeywordDifficulty || this.chapter.KeywordDifficulty == 1) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.realAnswer), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var char = _step.value;
	
	            a += char === ' ' ? ' ' : '*';
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      } else if (this.chapter.KeywordDifficulty == 2) {
	        a = "----- ".repeat(this.realAnswer.split(' ').length).trim();
	      } else {
	        a = " ? ";
	      }
	      return a;
	    },
	    answerDiff: function answerDiff() {
	      if (!this.answer || !this.realAnswer) return '';
	      var answer = this.answer.trim().toLowerCase();
	      var realAnswer = this.realAnswer.trim().toLowerCase();
	
	      if (answer === realAnswer) return '<span>' + this.answer + '</span>';
	      var html = '';
	
	      var answerArr = answer.split('');
	      var realAnswerArr = realAnswer.trim().split('');
	
	      while (realAnswerArr.length || answerArr.length) {
	        var x = answerArr.shift() || '';
	        var y = realAnswerArr.shift() || '';
	        var char = y || x;
	
	        if (x === y) {
	          html = html + char;
	        } else {
	          html = html + ('<span class="mistake">' + char + '</span>');
	        }
	      }
	
	      return html;
	    },
	    answerIsCorrect: function answerIsCorrect() {
	      return this.keyword ? this.keyword.correct : false;
	    },
	    keyword: function keyword() {
	      return this.keywords[this._uid];
	    },
	    answered: function answered() {
	      return this.keyword ? this.keyword.answered : false;
	    },
	    answer: function answer() {
	      return this.keyword ? this.keyword.answer : null;
	    },
	    realAnswer: function realAnswer() {
	      return this.keyword ? this.keyword.realAnswer : null;
	    },
	    placeholder: function placeholder() {
	      return this.keyword ? this.keyword.placeholder : null;
	    },
	    active: function active() {
	      if (this._uid === this.$store.state.studier.currentKeywordUID) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  })
	
	};

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(2);
	
	var _ImageKeyword = __webpack_require__(528);
	
	var _ImageKeyword2 = _interopRequireDefault(_ImageKeyword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['microNote'],
	
	  components: {
	    ImageKeyword: _ImageKeyword2.default
	  },
	
	  created: function created() {
	    var _this = this;
	
	    $(window).on('resize.microNoteImageStudier', _.debounce(function () {
	      _this.imageDisplayWidth = $('.image-container img').width();
	    }, 200));
	
	    this.loadKeywords();
	    this.$watch('microNote.keywords', function (newVal, oldVal) {
	      _this.loadKeywords();
	    });
	  },
	  mounted: function mounted() {
	    this.imageDisplayWidth = $('.image-container img').width();
	  },
	  beforeDestroy: function beforeDestroy() {
	    $(window).off('resize.microNoteImageStudier');
	  },
	
	
	  methods: {
	    loadKeywords: function loadKeywords() {
	      var _this2 = this;
	
	      console.log('microNoteImageStudier.loadKeywords()');
	
	      var keywords = _.values(this.microNote.keywords);
	      this.keywords = keywords;
	      _.each(keywords, function (keyword) {
	        var realAnswer = keyword.value;
	        var length = realAnswer.length;
	
	        var placeholder = '';
	
	        _this2.$store.commit('studier/REGISTER_KEYWORD', {
	          keyword: {
	            _uid: keyword.id,
	            placeholder: placeholder,
	            realAnswer: realAnswer,
	            answer: null,
	            answered: false,
	            correct: false,
	
	            x: keyword.x,
	            y: keyword.y,
	            width: keyword.width,
	            height: keyword.height
	          }
	        });
	      });
	    },
	    handleClick: function handleClick(e) {
	      var $target = $(e.target);
	
	      if ($target.hasClass('clex-keyword')) return;
	
	      this.$store.dispatch('studier/setActiveKeyword', { keyword: null });
	    }
	  },
	
	  computed: {
	    scale: function scale() {
	      if (!this.microNote || !this.imageDisplayWidth || !this.microNote.micro_note_images[0].image_width) return 1;
	      return this.imageDisplayWidth / this.microNote.micro_note_images[0].image_width;
	    },
	    keywords: function keywords() {
	      return _.values(this.microNote.keywords);
	    }
	  },
	
	  data: function data() {
	    return {
	      imageDisplayWidth: null
	
	    };
	  }
	};

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    keywords: function keywords(state) {
	      return state.studier.keywords;
	    }
	  }), {
	    percentScore: function percentScore() {
	      var keywords = _.values(this.keywords);
	      if (!keywords.length) return null;
	      var right = 0;
	
	      _.each(keywords, function (keyword) {
	        if (keyword && keyword.correct) right++;
	      });
	      return Math.round(right / keywords.length * 100);
	    }
	  })
	};

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(2);
	
	var _DynamicRenderer = __webpack_require__(527);
	
	var _DynamicRenderer2 = _interopRequireDefault(_DynamicRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['microNote'],
	
	  components: {
	    DynamicRenderer: _DynamicRenderer2.default
	  },
	
	  methods: {
	    handleClick: function handleClick(e) {
	      var $target = $(e.target);
	
	      if ($target.hasClass('clex-keyword')) return;
	
	      this.$store.dispatch('studier/setActiveKeyword', { keyword: null });
	    }
	  }
	
	};

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _momentTimezone = __webpack_require__(71);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['microNote'],
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)(['currentMicroNote'])),
	
	  methods: {
	    setMicroNoteNextStudy: function setMicroNoteNextStudy(hoursFromNow) {
	      var _this = this;
	
	
	      var now = (0, _momentTimezone2.default)();
	      var nextStudyAt = now.clone().add(hoursFromNow, 'hours');
	
	      console.log('setting nextStudyAt for microNote #' + this.microNote.id + ' to ' + hoursFromNow + ' hours from now.');
	      var payload = {
	        id: this.microNote.id,
	        changes: {
	          last_studied_at: now.toISOString(),
	          next_study_at: nextStudyAt.toISOString()
	        },
	        callback: function callback(err) {
	          if (!err) {
	            window.scrollTo(0, 0);
	            if (hoursFromNow <= 0 && _this.currentUser.studySort !== 'next_study_at') {
	              _this.$store.dispatch('studier/nextMicroNote');
	            } else if (!this.currentMicroNote) {
	              _this.$store.dispatch('studier/nextMicroNote');
	            }
	          }
	        }
	      };
	
	      this.$store.dispatch('updateMicroNote', payload);
	    }
	  }
	};

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _WordbankWord = __webpack_require__(535);
	
	var _WordbankWord2 = _interopRequireDefault(_WordbankWord);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['words'],
	  components: {
	    WordbankWord: _WordbankWord2.default
	  }
	};

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['word'],
	  components: {},
	
	  methods: {
	    select: function select() {
	      this.$store.dispatch('studier/answerKeyword', { answer: this.word });
	    }
	  }
	};

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    chapter: Object
	  },
	
	  components: {},
	
	  created: function created() {},
	
	
	  methods: {
	    updateSelected: function updateSelected() {
	      if (!this.selected) {
	        this.$store.dispatch('addChaptersToExport', { chapterIds: [this.chapter.id] });
	      } else {
	        this.$store.dispatch('removeChaptersFromExport', { chapterIds: [this.chapter.id] });
	      }
	    }
	  },
	
	  data: function data() {
	    return {};
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    selectedExportChapterIds: 'selectedExportChapterIds'
	  }), {
	    selected: function selected() {
	      return _underscore2.default.contains(this.selectedExportChapterIds, this.chapter.id);
	    }
	  })
	};

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _BoolSwitch = __webpack_require__(34);
	
	var _BoolSwitch2 = _interopRequireDefault(_BoolSwitch);
	
	var _SubjectRow = __webpack_require__(538);
	
	var _SubjectRow2 = _interopRequireDefault(_SubjectRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BoolSwitch: _BoolSwitch2.default,
	    SubjectRow: _SubjectRow2.default
	  },
	  created: function created() {
	    this.getSubjects();
	    this.getChapters();
	    this.getMicroNotes();
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getSubjects', 'getChapters', 'getMicroNotes']), {
	    exportChapter: function exportChapter() {
	      var microNoteIds = this.microNotesForSelectedChapters;
	      if (microNoteIds.length > 0) {
	        this.status = 'exporting';
	        var self = this;
	        var date = new Date();
	        var fileName = 'CLEX_LectureNotes_' + date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
	        this.$store.dispatch('exportMicroNotes', {
	          fileName: fileName,
	          export: { micronote_ids: '[' + microNoteIds.toString() + ']' },
	          callback: function callback(error) {
	            self.status = '';
	          }
	        });
	      }
	    },
	    toggleInactive: function toggleInactive(value) {
	      this.includeInactive = value;
	      this.$store.commit('SET_INCLUDE_INACTIVE_MICRONOTES', { includeInactive: value });
	    }
	  }),
	  data: function data() {
	    return {
	      status: ''
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    micronotes: 'allMicroNotes',
	    subjects: 'allSubjects',
	    includeInactive: 'includeInactiveMicroNotes',
	    microNotesForSelectedChapters: 'microNotesForSelectedChapters'
	  }), (0, _vuex.mapState)(['currentUser']))
	};

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _ChapterRow = __webpack_require__(536);
	
	var _ChapterRow2 = _interopRequireDefault(_ChapterRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['subject'],
	
	  components: {
	    ChapterRow: _ChapterRow2.default
	  },
	
	  created: function created() {},
	
	
	  methods: {
	    toggleExpanded: function toggleExpanded() {
	      this.expanded = !this.expanded;
	    },
	    selectAll: function selectAll() {
	      var ids = _underscore2.default.pluck(this.chapters, 'id');
	      this.$store.dispatch('addChaptersToExport', { chapterIds: ids });
	    }
	  },
	
	  data: function data() {
	    return {
	      expanded: true
	    };
	  },
	
	
	  computed: {
	    chapters: function chapters() {
	      var chapters = _underscore2.default.where(this.$store.getters.allChapters, { subject_id: this.subject.id });
	      return chapters;
	    }
	  }
	};

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _index = __webpack_require__(189);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Dropzone: _index2.default
	  },
	
	  created: function created() {
	    this.getSubjects();
	    this.getChapters();
	    this.getCourses();
	  },
	
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    getSubjects: 'getSubjects',
	    getChapters: 'getChapters',
	    getCourses: 'getCourses'
	  }), {
	    toggleOther: function toggleOther() {
	      this.showOther = !this.showOther;
	    },
	    createLectureNote: function createLectureNote(file) {
	      var _this2 = this;
	
	      var _this = this;
	      this.fileName = file.name;
	
	      if (typeof this.newLectureNoteFirstPage == "number" && typeof this.newLectureNoteLastPage == "number" && this.newLectureNoteFirstPage > this.newLectureNoteLastPage) return Toast.error('First PDF page must be lower than last PDF page');
	
	      if (file.type != "application/pdf" && this.importType === 'pdf') {
	        return Toast.error('Please select a PDF file.');
	      }
	      if (!this.fileName.toLowerCase().endsWith('.clex') && this.importType === 'clex') {
	        return Toast.error('Please select a .CLEX file.');
	      }
	
	      if (!this.validSubject && this.importType === 'pdf') return Toast.error('Please select a subject first');
	      if (!this.validPageNums) return Toast.error('Please enter valid page numbers');
	      if (this.showCourses && this.course_id <= 0) return Toast.error('Please select a course from the dropdown');
	
	      if (this.importType === 'pdf') {
	        var formData = new FormData();
	        formData.append('lecture_note[pdf]', file);
	        formData.append('lecture_note[title]', file.name.replace('.pdf', ''));
	        if (this.newLectureNoteFirstPage) formData.append('lecture_note[first_page]', this.newLectureNoteFirstPage);
	        if (this.newLectureNoteLastPage) formData.append('lecture_note[last_page]', this.newLectureNoteLastPage);
	        var subjectTitle = this.newSubjectTitle || this.selectedSubjectTitle;
	        if (subjectTitle) formData.append('lecture_note[subject_title]', subjectTitle);
	
	        formData.append('lecture_note[course_id]', this.course_id);
	
	        this.$http.post('upload', formData, {
	          emulateJSON: true,
	          timeout: 99999999,
	          progress: function progress(pe) {
	            if (pe.lengthComputable) {
	              var progressPercent = pe.loaded / pe.total * 100;
	              _this.uploadProgressPercentage = progressPercent;
	            }
	          }
	        }).then(function (res) {
	          if (res.body.id) {
	            _this.$router.push({ name: 'processing', params: { id: res.body.id } });
	          } else {
	            Toast.error('Failed to import lecture note. Please try again.');
	          }
	        }, function (res) {
	          _this.uploadProgressPercentage = null;
	          _this.fileName = null;
	
	          var errMessage = 'Failed to import lecture note';
	          if (res.body && _.isArray(res.body.errors)) errMessage = 'Error: ' + res.body.errors[0];
	          Toast.error(errMessage);
	        });
	      } else if (this.importType === 'clex') {
	
	        var _formData = new FormData();
	
	        _formData.append('archive', file);
	        _formData.append('filename', file.name.replace('.clex', ''));
	
	        _formData.append('course_id', this.course_id);
	
	        var _subjectTitle = this.newSubjectTitle || this.selectedSubjectTitle;
	        if (_subjectTitle) _formData.append('subject_title', _subjectTitle);
	
	        this.$http.post('micro_notes/import', _formData, {
	          emulateJSON: true,
	          progress: function progress(pe) {
	            if (pe.lengthComputable) {
	              var progressPercent = pe.loaded / pe.total * 100;
	              _this.uploadProgressPercentage = progressPercent;
	            }
	          }
	        }).then(function (res) {
	          _this2.$store.commit('IMPORT_MICRONOTES_SUCCESS', { lecture_note: res.body });
	          _this2.$router.push({
	            name: 'micronote-import-success', params: {
	              chapters_added: res.body.chapters_added,
	              chapters_skipped: res.body.chapters_skipped,
	              micronotes_added: res.body.micronotes_added,
	              micronotes_skipped: res.body.micronotes_skipped,
	              subjects_added: res.body.subjects_added,
	              subjects_skipped: res.body.subjects_skipped
	            }
	          });
	
	          Toast.success('Micro notes imported');
	        }, function (res) {
	          _this.uploadProgressPercentage = null;
	          _this.fileName = null;
	
	          var errMessage = 'Failed to import micro notes';
	          if (res.body && _.isArray(res.body.errors)) errMessage = 'Error: ${res.body.errors[0]}';
	          Toast.error(errMessage);
	        });
	      }
	    }
	  }),
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)({
	    subjects: 'allSubjects',
	    chapters: 'allChapters',
	    allCourses: 'allCourses'
	  }), {
	    validSubject: function validSubject() {
	      if (this.selectedSubjectTitle || this.newSubjectTitle) return true;
	    },
	    validPageNums: function validPageNums() {
	      console.log(this.newLectureNoteFirstPage);
	      if (this.newLectureNoteFirstPage < this.newLectureNoteLastPage || !this.newLectureNoteFirstPage && !this.newLectureNoteLastPage) {
	        return true;
	      }
	      return false;
	    },
	    roundedUploadProgressPercentage: function roundedUploadProgressPercentage() {
	      return Math.round(this.uploadProgressPercentage);
	    },
	    showCourses: function showCourses() {
	      return this.currentUser.role === 'teacher';
	    }
	  }),
	
	  data: function data() {
	    return {
	      importType: 'pdf',
	      fileName: null,
	      uploadProgressPercentage: null,
	      selectedSubjectTitle: null,
	      newSubjectTitle: null,
	      newChapterTitle: null,
	      newLectureNoteFirstPage: null,
	      newLectureNoteLastPage: null,
	      showOther: false,
	      course_id: null
	    };
	  }
	};

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    chapter: Object
	  },
	
	  components: {},
	
	  created: function created() {
	    this.getChapters();
	
	    var id = this.$route.params.id;
	    if (id && !isNaN(id)) {
	      this.checkStatus(id);
	    }
	  },
	
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    getChapters: 'getChapters'
	  }), {
	    checkStatus: function checkStatus(id) {
	      var _this = this;
	
	      if (this.process) {
	        if (this.timer) {
	          clearTimeout(this.timer);
	          this.timer = null;
	        }
	
	        this.$http.get('upload/' + id, {
	          emulateJSON: true,
	          timeout: 99999999
	        }).then(function (res) {
	          console.log(res);
	
	          if (res.body.status.toLowerCase() === 'in progress') {
	            _this.updateProcessMessage();
	            _this.timer = setTimeout(function () {
	              this.checkStatus(id);
	            }.bind(_this), 2000);
	          } else if (res.body.status.toLowerCase() === 'error') {
	            _this.processFailed(res.body.error);
	          } else if (res.body.status.toLowerCase() === 'complete' && !isNaN(res.body.lecture_note_id)) {
	            _this.$router.push({ name: 'lecture-note-editor', params: { id: res.body.lecture_note_id }, query: { help: _this.chapters.length <= 0 } });
	            Toast.success('Lecture note imported');
	          } else {
	            _this.processFailed('Failed to import lecture note. Please try again.');
	          }
	        }, function (res) {
	          var errMessage = 'Failed to import lecture note. Please try again.';
	          if (res.body && _underscore2.default.isArray(res.body.errors)) errMessage = 'Error: ' + res.body.errors[0];
	          _this.processFailed(errMessage);
	        });
	      }
	    },
	    updateProcessMessage: function updateProcessMessage() {
	      this.attempt += 1;
	      this.message += '.';
	      if (this.message.length > 3) {
	        this.message = '';
	      }
	    },
	    processFailed: function processFailed(message) {
	      Toast.error(message);
	      this.$router.push({ name: 'importer' });
	    }
	  }),
	
	  data: function data() {
	    return {
	      attempt: 1,
	      message: '',
	      timer: null,
	      process: true
	    };
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    chapters: 'allChapters'
	  })),
	
	  beforeDestroy: function beforeDestroy() {
	    this.process = false;
	    if (this.timer) {
	      clearTimeout(this.timer);
	      this.timer = null;
	    }
	  }
	};

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	
	  created: function created() {},
	
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({})),
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({}), {
	    showSummary: function showSummary() {
	      if (this.chapters_added > 0 || this.chapters_skipped > 0 || this.micronotes_added > 0 || this.micronotes_skipped > 0 || this.subjects_added > 0 || this.subjects_skipped > 0) {
	        return true;
	      }
	
	      return false;
	    }
	  }),
	
	  data: function data() {
	    return {
	      chapters_added: this.$route.params.chapters_added,
	      chapters_skipped: this.$route.params.chapters_skipped,
	      micronotes_added: this.$route.params.micronotes_added,
	      micronotes_skipped: this.$route.params.micronotes_skipped,
	      subjects_added: this.$route.params.subjects_added,
	      subjects_skipped: this.$route.params.subjects_skipped
	    };
	  }
	};

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	__webpack_require__(307);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isWithinTag = function isWithinTag(tagName, elem) {
	  return $(elem).closest(tagName).length > 0;
	};
	
	exports.default = {
	  name: 'froala-editor',
	
	  data: function data() {
	    return {
	      html: ''
	    };
	  },
	
	
	  props: {
	    chapterId: Number,
	    value: String,
	    imageCreatedFunction: Function,
	    config: {
	      type: Object,
	      required: false,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.initialize();
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.froalaEditor) this.froalaEditor.froalaEditor('destroy');
	    this.froalaEditor = null;
	  },
	
	
	  methods: {
	    initialize: function initialize() {
	      var _this = this;
	
	      var self = this;
	      var config = (0, _assign2.default)({ key: 'nddlrE4ol==' }, self.config || {});
	
	      self.froalaEditor = $(this.$el).froalaEditor(config).eq(0);
	
	      self.froalaEditor.froalaEditor('html.set', self.value);
	
	      $('.fr-box').css('height', '100%');
	      $('body').css('height', '100%');
	
	      self.froalaEditor.on('froalaEditor.contentChanged', function (e, editor) {
	        var html = editor.html.get();
	        self.html = html;
	
	        self.$emit('input', html);
	        self.$emit('change', {
	          editor: self.froalaEditor,
	          html: html
	        });
	      });
	
	      self.froalaEditor.on('froalaEditor.clex.convertImageToMicroNote', function (e, editor) {
	        if (!self.chapterId) throw new Error('froalaEditor.clex.convertImageToMicroNote - Missing required param chapterId');
	
	        var imageUrl = editor.image.get().attr('src');
	        var height = editor.image.get().attr('height');
	        var width = editor.image.get().attr('width');
	
	        _this.$store.dispatch('createMicroNote', {
	          microNote: {
	            image_url: imageUrl,
	            image_height: height,
	            image_width: width,
	
	            chapter_id: self.chapterId,
	            micro_note_type: 'image'
	          },
	          callback: function callback(err) {
	            if (!err) {
	              if (self.imageCreatedFunction) {
	                self.imageCreatedFunction();
	              }
	
	              editor.image.remove();
	              Toast.success('Image converted to Micro Note. Keywords can be identified in the next step, once "create micro notes" is selected above.');
	            } else {
	              Toast.error('Failed to convert image to Micro Note');
	            }
	          }
	        });
	      });
	
	      var keywordAllowedCommands = ['undo', 'redo', 'CLEX_Keyword', 'html'];
	      self.froalaEditor.on('froalaEditor.commands.before', function (e, editor, cmd) {
	        var isAllowed = _underscore2.default.contains(keywordAllowedCommands, cmd);
	        if (isAllowed) return true;
	
	        var startElem = editor.selection.element();
	        var endElem = editor.selection.endElement();
	        var isWithinKeyword = isWithinTag('keyword', startElem) || isWithinTag('keyword', endElem);
	        if (isWithinKeyword) {
	          console.log(cmd + ' is blocked within a keyword');
	          return false;
	        }
	      });
	
	      self.$emit('ready');
	    }
	  },
	
	  watch: {
	    value: function value(newVal, oldVal) {
	      if (!this.froalaEditor) return;
	
	      if (newVal !== this.html) {
	        this.html = newVal;
	        this.froalaEditor.froalaEditor('html.set', newVal);
	      }
	    }
	  }
	
	};

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _HorizontalAd = __webpack_require__(17);
	
	var _HorizontalAd2 = _interopRequireDefault(_HorizontalAd);
	
	var _VerticalAd = __webpack_require__(18);
	
	var _VerticalAd2 = _interopRequireDefault(_VerticalAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HorizontalAd: _HorizontalAd2.default,
	    VerticalAd: _VerticalAd2.default
	  }
	};

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _InnerBanner = __webpack_require__(185);
	
	var _InnerBanner2 = _interopRequireDefault(_InnerBanner);
	
	var _vuex = __webpack_require__(2);
	
	var _HorizontalAd = __webpack_require__(17);
	
	var _HorizontalAd2 = _interopRequireDefault(_HorizontalAd);
	
	var _VerticalAd = __webpack_require__(18);
	
	var _VerticalAd2 = _interopRequireDefault(_VerticalAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InnerBanner: _InnerBanner2.default,
	    HorizontalAd: _HorizontalAd2.default,
	    VerticalAd: _VerticalAd2.default
	  }
	};

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _BlogCommentsList = __webpack_require__(180);
	
	var _BlogCommentsList2 = _interopRequireDefault(_BlogCommentsList);
	
	var _HorizontalAd = __webpack_require__(17);
	
	var _HorizontalAd2 = _interopRequireDefault(_HorizontalAd);
	
	var _VerticalAd = __webpack_require__(18);
	
	var _VerticalAd2 = _interopRequireDefault(_VerticalAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BlogCommentsList: _BlogCommentsList2.default,
	    HorizontalAd: _HorizontalAd2.default,
	    VerticalAd: _VerticalAd2.default
	  },
	  created: function created() {
	    this.$store.dispatch('getBlogPosts');
	    this.checkBlogs();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([]), (0, _vuex.mapGetters)({
	    allBlogPosts: 'allBlogPosts'
	  }), {
	    postId: function postId() {
	      return parseInt(this.$route.params.id);
	    },
	    blogArticle: function blogArticle() {
	      if (!this.postId || this.postId <= 0) {
	        _router2.default.push({ name: 'blog' });
	      };
	
	      return _underscore2.default.first(_underscore2.default.where(this.allBlogPosts, { id: this.postId }));
	    },
	    image: function image() {
	      if (this.blogArticle && this.blogArticle.blog_images.length > 0) {
	        return this.blogArticle.blog_images[0].image_url;
	      }
	      return null;
	    }
	  }),
	  methods: {
	    checkBlogs: function checkBlogs() {
	      if (!this.blogArticle) {
	        var self = this;
	        window.setTimeout(function () {
	          self.checkBlogs();
	        }, 500);
	      } else {
	        this.$store.commit('SET_PAGE_TITLE', { title: this.blogArticle.meta_title || this.blogArticle.title });
	        if (this.blogArticle.meta_desc) {
	          this.$store.commit('SET_PAGE_DESCRIPTION', { description: this.blogArticle.meta_desc });
	        }
	      }
	    }
	  }
	};

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _BlogList = __webpack_require__(520);
	
	var _BlogList2 = _interopRequireDefault(_BlogList);
	
	var _HorizontalAd = __webpack_require__(17);
	
	var _HorizontalAd2 = _interopRequireDefault(_HorizontalAd);
	
	var _VerticalAd = __webpack_require__(18);
	
	var _VerticalAd2 = _interopRequireDefault(_VerticalAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BlogList: _BlogList2.default,
	    HorizontalAd: _HorizontalAd2.default,
	    VerticalAd: _VerticalAd2.default
	  }
	};

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _InquiryForm = __webpack_require__(181);
	
	var _InquiryForm2 = _interopRequireDefault(_InquiryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InquiryForm: _InquiryForm2.default
	  }
	};

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _HorizontalAd = __webpack_require__(17);
	
	var _HorizontalAd2 = _interopRequireDefault(_HorizontalAd);
	
	var _VerticalAd = __webpack_require__(18);
	
	var _VerticalAd2 = _interopRequireDefault(_VerticalAd);
	
	var _VideoPlayer = __webpack_require__(186);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    HorizontalAd: _HorizontalAd2.default,
	    VerticalAd: _VerticalAd2.default,
	    VideoPlayer: _VideoPlayer2.default
	  }
	};

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _InquiryForm = __webpack_require__(181);
	
	var _InquiryForm2 = _interopRequireDefault(_InquiryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InquiryForm: _InquiryForm2.default
	  }
	};

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(2);
	
	var _SubscribeForm = __webpack_require__(182);
	
	var _SubscribeForm2 = _interopRequireDefault(_SubscribeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SubscribeForm: _SubscribeForm2.default
	  },
	  data: function data() {
	    return {
	      year: new Date().getFullYear()
	    };
	  }
	};

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _QuickLogin = __webpack_require__(560);
	
	var _QuickLogin2 = _interopRequireDefault(_QuickLogin);
	
	var _VideoPlayer = __webpack_require__(186);
	
	var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    QuickLogin: _QuickLogin2.default,
	    VideoPlayer: _VideoPlayer2.default
	  },
	  methods: {
	    scrollToVideo: function scrollToVideo() {
	      $('html, body').animate({
	        scrollTop: $("#homeVideo").offset().top - 120
	      }, 1000);
	    }
	  }
	};

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {}
	};

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {}
	};

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _Navbar = __webpack_require__(33);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Sidebar = __webpack_require__(577);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _HorizontalAd = __webpack_require__(17);
	
	var _HorizontalAd2 = _interopRequireDefault(_HorizontalAd);
	
	var _VerticalAd = __webpack_require__(18);
	
	var _VerticalAd2 = _interopRequireDefault(_VerticalAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Navbar: _Navbar2.default,
	    Sidebar: _Sidebar2.default,
	    HorizontalAd: _HorizontalAd2.default,
	    VerticalAd: _VerticalAd2.default
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['page']), {
	    currentRoute: function currentRoute() {
	      return this.$route.name;
	    }
	  })
	};

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__(33);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Navbar: _Navbar2.default
	  }
	};

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__(33);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _FooterNav = __webpack_require__(549);
	
	var _FooterNav2 = _interopRequireDefault(_FooterNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Navbar: _Navbar2.default,
	    FooterNav: _FooterNav2.default
	  }
	};

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vuex = __webpack_require__(2);
	
	var _lectureNoteEditor = __webpack_require__(50);
	
	var _lectureNoteEditor2 = _interopRequireDefault(_lectureNoteEditor);
	
	var _lectureNote = __webpack_require__(54);
	
	var _lectureNote2 = _interopRequireDefault(_lectureNote);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FroalaEditor = __webpack_require__(31);
	
	var _FroalaEditor2 = _interopRequireDefault(_FroalaEditor);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _KeywordSettings = __webpack_require__(32);
	
	var _KeywordSettings2 = _interopRequireDefault(_KeywordSettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FroalaEditor: _FroalaEditor2.default,
	    KeywordSettings: _KeywordSettings2.default
	  },
	
	  created: function created() {
	    this.$store.dispatch('getChapters');
	
	    this.getLectureNote();
	  },
	
	
	  methods: {
	    getLectureNote: function getLectureNote() {
	      var self = this;
	      var id = this.$route.params.id;
	      if (id) {
	        console.log('Fetching lecture note ' + id + '...');
	        _lectureNote2.default.get({ id: id }).then(function (res) {
	          self.lectureNote = res.data;
	        }, function (res) {
	          Toast.error('Error, failed to retrieve lecture note', res);
	        });
	      }
	    },
	    saveLectureNote: function saveLectureNote() {
	      var _this = this;
	      this.status = 'saving';
	      _lectureNote2.default.update({ id: this.lectureNote.id }, { lecture_note: this.lectureNote }).then(function (res) {
	        _this.status = 'saved';
	      }, function (res) {
	        Toast.error('Failed to save changes');
	      });
	    },
	    imageCreated: function imageCreated() {
	      this.imageCount += 1;
	    },
	    toggleReplaceWarning: function toggleReplaceWarning() {
	      this.showReplaceWarning = !this.showReplaceWarning;
	    },
	    replaceMicroNotes: function replaceMicroNotes() {
	      _lectureNote2.default.update({ id: this.lectureNote.id }, { lecture_note: (0, _assign2.default)(this.lectureNote, { replace_micro_notes: true }) }).then(function (res) {
	        Toast.success('Micro Notes replaced');
	        _router2.default.push({ name: 'subject-shelf' });
	      }, function (res) {
	        Toast.error('Failed to save changes');
	      });
	    },
	    convertToMicroNotes: function convertToMicroNotes() {
	      var _this2 = this;
	
	      _lectureNote2.default.update({ id: this.lectureNote.id }, { lecture_note: (0, _assign2.default)(this.lectureNote, { create_micro_notes: true }) }).then(function (res) {
	        Toast.success('Micro Notes created');
	        if (_this2.imageCount > 0) {
	          _router2.default.push({ name: 'micro-note-editor', params: { chapterId: _this2.lectureNote.chapter_id, editType: 'image' } });
	        } else {
	          _router2.default.push({ name: 'subject-shelf' });
	        }
	      }, function (res) {
	        Toast.error('Failed to save changes');
	      });
	    },
	    microNotable: function microNotable() {
	      return this.lectureNote.html.replace('/<[^>]*>/', '') != '' && this.lectureNote.html.match(/<hr is="divider"\/?>/) != null;
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    chapter: 'studier/chapter',
	    chapters: 'allChapters'
	  }), {
	    statusMessage: function statusMessage() {
	      if (!this.lectureNote) return '';
	      if (this.status === 'saving') {
	        return 'Saving...';
	      } else if (this.status === 'saved') {
	        return 'Changes saved.';
	      } else {
	        return 'Last saved ' + (0, _moment2.default)(this.lectureNote.updated_at).fromNow();
	      }
	    }
	  }),
	
	  data: function data() {
	    return {
	      lectureNote: null,
	
	      froalaConfig: (0, _assign2.default)({}, _lectureNoteEditor2.default, {
	        height: 'calc(100% - 55px)'
	      }),
	      showReplaceWarning: false,
	      status: null,
	      imageCount: 0,
	      showInstructions: false,
	      showHelp: this.$route.query.help
	    };
	  }
	};

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	
	  created: function created() {},
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({})),
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)({
	    lectureNotes: function lectureNotes(state) {
	      return state.lectureNotes.all;
	    }
	  })),
	
	  data: function data() {
	    return {};
	  }
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	
	  methods: {
	    submit: function submit() {
	      this.$store.commit('CLEAR_USER_ERRORS');
	      this.showSuccess = false;
	      this.saving = true;
	
	      var self = this;
	
	      var payload = {
	        credentials: {
	          email: this.credentials.email,
	          redirect_url: 'http://www.clex.ca/reset-password' },
	        callback: function callback(errors) {
	          self.saving = false;
	          if (!errors) {
	            self.showSuccess = true;
	            self.credentials.email = '';
	          }
	        }
	      };
	
	      this.$store.dispatch('forgotPassword', payload);
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      credentials: {
	        email: null
	      },
	      showSuccess: false,
	      saving: false
	    };
	  }
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	  methods: {
	    login: function login() {
	      var user = {
	        user: {
	          email: this.credentials.email,
	          password: this.credentials.password
	        }
	      };
	
	      if (this.$route.query.redirect) {
	        user.redirect = this.$route.query.redirect;
	      }
	
	      this.$store.dispatch('login', user);
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      credentials: {
	        email: null,
	        password: null
	      }
	    };
	  }
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	  methods: {
	    login: function login() {
	      console.log(this.credentials);
	      this.$store.dispatch('login', { user: {
	          email: this.credentials.email,
	          password: this.credentials.password
	        } });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      credentials: {
	        email: null,
	        password: null
	      }
	    };
	  }
	};

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	
	  methods: {
	    submit: function submit() {
	      this.$store.commit('CLEAR_USER_ERRORS');
	      this.saving = true;
	      var self = this;
	
	      var payload = {
	        credentials: {
	          password: this.credentials.password,
	          password_confirmation: this.credentials.confirmPassword
	        },
	        accessToken: this.accessToken,
	        clientId: this.clientId,
	        uid: this.uid,
	        callback: function callback(errors) {
	          self.saving = false;
	        }
	      };
	
	      this.$store.dispatch('resetPassword', payload);
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), {
	    accessToken: function accessToken() {
	      var urlParams = new URLSearchParams(window.location.search);
	      var myParam = urlParams.get('access-token');
	      return myParam;
	    },
	    clientId: function clientId() {
	      var urlParams = new URLSearchParams(window.location.search);
	      var myParam = urlParams.get('client_id');
	      return myParam;
	    },
	    uid: function uid() {
	      var urlParams = new URLSearchParams(window.location.search);
	      var myParam = urlParams.get('uid');
	      return myParam;
	    },
	    valid: function valid() {
	      if (!this.accessToken || !this.clientId || !this.uid) {
	        return false;
	      }
	      return true;
	    }
	  }),
	
	  data: function data() {
	    return {
	      credentials: {
	        password: null,
	        confirmPassword: null
	      },
	      saving: false
	    };
	  }
	};

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	  props: ['keyword', 'scale', 'onDelete', 'onUpdate', 'onClick', 'activeKeywordId'],
	  mounted: function mounted() {
	    if (!this.keyword) return;
	
	    if (this.activeKeywordId === parseInt(this.keyword.id)) {
	      this.$refs.input.focus();
	    }
	  },
	
	
	  methods: {
	    beforeDestroy: function beforeDestroy() {
	      this.clearListeners();
	    },
	    change: function change() {},
	    focus: function focus() {
	      this.onClick(this.keyword);
	    },
	    destroy: function destroy() {
	      this.onDelete(this.keyword);
	    },
	    resizeStart: function resizeStart(e) {
	      var resizeCoords = {
	        absoluteStartX: e.pageX,
	        absoluteStartY: e.pageY
	      };
	
	      (0, _assign2.default)(resizeCoords, {
	        absoluteEndX: resizeCoords.absoluteStartX,
	        absoluteEndY: resizeCoords.absoluteStartY
	      });
	
	      this.resizeCoords = resizeCoords;
	
	      $(window).on('mousemove.imageKeyword', this.resizeMove);
	      $(window).on('mouseup.imageKeyword', this.resizeEnd);
	    },
	    resizeMove: function resizeMove(e) {
	      if (!this.resizeCoords) return;
	      _vue2.default.set(this.resizeCoords, 'absoluteEndX', e.pageX);
	      _vue2.default.set(this.resizeCoords, 'absoluteEndY', e.pageY);
	    },
	    resizeEnd: function resizeEnd(e) {
	      var width = ('' + this.style.width).replace('px', '') / this.scale;
	      var height = ('' + this.style.height).replace('px', '') / this.scale;
	
	      this.onUpdate(this.keyword.id, { width: width, height: height });
	
	      this.resizeCoords = null;
	      this.clearListeners();
	    },
	    dragStart: function dragStart(e) {
	      var dragCoords = {
	        absoluteStartX: e.pageX,
	        absoluteStartY: e.pageY
	      };
	
	      (0, _assign2.default)(dragCoords, {
	        absoluteEndX: dragCoords.absoluteStartX,
	        absoluteEndY: dragCoords.absoluteStartY
	      });
	
	      this.dragCoords = dragCoords;
	
	      $(window).on('mousemove.imageKeyword', this.dragMove);
	      $(window).on('mouseup.imageKeyword', this.dragEnd);
	    },
	    dragMove: function dragMove(e) {
	      if (!this.dragCoords) return;
	      _vue2.default.set(this.dragCoords, 'absoluteEndX', e.pageX);
	      _vue2.default.set(this.dragCoords, 'absoluteEndY', e.pageY);
	    },
	    dragEnd: function dragEnd(e) {
	      var newX = ('' + this.style.left).replace('px', '') / this.scale;
	      var newY = ('' + this.style.top).replace('px', '') / this.scale;
	
	      this.onUpdate(this.keyword.id, { x: newX, y: newY });
	
	      this.dragCoords = null;
	      this.clearListeners();
	    },
	    clearListeners: function clearListeners() {
	      $(window).off('mousemove.imageKeyword');
	      $(window).off('mouseup.imageKeyword');
	    }
	  },
	
	  computed: {
	    style: function style() {
	      var style = {
	        left: this.keyword.x,
	        top: this.keyword.y,
	        width: this.keyword.width,
	        height: this.keyword.height
	      };
	
	      for (var prop in style) {
	        style[prop] = style[prop] * this.scale;
	      }
	
	      if (this.dragCoords) {
	        var _dragCoords = this.dragCoords,
	            absoluteStartX = _dragCoords.absoluteStartX,
	            absoluteStartY = _dragCoords.absoluteStartY,
	            absoluteEndX = _dragCoords.absoluteEndX,
	            absoluteEndY = _dragCoords.absoluteEndY;
	
	        var distX = absoluteEndX - absoluteStartX;
	        var distY = absoluteEndY - absoluteStartY;
	        var $img = $('.image-container img');
	        var $keyword = $(this.$refs.keyword);
	
	        var minLeft = 0;
	        var maxLeft = $img.width() - $keyword.width();
	        style.left += distX;
	        if (style.left > maxLeft) {
	          style.left = maxLeft;
	        } else if (style.left < minLeft) {
	          style.left = minLeft;
	        }
	
	        var minTop = 0;
	        var maxTop = $img.height() - $keyword.height();
	        style.top += distY;
	        if (style.top > maxTop) {
	          style.top = maxTop;
	        } else if (style.top < minTop) {
	          style.top = minTop;
	        }
	      } else if (this.resizeCoords) {
	        var _resizeCoords = this.resizeCoords,
	            _absoluteStartX = _resizeCoords.absoluteStartX,
	            _absoluteStartY = _resizeCoords.absoluteStartY,
	            _absoluteEndX = _resizeCoords.absoluteEndX,
	            _absoluteEndY = _resizeCoords.absoluteEndY;
	
	        var _distX = _absoluteEndX - _absoluteStartX;
	        var _distY = _absoluteEndY - _absoluteStartY;
	        var _$img = $('.image-container img');
	        var _$keyword = $(this.$refs.keyword);
	
	        var minWidth = 10;
	        var maxWidth = _$img.offset().left + _$img.width() - _$keyword.offset().left;
	        style.width += _distX;
	        if (style.width > maxWidth) {
	          style.width = maxWidth;
	        } else if (style.width < minWidth) {
	          style.width = minWidth;
	        }
	
	        var minHeight = 15;
	        var maxHeight = _$img.offset().top + _$img.height() - _$keyword.offset().top;
	        style.height += _distY;
	        if (style.height > maxHeight) {
	          style.height = maxHeight;
	        } else if (style.height < minHeight) {
	          style.height = minHeight;
	        }
	      }
	      for (var _prop in style) {
	        style[_prop] = style[_prop] + 'px';
	      }return style;
	    },
	    active: function active() {
	      if (_underscore2.default.isUndefined(this.activeKeywordId)) return false;
	      if (parseInt(this.activeKeywordId) === parseInt(this.keyword.id)) return true;
	    }
	  },
	
	  data: function data() {
	    return {
	      dragCoords: null,
	      resizeCoords: null
	    };
	  }
	};

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  beforeMount: function beforeMount() {
	    this.keywordDifficulty = this.chapter && this.chapter.KeywordDifficulty ? this.chapter.KeywordDifficulty : 1;
	  },
	
	
	  methods: {
	    saveChapter: function saveChapter(difficulty) {
	      this.keywordDifficulty = difficulty;
	
	      if (this.chapter) {
	        var changes = (0, _assign2.default)({}, this.chapter, { KeywordDifficulty: this.keywordDifficulty });
	        this.$store.dispatch('updateChapter', {
	          id: this.chapter.id,
	          changes: changes,
	          callback: function callback(err) {
	            Toast.success('Keyword difficulty updated');
	          }
	        });
	      }
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.dropdownVisible = !this.dropdownVisible;
	    }
	  },
	
	  data: function data() {
	    return {
	      keywordDifficulty: 1,
	      dropdownVisible: false
	    };
	  },
	
	
	  props: {
	    chapterId: Number
	  },
	
	  computed: {
	    chapter: function chapter() {
	      return this.$store.state.chapters[this.$route.params.chapterId || this.chapterId];
	    },
	    example: function example() {
	      switch (parseInt(this.keywordDifficulty)) {
	        case 1:
	          return '********  *****';
	          break;
	        case 2:
	          return '-----  -----';
	          break;
	        case 3:
	          return ' ? ';
	          break;
	      }
	    },
	    description: function description() {
	      switch (parseInt(this.keywordDifficulty)) {
	        case 1:
	          return 'Hints at number of characters & words';
	          break;
	        case 2:
	          return 'Hints at the number of words';
	          break;
	        case 3:
	          return 'No hints';
	          break;
	      }
	    }
	  }
	};

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _lectureNoteEditor = __webpack_require__(50);
	
	var _lectureNoteEditor2 = _interopRequireDefault(_lectureNoteEditor);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FroalaEditor = __webpack_require__(31);
	
	var _FroalaEditor2 = _interopRequireDefault(_FroalaEditor);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _KeywordSettings = __webpack_require__(32);
	
	var _KeywordSettings2 = _interopRequireDefault(_KeywordSettings);
	
	var _LoadingIndicator = __webpack_require__(184);
	
	var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FroalaEditor: _FroalaEditor2.default,
	    KeywordSettings: _KeywordSettings2.default,
	    LoadingIndicator: _LoadingIndicator2.default
	  },
	
	  created: function created() {
	    this.getChapters();
	    this.getMicroNotes();
	  },
	
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getMicroNotes', 'getChapters']), {
	    saveMicroNotes: function saveMicroNotes(deleteOld) {
	      var _this = this;
	
	      this.status = 'saving';
	      var splitHtml = this.html.split('<hr is="divider">');
	      var currentMicroNotes = this.microNotes;
	
	      var processed = 0;
	      if (splitHtml.length > 0) {
	        this.saving = true;
	        this.toggleReplaceWarning();
	
	        for (var i = 0; i < splitHtml.length; i++) {
	          this.$store.dispatch('createMicroNote', {
	            microNote: {
	              chapter_id: this.chapter.id,
	              html: splitHtml[i],
	              micro_note_type: 'html'
	            },
	            callback: function callback(err) {
	              _this.status = 'saved';
	              processed += 1;
	
	              if (processed === splitHtml.length) {
	                if (deleteOld) {
	                  _this.deleteMicroNotes(currentMicroNotes);
	                } else {
	                  _this.saving = false;
	                  _this.redirect();
	                }
	              }
	            }
	          });
	        }
	      }
	    },
	    deleteMicroNotes: function deleteMicroNotes(microNotes) {
	      this.microNotesToDelete = microNotes;
	      this.deleteNextMicroNote();
	    },
	    deleteNextMicroNote: function deleteNextMicroNote() {
	      if (this.microNotesToDelete.length > 0) {
	        var m = (0, _assign2.default)({}, this.microNotesToDelete[0]);
	        if (this.microNotesToDelete.length > 1) {
	          this.$store.dispatch('deleteMicroNote', { micronote: m, callback: this.deleteNextMicroNote });
	        } else {
	          this.$store.dispatch('deleteMicroNote', { micronote: m, callback: this.redirect });
	        }
	
	        this.microNotesToDelete.shift();
	      } else {
	        this.saving = false;
	        this.redirect();
	      }
	    },
	    redirect: function redirect() {
	      Toast.success('Micro Notes updated');
	      _router2.default.push({ name: 'subject-shelf' });
	    },
	    toggleReplaceWarning: function toggleReplaceWarning() {
	      this.showReplaceWarning = !this.showReplaceWarning;
	    },
	    replaceMicroNotes: function replaceMicroNotes() {
	      if (this.microNotable()) {
	        this.saveMicroNotes(true);
	      }
	    },
	    microNotable: function microNotable() {
	      if (this.html) {
	        return this.html.replace('/<[^>]*>/', '') != '' && this.html.match(/<hr is="divider"\/?>/) != null;
	      } else {
	        return false;
	      }
	    }
	  }),
	
	  computed: {
	    chapter: function chapter() {
	      return this.$store.state.chapters[this.$route.params.chapterId];
	    },
	    microNotes: function microNotes() {
	      var chapterId = parseInt(this.$route.params.chapterId);
	      if (!chapterId) return [];
	      var allMicroNotes = this.$store.getters.allMicroNotes;
	      var microNotes = _underscore2.default.where(allMicroNotes, { chapter_id: chapterId, micro_note_type: 'html' });
	
	      return microNotes;
	    },
	    statusMessage: function statusMessage() {
	      if (!this.chapter) return '';
	      if (this.status === 'saving') {
	        return 'Saving...';
	      } else if (this.status === 'saved') {
	        return 'Changes saved.';
	      } else {
	        return 'Last saved ' + (0, _moment2.default)(this.chapter.updated_at).fromNow();
	      }
	    },
	    newMicroNoteCount: function newMicroNoteCount() {
	      return this.html.split('<hr is="divider">').length;
	    }
	  },
	
	  data: function data() {
	    return {
	      html: '',
	      froalaConfig: (0, _assign2.default)({}, _lectureNoteEditor2.default, {
	        height: 'calc(100% - 55px)'
	      }),
	      showReplaceWarning: false,
	      status: null,
	      microNotesToDelete: [],
	      saving: false
	    };
	  },
	
	
	  watch: {
	    microNotes: function microNotes(newMicroNotes, oldMicroNotes) {
	      if (newMicroNotes && newMicroNotes.length > 0) {
	        var html = '';
	        var length = newMicroNotes.length;
	
	        for (var i = 0; i < newMicroNotes.length; i++) {
	          var microNote = newMicroNotes[i];
	          html += microNote.html;
	          if (i < length - 1) {
	            html += '<hr is="divider">';
	          }
	        }
	        this.html = html;
	      } else {
	        this.html = '';
	      }
	    }
	  }
	};

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _microNoteEditor = __webpack_require__(306);
	
	var _microNoteEditor2 = _interopRequireDefault(_microNoteEditor);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	var _microNote = __webpack_require__(19);
	
	var _microNote2 = _interopRequireDefault(_microNote);
	
	var _vuex = __webpack_require__(2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _MicroNoteImageEditor = __webpack_require__(565);
	
	var _MicroNoteImageEditor2 = _interopRequireDefault(_MicroNoteImageEditor);
	
	var _FroalaEditor = __webpack_require__(31);
	
	var _FroalaEditor2 = _interopRequireDefault(_FroalaEditor);
	
	var _KeywordSettings = __webpack_require__(32);
	
	var _KeywordSettings2 = _interopRequireDefault(_KeywordSettings);
	
	var _BoolSwitch = __webpack_require__(34);
	
	var _BoolSwitch2 = _interopRequireDefault(_BoolSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    FroalaEditor: _FroalaEditor2.default,
	    MicroNoteImageEditor: _MicroNoteImageEditor2.default,
	    KeywordSettings: _KeywordSettings2.default,
	    BoolSwitch: _BoolSwitch2.default
	  },
	
	  created: function created() {
	    this.getChapters();
	    this.getMicroNotes();
	  },
	
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getMicroNotes', 'getChapters']), {
	    nextMicroNote: function nextMicroNote() {
	      var nextIndex = this.currentMicroNoteIndex + 1;
	      if (!this.microNotes[nextIndex]) nextIndex = 0;
	      this.currentMicroNoteIndex = nextIndex;
	    },
	    previousMicroNote: function previousMicroNote() {
	      var nextIndex = this.currentMicroNoteIndex - 1;
	      if (!this.microNotes[nextIndex]) nextIndex = this.microNotes.length - 1;
	      this.currentMicroNoteIndex = nextIndex;
	    },
	    toggleDeleteWarning: function toggleDeleteWarning() {
	      this.showDeleteWarning = !this.showDeleteWarning;
	    },
	    deleteMicroNote: function deleteMicroNote() {
	      var _this = this;
	
	      this.$store.dispatch('deleteMicroNote', { micronote: this.microNote, callback: function callback(err) {
	          if (err) {
	            Toast.error(err);
	          } else {
	            Toast.success('Micro note deleted');
	            _this.toggleDeleteWarning();
	            if (_this.microNotes.length > 0) {
	              _this.nextMicroNote();
	            } else {
	              _router2.default.push({ name: 'subject-shelf' });
	            }
	          }
	        }
	      });
	    },
	    addMicroNote: function addMicroNote() {
	      var _this2 = this;
	
	      this.status = 'Creating micro note';
	      this.$store.dispatch('createMicroNote', {
	        microNote: {
	          chapter_id: this.chapter.id,
	          html: '<p>Enter your study notes here.</p><p>Keywords display <keyword>like this</keyword>.</p>',
	          micro_note_type: 'html'
	        },
	        callback: function callback(err) {
	          _this2.status = 'saved';
	          _this2.currentMicroNoteIndex = _this2.microNotes.length - 1;
	        }
	      });
	    },
	    saveMicroNote: function saveMicroNote() {
	      var _this3 = this;
	
	      this.status = 'saving';
	      var changes = (0, _assign2.default)({}, this.microNote, { html: this.newHtml, active: this.microNoteActive });
	      this.$store.dispatch('updateMicroNote', {
	        id: this.microNote.id,
	        changes: changes,
	        callback: function callback(err) {
	          _this3.status = 'saved';
	        }
	      });
	    },
	    toggleActive: function toggleActive(value) {
	      this.microNoteActive = value;
	      this.saveMicroNote();
	    }
	  }),
	
	  data: function data() {
	    return {
	      currentMicroNoteIndex: 0,
	      newHtml: '',
	      microNoteActive: true,
	
	      froalaConfig: (0, _assign2.default)({}, _microNoteEditor2.default, {
	        height: 'calc(100% - 55px)'
	      }),
	
	      status: null,
	      showDeleteWarning: false
	    };
	  },
	
	
	  watch: {
	    microNote: function microNote(newMicroNote, oldMicroNote) {
	      var newId = newMicroNote ? newMicroNote.id : null;
	      var oldId = oldMicroNote ? oldMicroNote.id : null;
	
	      if (newId && newId != oldId || !this.newHtml && newMicroNote) {
	        this.newHtml = newMicroNote.html;
	        this.microNoteActive = newMicroNote.active;
	
	        if (this.microNoteActive === null) {
	          this.microNoteActive = true;
	        }
	      }
	    }
	  },
	
	  computed: {
	    statusMessage: function statusMessage() {
	      if (!this.microNote) return '';
	      if (this.status === 'saving') {
	        return 'Saving...';
	      } else if (this.status === 'saved') {
	        return 'Changes saved.';
	      } else {
	        return 'Last saved ' + (0, _moment2.default)(this.microNote.updated_at).fromNow();
	      }
	    },
	    chapter: function chapter() {
	      return this.$store.state.chapters[this.$route.params.chapterId];
	    },
	    editType: function editType() {
	      if (this.$route.params.editType) {
	        return this.$route.params.editType;
	      }
	      return 'all';
	    },
	    microNotes: function microNotes() {
	      var chapterId = parseInt(this.$route.params.chapterId);
	      if (!chapterId) return [];
	      var allMicroNotes = this.$store.getters.allMicroNotes;
	
	      var filter = { chapter_id: chapterId };
	      if (this.editType !== 'all') {
	        filter.micro_note_type = this.editType;
	      }
	      var microNotes = _underscore2.default.where(allMicroNotes, filter);
	      return microNotes;
	    },
	    microNote: function microNote() {
	      if (!this.chapter) return null;
	      if (!_underscore2.default.isArray(this.microNotes)) return null;
	      return this.microNotes[this.currentMicroNoteIndex];
	    }
	  }
	};

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(345);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _lodash = __webpack_require__(30);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	var _microNote = __webpack_require__(19);
	
	var _microNote2 = _interopRequireDefault(_microNote);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ImageKeyword = __webpack_require__(562);
	
	var _ImageKeyword2 = _interopRequireDefault(_ImageKeyword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nextKeywordId = function nextKeywordId(keywords) {
	  var ids = _underscore2.default.map(keywords, function (keyword) {
	    return parseInt(keyword.id);
	  });
	
	  if (!_underscore2.default.isArray(ids) || !ids.length) return 0;
	  return _underscore2.default.max(ids) + 1;
	};
	
	exports.default = {
	  props: ['microNote'],
	
	  components: {
	    ImageKeyword: _ImageKeyword2.default
	  },
	
	  created: function created() {
	    var _this = this;
	
	    this.newKeywords = (0, _lodash.cloneDeep)(this.microNote.keywords);
	
	    $(window).on('resize.microNoteImageEditor', _underscore2.default.debounce(function () {
	      _this.imageDisplayWidth = $('.image-container img').width();
	    }, 200));
	  },
	  mounted: function mounted() {
	    this.imageDisplayWidth = $('.image-container img').width();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.clearListeners();
	  },
	
	
	  methods: {
	    reset: function reset() {
	      console.log('reset!');
	      this.newKeywords = (0, _lodash.cloneDeep)(this.microNote.keywords);
	      this.activeKeywordId = null;
	      this.dragCoords = null;
	      this.status = null;
	      this.imageDisplayWidth = $('.image-container img').width();
	    },
	    handleDeleteKeyword: function handleDeleteKeyword(keyword) {
	      _vue2.default.delete(this.newKeywords, keyword.id);
	    },
	    handleUpdateKeyword: function handleUpdateKeyword(keywordId, changes) {
	      var newKeyword = (0, _assign2.default)({}, this.newKeywords[keywordId], changes);
	      _vue2.default.set(this.newKeywords, keywordId, newKeyword);
	    },
	    handleImageClick: function handleImageClick() {
	      this.activeKeywordId = null;
	      $('.keyword input').blur();
	    },
	    handleKeywordClick: function handleKeywordClick(keyword) {
	      this.activeKeywordId = keyword.id;
	    },
	    validKeyword: function validKeyword(keyword) {
	      if (!keyword) return false;
	      var valid = true;
	
	      var requiredProps = ['x', 'y', 'width', 'height'];
	      _underscore2.default.each(requiredProps, function (prop) {
	        if (!_underscore2.default.has(keyword, prop)) valid = false;
	        if (_underscore2.default.isNaN(keyword[prop])) valid = false;
	      });
	      if (!valid) return false;
	
	      if (keyword.width < this.minKeywordWidth) return false;
	      if (keyword.height < this.minKeywordHeight) return false;
	
	      return true;
	    },
	    addKeyword: function addKeyword(keyword) {
	      if (!this.validKeyword(keyword)) return false;
	      delete keyword.isNew;
	
	      var newId = nextKeywordId(this.newKeywordsArray);
	      _vue2.default.set(this.newKeywords, newId, keyword);
	      this.activeKeywordId = newId;
	    },
	    createKeywordStart: function createKeywordStart(e) {
	      var offset = $(e.target).offset();
	      this.dragCoords = {
	        absoluteStartX: e.pageX,
	        absoluteStartY: e.pageY,
	
	        relativeStartX: e.pageX - offset.left,
	        relativeStartY: e.pageY - offset.top
	      };
	
	      $(window).on('mousemove.microNoteImageEditor', this.createKeywordMouseMove);
	      $(window).on('mouseup.microNoteImageEditor', this.createKeywordEnd);
	    },
	    createKeywordMouseMove: function createKeywordMouseMove(e) {
	      if (!this.dragCoords) return;
	      var offset = $(this.$refs.image).offset();
	      var imageWidth = $(this.$refs.image).width();
	      var imageHeight = $(this.$refs.image).height();
	
	      var relativeEndX = e.pageX - offset.left;
	      var absoluteEndX = e.pageX;
	      if (e.pageX < offset.left) {
	        relativeEndX = 0;
	        absoluteEndX = offset.left;
	      } else if (e.pageX > offset.left + imageWidth) {
	        relativeEndX = imageWidth;
	        absoluteEndX = imageWidth + offset.left;
	      }
	
	      var relativeEndY = e.pageY - offset.top;
	      var absoluteEndY = e.pageY;
	      if (e.pageY < offset.top) {
	        relativeEndY = 0;
	        absoluteEndY = offset.top;
	      } else if (e.pageY > offset.top + imageHeight) {
	        relativeEndY = imageHeight;
	        absoluteEndY = imageHeight + offset.top;
	      }
	
	      _vue2.default.set(this.dragCoords, 'relativeEndX', relativeEndX);
	      _vue2.default.set(this.dragCoords, 'absoluteEndX', absoluteEndX);
	      _vue2.default.set(this.dragCoords, 'relativeEndY', relativeEndY);
	      _vue2.default.set(this.dragCoords, 'absoluteEndY', absoluteEndY);
	    },
	    createKeywordEnd: function createKeywordEnd(e) {
	      this.addKeyword((0, _assign2.default)({}, this.newKeyword));
	      this.dragCoords = null;
	      this.clearListeners();
	    },
	    clearListeners: function clearListeners() {
	      $(window).off('mousemove.microNoteImageEditor');
	      $(window).off('mouseup.microNoteImageEditor');
	      $(window).off('resize.microNoteImageEditor');
	    },
	
	
	    saveChanges: _underscore2.default.debounce(function (keywords) {
	      var _this2 = this;
	
	      this.status = 'saving';
	      var changes = (0, _assign2.default)({}, { keywords: this.newKeywords });
	      this.$store.dispatch('updateMicroNote', {
	        id: this.microNote.id,
	        changes: changes,
	        callback: function callback(err) {
	          if (err) {
	            Toast.error('Failed to save changes');
	            _this2.status = 'error';
	          } else {
	            _this2.status = 'saved';
	          }
	        }
	      });
	    }, 500)
	
	  },
	
	  computed: {
	    statusMessage: function statusMessage() {
	      if (!this.microNote) return '';
	      if (this.status === 'saving') {
	        return 'Saving...';
	      } else if (this.status === 'saved') {
	        return 'Changed saved.';
	      } else if (this.status === 'error') {
	        return 'Failed to save changes';
	      } else {
	        return 'Last saved ' + (0, _moment2.default)(this.microNote.updated_at).fromNow();
	      }
	    },
	    scale: function scale() {
	      if (!this.microNote || !this.imageDisplayWidth || !this.microNote.micro_note_images || !this.microNote.micro_note_images[0].image_width) return 1;
	      return this.imageDisplayWidth / this.microNote.micro_note_images[0].image_width;
	    },
	    newKeyword: function newKeyword() {
	      var _this3 = this;
	
	      if (!this.dragCoords) return null;
	
	      var _dragCoords = this.dragCoords,
	          absoluteStartX = _dragCoords.absoluteStartX,
	          absoluteStartY = _dragCoords.absoluteStartY,
	          absoluteEndX = _dragCoords.absoluteEndX,
	          absoluteEndY = _dragCoords.absoluteEndY,
	          relativeStartX = _dragCoords.relativeStartX,
	          relativeStartY = _dragCoords.relativeStartY,
	          relativeEndX = _dragCoords.relativeEndX,
	          relativeEndY = _dragCoords.relativeEndY;
	
	
	      var newKeyword = {
	        value: '',
	        isNew: true
	      };
	
	      var absXDist = Math.abs(absoluteStartX - absoluteEndX);
	      var absYDist = Math.abs(absoluteStartY - absoluteEndY);
	      newKeyword = {
	        width: absXDist,
	        height: absYDist,
	        x: relativeStartX,
	        y: relativeStartY,
	        value: '',
	        isNew: true
	      };
	
	      if (relativeEndX < relativeStartX) newKeyword.x -= absXDist;
	      if (relativeEndY < relativeStartY) newKeyword.y -= absYDist;
	
	      _underscore2.default.each(['x', 'y', 'width', 'height'], function (prop) {
	        newKeyword[prop] = newKeyword[prop] / _this3.scale;
	      });
	
	      return newKeyword;
	    },
	    newKeywordsArray: function newKeywordsArray() {
	      if (!this.newKeywords) return [];
	
	      var keywords = [];
	      _underscore2.default.map(_underscore2.default.pairs(this.newKeywords), function (pair) {
	        var _pair = (0, _slicedToArray3.default)(pair, 2),
	            id = _pair[0],
	            keyword = _pair[1];
	
	        keyword.id = id;
	        keywords.push(keyword);
	      });
	      return keywords;
	    }
	  },
	
	  data: function data() {
	    return {
	      newKeywords: null,
	      activeKeywordId: null,
	
	      dragCoords: null,
	      minKeywordWidth: 10,
	      minKeywordHeight: 10,
	
	      status: null,
	
	      imageDisplayWidth: null
	    };
	  },
	
	
	  watch: {
	    microNote: function microNote(oldValue, newValue) {
	      var oldId = oldValue ? oldValue.id : null;
	      var newId = newValue ? newValue.id : null;
	      if (oldId !== newId) {
	        this.reset();
	      }
	    },
	
	
	    newKeywords: {
	      deep: true,
	      handler: function handler(newVal, oldVal) {
	        if (!oldVal) return;
	        this.saveChanges();
	      }
	    }
	  }
	
	};

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(2);
	
	exports.default = {
	  components: {},
	
	  mounted: function mounted() {},
	
	  methods: {},
	
	  data: function data() {
	    return {
	      text: "Hello World what's going on!"
	
	    };
	  }
	};

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _NotificationList = __webpack_require__(183);
	
	var _NotificationList2 = _interopRequireDefault(_NotificationList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    NotificationList: _NotificationList2.default
	  },
	
	  data: function data() {
	    return {};
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)({
	    allNotifications: 'allNotifications'
	  })),
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['logout']), {
	    removeNotification: function removeNotification(n) {
	      console.log(n);
	      this.$store.commit('REMOVE_NOTIFICATION', { notification: n });
	    },
	    removeAllNotifications: function removeAllNotifications() {
	      this.$store.commit('REMOVE_ALL_NOTIFICATIONS', {});
	    }
	  })
	
	};

/***/ },
/* 250 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'navbar'
	};

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(2);
	
	var _LoggedInLinks = __webpack_require__(567);
	
	var _LoggedInLinks2 = _interopRequireDefault(_LoggedInLinks);
	
	var _LoggedOutLinks = __webpack_require__(568);
	
	var _LoggedOutLinks2 = _interopRequireDefault(_LoggedOutLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoggedInLinks: _LoggedInLinks2.default,
	    LoggedOutLinks: _LoggedOutLinks2.default
	  },
	
	  data: function data() {
	    return {
	      navLinks: [{ title: 'Features', routeName: 'features' }, { title: 'About CLEX', routeName: 'about-us' }, { title: 'Contact Us', routeName: 'contact-us' }, { title: 'Advertise', routeName: 'advertise' }, { title: 'Blog', routeName: 'blog' }]
	    };
	  },
	
	
	  computed: (0, _vuex.mapState)(['currentUser', 'page'])
	};

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SubscribeForm = __webpack_require__(182);
	
	var _SubscribeForm2 = _interopRequireDefault(_SubscribeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: { SubscribeForm: _SubscribeForm2.default }
	};

/***/ },
/* 253 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      email: '',
	      status: ''
	    };
	  },
	
	  methods: {
	    subscribe: function subscribe() {
	      if (this.email) {
	        this.status = 'saving';
	        var self = this;
	
	        this.$store.dispatch('subscribe', {
	          sub: { email: this.email }, callback: function callback(res) {
	            self.status = '';
	
	            if (res.errors) {
	              Toast.error(res.errors[0]);
	            } else {
	              Toast.success('Thanks! We\'ve added you to our mailing list');
	              self.email = '';
	            }
	          }
	        });
	      }
	    }
	  }
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	
	    this.getAllReceivedShares();
	  },
	  data: function data() {
	    return {};
	  },
	
	
	  props: {
	    showDelete: Boolean
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    allNotifications: 'allNotifications'
	  })),
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)([]), {
	    getAllReceivedShares: function getAllReceivedShares() {
	      var _this = this;
	
	      this.$store.dispatch('getAllReceivedShares', {
	        callback: function callback(error, shares) {
	          _underscore2.default.each(shares, function (share) {
	            var existing = _underscore2.default.where(_this.allNotifications, {
	              itemId: share.id, itemType: 'share'
	            });
	
	            if (existing.length <= 0 && share.accepted !== true) {
	              _this.$store.commit('ADD_NOTIFICATION', {
	                notification: {
	                  id: new Date().getTime(),
	                  message: share.sender_email + ' shared their study notes \'' + share.chapter_name + '\' with you.',
	                  navLocation: 'receive-chapter',
	                  itemId: share.id,
	                  itemType: 'share'
	                }
	              });
	            }
	          });
	        }
	      });
	    },
	    removeNotification: function removeNotification(n) {
	      this.$store.commit('REMOVE_NOTIFICATION', { notification: n });
	    },
	    removeAllNotifications: function removeAllNotifications() {
	      this.$store.commit('REMOVE_ALL_NOTIFICATIONS');
	    }
	  })
	
	};

/***/ },
/* 255 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['text'],
	  computed: {
	    displaytext: function displaytext() {
	      if (this.text) return this.text;
	      return 'Loading...';
	    }
	  }
	};

/***/ },
/* 256 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'subtitle']
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['containerClass'],
	
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {}
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['containerClass'],
	
	  data: function data() {
	    return {};
	  },
	  mounted: function mounted() {}
	};

/***/ },
/* 259 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['toggleBool', 'toggleFunction', 'onText', 'offText'],
	
	  data: function data() {
	    return {
	      switchBool: this.toggleBool
	    };
	  },
	
	  methods: {
	    toggle: function toggle() {
	      this.switchBool = !this.switchBool;
	      this.toggleFunction(this.switchBool);
	    }
	  },
	  watch: {
	    toggleBool: function toggleBool(newVal, oldVal) {
	      this.switchBool = newVal;
	    }
	  }
	};

/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: String,
	      default: ''
	    },
	    placeholder: {
	      type: String
	    }
	  },
	  computed: {
	    showPlaceHolder: function showPlaceHolder() {
	      return this.value === '';
	    }
	  },
	  mounted: function mounted() {
	    this.$refs.editable.innerText = this.value;
	  },
	
	  methods: {
	    onInput: function onInput(e) {
	      this.$emit('input', e.target.innerText);
	    }
	  }
	};

/***/ },
/* 261 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'imageUrl', 'subText'],
	
	  data: function data() {
	    return {};
	  }
	};

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['src', 'reference'],
	
	  data: function data() {
	    return {
	      autoPlay: false
	    };
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    setTimeout(function () {
	      _this.autoPlay = true;
	      _this.handleScroll();
	      window.addEventListener('scroll', _this.handleScroll);
	    }, 1000);
	
	    var self = this;
	    document.getElementById(this.reference).onpause = function () {
	      self.autoPlay = false;
	    };
	  },
	  destroyed: function destroyed() {
	    window.removeEventListener('scroll', this.handleScroll);
	  },
	
	  methods: {
	    handleScroll: function handleScroll() {
	      if (this.autoPlay) {
	        var padding = 100;
	        var scrollTop = $(document).scrollTop();
	        var windowHeight = $(window).height();
	        var height = $('#' + this.reference).height();
	        var top = $('#' + this.reference).offset().top;
	        var bottom = top + height;
	
	        var visible = top < windowHeight + scrollTop - padding && top > scrollTop - height + padding;
	
	        if (visible) {
	          this.$refs[this.reference].play();
	        } else {
	          this.$refs[this.reference].pause();
	        }
	      }
	    }
	  }
	};

/***/ },
/* 263 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 264 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'subtitle']
	};

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  props: ['showhelp'],
	  data: function data() {
	    return {
	      showInstructions: this.showhelp === 'true'
	    };
	  },
	  created: function created() {
	    if (this.$route.query.help) {
	      this.showInstructions = this.$route.query.help;
	    }
	  }
	};

/***/ },
/* 266 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(344);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    data: Array,
	    fields: Array,
	    pageSize: Number,
	    pageNum: Number,
	    onClick: Function,
	    defaultSort: String
	  },
	
	  created: function created() {
	    this.sort.by = this.defaultSort ? this.defaultSort : this.fields[0];
	
	    this.resetPaging();
	  },
	  data: function data() {
	    var _paging;
	
	    return {
	      paging: (_paging = {
	        show: true,
	        pageSize: 0,
	        pageNum: 0,
	        totalCount: 0
	      }, (0, _defineProperty3.default)(_paging, 'totalCount', 0), (0, _defineProperty3.default)(_paging, 'numPages', 0), _paging),
	      sort: {
	        by: '',
	        direction: 'asc'
	      }
	    };
	  },
	
	
	  computed: {
	    cols: function cols() {
	      var cols = [];
	      for (var i = 0; i < this.fields.length; i++) {
	        cols.push({
	          name: this.fields[i].replace(/([A-Z])/g, ' $1').replace(/_/g, ' ').replace(/^./, function (str) {
	            return str.toUpperCase();
	          }),
	          prop: this.fields[i]
	        });
	      }
	      return cols;
	    },
	    rowData: function rowData() {
	      var fields = this.fields;
	
	      var sortedData = this.data;
	      if (this.sort.by) {
	        sortedData = _underscore2.default.sortBy(sortedData, this.sort.by);
	        if (this.sort.direction === 'desc') {
	          sortedData.reverse();
	        }
	      }
	
	      var rows = [];
	
	      var _loop = function _loop() {
	        var d = sortedData[i];
	        var cols = {
	          id: d.id,
	          data: new Array(fields.length)
	        };
	
	        (0, _keys2.default)(d).map(function (key) {
	          if (fields.indexOf(key) >= 0) {
	            cols.data[fields.indexOf(key)] = d[key];
	          }
	        });
	
	        rows.push(cols);
	      };
	
	      for (var i = 0; i < sortedData.length; i++) {
	        _loop();
	      }
	
	      var from = (this.paging.pageNum - 1) * this.paging.pageSize;
	      var to = this.paging.pageNum * this.paging.pageSize;
	      rows = rows.slice(from, to);
	
	      return rows;
	    }
	  },
	
	  methods: {
	    resetPaging: function resetPaging() {
	      var _paging2;
	
	      this.paging = (_paging2 = {
	        show: true,
	        pageSize: this.pageSize || 12,
	        pageNum: this.pageNum || 1,
	        totalCount: this.data.length
	      }, (0, _defineProperty3.default)(_paging2, 'totalCount', 0), (0, _defineProperty3.default)(_paging2, 'numPages', 0), _paging2);
	
	      this.paging.totalCount = this.data.length;
	      this.paging.numPages = this.paging.totalCount > 0 ? Math.ceil(this.paging.totalCount / this.paging.pageSize) : 0;
	      this.paging.show = this.paging.numPages > 1;
	    },
	    nextPage: function nextPage() {
	      if (this.paging.pageNum < this.paging.numPages) {
	        this.paging.pageNum += 1;
	      }
	    },
	    prevPage: function prevPage() {
	      if (this.paging.pageNum > 1) {
	        this.paging.pageNum -= 1;
	      }
	    },
	    changePage: function changePage(p) {
	      this.paging.pageNum = p;
	    },
	    changeSort: function changeSort(prop) {
	      this.sort.direction = prop === this.sort.by ? this.sort.direction === 'asc' ? 'desc' : 'asc' : 'asc';
	      this.sort.by = prop;
	    }
	  },
	  watch: {
	    data: function data(val) {
	      this.resetPaging();
	    }
	  }
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	
	  mounted: function mounted() {
	    window.leftSidebarInit();
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)({
	    receivedShares: 'receivedShares'
	  }), {
	    studyProgressPercent: function studyProgressPercent() {
	      if (!this.totalNotesCount) return null;
	      return Math.round(this.completedNotesCount / this.totalNotesCount * 100);
	    },
	    completedNotesCount: function completedNotesCount() {
	      if (!this.totalNotesCount) return 0;
	      var unstudiedMicroNotes = this.$store.getters.unstudiedMicroNotes;
	      return _underscore2.default.isArray(unstudiedMicroNotes) ? this.totalNotesCount - unstudiedMicroNotes.length : 0;
	    },
	    totalNotesCount: function totalNotesCount() {
	      var allMicroNotes = this.$store.getters.allMicroNotes;
	      return _underscore2.default.isArray(allMicroNotes) ? allMicroNotes.length : 0;
	    },
	    showAdmin: function showAdmin() {
	      return this.currentUser.role === 'admin';
	    },
	    showImport: function showImport() {
	      return this.currentUser.role !== 'student';
	    },
	    showBlogger: function showBlogger() {
	      return this.currentUser.role === 'blogger';
	    }
	  })
	
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	    this.getCourses();
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getCourses']), {
	    register: function register() {
	      this.$store.commit('CLEAR_USER_ERRORS');
	      if (this.selectedSchoolId > 0 && !this.newUser.course_id) {
	        Toast.error('Course is required when you select a school');
	      } else {
	        this.$store.dispatch('register', this.newUser);
	      }
	    },
	    schoolChanged: function schoolChanged() {
	      if (this.selectedSchoolId === 0) {
	        this.newUser.course_id = null;
	        this.newUser.role = null;
	      } else {
	        if (this.allCourses.length) {
	          this.newUser.course_id = this.allCourses[0].id;
	        }
	        this.newUser.role = this.roles[0].id;
	      }
	    }
	  }),
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)({
	    allCourses: 'allCourses'
	  })),
	
	  data: function data() {
	    return {
	      newUser: {
	        first_name: null,
	        last_name: null,
	        email: null,
	        password: null,
	        password_confirmation: null,
	        role: null,
	        course_id: null
	      },
	      selectedSchoolId: 0,
	      schools: [{ id: 1, name: 'IHN - Institute of Holistic Nutrition' }],
	      roles: [{ id: 'student', name: 'Student' }, { id: 'teacher', name: 'Teacher' }]
	    };
	  }
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _InnerBanner = __webpack_require__(185);
	
	var _InnerBanner2 = _interopRequireDefault(_InnerBanner);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InnerBanner: _InnerBanner2.default
	  }
	};

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _subject = __webpack_require__(55);
	
	var _subject2 = _interopRequireDefault(_subject);
	
	var _SubjectShelfSubject = __webpack_require__(582);
	
	var _SubjectShelfSubject2 = _interopRequireDefault(_SubjectShelfSubject);
	
	var _NotificationList = __webpack_require__(183);
	
	var _NotificationList2 = _interopRequireDefault(_NotificationList);
	
	var _vuex = __webpack_require__(2);
	
	var _vueClickaway = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SubjectShelfSubject: _SubjectShelfSubject2.default,
	    NotificationList: _NotificationList2.default
	  },
	
	  created: function created() {
	    this.getSubjects();
	    this.getChapters();
	    this.getMicroNotes();
	  },
	
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['getSubjects', 'getChapters', 'getMicroNotes'])),
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)({
	    subjects: 'allSubjects',
	    allNotifications: 'allNotifications'
	  }), {
	    showImport: function showImport() {
	      return this.currentUser.role !== 'student';
	    }
	  })
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _vueClickaway = __webpack_require__(48);
	
	var _momentTimezone = __webpack_require__(71);
	
	var _momentTimezone2 = _interopRequireDefault(_momentTimezone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['chapter'],
	  methods: {
	    deleteChapter: function deleteChapter(chapter) {
	      this.$store.dispatch('deleteChapter', { chapter: chapter });
	    },
	    exportChapter: function exportChapter(chapter) {
	      this.$store.dispatch('exportMicroNotes', { fileName: chapter.title, export: { chapter_ids: chapter.id.toString() } });
	    },
	    shareChapter: function shareChapter(chapter) {
	      this.$store.dispatch('exportMicroNotes', { fileName: chapter.title, export: { chapter_ids: chapter.id.toString() } });
	    },
	    startEditingTitle: function startEditingTitle() {
	      if (this.showActions) {
	        this.newTitle = this.chapter.title;
	        this.editingTitle = true;
	      }
	    },
	    cancelEditingTitle: function cancelEditingTitle() {
	      this.editingTitle = false;
	    },
	    finishEditingTitle: function finishEditingTitle() {
	      var _this = this;
	      var changes = { title: this.newTitle };
	      this.$store.dispatch('updateChapter', { id: this.chapter.id, changes: changes }).then(function () {
	        _this.editingTitle = false;
	        _this.newTitle = '';
	      });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), {
	    friendlyLastStudiedAt: function friendlyLastStudiedAt() {
	      if (!this.chapter.last_studied_at) return 'Never';
	      return (0, _momentTimezone2.default)(this.chapter.last_studied_at).fromNow();
	    },
	    studyProgressPercent: function studyProgressPercent() {
	      if (this.activeMicroNoteCount <= 0) {
	        return 0;
	      }
	      return Math.round((this.activeMicroNoteCount - this.unstudiedMicroNotesCount) / this.activeMicroNoteCount * 100);
	    },
	    unstudiedMicroNotesCount: function unstudiedMicroNotesCount() {
	      if (!this.chapter.micro_notes_count) return 0;
	      var unstudiedMicroNotes = this.$store.getters.unstudiedMicroNotes;
	      unstudiedMicroNotes = _underscore2.default.where(unstudiedMicroNotes, { chapter_id: this.chapter.id });
	      return _underscore2.default.isArray(unstudiedMicroNotes) ? unstudiedMicroNotes.length : 0;
	    },
	    activeMicroNoteCount: function activeMicroNoteCount() {
	      if (!this.chapter.micro_notes_count) return 0;
	      var activeMicroNotes = this.$store.getters.activeMicroNotes;
	      activeMicroNotes = _underscore2.default.where(activeMicroNotes, { chapter_id: this.chapter.id });
	      return _underscore2.default.isArray(activeMicroNotes) ? activeMicroNotes.length : 0;
	    },
	    showActions: function showActions() {
	      return this.currentUser.role !== 'student';
	    }
	  }),
	
	  data: function data() {
	    return {
	      editingTitle: false,
	      newTitle: ''
	    };
	  },
	
	  directives: {
	    onClickAway: _vueClickaway.directive,
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  }
	
	};

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _SubjectShelfChapterRow = __webpack_require__(581);
	
	var _SubjectShelfChapterRow2 = _interopRequireDefault(_SubjectShelfChapterRow);
	
	var _vueClickaway = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['subject'],
	
	  components: {
	    SubjectShelfChapterRow: _SubjectShelfChapterRow2.default
	  },
	
	  methods: {
	    deleteSubject: function deleteSubject(subject) {
	      this.$store.dispatch('deleteSubject', { subject: subject });
	    },
	    toggleExpanded: function toggleExpanded() {
	      this.expanded = !this.expanded;
	    },
	    startEditingTitle: function startEditingTitle() {
	      if (showActions) {
	        this.newTitle = this.subject.title;
	        this.editingTitle = true;
	      }
	    },
	    cancelEditingTitle: function cancelEditingTitle() {
	      this.editingTitle = false;
	    },
	    finishEditingTitle: function finishEditingTitle() {
	      var _this = this;
	      var changes = { title: this.newTitle };
	      this.$store.dispatch('updateSubject', { id: this.subject.id, changes: changes }).then(function () {
	        _this.editingTitle = false;
	        _this.newTitle = '';
	      });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), {
	    chapters: function chapters() {
	      var chapters = _underscore2.default.where(this.$store.getters.allChapters, { subject_id: this.subject.id });
	      return chapters;
	    },
	    showActions: function showActions() {
	      return this.currentUser.role !== 'student';
	    }
	  }),
	
	  data: function data() {
	    return {
	      expanded: true,
	      editingTitle: false,
	      newTitle: ''
	    };
	  },
	
	
	  directives: {
	    onClickAway: _vueClickaway.directive,
	    focus: {
	      inserted: function inserted(el) {
	        el.focus();
	      }
	    }
	  }
	};

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    comment: Object,
	    showDelete: Boolean,
	    blogArticleId: Number
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)({
	    allBlogPosts: 'allBlogPosts'
	  }), {
	    friendlyDate: function friendlyDate() {
	      var d = new Date(this.comment.created_at);
	
	      return d.toLocaleDateString() + ' - ' + d.getHours() + ':' + d.getMinutes();
	    }
	  }),
	  methods: {
	    deleteComment: function deleteComment() {
	      var self = this;
	      this.$store.dispatch('deleteComment', {
	        comment: this.comment, callback: function callback(obj) {
	          self.deleted = true;
	          Toast.success('Comment deleted');
	        }
	      });
	    }
	  },
	
	  data: function data() {
	    return {
	      deleted: false
	    };
	  }
	};

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _BlogComment = __webpack_require__(583);
	
	var _BlogComment2 = _interopRequireDefault(_BlogComment);
	
	var _Editable = __webpack_require__(606);
	
	var _Editable2 = _interopRequireDefault(_Editable);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    comments: Array,
	    articleId: Number,
	    showDelete: Boolean
	  },
	  components: {
	    BlogComment: _BlogComment2.default,
	    Editable: _Editable2.default
	  },
	
	  created: function created() {},
	
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      if (this.commentText) {
	        this.status = 'Submitting...';
	        var create = {
	          comment: {
	            blog_id: this.articleId,
	            body: this.commentText
	          },
	          callback: function callback(comment) {
	            _this.status = '';
	            _this.newComments.push(comment);
	            Toast.success('Comment created');
	          }
	        };
	        this.$store.dispatch('createComment', create);
	      }
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), {
	    filteredComments: function filteredComments() {
	      var com = this.comments.concat(this.newComments);
	      return _underscore2.default.sortBy(com, function (c) {
	        var d = new Date(c.created_at);
	        return d;
	      }).reverse();
	    }
	  }),
	
	  data: function data() {
	    return {
	      commentText: '',
	      newComments: [],
	      status: ''
	    };
	  }
	};

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _BlogListArticle = __webpack_require__(586);
	
	var _BlogListArticle2 = _interopRequireDefault(_BlogListArticle);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BlogListArticle: _BlogListArticle2.default
	  },
	
	  created: function created() {
	    this.$store.dispatch('getBlogPosts');
	  },
	
	
	  methods: {
	    loadMore: function loadMore() {
	      this.showCount += 10;
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([]), {
	    heroPost: function heroPost() {
	      var posts = this.blogPosts;
	      if (posts.length > 0) {
	        return posts[0];
	      } else {
	        return null;
	      }
	    },
	    heroImg: function heroImg() {
	      if (!this.heroPost || this.heroPost.blog_images.length <= 0) {
	        return null;
	      } else {
	        return this.heroPost.blog_images[0].image_url;
	      }
	    },
	    heroContent: function heroContent() {
	      if (!this.heroPost) {
	        return '';
	      } else {
	        var html = this.heroPost.content;
	        var div = document.createElement("div");
	        div.innerHTML = html;
	        var text = div.textContent || div.innerText || "";
	        return text;
	      }
	    },
	    blogPosts: function blogPosts() {
	      var posts = this.$store.getters.allBlogPosts;
	      return posts;
	    },
	    showList: function showList() {
	      return this.blogPosts.slice(1, this.showCount);
	    }
	  }),
	
	  data: function data() {
	    return {
	      showCount: 10
	    };
	  }
	};

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    article: Object
	  },
	
	  components: {},
	
	  created: function created() {},
	
	
	  methods: {},
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([]), {
	    content: function content() {
	      var html = this.article.content;
	      var div = document.createElement("div");
	      div.innerHTML = html;
	      var text = div.textContent || div.innerText || "";
	      return text;
	    },
	    image: function image() {
	      if (this.article.blog_images.length > 0) {
	        return this.article.blog_images[0].image_url;
	      }
	      return null;
	    }
	  }),
	
	  data: function data() {
	    return {};
	  }
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {}
	};

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _InnerBanner = __webpack_require__(188);
	
	var _InnerBanner2 = _interopRequireDefault(_InnerBanner);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InnerBanner: _InnerBanner2.default
	  }
	};

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _BlogCommentsList = __webpack_require__(584);
	
	var _BlogCommentsList2 = _interopRequireDefault(_BlogCommentsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BlogCommentsList: _BlogCommentsList2.default
	  },
	  created: function created() {
	    this.$store.dispatch('getBlogPosts');
	    this.checkBlogs();
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)([]), (0, _vuex.mapGetters)({
	    allBlogPosts: 'allBlogPosts'
	  }), {
	    postId: function postId() {
	      return parseInt(this.$route.params.id);
	    },
	    blogArticle: function blogArticle() {
	      if (!this.postId || this.postId <= 0) {
	        _router2.default.push({ name: 'blog' });
	      };
	
	      return _underscore2.default.first(_underscore2.default.where(this.allBlogPosts, { id: this.postId }));
	    },
	    image: function image() {
	      if (this.blogArticle && this.blogArticle.blog_images.length > 0) {
	        return this.blogArticle.blog_images[0].image_url;
	      }
	      return null;
	    }
	  }),
	  methods: {
	    checkBlogs: function checkBlogs() {
	      if (!this.blogArticle) {
	        var self = this;
	        window.setTimeout(function () {
	          self.checkBlogs();
	        }, 500);
	      } else {
	        this.$store.commit('SET_PAGE_TITLE', { title: this.blogArticle.meta_title || this.blogArticle.title });
	        if (this.blogArticle.meta_desc) {
	          this.$store.commit('SET_PAGE_DESCRIPTION', { description: this.blogArticle.meta_desc });
	        }
	      }
	    }
	  }
	};

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _BlogList = __webpack_require__(585);
	
	var _BlogList2 = _interopRequireDefault(_BlogList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BlogList: _BlogList2.default
	  }
	};

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _InquiryForm = __webpack_require__(187);
	
	var _InquiryForm2 = _interopRequireDefault(_InquiryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InquiryForm: _InquiryForm2.default
	  }
	};

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {}
	};

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _InquiryForm = __webpack_require__(187);
	
	var _InquiryForm2 = _interopRequireDefault(_InquiryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InquiryForm: _InquiryForm2.default
	  }
	};

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(2);
	
	var _SubscribeForm = __webpack_require__(604);
	
	var _SubscribeForm2 = _interopRequireDefault(_SubscribeForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    SubscribeForm: _SubscribeForm2.default
	  },
	  data: function data() {
	    return {
	      year: new Date().getFullYear()
	    };
	  }
	};

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	var _QuickLogin = __webpack_require__(599);
	
	var _QuickLogin2 = _interopRequireDefault(_QuickLogin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        QuickLogin: _QuickLogin2.default
	    }
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vueRecaptcha = __webpack_require__(725);
	
	var _vueRecaptcha2 = _interopRequireDefault(_vueRecaptcha);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { VueRecaptcha: _vueRecaptcha2.default },
	  props: ['subject'],
	  methods: {
	    contact: function contact() {
	
	      this.$refs.recaptcha.execute();
	    },
	
	    onCaptchaVerified: function onCaptchaVerified(recaptchaToken) {
	      var _this = this;
	
	      if (!this.values.email) {
	        this.errors.push('Please enter an email address');
	      }
	      if (!this.values.name) {
	        this.errors.push('Please enter your name');
	      }
	      if (!this.values.subject) {
	        this.errors.push('Please enter a subject');
	      }
	
	      if (!this.errors.length) {
	        (function () {
	
	          var self = _this;
	          self.$refs.recaptcha.reset();
	
	          _this.status = "submitting";
	          _this.$store.dispatch('contactus', {
	            form: _this.values,
	            callback: function callback(err) {
	              self.status = "";
	              Toast.success('Inquiry sent successfully');
	            }
	          });
	        })();
	      }
	    },
	    onCaptchaExpired: function onCaptchaExpired() {
	      this.$refs.recaptcha.reset();
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      sitekey: '6Lfh7YQUAAAAAFFo97nwwFbBJcN02XSKS_DxC8Vx',
	      values: {
	        email: null,
	        name: null,
	        telephone: null,
	        body: null,
	        subject: this.subject
	
	      },
	      status: '',
	      errors: []
	    };
	  }
	};

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__(603);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _FooterNav = __webpack_require__(594);
	
	var _FooterNav2 = _interopRequireDefault(_FooterNav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Navbar: _Navbar2.default,
	    FooterNav: _FooterNav2.default
	  }
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	
	  methods: {
	    submit: function submit() {
	      this.$store.commit('CLEAR_USER_ERRORS');
	      this.showSuccess = false;
	      this.saving = true;
	
	      var self = this;
	
	      var payload = {
	        credentials: {
	          email: this.credentials.email,
	          redirect_url: 'http://www.clex.ca/reset-password' },
	        callback: function callback(errors) {
	          self.saving = false;
	          if (!errors) {
	            self.showSuccess = true;
	            self.credentials.email = '';
	          }
	        }
	      };
	
	      this.$store.dispatch('forgotPassword', payload);
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      credentials: {
	        email: null
	      },
	      showSuccess: false,
	      saving: false
	    };
	  }
	};

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	  methods: {
	    login: function login() {
	      var user = {
	        user: {
	          email: this.credentials.email,
	          password: this.credentials.password
	        }
	      };
	
	      if (this.$route.query.redirect) {
	        user.redirect = this.$route.query.redirect;
	      }
	
	      this.$store.dispatch('login', user);
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      credentials: {
	        email: null,
	        password: null
	      }
	    };
	  }
	};

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	  methods: {
	    login: function login() {
	      console.log(this.credentials);
	      this.$store.dispatch('login', { user: {
	          email: this.credentials.email,
	          password: this.credentials.password
	        } });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      credentials: {
	        email: null,
	        password: null
	      }
	    };
	  }
	};

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	
	  methods: {
	    submit: function submit() {
	      this.$store.commit('CLEAR_USER_ERRORS');
	      this.saving = true;
	      var self = this;
	
	      var payload = {
	        credentials: {
	          password: this.credentials.password,
	          password_confirmation: this.credentials.confirmPassword
	        },
	        accessToken: this.accessToken,
	        clientId: this.clientId,
	        uid: this.uid,
	        callback: function callback(errors) {
	          self.saving = false;
	        }
	      };
	
	      this.$store.dispatch('resetPassword', payload);
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), {
	    accessToken: function accessToken() {
	      var urlParams = new URLSearchParams(window.location.search);
	      var myParam = urlParams.get('access-token');
	      return myParam;
	    },
	    clientId: function clientId() {
	      var urlParams = new URLSearchParams(window.location.search);
	      var myParam = urlParams.get('client_id');
	      return myParam;
	    },
	    uid: function uid() {
	      var urlParams = new URLSearchParams(window.location.search);
	      var myParam = urlParams.get('uid');
	      return myParam;
	    },
	    valid: function valid() {
	      if (!this.accessToken || !this.clientId || !this.uid) {
	        return false;
	      }
	      return true;
	    }
	  }),
	
	  data: function data() {
	    return {
	      credentials: {
	        password: null,
	        confirmPassword: null
	      },
	      saving: false
	    };
	  }
	};

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _NotificationList = __webpack_require__(605);
	
	var _NotificationList2 = _interopRequireDefault(_NotificationList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    NotificationList: _NotificationList2.default
	  },
	
	  data: function data() {
	    return {};
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser']), (0, _vuex.mapGetters)({
	    allNotifications: 'allNotifications'
	  })),
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['logout']), {
	    removeNotification: function removeNotification(n) {
	      console.log(n);
	      this.$store.commit('REMOVE_NOTIFICATION', { notification: n });
	    },
	    removeAllNotifications: function removeAllNotifications() {
	      this.$store.commit('REMOVE_ALL_NOTIFICATIONS', {});
	    }
	  })
	
	};

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'navbar'
	};

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(2);
	
	var _LoggedInLinks = __webpack_require__(601);
	
	var _LoggedInLinks2 = _interopRequireDefault(_LoggedInLinks);
	
	var _LoggedOutLinks = __webpack_require__(602);
	
	var _LoggedOutLinks2 = _interopRequireDefault(_LoggedOutLinks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    LoggedInLinks: _LoggedInLinks2.default,
	    LoggedOutLinks: _LoggedOutLinks2.default
	  },
	
	  data: function data() {
	    return {
	      navLinks: [{ title: 'Features', routeName: 'features' }, { title: 'About CLEX', routeName: 'about-us' }, { title: 'Contact Us', routeName: 'contact-us' }, { title: 'Advertise', routeName: 'advertise' }, { title: 'Blog', routeName: 'blog' }]
	    };
	  },
	
	
	  computed: (0, _vuex.mapState)(['currentUser', 'page'])
	};

/***/ },
/* 296 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      email: '',
	      status: ''
	    };
	  },
	
	  methods: {
	    subscribe: function subscribe() {
	      if (this.email) {
	        this.status = 'saving';
	        var self = this;
	
	        this.$store.dispatch('subscribe', {
	          sub: { email: this.email }, callback: function callback(res) {
	            self.status = '';
	
	            if (res.errors) {
	              Toast.error(res.errors[0]);
	            } else {
	              Toast.success('Thanks! We\'ve added you to our mailing list');
	              self.email = '';
	            }
	          }
	        });
	      }
	    }
	  }
	};

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	
	    this.getAllReceivedShares();
	  },
	  data: function data() {
	    return {};
	  },
	
	
	  props: {
	    showDelete: Boolean
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    allNotifications: 'allNotifications'
	  })),
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)([]), {
	    getAllReceivedShares: function getAllReceivedShares() {
	      var _this = this;
	
	      this.$store.dispatch('getAllReceivedShares', {
	        callback: function callback(error, shares) {
	          _underscore2.default.each(shares, function (share) {
	            var existing = _underscore2.default.where(_this.allNotifications, {
	              itemId: share.id, itemType: 'share'
	            });
	
	            if (existing.length <= 0 && share.accepted !== true) {
	              _this.$store.commit('ADD_NOTIFICATION', {
	                notification: {
	                  id: new Date().getTime(),
	                  message: share.sender_email + ' shared their study notes \'' + share.chapter_name + '\' with you.',
	                  navLocation: 'receive-chapter',
	                  itemId: share.id,
	                  itemType: 'share'
	                }
	              });
	            }
	          });
	        }
	      });
	    },
	    removeNotification: function removeNotification(n) {
	      this.$store.commit('REMOVE_NOTIFICATION', { notification: n });
	    },
	    removeAllNotifications: function removeAllNotifications() {
	      this.$store.commit('REMOVE_ALL_NOTIFICATIONS');
	    }
	  })
	
	};

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: {
	      type: String,
	      default: ''
	    },
	    placeholder: {
	      type: String
	    }
	  },
	  computed: {
	    showPlaceHolder: function showPlaceHolder() {
	      return this.value === '';
	    }
	  },
	  mounted: function mounted() {
	    this.$refs.editable.innerText = this.value;
	  },
	
	  methods: {
	    onInput: function onInput(e) {
	      this.$emit('input', e.target.innerText);
	    }
	  }
	};

/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['title', 'imageUrl', 'subText'],
	
	  data: function data() {
	    return {};
	  }
	};

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	  },
	
	  methods: {
	    register: function register() {
	      this.$store.commit('CLEAR_USER_ERRORS');
	      this.$store.dispatch('register', this.newUser);
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      newUser: {
	        first_name: null,
	        last_name: null,
	        email: null,
	        password: null,
	        password_confirmation: null
	      }
	    };
	  }
	};

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _InnerBanner = __webpack_require__(188);
	
	var _InnerBanner2 = _interopRequireDefault(_InnerBanner);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    InnerBanner: _InnerBanner2.default
	  }
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {},
	
	  created: function created() {
	    this.$store.commit('CLEAR_USER_ERRORS');
	    this.user.email = this.currentUser.email;
	    this.user.firstName = this.currentUser.firstName;
	    this.user.lastName = this.currentUser.lastName;
	  },
	
	
	  methods: {
	    save: function save(event) {
	
	      if (!this.user.email) {
	        Toast.error('You must enter an email address');
	        return;
	      }
	
	      if (this.user.password != this.user.password_confirmation) {
	        Toast.error('Password fields must match');
	        return;
	      }
	
	      var changes = { first_name: this.user.firstName, last_name: this.user.lastName };
	      if (this.user.email) {
	        changes.email = this.user.email;
	      }
	      if (this.user.password) {
	        changes.password = this.user.password;
	      }
	
	      this.$store.dispatch('updateUser', {
	        changes: changes,
	        callback: function callback(err) {
	          if (err) {
	            Toast.error(err[0]);
	          } else {
	            Toast.success('Account updated successfully');
	          }
	        }
	      });
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      user: {
	        email: null,
	        password: null,
	        password_confirmation: null,
	        firstName: '',
	        lastName: ''
	      }
	    };
	  }
	};

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(4);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(2);
	
	var _BoolSwitch = __webpack_require__(34);
	
	var _BoolSwitch2 = _interopRequireDefault(_BoolSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    BoolSwitch: _BoolSwitch2.default
	  },
	
	  created: function created() {
	    if (this.currentUser.studySort && this.currentUser.sortOrder) {
	      this.selectedMicroNoteOrder = this.currentUser.studySort + '|' + this.currentUser.sortOrder;
	    }
	    if (this.currentUser.AllowSharing !== undefined) {
	      this.AllowSharing = this.currentUser.AllowSharing;
	    }
	    if (this.currentUser.notifications !== undefined) {
	      this.notifications = this.currentUser.notifications;
	    }
	  },
	
	
	  methods: {
	    saveSettings: function saveSettings(event) {
	      var microNoteOrder = this.selectedMicroNoteOrder.split('|');
	
	      this.$store.dispatch('updateUser', {
	        changes: {
	          studySort: microNoteOrder[0],
	          sortOrder: microNoteOrder[1],
	          AllowSharing: this.AllowSharing,
	          notifications: this.notifications
	        },
	        callback: function callback(err) {
	          Toast.success('Settings updated successfully');
	        }
	      });
	    },
	
	    toggleSharing: function toggleSharing(value) {
	      this.AllowSharing = value;
	    },
	    toggleNotifications: function toggleNotifications(value) {
	      this.notifications = value;
	    }
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['currentUser'])),
	
	  data: function data() {
	    return {
	      selectedMicroNoteOrder: 'created_at|ASC',
	      AllowSharing: true,
	      notifications: true,
	      microNoteOrderOptions: [{ label: 'Creation date, ascending', value: 'created_at|ASC' }, { label: 'Creation date, descending', value: 'created_at|DESC' }, { label: 'Next study date, ascending', value: 'next_study_at|ASC' }, { label: 'Next study date, descending', value: 'next_study_at|DESC' }]
	    };
	  }
	};

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var Dropzone = __webpack_require__(387);
	Dropzone.autoDiscover = false;
	
	exports.default = {
	  props: {
	    id: {
	      type: String,
	      required: true
	    },
	    url: {
	      type: String,
	      required: true
	    },
	    clickable: {
	      type: Boolean,
	      default: true
	    },
	    acceptedFileTypes: {
	      type: String
	    },
	    thumbnailHeight: {
	      type: Number,
	      default: 200
	    },
	    thumbnailWidth: {
	      type: Number,
	      default: 200
	    },
	    showRemoveLink: {
	      type: Boolean,
	      default: true
	    },
	    maxFileSizeInMB: {
	      type: Number,
	      default: 2
	    },
	    maxNumberOfFiles: {
	      type: Number,
	      default: 5
	    },
	    autoProcessQueue: {
	      type: Boolean,
	      default: true
	    },
	    useFontAwesome: {
	      type: Boolean,
	      default: false
	    },
	    useCustomDropzoneOptions: {
	      type: Boolean,
	      default: false
	    },
	    dropzoneOptions: {
	      type: Object
	    }
	  },
	  methods: {
	    removeAllFiles: function removeAllFiles() {
	      this.dropzone.removeAllFiles(true);
	    },
	    processQueue: function processQueue() {
	      this.dropzone.processQueue();
	    }
	  },
	  computed: {
	    cloudIcon: function cloudIcon() {
	      if (this.useFontAwesome) {
	        return '<i class="fa fa-cloud-upload"></i>';
	      } else {
	        return '<i class="material-icons">cloud_upload</i>';
	      }
	    },
	    doneIcon: function doneIcon() {
	      if (this.useFontAwesome) {
	        return '<i class="fa fa-check"></i>';
	      } else {
	        return ' <i class="material-icons">done</i>';
	      }
	    },
	    errorIcon: function errorIcon() {
	      if (this.useFontAwesome) {
	        return '<i class="fa fa-close"></i>';
	      } else {
	        return ' <i class="material-icons">error</i>';
	      }
	    }
	  },
	  mounted: function mounted() {
	    var element = document.getElementById(this.id);
	    if (!this.useCustomDropzoneOptions) {
	      this.dropzone = new Dropzone(element, {
	        clickable: this.clickable,
	        thumbnailWidth: this.thumbnailWidth,
	        thumbnailHeight: this.thumbnailHeight,
	        maxFiles: this.maxNumberOfFiles,
	        maxFilesize: this.maxFileSizeInMB,
	        dictRemoveFile: 'Remove',
	        addRemoveLinks: this.showRemoveLink,
	        acceptedFiles: this.acceptedFileTypes,
	        autoProcessQueue: this.autoProcessQueue,
	        dictDefaultMessage: this.cloudIcon + '<br>Drop files here to upload',
	        previewTemplate: '<div class="dz-preview dz-file-preview">  <div class="dz-image" style="width:' + this.thumbnailWidth + 'px;height:' + this.thumbnailHeight + 'px"><img data-dz-thumbnail /></div>  <div class="dz-details">    <div class="dz-size"><span data-dz-size></span></div>    <div class="dz-filename"><span data-dz-name></span></div>  </div>  <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>  <div class="dz-error-message"><span data-dz-errormessage></span></div>  <div class="dz-success-mark">' + this.doneIcon + ' </div>  <div class="dz-error-mark' + this.errorIcon + '</div></div>'
	      });
	    } else {
	      this.dropzone = new Dropzone(element, this.dropzoneOptions);
	    }
	
	    var vm = this;
	    this.dropzone.on('addedfile', function (file) {
	      console.log(file);
	      vm.$emit('vdropzone-fileAdded', file);
	    });
	
	    this.dropzone.on('removedfile', function (file) {
	      vm.$emit('vdropzone-removedFile', file);
	    });
	
	    this.dropzone.on('success', function (file, response) {
	      vm.$emit('vdropzone-success', file, response);
	    });
	
	    this.dropzone.on('error', function (file, error, xhr) {
	      vm.$emit('vdropzone-error', file, error, xhr);
	    });
	  }
	};

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(30);
	
	var toolbarButtons = ['paragraphFormat', 'bold', 'italic', 'underline', '|', 'formatOL', 'formatUL', '|', 'undo', 'redo', 'html', 'insertImage'];
	
	var config = {
	  toolbarButtons: toolbarButtons,
	  toolbarButtonsMD: toolbarButtons,
	  toolbarButtonsSM: toolbarButtons,
	  toolbarButtonsXS: toolbarButtons,
	  paragraphFormat: { h2: 'Heading 1', h3: 'Heading 2', n: 'Normal' },
	  htmlExecuteScripts: false,
	  pastePlain: true,
	
	  htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
	  htmlAllowedEmptyTags: ['object', 'video'],
	  htmlDoNotWrapTags: ['script', 'style'],
	  htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'alt', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'width', 'wrap'],
	  pasteDeniedTags: ['sup'],
	  shortcutsEnabled: ['show', 'bold', 'italic', 'underline', 'strikeThrough', 'indent', 'outdent', 'undo', 'redo', 'insertImage'],
	
	  imageEditButtons: ['imageAlign', 'imageDisplay', 'imageRemove', '|']
	};
	
	exports.default = config;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _ = __webpack_require__(30);
	
	var toolbarButtons = ['CLEX_Keyword', '|', 'paragraphFormat', 'bold', 'italic', 'underline', '|', 'formatOL', 'formatUL', '|', 'undo', 'redo', 'html', 'insertImage'];
	
	var config = {
	  toolbarButtons: toolbarButtons,
	  toolbarButtonsMD: toolbarButtons,
	  toolbarButtonsSM: toolbarButtons,
	  toolbarButtonsXS: toolbarButtons,
	  paragraphFormat: { h2: 'Heading 1', h3: 'Heading 2', n: 'Normal' },
	  htmlExecuteScripts: false,
	  pastePlain: true,
	
	  htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
	  htmlAllowedEmptyTags: ['object', 'video'],
	  htmlDoNotWrapTags: ['script', 'style'],
	  htmlAllowedAttrs: ['accept', 'accept-charset', 'accesskey', 'action', 'align', 'alt', 'async', 'autocomplete', 'autofocus', 'autoplay', 'autosave', 'background', 'bgcolor', 'border', 'charset', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'color', 'cols', 'colspan', 'content', 'contenteditable', 'contextmenu', 'controls', 'coords', 'data', 'data-.*', 'datetime', 'default', 'defer', 'dir', 'dirname', 'disabled', 'download', 'draggable', 'dropzone', 'enctype', 'for', 'form', 'formaction', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'http-equiv', 'icon', 'id', 'ismap', 'itemprop', 'keytype', 'kind', 'label', 'lang', 'language', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'novalidate', 'open', 'optimum', 'pattern', 'ping', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'reversed', 'rows', 'rowspan', 'sandbox', 'scope', 'scoped', 'scrolling', 'seamless', 'selected', 'shape', 'size', 'sizes', 'span', 'src', 'srcdoc', 'srclang', 'srcset', 'start', 'step', 'summary', 'spellcheck', 'style', 'tabindex', 'target', 'title', 'type', 'translate', 'usemap', 'value', 'valign', 'width', 'wrap'],
	  pasteDeniedTags: ['sup'],
	  shortcutsEnabled: ['show', 'bold', 'italic', 'underline', 'strikeThrough', 'indent', 'outdent', 'undo', 'redo', 'insertImage', 'CLEX_Keyword'],
	
	  imageEditButtons: ['CLEX_ConvertImageToMicroNote', '|', 'imageAlign', 'imageDisplay', 'imageRemove', '|']
	};
	
	config.htmlAllowedTags = config.htmlAllowedTags.concat(['keyword']);
	
	config.htmlAllowedEmptyTags = config.htmlAllowedEmptyTags.concat([]);
	config.htmlDoNotWrapTags = config.htmlDoNotWrapTags.concat(['keyword']);
	config.htmlAllowedAttrs = config.htmlAllowedAttrs.concat([]);exports.default = config;

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	$.FroalaEditor.DEFAULTS = $.extend($.FroalaEditor.DEFAULTS, {
	  myOption: false
	});
	
	$.FroalaEditor.DefineIcon('CLEX_ConvertImageToMicroNote', { NAME: 'object-group' });
	$.FroalaEditor.RegisterCommand('CLEX_ConvertImageToMicroNote', {
	  title: 'Convert Image to Micro Note',
	  focus: true,
	  undo: true,
	  refreshAfterCallback: true,
	
	  callback: function callback() {
	    console.log('CLEX_ConvertImageToMicroNote()');
	    this.events.trigger('clex.convertImageToMicroNote');
	  }
	});
	
	$.FroalaEditor.DefineIcon('CLEX_InsertDivider', { NAME: 'minus' });
	$.FroalaEditor.RegisterCommand('CLEX_InsertDivider', {
	  title: 'Insert Lecture Note Divider',
	  focus: true,
	  undo: true,
	  refreshAfterCallback: true,
	
	  callback: function callback() {
	    console.log('CLEX_InsertDivider()');
	    console.log('selection:');
	    console.log(this.selection.element());
	    this.html.insert('<hr is="divider">');
	  }
	});
	$.FroalaEditor.RegisterShortcut(77, 'CLEX_InsertDivider', '', 'm', true, false);
	$.FroalaEditor.RegisterShortcut(189, '', '', '-', true, false);
	
	$.FroalaEditor.DefineIcon('CLEX_Keyword', { NAME: 'key' });
	$.FroalaEditor.RegisterCommand('CLEX_Keyword', {
	  title: 'Keyword',
	  focus: true,
	  undo: true,
	  refreshAfterCallback: true,
	
	  callback: function callback(buttonName) {
	    var elem = this.selection.element();
	    var selectionText = this.selection.text().trim();
	
	    var padStart = this.selection.text().startsWith(' ');
	    var padEnd = this.selection.text().endsWith(' ');
	
	    var isActive = isWithinTag('keyword', elem);
	
	
	    if (isActive) {
	      $(elem).closest('keyword').contents().unwrap();
	    } else {
	      if (!selectionText) return;
	
	
	      this.html.insert((padStart ? ' ' : '') + '<keyword>' + selectionText + '</keyword>' + (padEnd ? ' ' : ''));
	    }
	  },
	  refresh: function refresh($btn) {
	    var elem = this.selection.element();
	    var isActive = isWithinTag('keyword', elem);
	    $btn.toggleClass('fr-active', isActive);
	  }
	});
	$.FroalaEditor.RegisterShortcut(75, 'CLEX_Keyword', '', 'k', true, false);
	
	var isWithinTag = function isWithinTag(tagName, elem) {
	  return $(elem).closest(tagName).length > 0;
	};

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.directive('scrollInViewWhen', {
	  update: function update(el, binding, vnode, oldVnode) {
	    if (!binding.value) return;
	
	    var $el = $(el);
	    var halfHeight = $(window).height() / 2;
	
	    var newScrollTop = $el.offset().top - halfHeight;
	
	
	    $('html, body').animate({
	      scrollTop: newScrollTop + 'px'
	    });
	  }
	});

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var acceptShare = _vue2.default.resource('shares{/id}/accept');
	
	exports.default = acceptShare;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _auth = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.http.options.root = ("https://api.clexstudy.com/api/v1");
	
	_vue2.default.http.interceptors.push(function (request, next) {
	  _auth.authHeaders.forEach(function (headerItem) {
	    if (!request.headers.hasOwnProperty(headerItem)) {
	      var storedVal = localStorage.getItem(headerItem);
	      if (storedVal) request.headers.set(headerItem, storedVal);
	    }
	  });
	
	  next(function (response) {
	    console.log(response);
	  });
	});

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var contact = _vue2.default.resource('messages{/id}');
	
	exports.default = contact;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var course = _vue2.default.resource('courses{/id}');
	
	exports.default = course;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var ad = _vue2.default.resource('admin/ads/display{/id}');
	
	exports.default = ad;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var exportSubscribers = _vue2.default.resource('newsletters/export{/id}');
	
	exports.default = exportSubscribers;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var microNoteExport = _vue2.default.resource('micro_notes/export{/id}');
	
	exports.default = microNoteExport;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var newsletterSub = _vue2.default.resource('newsletters{/id}');
	
	exports.default = newsletterSub;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var newsletterUnSub = _vue2.default.resource('newsletters/remove{/id}');
	
	exports.default = newsletterUnSub;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var share = _vue2.default.resource('shares{/id}');
	
	exports.default = share;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var exportUsers = _vue2.default.resource('admin/reports{/id}');
	
	exports.default = exportUsers;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(6);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueResource2.default);
	
	var userSearch = _vue2.default.resource('shares/user_search{/id}');
	
	exports.default = userSearch;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueEasyToast = __webpack_require__(510);
	
	var _vueEasyToast2 = _interopRequireDefault(_vueEasyToast);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueEasyToast2.default);
	
	var toast = {
	  success: function success(str) {
	    _vue2.default.toast(str, { className: 'et-info' });
	  },
	  info: function info(str) {
	    _vue2.default.toast(str, { className: 'et-info' });
	  },
	  warn: function warn(str) {
	    _vue2.default.toast(str, { className: 'et-warn' });
	  },
	  error: function error(str) {
	    _vue2.default.toast(str, { className: 'et-alert' });
	  },
	  warning: function warning(str) {
	    this.warn(str);
	  },
	  danger: function danger(str) {
	    this.error(str);
	  }
	};
	
	exports.default = toast;

/***/ },
/* 322 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 323 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ad = __webpack_require__(51);
	
	var _ad2 = _interopRequireDefault(_ad);
	
	var _displayAd = __webpack_require__(313);
	
	var _displayAd2 = _interopRequireDefault(_displayAd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  ads: [],
	  displayAds: []
	};
	
	var getters = {
	  allAds: function allAds(state) {
	    return _underscore2.default.values(state.ads);
	  },
	  allDisplayAds: function allDisplayAds(state) {
	    return _underscore2.default.values(state.displayAds);
	  }
	};
	
	var actions = {
	  getAds: function getAds(context) {
	    _ad2.default.query({}).then(function (res) {
	      context.commit('RETRIEVE_AD_SUCCESS', { ads: res.data });
	    }, function (res) {
	      Toast.error('Failed to retrieve ads');
	    });
	  },
	  getDisplayAds: function getDisplayAds(context) {
	    console.log('Fetching display ads...');
	    _displayAd2.default.query({}).then(function (res) {
	      context.commit('RETRIEVE_DISPLAY_AD_SUCCESS', { ads: res.data });
	    }, function (res) {
	      Toast.error('Failed to retrieve display ads');
	    });
	  },
	  deleteAd: function deleteAd(context, payload) {
	    _ad2.default.delete({ id: payload.ad.id }).then(function (res) {
	      context.commit('DELETE_AD_SUCCESS', { ad: payload.ad });
	    }, function (res) {
	      Toast.error('Failed to delete ad');
	    });
	  },
	  updateAd: function updateAd(context, payload) {
	    _ad2.default.update({ id: payload.id }, payload.changes).then(function (res) {
	      context.commit('UPDATE_AD_SUCCESS', { ad: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to save ad');
	    });
	  },
	  createAd: function createAd(context, payload) {
	    _ad2.default.save(payload.ad).then(function (res) {
	      context.commit('CREATE_AD_SUCCESS', { ad: res.data });
	    }, function (res) {
	      Toast.error('Failed to create ad');
	    });
	  }
	};
	
	var mutations = {
	  RETRIEVE_AD_SUCCESS: function RETRIEVE_AD_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.ads, function (ad) {
	      _vue2.default.set(state.ads, ad.id, ad);
	    });
	  },
	  RETRIEVE_DISPLAY_AD_SUCCESS: function RETRIEVE_DISPLAY_AD_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.ads, function (ad) {
	      _vue2.default.set(state.displayAds, ad.id, ad);
	    });
	  },
	  DELETE_AD_SUCCESS: function DELETE_AD_SUCCESS(state, payload) {
	    _vue2.default.delete(state.ads, payload.ad.id);
	  },
	  UPDATE_AD_SUCCESS: function UPDATE_AD_SUCCESS(state, payload) {
	    _vue2.default.set(state.ads, payload.ad.id, payload.ad);
	  },
	  CREATE_AD_SUCCESS: function CREATE_AD_SUCCESS(state, payload) {
	    _vue2.default.set(state.ads, payload.ad.id, payload.ad);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _blog = __webpack_require__(35);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {
	  allBlogPosts: function allBlogPosts(state) {
	    return _underscore2.default.values(state);
	  }
	};
	
	var actions = {
	  getBlogPosts: function getBlogPosts(context) {
	    _blog2.default.query({}).then(function (res) {
	      context.commit('RETRIEVE_BLOGPOSTS_SUCCESS', { blogPosts: res.data });
	    }, function (res) {
	      Toast.error('Failed to retrieve blog posts');
	    });
	  },
	  deleteBlogPost: function deleteBlogPost(context, payload) {
	    _blog2.default.delete({ id: payload.blogPost.id }).then(function (res) {
	      context.commit('DELETE_BLOGPOST_SUCCESS', { blogPost: payload.blogPost });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to delete blog post');
	    });
	  },
	  updateBlogPost: function updateBlogPost(context, payload) {
	    _blog2.default.update({ id: payload.id }, payload.changes).then(function (res) {
	      context.commit('UPDATE_BLOGPOST_SUCCESS', { blogPost: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to save blog post');
	    });
	  },
	  createBlogPost: function createBlogPost(context, payload) {
	    _blog2.default.save(payload.blogPost).then(function (res) {
	      context.commit('CREATE_BLOGPOST_SUCCESS', { blogPost: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(res.data);
	    }, function (res) {
	      Toast.error('Failed to create blog post');
	    });
	  }
	};
	
	var mutations = {
	  RETRIEVE_BLOGPOSTS_SUCCESS: function RETRIEVE_BLOGPOSTS_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.blogPosts, function (post) {
	      _vue2.default.set(state, post.id, post);
	    });
	  },
	  DELETE_BLOGPOST_SUCCESS: function DELETE_BLOGPOST_SUCCESS(state, payload) {
	    _vue2.default.delete(state, payload.blogPost.id);
	  },
	  UPDATE_BLOGPOST_SUCCESS: function UPDATE_BLOGPOST_SUCCESS(state, payload) {
	    _vue2.default.set(state, payload.blogPost.id, payload.blogPost);
	  },
	  CREATE_BLOGPOST_SUCCESS: function CREATE_BLOGPOST_SUCCESS(state, payload) {}
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _share = __webpack_require__(318);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _acceptShare = __webpack_require__(309);
	
	var _acceptShare2 = _interopRequireDefault(_acceptShare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  retrievedShares: [],
	  selectedShareImportIds: []
	};
	
	var getters = {
	  receivedShares: function receivedShares(state) {
	    return _underscore2.default.values(state.retrievedShares);
	  },
	  selectedShareImportIds: function selectedShareImportIds(state) {
	    if (!state.selectedShareImportIds) return [];
	    return state.selectedShareImportIds;
	  }
	};
	
	var actions = {
	  shareChapter: function shareChapter(context, payload) {
	    _share2.default.save(payload.share).then(function (res) {
	      context.commit('CREATE_SHARE_SUCCESS', { result: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(null, res.data);
	    }, function (res) {
	      Toast.error('Failed to share with ' + payload.share.recipient_uid + ': ' + res.body.errors[0]);
	    });
	  },
	  getAllReceivedShares: function getAllReceivedShares(context, props) {
	    _share2.default.query({ recipient: true }).then(function (res) {
	      context.commit('RETRIEVE_RECEIVED_SHARES_SUCCESS', { shares: res.data });
	      if (props && _underscore2.default.isFunction(props.callback)) props.callback(null, res.data);
	    }, function (res) {
	      Toast.error('Failed to retrieve shares');
	    });
	  },
	  getAllSentShares: function getAllSentShares(context, props) {
	    _share2.default.query({ sender: true }).then(function (res) {
	      context.commit('RETRIEVE_SENT_SHARES_SUCCESS', { shares: res.data });
	      if (props && _underscore2.default.isFunction(props.callback)) props.callback(null, res.data);
	    }, function (res) {
	      Toast.error('Failed to retrieve shares');
	    });
	  },
	  acceptShare: function acceptShare(context, payload) {
	    _acceptShare2.default.save({ id: payload.share.id }).then(function (res) {
	      context.commit('ACCEPT_SHARE_SUCCESS', { share: payload.share });
	      if (payload && _underscore2.default.isFunction(payload.callback)) payload.callback(null, res.data);
	    }, function (res) {
	      Toast.error('Failed to retrieve shares');
	    });
	  },
	  deleteShare: function deleteShare(context, payload) {
	    _share2.default.delete({ id: payload.id }).then(function (res) {
	      context.commit('REMOVE_RECEIVED_SHARE', { id: payload.id });
	      context.commit('REMOVE_SHARE_FROM_IMPORT', { id: payload.id });
	    }, function (res) {
	      Toast.error('Failed to delete share');
	    });
	  },
	  addShareToSelected: function addShareToSelected(context, payload) {
	    if (!payload.share) {
	      return;
	    }
	    context.commit('ADD_SHARE_TO_IMPORT', payload);
	  },
	  removeShareFromSelected: function removeShareFromSelected(context, payload) {
	    if (!payload.share) {
	      return;
	    }
	    context.commit('REMOVE_SHARE_FROM_IMPORT', { id: payload.share.id });
	  }
	};
	
	var mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    for (var prop in state.retrievedShares) {
	      _vue2.default.delete(state, prop);
	    }
	  },
	  CREATE_SHARE_SUCCESS: function CREATE_SHARE_SUCCESS(state, payload) {},
	  RETRIEVE_RECEIVED_SHARES_SUCCESS: function RETRIEVE_RECEIVED_SHARES_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.shares, function (share) {
	      if (!share.accepted) {
	        _vue2.default.set(state.retrievedShares, share.id, share);
	      }
	    });
	  },
	  RETRIEVE_SENT_SHARES_SUCCESS: function RETRIEVE_SENT_SHARES_SUCCESS(state, payload) {},
	  REMOVE_RECEIVED_SHARE: function REMOVE_RECEIVED_SHARE(state, payload) {
	
	    _vue2.default.delete(state.retrievedShares, payload.id);
	  },
	  REMOVE_ALL_RECEIVED_SHARES: function REMOVE_ALL_RECEIVED_SHARES(state, payload) {
	    for (var prop in state.retrievedShares) {
	      _vue2.default.delete(state.retrievedShares, prop);
	    }
	  },
	  ACCEPT_SHARE_SUCCESS: function ACCEPT_SHARE_SUCCESS(state, payload) {
	    _vue2.default.delete(state.retrievedShares, payload.share.id);
	  },
	  ADD_SHARE_TO_IMPORT: function ADD_SHARE_TO_IMPORT(state, payload) {
	    if (!payload.share) {
	      return;
	    }
	    var share = payload.share;
	    state.selectedShareImportIds.push(share.id);
	  },
	  REMOVE_SHARE_FROM_IMPORT: function REMOVE_SHARE_FROM_IMPORT(state, payload) {
	    if (!payload.id) {
	      return;
	    }
	    var id = payload.id;
	    state.selectedShareImportIds = _underscore2.default.difference(state.selectedShareImportIds, [id]);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {
	  allChapters: function allChapters(state) {
	    return _underscore2.default.values(state);
	  }
	};
	
	var actions = {
	  getChapters: function getChapters(context) {
	    console.log('Fetching chapters...');
	    _chapter2.default.query({}).then(function (res) {
	      context.commit('RETRIEVE_CHAPTERS_SUCCESS', { chapters: res.data });
	    }, function (res) {
	      Toast.error('Failed to retrieve chapters');
	    });
	  },
	  deleteChapter: function deleteChapter(context, payload) {
	    _chapter2.default.delete({ id: payload.chapter.id }).then(function (res) {
	      context.commit('DELETE_CHAPTER_SUCCESS', { chapter: payload.chapter });
	    }, function (res) {
	      Toast.error('Failed to delete chapter');
	    });
	  },
	  updateChapter: function updateChapter(context, payload) {
	    _chapter2.default.update({ id: payload.id }, payload.changes).then(function (res) {
	      context.commit('UPDATE_CHAPTER_SUCCESS', { chapter: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to save chapter');
	    });
	  }
	};
	
	var mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    for (var prop in state) {
	      _vue2.default.delete(state, prop);
	    }
	  },
	  RETRIEVE_CHAPTERS_SUCCESS: function RETRIEVE_CHAPTERS_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.chapters, function (chapter) {
	      _vue2.default.set(state, chapter.id, chapter);
	    });
	  },
	  DELETE_CHAPTER_SUCCESS: function DELETE_CHAPTER_SUCCESS(state, payload) {
	    _vue2.default.delete(state, payload.chapter.id);
	  },
	  UPDATE_CHAPTER_SUCCESS: function UPDATE_CHAPTER_SUCCESS(state, payload) {
	    _vue2.default.set(state, payload.chapter.id, payload.chapter);
	  },
	  CREATE_CHAPTER_SUCCESS: function CREATE_CHAPTER_SUCCESS(state, payload) {
	    _vue2.default.set(state, payload.chapter.id, payload.chapter);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _comment = __webpack_require__(52);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {
	  allComments: function allComments(state) {
	    return _underscore2.default.values(state);
	  }
	};
	
	var actions = {
	  getComments: function getComments(context) {
	    _comment2.default.query({}).then(function (res) {
	      context.commit('RETRIEVE_COMMENTS_SUCCESS', { comments: res.data });
	    }, function (res) {
	      Toast.error('Failed to retrieve comments');
	    });
	  },
	  deleteComment: function deleteComment(context, payload) {
	    _comment2.default.delete({ id: payload.comment.id }).then(function (res) {
	      context.commit('DELETE_COMMENT_SUCCESS', { comment: payload.comment });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to delete comment');
	    });
	  },
	  updateComment: function updateComment(context, payload) {
	    _comment2.default.update({ id: payload.id }, payload.changes).then(function (res) {
	      context.commit('UPDATE_COMMENT_SUCCESS', { comment: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to save comment');
	    });
	  },
	  createComment: function createComment(context, payload) {
	    _comment2.default.save(payload.comment).then(function (res) {
	      context.commit('CREATE_COMMENT_SUCCESS', { comment: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(res.data);
	    }, function (res) {
	      Toast.error('Failed to create comment');
	    });
	  }
	};
	
	var mutations = {
	  RETRIEVE_COMMENTS_SUCCESS: function RETRIEVE_COMMENTS_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.comments, function (comment) {
	      _vue2.default.set(state, comment.id, comment);
	    });
	  },
	  DELETE_COMMENT_SUCCESS: function DELETE_COMMENT_SUCCESS(state, payload) {
	    console.log(payload);
	    _vue2.default.delete(state, payload.comment.id);
	  },
	  UPDATE_COMMENT_SUCCESS: function UPDATE_COMMENT_SUCCESS(state, payload) {
	    _vue2.default.set(state, payload.comment.id, payload.comment);
	  },
	  CREATE_COMMENT_SUCCESS: function CREATE_COMMENT_SUCCESS(state, payload) {
	    _vue2.default.set(state, payload.comment.id, payload.comment);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _course = __webpack_require__(312);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  courses: []
	};
	
	var getters = {
	  allCourses: function allCourses(state) {
	    return _underscore2.default.values(state.courses);
	  }
	};
	
	var actions = {
	  getCourses: function getCourses(context) {
	    _course2.default.query({}).then(function (res) {
	      context.commit('RETRIEVE_COURSE_SUCCESS', { courses: res.data });
	    }, function (res) {
	      Toast.error('Failed to retrieve courses');
	    });
	  },
	  deleteCourse: function deleteCourse(context, payload) {
	    _course2.default.delete({ id: payload.course.id }).then(function (res) {
	      context.commit('DELETE_COURSE_SUCCESS', { course: payload.course });
	    }, function (res) {
	      Toast.error('Failed to delete course');
	    });
	  },
	  updateCourse: function updateCourse(context, payload) {
	    _course2.default.update({ id: payload.id }, payload.changes).then(function (res) {
	      context.commit('UPDATE_COURSE_SUCCESS', { course: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to save course');
	    });
	  },
	  createCourse: function createCourse(context, payload) {
	    _course2.default.save(payload.course).then(function (res) {
	      context.commit('CREATE_COURSE_SUCCESS', { course: res.data });
	    }, function (res) {
	      Toast.error('Failed to create course');
	    });
	  }
	};
	
	var mutations = {
	  RETRIEVE_COURSE_SUCCESS: function RETRIEVE_COURSE_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.courses, function (course) {
	      _vue2.default.set(state.courses, course.id, course);
	    });
	  },
	  DELETE_COURSE_SUCCESS: function DELETE_COURSE_SUCCESS(state, payload) {
	    _vue2.default.delete(state.courses, payload.course.id);
	  },
	  UPDATE_COURSE_SUCCESS: function UPDATE_COURSE_SUCCESS(state, payload) {
	    _vue2.default.set(state.courses, payload.course.id, payload.course);
	  },
	  CREATE_COURSE_SUCCESS: function CREATE_COURSE_SUCCESS(state, payload) {
	    _vue2.default.set(state.courses, payload.course.id, payload.course);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _lectureNote = __webpack_require__(54);
	
	var _lectureNote2 = _interopRequireDefault(_lectureNote);
	
	var _mutationTypes = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {
	  allLectureNotes: function allLectureNotes(state) {
	    return _underscore2.default.values(state);
	  }
	};
	
	var actions = {};
	
	var mutations = (_mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    for (var prop in state) {
	      Vue.delete(state, prop);
	    }
	  }
	}, (0, _defineProperty3.default)(_mutations, _mutationTypes.CREATE_LECTURE_NOTE_SUCCESS, function (state, payload) {}), (0, _defineProperty3.default)(_mutations, _mutationTypes.IMPORT_MICRONOTES_SUCCESS, function (state, payload) {}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _microNoteExport = __webpack_require__(315);
	
	var _microNoteExport2 = _interopRequireDefault(_microNoteExport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utils = {
	  resetState: function resetState(state) {
	    state.exportChapterIds = [];
	    state.includeInactiveMicroNotes = false;
	  }
	};
	
	var state = {};
	utils.resetState(state);
	
	var getters = {
	  selectedExportChapterIds: function selectedExportChapterIds(state, getters, rootState, rootGetters) {
	    if (!state.exportChapterIds) return [];
	    return state.exportChapterIds;
	  },
	  includeInactiveMicroNotes: function includeInactiveMicroNotes(state) {
	    if (!state.includeInactiveMicroNotes) return false;
	    return state.includeInactiveMicroNotes;
	  },
	  microNotesForSelectedChapters: function microNotesForSelectedChapters(state, getters, rootState, rootGetters) {
	    var microNotes = rootGetters.allMicroNotes;
	    microNotes = _underscore2.default.filter(microNotes, function (microNote) {
	      if (!state.includeInactiveMicroNotes && microNote.active === false) return false;
	      return _underscore2.default.contains(state.exportChapterIds, microNote.chapter_id);
	    });
	
	    return _underscore2.default.pluck(microNotes, 'id');
	  }
	};
	
	var actions = {
	  exportMicroNotes: function exportMicroNotes(context, payload) {
	    var ex = payload.export;
	    if (!ex) {
	      return;
	    }
	
	    _microNoteExport2.default.save(ex).then(function (res) {
	      context.commit('EXPORT_MICRONOTES_SUCCESS', { export: res });
	
	      var blob = new Blob([res.body]);
	      var link = document.createElement('a');
	      link.href = window.URL.createObjectURL(blob);
	      link.download = payload.fileName + ".clex";
	      link.click();
	
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to export lecture note');
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(new Error('Failed to export'));
	    });
	  },
	  addChaptersToExport: function addChaptersToExport(context, payload) {
	    if (!payload.chapterIds) {
	      return;
	    }
	    context.commit('ADD_CHAPTERS_TO_EXPORT', payload);
	  },
	  removeChaptersFromExport: function removeChaptersFromExport(context, payload) {
	    if (!payload.chapterIds) {
	      return;
	    }
	    context.commit('REMOVE_CHAPTERS_FROM_EXPORT', payload);
	  }
	};
	
	var mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    utils.resetState(state);
	  },
	  EXPORT_MICRONOTES_SUCCESS: function EXPORT_MICRONOTES_SUCCESS(state, payload) {
	    utils.resetState(state);
	  },
	  ADD_CHAPTERS_TO_EXPORT: function ADD_CHAPTERS_TO_EXPORT(state, payload) {
	    if (!payload.chapterIds) {
	      return;
	    }
	    var chapterIds = payload.chapterIds;
	    state.exportChapterIds = _underscore2.default.union(state.exportChapterIds, chapterIds);
	  },
	  REMOVE_CHAPTERS_FROM_EXPORT: function REMOVE_CHAPTERS_FROM_EXPORT(state, payload) {
	    if (!payload.chapterIds) {
	      return;
	    }
	    var chapterIds = payload.chapterIds;
	    state.exportChapterIds = _underscore2.default.difference(state.exportChapterIds, chapterIds);
	  },
	  SET_INCLUDE_INACTIVE_MICRONOTES: function SET_INCLUDE_INACTIVE_MICRONOTES(state, payload) {
	    state.includeInactiveMicroNotes = payload.includeInactive;
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _microNote = __webpack_require__(19);
	
	var _microNote2 = _interopRequireDefault(_microNote);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {
	  allMicroNotes: function allMicroNotes(state) {
	    return _underscore2.default.values(state);
	  },
	  unstudiedMicroNotes: function unstudiedMicroNotes(state, getters) {
	    var microNotes = getters.allMicroNotes;
	    if (!microNotes) return [];
	
	    var now = (0, _moment2.default)();
	    microNotes = _underscore2.default.filter(microNotes, function (microNote) {
	      if (microNote.active === false) return false;
	      if (!microNote.next_study_at) return true;
	      var inThePast = now.diff(microNote.next_study_at) >= 0;
	      if (inThePast) return true;
	    });
	    return microNotes;
	  },
	  activeMicroNotes: function activeMicroNotes(state, getters) {
	    var microNotes = getters.allMicroNotes;
	    if (!microNotes) return [];
	
	    microNotes = _underscore2.default.filter(microNotes, function (microNote) {
	      return microNote.active !== false;
	    });
	    return microNotes;
	  }
	};
	
	var actions = {
	  createMicroNote: function createMicroNote(context, payload) {
	    payload.microNote.active = true;
	    _microNote2.default.save({ micro_note: payload.microNote }).then(function (res) {
	      context.commit('CREATE_MICRO_NOTE_SUCCESS', { microNote: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(null, res.data);
	    }, function (res) {
	      Toast.error(res.error);
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(new Error(res.error));
	    });
	  },
	  getMicroNotes: function getMicroNotes(context) {
	    console.log('Fetching micro notes...');
	    _microNote2.default.query({}).then(function (res) {
	      context.commit('RETRIEVE_MICRO_NOTES_SUCCESS', { microNotes: res.data });
	    }, function (res) {
	      Toast.error('Failed to retrieve micro notes');
	    });
	  },
	  updateMicroNote: function updateMicroNote(context, payload) {
	    if (!payload.changes) throw new Error('updateMicroNote error: Missing payload.changes');
	
	    if (_underscore2.default.has(payload.changes, 'keywords') && _underscore2.default.isEmpty(payload.changes.keywords)) {
	      payload.changes.keywords = "";
	    }
	
	    _microNote2.default.update({ id: payload.id }, { micro_note: payload.changes }).then(function (res) {
	      context.commit('UPDATE_MICRO_NOTE_SUCCESS', { microNote: res.data });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to save microNote');
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(new Error('Failed to save'));
	    });
	  },
	  deleteMicroNote: function deleteMicroNote(context, payload) {
	    _microNote2.default.delete({ id: payload.micronote.id }).then(function (res) {
	      console.log('deleted ' + payload.micronote.id);
	      context.commit('DELETE_MICRO_NOTE_SUCCESS', { micronote: payload.micronote });
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback();
	    }, function (res) {
	      Toast.error('Failed to delete microNote');
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(new Error('Failed to delete'));
	    });
	  }
	};
	
	var mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    for (var prop in state) {
	      _vue2.default.delete(state, prop);
	    }
	  },
	  CREATE_MICRO_NOTE_SUCCESS: function CREATE_MICRO_NOTE_SUCCESS(state, payload) {
	    var microNote = payload.microNote;
	    _vue2.default.set(state, microNote.id, microNote);
	  },
	  RETRIEVE_MICRO_NOTES_SUCCESS: function RETRIEVE_MICRO_NOTES_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.microNotes, function (microNote) {
	
	      _vue2.default.set(state, microNote.id, microNote);
	    });
	  },
	  DELETE_MICRO_NOTE_SUCCESS: function DELETE_MICRO_NOTE_SUCCESS(state, payload) {
	    _vue2.default.delete(state, payload.micronote.id);
	  },
	  UPDATE_MICRO_NOTE_SUCCESS: function UPDATE_MICRO_NOTE_SUCCESS(state, payload) {
	    _vue2.default.set(state, payload.microNote.id, payload.microNote);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _newsletterSub = __webpack_require__(316);
	
	var _newsletterSub2 = _interopRequireDefault(_newsletterSub);
	
	var _newsletterUnSub = __webpack_require__(317);
	
	var _newsletterUnSub2 = _interopRequireDefault(_newsletterUnSub);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {};
	
	var actions = {
	  subscribe: function subscribe(context, payload) {
	    _newsletterSub2.default.save(payload.sub).then(function (res) {
	      context.commit('NEWSLETTER_SUBSCRIBE_SUCCESS');
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(res.data);
	    }, function (errors) {
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(errors.data);
	    });
	  },
	  unsubscribe: function unsubscribe(context, payload) {
	    _newsletterUnSub2.default.save(payload.sub).then(function (res) {
	      context.commit('NEWSLETTER_UNSUBSCRIBE_SUCCESS');
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(res.data);
	    }, function (errors) {
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(errors.data);
	    });
	  }
	};
	
	var mutations = {
	  NEWSLETTER_SUBSCRIBE_SUCCESS: function NEWSLETTER_SUBSCRIBE_SUCCESS(state, payload) {},
	  NEWSLETTER_UNSUBSCRIBE_SUCCESS: function NEWSLETTER_UNSUBSCRIBE_SUCCESS(state, payload) {}
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _mutationTypes = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {
	  allNotifications: function allNotifications(state) {
	    return _underscore2.default.values(state);
	  }
	};
	
	var actions = {};
	
	var mutations = (_mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    for (var prop in state) {
	      _vue2.default.delete(state, prop);
	    }
	  }
	}, (0, _defineProperty3.default)(_mutations, _mutationTypes.ADD_NOTIFICATION, function (state, payload) {
	  _vue2.default.set(state, payload.notification.id, payload.notification);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.REMOVE_NOTIFICATION, function (state, payload) {
	  _vue2.default.delete(state, payload.notification.id);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.REMOVE_ALL_NOTIFICATIONS, function (state, payload) {
	  for (var prop in state) {
	    _vue2.default.delete(state, prop);
	  }
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.REMOVE_NOTIFICATION_WITH_ITEM, function (state, payload) {
	  var notification = _underscore2.default.where(_underscore2.default.values(state), payload);
	  if (notification.length > 0) {
	    _vue2.default.delete(state, notification[0].id);
	  }
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _mutationTypes = __webpack_require__(20);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _contact = __webpack_require__(311);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  title: null,
	  description: null,
	  keywords: null,
	  sidebarOpen: true,
	  publicNav: true,
	  adArea: ''
	};
	
	var getters = {};
	
	var actions = {
	  contactus: function contactus(context, payload) {
	    _contact2.default.save(payload.form).then(function (res) {
	      Toast.success('Your message was sent successfully.');
	    }, function (res) {
	      Toast.error('Failed to send contact form');
	    });
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_PAGE_TITLE, function (state, payload) {
	  state.title = payload.title;
	  document.title = 'CLEX | ' + payload.title;
	  $('meta[name=title]').remove();
	  if (payload.title) {
	    $('head').append('<meta name="title" content="' + payload.title + '">');
	  }
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_PAGE_DESCRIPTION, function (state, payload) {
	  state.description = payload.description;
	  $('meta[name=description]').remove();
	  if (payload.description) {
	    $('head').append('<meta name="description" content="' + payload.description + '">');
	  }
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_PAGE_KEYWORDS, function (state, payload) {
	  state.keywords = payload.keywords;
	  $('meta[name=keywords]').remove();
	  if (payload.keywords) {
	    $('head').append('<meta name="keywords" content="' + payload.keywords + '">');
	  }
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.OPEN_SIDEBAR, function (state, payload) {
	  state.sidebarOpen = true;
	  $('body').removeClass('be-nosidebar-left');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.CLOSE_SIDEBAR, function (state, payload) {
	  state.sidebarOpen = false;
	  $('body').addClass('be-nosidebar-left');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SHOW_PUBLIC_ELEMS, function (state, payload) {
	  state.publicNav = true;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.HIDE_PUBLIC_ELEMS, function (state, payload) {
	  state.publicNav = false;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_AD_AREA, function (state, payload) {
	  state.adArea = payload.adArea;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(8);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _chapter = __webpack_require__(12);
	
	var _chapter2 = _interopRequireDefault(_chapter);
	
	var _microNote = __webpack_require__(19);
	
	var _microNote2 = _interopRequireDefault(_microNote);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utils = {
	  resetState: function resetState(state) {
	    state.chapterId = null;
	    state.currentMicroNoteIndex = 0;
	    state.currentKeywordUID = null;
	    state.keywords = {};
	  },
	  unansweredKeywords: function unansweredKeywords(state) {
	    var keywords = _underscore2.default.values(state.keywords);
	    var unanswered = _underscore2.default.filter(keywords, function (keyword) {
	      return !keyword.answered;
	    });
	    return unanswered;
	  },
	
	  nextKeyword: function nextKeyword(state) {
	    var unanswered = utils.unansweredKeywords(state);
	    if (!unanswered || !unanswered.length) return null;
	    if (unanswered.length === 1) return unanswered[0];
	
	    var nextKeyword = void 0;
	    var nextKeywordIndex = _underscore2.default.findIndex(unanswered, { _uid: state.currentKeywordUID + 1 });
	    nextKeyword = unanswered[nextKeywordIndex] || unanswered[0];
	    return nextKeyword;
	  },
	
	  answersMatch: function answersMatch(answer1, answer2) {
	    if (!_underscore2.default.isString(answer1) || !_underscore2.default.isString(answer2)) return false;
	    return answer1.toLowerCase().trim() === answer2.toLowerCase().trim();
	  }
	};
	
	var state = {};
	utils.resetState(state);
	
	var getters = {
	  chapter: function chapter(state, getters, rootState, rootGetters) {
	    if (!state.chapterId || !rootState.chapters) return null;
	    return rootState.chapters[state.chapterId];
	  },
	  microNotes: function microNotes(state, getters, rootState, rootGetters) {
	
	    if (!state.chapterId || !_underscore2.default.isArray(rootGetters.allMicroNotes)) return [];
	    var microNotes = _underscore2.default.where(rootGetters.allMicroNotes, { chapter_id: parseInt(state.chapterId) });
	
	    var now = (0, _moment2.default)();
	    microNotes = _underscore2.default.filter(microNotes, function (microNote) {
	      if (microNote.active === false) return false;
	      if (!microNote.next_study_at) return true;
	
	      var inThePast = now.diff(microNote.next_study_at) >= 0;
	      if (inThePast) return true;
	    });
	
	    var sortOrder = 'ASC';
	    var studySort = 'created_at';
	
	    if (rootState.currentUser) {
	      sortOrder = rootState.currentUser.sortOrder;
	      studySort = rootState.currentUser.studySort;
	    }
	
	    var sortInt = sortOrder === 'ASC' ? -1 : 1;
	
	    if (studySort === 'created_at') {
	      microNotes.sort(function (a, b) {
	        if (!a.created_at) return sortInt;
	        if (!b.created_at) return sortInt * -1;
	
	        var diff = (0, _moment2.default)(a.created_at).diff(b.created_at);
	        if (diff < 0) return sortInt;
	        if (diff > 0) return sortInt * -1;
	
	        if (a.id < b.id) return sortInt;else return sortInt * -1;
	      });
	    } else if (studySort === 'next_study_at') {
	      microNotes.sort(function (a, b) {
	        if (!a.next_study_at) return sortInt;
	        if (!b.next_study_at) return sortInt * -1;
	
	        var diff = (0, _moment2.default)(a.next_study_at).diff(b.next_study_at);
	        if (diff < 0) return sortInt;
	        if (diff > 0) return sortInt * -1;
	
	        if (a.id < b.id) return sortInt;else return sortInt * -1;
	      });
	    }
	
	    return microNotes;
	  },
	
	
	  currentMicroNote: function currentMicroNote(state, getters) {
	    if (!getters.microNotes) return null;
	    return getters.microNotes[state.currentMicroNoteIndex];
	  },
	
	  wordbankWords: function wordbankWords(state, getters, rootState, rootGetters) {
	    var microNote = getters.currentMicroNote;
	    if (!microNote) return [];
	    var words = [];
	
	    if (microNote.micro_note_type === 'html') {
	      $(microNote.html).find('keyword').each(function (i, el) {
	        words.push($(el).html());
	      });
	    } else {
	      words = _underscore2.default.map(microNote.keywords, function (keyword) {
	        return keyword.value;
	      });
	    }
	
	    return _underscore2.default.shuffle(words);
	  },
	
	
	  currentKeyword: function currentKeyword(state) {
	    return state.keywords[state.currentKeywordUID];
	  },
	
	  microNoteIsCompleted: function microNoteIsCompleted(state) {
	    var remaining = utils.unansweredKeywords(state).length;
	    if (!remaining) return true;
	  }
	};
	
	var actions = {
	  nextMicroNote: function nextMicroNote(_ref, payload) {
	    var commit = _ref.commit,
	        state = _ref.state,
	        getters = _ref.getters;
	
	    var nextIndex = state.currentMicroNoteIndex + 1;
	    if (!getters.microNotes[nextIndex]) nextIndex = 0;
	    commit('SET_ACTIVE_MICRO_NOTE', { microNoteIndex: nextIndex });
	  },
	  previousMicroNote: function previousMicroNote(_ref2, payload) {
	    var commit = _ref2.commit,
	        state = _ref2.state,
	        getters = _ref2.getters;
	
	    var nextIndex = state.currentMicroNoteIndex - 1;
	    if (!getters.microNotes[nextIndex]) nextIndex = getters.microNotes.length - 1;
	    commit('SET_ACTIVE_MICRO_NOTE', { microNoteIndex: nextIndex });
	  },
	  nextKeyword: function nextKeyword(_ref3) {
	    var commit = _ref3.commit,
	        state = _ref3.state,
	        getters = _ref3.getters;
	
	    var currentKeyword = getters.currentKeyword;
	
	    if (currentKeyword && currentKeyword.answer && !currentKeyword.answered) {
	      commit('UPDATE_KEYWORD', {
	        _uid: currentKeyword._uid,
	        changes: {
	          answered: true,
	          correct: utils.answersMatch(currentKeyword.answer, currentKeyword.realAnswer)
	        }
	      });
	    }
	
	    var nextKeyword = utils.nextKeyword(state);
	    commit('SET_ACTIVE_KEYWORD', { keyword: nextKeyword });
	  },
	  setActiveKeyword: function setActiveKeyword(_ref4, payload) {
	    var commit = _ref4.commit,
	        state = _ref4.state,
	        getters = _ref4.getters;
	
	    var currentKeyword = getters.currentKeyword;
	
	    if (currentKeyword && currentKeyword.answer && !currentKeyword.answered) {
	      commit('UPDATE_KEYWORD', {
	        _uid: currentKeyword._uid,
	        changes: {
	          answered: true,
	          correct: utils.answersMatch(currentKeyword.answer, currentKeyword.realAnswer)
	        }
	      });
	    }
	
	    commit('SET_ACTIVE_KEYWORD', payload);
	  },
	  answerKeyword: function answerKeyword(_ref5, payload) {
	    var commit = _ref5.commit,
	        state = _ref5.state,
	        dispatch = _ref5.dispatch,
	        getters = _ref5.getters;
	
	    var currentKeyword = getters.currentKeyword;
	
	    if (!currentKeyword) {
	      dispatch('nextKeyword');
	      currentKeyword = getters.currentKeyword;
	    }
	
	    var keywordUID = currentKeyword._uid;
	
	    commit('UPDATE_KEYWORD', {
	      _uid: keywordUID,
	      changes: {
	        answer: payload.answer,
	        answered: payload.answer ? true : false,
	        correct: utils.answersMatch(payload.answer, currentKeyword.realAnswer)
	      }
	    });
	    dispatch('nextKeyword');
	  }
	};
	
	var mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    utils.resetState(state);
	  },
	  RESET_KEYWORDS: function RESET_KEYWORDS(state, payload) {
	    state.keywords = {};
	    state.currentKeywordUID = null;
	  },
	  LOAD_CHAPTER: function LOAD_CHAPTER(state, payload) {
	    state.chapterId = payload.chapterId;
	  },
	  REGISTER_KEYWORD: function REGISTER_KEYWORD(state, payload) {
	    var keyword = payload.keyword;
	    _vue2.default.set(state.keywords, keyword._uid, keyword);
	
	    if (!state.currentKeywordUID) {
	      state.currentKeywordUID = keyword._uid;
	    }
	  },
	  SET_ACTIVE_MICRO_NOTE: function SET_ACTIVE_MICRO_NOTE(state, payload) {
	    var microNoteIndex = payload.microNoteIndex;
	
	    if (microNoteIndex !== state.currentMicroNoteIndex) {
	      _vue2.default.set(state, 'keywords', {});
	      _vue2.default.set(state, 'currentMicroNoteIndex', microNoteIndex);
	      _vue2.default.set(state, 'currentKeywordUID', null);
	    } else {
	      _vue2.default.set(state, 'currentKeywordUID', null);
	
	      var keywords = _underscore2.default.values(state.keywords);
	      for (var i = 0; i < keywords.length; i++) {
	        var key = keywords[i];
	
	        var newKeyword = (0, _assign2.default)({}, key, {
	          answer: null,
	          answered: false,
	          correct: null
	        });
	        _vue2.default.set(state.keywords, key._uid, newKeyword);
	      }
	    }
	  },
	  UPDATE_KEYWORD: function UPDATE_KEYWORD(state, payload) {
	
	    var uid = payload._uid;
	    var changes = payload.changes;
	
	    var newKeyword = (0, _assign2.default)({}, state.keywords[uid], changes);
	    _vue2.default.set(state.keywords, state.currentKeywordUID, newKeyword);
	  },
	  SET_ACTIVE_KEYWORD: function SET_ACTIVE_KEYWORD(state, payload) {
	    if (!payload.keyword) {
	      state.currentKeywordUID = null;
	      return;
	    }
	    var keywordUID = payload.keyword._uid;
	    state.currentKeywordUID = keywordUID;
	  }
	};
	
	exports.default = {
	  namespaced: true,
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _subject = __webpack_require__(55);
	
	var _subject2 = _interopRequireDefault(_subject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {
	  allSubjects: function allSubjects(state) {
	    return _underscore2.default.values(state);
	  }
	};
	
	var actions = {
	  getSubjects: function getSubjects(context) {
	    console.log('Fetching subjects...');
	    _subject2.default.query({}).then(function (res) {
	      context.commit('RETRIEVE_SUBJECTS_SUCCESS', { subjects: res.data });
	    }, function (res) {
	      Toast.error('Failed to retrieve subjects');
	    });
	  },
	  createSubject: function createSubject(context, payload) {
	    _subject2.default.save(payload.subject).then(function (res) {
	      context.commit('CREATE_SUBJECT_SUCCESS', { subject: res.data });
	      if (payload && _underscore2.default.isFunction(payload.callback)) payload.callback(null, res.data);
	    }, function (res) {
	      Toast.error('Failed to create subject');
	    });
	  },
	  deleteSubject: function deleteSubject(context, payload) {
	    _subject2.default.delete({ id: payload.subject.id }).then(function (res) {
	      context.commit('DELETE_SUBJECT_SUCCESS', { subject: payload.subject });
	    }, function (res) {
	      Toast.error('Failed to delete subject');
	    });
	  },
	  updateSubject: function updateSubject(context, payload) {
	    _subject2.default.update({ id: payload.id }, payload.changes).then(function (res) {
	      context.commit('UPDATE_SUBJECT_SUCCESS', { subject: res.data });
	    }, function (res) {
	      Toast.error('Failed to save subject');
	    });
	  }
	};
	
	var mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    for (var prop in state) {
	      _vue2.default.delete(state, prop);
	    }
	  },
	  RETRIEVE_SUBJECTS_SUCCESS: function RETRIEVE_SUBJECTS_SUCCESS(state, payload) {
	    _underscore2.default.each(payload.subjects, function (subject) {
	      _vue2.default.set(state, subject.id, subject);
	    });
	  },
	  CREATE_SUBJECT_SUCCESS: function CREATE_SUBJECT_SUCCESS(state, payload) {
	    _vue2.default.set(state, payload.subject.id, payload.subject);
	  },
	  DELETE_SUBJECT_SUCCESS: function DELETE_SUBJECT_SUCCESS(state, payload) {
	    _vue2.default.delete(state, payload.subject.id);
	  },
	  UPDATE_SUBJECT_SUCCESS: function UPDATE_SUBJECT_SUCCESS(state, payload) {
	    _vue2.default.set(state, payload.subject.id, payload.subject);
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _userActivityExport = __webpack_require__(56);
	
	var _userActivityExport2 = _interopRequireDefault(_userActivityExport);
	
	var _userActivityReport = __webpack_require__(319);
	
	var _userActivityReport2 = _interopRequireDefault(_userActivityReport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {};
	
	var actions = {
	  getUserActivityExport: function getUserActivityExport(context, payload) {
	    if (payload.model) {
	      _userActivityExport2.default.save(payload.model).then(function (res) {
	        if (_underscore2.default.isFunction(payload.callback)) payload.callback(res.body);
	      }, function (res) {
	        Toast.error('Failed to export user activity');
	        if (_underscore2.default.isFunction(payload.failedCallback)) payload.failedCallback(res.body);
	      });
	    } else {
	      Toast.error('No parameters specified');
	      if (_underscore2.default.isFunction(payload.failedCallback)) payload.failedCallback(res.body);
	    }
	  },
	  getUserActivityReport: function getUserActivityReport(context, payload) {
	    if (payload.model) {
	      _userActivityReport2.default.save(payload.model).then(function (res) {
	        if (_underscore2.default.isFunction(payload.callback)) payload.callback(res.body);
	      }, function (res) {
	        Toast.error('Failed to export user activity');
	        if (_underscore2.default.isFunction(payload.failedCallback)) payload.failedCallback(res.body);
	      });
	    } else {
	      Toast.error('No parameters specified');
	      if (_underscore2.default.isFunction(payload.failedCallback)) payload.failedCallback(res.body);
	    }
	  }
	};
	
	var mutations = {};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _exportUsers = __webpack_require__(53);
	
	var _exportUsers2 = _interopRequireDefault(_exportUsers);
	
	var _exportSubscribers = __webpack_require__(314);
	
	var _exportSubscribers2 = _interopRequireDefault(_exportSubscribers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {};
	
	var getters = {};
	
	var actions = {
	  exportUsers: function exportUsers(context, payload) {
	    _exportUsers2.default.query({}).then(function (res) {
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(res.body);
	    }, function (res) {
	      Toast.error('Failed to export users');
	    });
	  },
	  exportSubscribers: function exportSubscribers(context, payload) {
	    _exportSubscribers2.default.query({}).then(function (res) {
	      if (_underscore2.default.isFunction(payload.callback)) payload.callback(res.body);
	    }, function (res) {
	      Toast.error('Failed to export subscribers');
	    });
	  }
	};
	
	var mutations = {
	  EXPORT_USERS_SUCCESS: function EXPORT_USERS_SUCCESS(state, payload) {},
	  EXPORT_SUBSCRIBERS_SUCCESS: function EXPORT_SUBSCRIBERS_SUCCESS(state, payload) {}
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _underscore = __webpack_require__(3);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	var _vue = __webpack_require__(5);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _userSearch = __webpack_require__(320);
	
	var _userSearch2 = _interopRequireDefault(_userSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var utils = {
	  resetState: function resetState(state) {
	    state.userSearchResults = [];
	    state.showNoResultsMessage = false;
	  }
	};
	
	var state = {
	  userSearchResults: [],
	  showNoResultsMessage: false
	};
	utils.resetState(state);
	
	var getters = {
	  userSearchResults: function userSearchResults(state) {
	    return _underscore2.default.values(state.userSearchResults);
	  },
	  showNoResultsMessage: function showNoResultsMessage(state) {
	    return state.showNoResultsMessage;
	  }
	};
	
	var actions = {
	  searchUsers: function searchUsers(context, props) {
	    _userSearch2.default.query({ search: props.searchTerm }).then(function (res) {
	      context.commit('RETRIEVE_SEARCH_SUCCESS', { user: res.data });
	      if (_underscore2.default.isFunction(props.callback)) props.callback(null, res.data);
	    }, function (res) {
	      Toast.error('Failed to find user');
	    });
	  },
	  clearSearch: function clearSearch(context) {
	    context.commit('CLEAR_SEARCH_RESULTS', {});
	  }
	};
	
	var mutations = {
	  LOGOUT_SUCCESS: function LOGOUT_SUCCESS() {
	    utils.resetState(state);
	  },
	  RETRIEVE_SEARCH_SUCCESS: function RETRIEVE_SEARCH_SUCCESS(state, payload) {
	    if (payload.user) {
	      state.userSearchResults = payload.user;
	      state.showNoResultsMessage = state.userSearchResults.length <= 0;
	    }
	  },
	  CLEAR_SEARCH_RESULTS: function CLEAR_SEARCH_RESULTS(state, payload) {
	    state.userSearchResults = [];
	    state.showNoResultsMessage = false;
	  }
	};
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _promise = __webpack_require__(59);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _mutations;
	
	var _auth = __webpack_require__(57);
	
	var _mutationTypes = __webpack_require__(20);
	
	var _router = __webpack_require__(7);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logout = function logout(state) {
	  state.id = null;
	  state.email = null;
	  state.firstName = null;
	  state.lastName = null;
	  state.role = null;
	  state.errors = null;
	  state.showSuccess = false;
	  state.loggedIn = false;
	  _auth.authHeaders.forEach(function (key) {
	    localStorage.removeItem(key);
	  });
	  _router2.default.push('/login');
	};
	
	var state = {
	  id: null,
	  email: null,
	  firstName: null,
	  lastName: null,
	  role: null,
	  errors: null,
	  loggedIn: false,
	  studySort: null,
	  sortOrder: null,
	  AllowSharing: true,
	  notifications: true,
	  showSuccess: false
	};
	
	var getters = {};
	
	var actions = {
	  validateToken: function validateToken(context) {
	    return _auth.authService.validateToken().then(function (user) {
	      context.commit(_mutationTypes.SET_USER, { user: user });
	      return _promise2.default.resolve(user);
	    }, function () {
	      context.commit(_mutationTypes.TOKEN_INVALID);
	      return _promise2.default.reject();
	    });
	  },
	  register: function register(context, payload) {
	    _auth.authService.register(payload).then(function (newUser) {
	      _auth.authService.login(payload).then(function (user) {
	        context.commit(_mutationTypes.LOGIN_SUCCESS, { user: user });
	        context.commit(_mutationTypes.REGISTER_SUCCESS, { user: newUser });
	      }, function (errors) {
	        context.commit(_mutationTypes.LOGIN_FAILURE, { errors: errors });
	      });
	    }, function (errors) {
	      context.commit(_mutationTypes.REGISTER_FAILURE, { errors: errors });
	    });
	  },
	  login: function login(context, payload) {
	    _auth.authService.login(payload.user).then(function (user) {
	      context.commit(_mutationTypes.LOGIN_SUCCESS, { user: user });
	    }, function (errors) {
	      context.commit(_mutationTypes.LOGIN_FAILURE, { errors: errors });
	    });
	  },
	  logout: function logout(context) {
	    _auth.authService.logout().then(function () {
	      context.commit('LOGOUT_SUCCESS');
	      context.commit('studier/LOGOUT_SUCCESS');
	    }, function () {
	      context.commit(_mutationTypes.LOGOUT_FAILURE);
	    });
	  },
	  updateUser: function updateUser(context, payload) {
	    _auth.authService.update(payload.changes).then(function (user) {
	      context.commit(_mutationTypes.USER_UPDATE_SUCCESS, { user: user });
	      if (_.isFunction(payload.callback)) payload.callback();
	    }, function (errors) {
	      context.commit(_mutationTypes.USER_UPDATE_FAILURE, { errors: errors });
	      if (_.isFunction(payload.callback)) payload.callback(errors);
	    });
	  },
	  forgotPassword: function forgotPassword(context, payload) {
	    _auth.authService.forgotPassword(payload.credentials).then(function (result) {
	      context.commit(_mutationTypes.FORGOT_PASSWORD_SUCCESS, { result: result });
	      if (_.isFunction(payload.callback)) payload.callback();
	    }, function (errors) {
	      context.commit(_mutationTypes.FORGOT_PASSWORD_FAILURE, { errors: errors });
	      if (_.isFunction(payload.callback)) payload.callback(errors);
	    });
	  },
	  resetPassword: function resetPassword(context, payload) {
	    _auth.authService.resetPassword(payload).then(function (result) {
	      context.commit(_mutationTypes.RESET_PASSWORD_SUCCESS, { result: result });
	      if (_.isFunction(payload.callback)) payload.callback();
	    }, function (errors) {
	      context.commit(_mutationTypes.RESET_PASSWORD_FAILURE, { errors: errors });
	      if (_.isFunction(payload.callback)) payload.callback(errors);
	    });
	  }
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.REGISTER_SUCCESS, function (state, payload) {
	  state.id = payload.user.id;
	  state.email = payload.user.email;
	  state.firstName = payload.user.first_name;
	  state.lastName = payload.user.last_name;
	  state.role = payload.user.role;
	  state.loggedIn = true;
	  state.errors = null;
	  state.studySort = payload.user.studySort;
	  state.sortOrder = payload.user.sortOrder;
	  state.role = payload.user.role;
	  state.AllowSharing = payload.user.AllowSharing;
	  state.notifications = payload.user.notifications;
	
	  state.showSuccess = true;
	  _router2.default.push('/signup-success');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.REGISTER_FAILURE, function (state, payload) {
	  state.id = false;
	  state.email = false;
	  state.firstName = null;
	  state.lastName = null;
	  state.role = null;
	  state.loggedIn = false;
	  state.errors = payload.errors;
	  state.showSuccess = false;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.LOGOUT_SUCCESS, function (state) {
	  logout(state);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.LOGOUT_FAILURE, function (state) {
	  logout(state);
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.TOKEN_INVALID, function (state) {
	  _router2.default.push('/login');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.LOGIN_SUCCESS, function (state, payload) {
	  state.id = payload.user.id;
	  state.email = payload.user.email;
	  state.firstName = payload.user.first_name;
	  state.lastName = payload.user.last_name;
	  state.role = payload.user.role;
	  state.loggedIn = true;
	  state.errors = null;
	  state.showSuccess = false;
	  state.studySort = payload.user.studySort;
	  state.sortOrder = payload.user.sortOrder;
	  state.role = payload.user.role;
	  state.AllowSharing = payload.user.AllowSharing;
	  state.notifications = payload.user.notifications;
	  _router2.default.push(payload.redirect || '/subject-shelf');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.LOGIN_FAILURE, function (state, payload) {
	  state.id = false;
	  state.email = false;
	  state.firstName = null;
	  state.lastName = null;
	  state.role = null;
	  state.loggedIn = false;
	  state.errors = payload.errors;
	  state.showSuccess = false;
	  _router2.default.push('/login');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.SET_USER, function (state, payload) {
	  state.id = payload.user.id;
	  state.email = payload.user.email;
	  state.firstName = payload.user.first_name;
	  state.lastName = payload.user.last_name;
	  state.studySort = payload.user.studySort;
	  state.sortOrder = payload.user.sortOrder;
	  state.role = payload.user.role;
	  state.AllowSharing = payload.user.AllowSharing;
	  state.notifications = payload.user.notifications;
	  state.loggedIn = true;
	  state.errors = null;
	  state.showSuccess = false;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_UPDATE_SUCCESS, function (state, payload) {
	  state.errors = null;
	  state.email = payload.user.email;
	  state.firstName = payload.user.first_name;
	  state.lastName = payload.user.last_name;
	  state.studySort = payload.user.studySort;
	  state.sortOrder = payload.user.sortOrder;
	  state.AllowSharing = payload.user.AllowSharing;
	  state.notifications = payload.user.notifications;
	  state.role = payload.user.role;
	  state.showSuccess = true;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.USER_UPDATE_FAILURE, function (state, payload) {
	  state.errors = payload.errors;
	  state.showSuccess = false;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.FORGOT_PASSWORD_SUCCESS, function (state, payload) {
	  Toast.success('Success! Please check your emails.');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.FORGOT_PASSWORD_FAILURE, function (state, payload) {
	  state.errors = payload.errors;
	  state.showSuccess = false;
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.RESET_PASSWORD_SUCCESS, function (state, payload) {
	  Toast.success('Password reset successful.');
	  _router2.default.push('/login');
	}), (0, _defineProperty3.default)(_mutations, _mutationTypes.RESET_PASSWORD_FAILURE, function (state, payload) {
	  state.errors = payload.errors;
	  state.showSuccess = false;
	}), (0, _defineProperty3.default)(_mutations, 'CLEAR_USER_ERRORS', function CLEAR_USER_ERRORS(state, payload) {
	  state.errors = null;
	  state.showSuccess = false;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  getters: getters,
	  actions: actions,
	  mutations: mutations
	};

/***/ },
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 389 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 390 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 391 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 392 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 393 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 394 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 395 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 396 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 397 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 398 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 399 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 400 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 401 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 402 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 403 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 404 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 405 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 406 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 407 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 408 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 409 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 410 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 411 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 412 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 413 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 414 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 415 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 416 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 417 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 418 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 419 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 420 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 421 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 422 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 423 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 424 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 425 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 426 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 427 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 428 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 429 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 430 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 431 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 432 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 433 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 434 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 435 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 436 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 437 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 438 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 439 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 440 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 441 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 442 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 443 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 444 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 445 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 446 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 447 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 448 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 449 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 450 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 451 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 452 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 453 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 454 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 455 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 456 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 457 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 458 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 459 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 460 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 461 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 462 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 463 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 464 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 465 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 466 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 467 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 468 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 469 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 470 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 471 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 472 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 473 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 474 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 475 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 476 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 477 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 478 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 479 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 480 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 481 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 482 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 483 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 484 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 485 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 486 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 487 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 488 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 489 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 490 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 491 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 492 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 493 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 494 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 495 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 496 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 497 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 498 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 499 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 500 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 501 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 502 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 503 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 504 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 505 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 506 */
/***/ function(module, exports) {

	module.exports = {
		"version": "2016j",
		"zones": [
			"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
			"Africa/Accra|LMT GMT GHST|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
			"Africa/Nairobi|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
			"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
			"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
			"Africa/Bissau|LMT WAT GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
			"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
			"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
			"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
			"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1y7p0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
			"Africa/El_Aaiun|LMT WAT WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
			"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
			"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5",
			"Africa/Monrovia|MMT LRT GMT|H.8 I.u 0|012|-23Lzg.Q 29s01.m|11e5",
			"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
			"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
			"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
			"Africa/Windhoek|SWAT SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4",
			"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
			"America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
			"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
			"America/Araguaina|LMT BRT BRST|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
			"America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
			"America/Argentina/Catamarca|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Cordoba|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
			"America/Argentina/Jujuy|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
			"America/Argentina/La_Rioja|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Mendoza|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|0121212121212121212121212121212121212121213434345656543235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 g0p0 10M0 agM0 Op0 7TX0 uL0",
			"America/Argentina/Rio_Gallegos|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
			"America/Argentina/Salta|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
			"America/Argentina/San_Juan|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ak00 m10 8lb0 uL0",
			"America/Argentina/San_Luis|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456536353465653|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 kin0 10M0 ak00 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
			"America/Argentina/Tucuman|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|012121212121212121212121212121212121212121343434345434323534343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 4N0 8BX0 uL0 1qN0 WL0",
			"America/Argentina/Ushuaia|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ajA0 8p0 8zb0 uL0",
			"America/Curacao|LMT ANT AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
			"America/Asuncion|AMT PYT PYT PYST|3O.E 40 30 30|012131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
			"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
			"America/Bahia|LMT BRT BRST|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
			"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
			"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
			"America/Belem|LMT BRT BRST|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
			"America/Belize|LMT CST CHDT CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
			"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
			"America/Boa_Vista|LMT AMT AMST|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
			"America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
			"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
			"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
			"America/Campo_Grande|LMT AMT AMST|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
			"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
			"America/Caracas|CMT VET VET|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
			"America/Cayenne|LMT GFT GFT|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
			"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
			"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
			"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
			"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
			"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
			"America/Cuiaba|LMT AMT AMST|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
			"America/Danmarkshavn|LMT WGT WGST GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
			"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
			"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
			"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
			"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
			"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
			"America/Eirunepe|LMT ACT ACST AMT|4D.s 50 40 40|0121212121212121212121212121212131|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
			"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
			"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
			"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
			"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Fortaleza|LMT BRT BRST|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
			"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"America/Godthab|LMT WGT WGST|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
			"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
			"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
			"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
			"America/Guayaquil|QMT ECT|5e 50|01|-1yVSK|27e5",
			"America/Guyana|LMT GBGT GYT GYT GYT|3Q.E 3J 3J 30 40|01234|-2dvU7.k 24JzQ.k mlc0 Bxbf|80e4",
			"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
			"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
			"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
			"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
			"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
			"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
			"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
			"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
			"America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
			"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
			"America/Maceio|LMT BRT BRST|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
			"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
			"America/Manaus|LMT AMT AMST|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
			"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
			"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
			"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
			"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
			"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
			"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
			"America/Miquelon|LMT AST PMST PMDT|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
			"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
			"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
			"America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
			"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
			"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
			"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
			"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
			"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
			"America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
			"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
			"America/Paramaribo|LMT PMT PMT NEGT SRT SRT|3E.E 3E.Q 3E.A 3u 3u 30|012345|-2nDUj.k Wqo0.c qanX.I 1dmLN.o lzc0|24e4",
			"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
			"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Rio_Branco|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
			"America/Porto_Velho|LMT AMT AMST|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
			"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
			"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
			"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
			"America/Recife|LMT BRT BRST|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
			"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
			"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
			"America/Santarem|LMT AMT AMST BRT|3C.M 40 30 30|0121212121212121212121212121213|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
			"America/Santiago|SMT CLT CLT CLST CLST|4G.K 50 40 40 30|010203131313131212421242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
			"America/Santo_Domingo|SDMT EST EDT EHDT AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
			"America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
			"America/Scoresbysund|LMT CGT CGST EGST EGT|1r.Q 20 10 0 10|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
			"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
			"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
			"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
			"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
			"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
			"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
			"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
			"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
			"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
			"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
			"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
			"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
			"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
			"Antarctica/Macquarie|AEST AEDT -00 MIST|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
			"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
			"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
			"Antarctica/Palmer|-00 ARST ART ART ARST CLT CLST|0 30 40 30 20 40 30|0121212121234356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|40",
			"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
			"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
			"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
			"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
			"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
			"Asia/Riyadh|LMT AST|-36.Q -30|01|-TvD6.Q|57e5",
			"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
			"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
			"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
			"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
			"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
			"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
			"Asia/Atyrau|LMT +04 +05 +06|-3r.I -40 -50 -60|01232323232323232323212323232323232321212121212|-1Pc3r.I eUnr.I 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0",
			"Asia/Baghdad|BMT AST ADT|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
			"Asia/Qatar|LMT GST AST|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
			"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
			"Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4|15e6",
			"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
			"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
			"Asia/Brunei|LMT BNT BNT|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
			"Asia/Kolkata|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0|15e6",
			"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
			"Asia/Choibalsan|LMT ULAT ULAT CHOST CHOT CHOT CHOST|-7C -70 -80 -a0 -90 -80 -90|0123434343434343434343434343434343434343434343456565656565656565656565656565656565656565656565|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|38e3",
			"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
			"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
			"Asia/Dhaka|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00|16e6",
			"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
			"Asia/Dili|LMT TLT JST TLT WITA|-8m.k -80 -90 -90 -80|012343|-2le8m.k 1dnXm.k 8HA0 1ew00 Xld0|19e4",
			"Asia/Dubai|LMT GST|-3F.c -40|01|-21JfF.c|39e5",
			"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
			"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0",
			"Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
			"Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
			"Asia/Ho_Chi_Minh|LMT PLMT ICT IDT JST|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
			"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
			"Asia/Hovd|LMT HOVT HOVT HOVST|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|81e3",
			"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
			"Asia/Jakarta|BMT JAVT WIB JST WIB WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
			"Asia/Jayapura|LMT WIT ACST|-9m.M -90 -9u|0121|-1uu9m.M sMMm.M L4nu|26e4",
			"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
			"Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0|46e5",
			"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
			"Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
			"Asia/Urumqi|LMT XJT|-5O.k -60|01|-1GgtO.k|32e5",
			"Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
			"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
			"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u|71e5",
			"Asia/Kuching|LMT BORT BORT BORTST JST MYT|-7l.k -7u -80 -8k -90 -80|01232323232323232425|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0 1so10|13e4",
			"Asia/Macau|LMT MOT MOST CST|-7y.k -80 -90 -80|0121212121212121212121212121212121212121213|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0 KEp0|57e4",
			"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
			"Asia/Makassar|LMT MMT WITA JST|-7V.A -7V.A -80 -90|01232|-21JjV.A vfc0 myLV.A 8ML0|15e5",
			"Asia/Manila|PHT PHST JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
			"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
			"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
			"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
			"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
			"Asia/Oral|LMT +04 +05 +06|-3p.o -40 -50 -60|01232323232323232121212121212121212121212121212|-1Pc3p.o eUnp.o 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
			"Asia/Pontianak|LMT PMT WIB JST WIB WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
			"Asia/Pyongyang|LMT KST JCST JST KST|-8n -8u -90 -90 -90|012341|-2um8n 97XR 12FXu jdA0 2Onc0|29e5",
			"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
			"Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u|48e5",
			"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
			"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
			"Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
			"Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0|56e5",
			"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
			"Asia/Taipei|JWST JST CST CDT|-80 -90 -80 -90|01232323232323232323232323232323232323232|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
			"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
			"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
			"Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
			"Asia/Thimphu|LMT IST BTT|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
			"Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
			"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
			"Asia/Ulaanbaatar|LMT ULAT ULAT ULAST|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|12e5",
			"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
			"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
			"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
			"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
			"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
			"Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
			"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
			"Atlantic/Canary|LMT CANT WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
			"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
			"Atlantic/Madeira|FMT MADT MADST MADMT WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
			"Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
			"Atlantic/South_Georgia|GST|20|0||30",
			"Atlantic/Stanley|SMT FKT FKST FKT FKST|3P.o 40 30 30 20|0121212121212134343212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 U10 1qM0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
			"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
			"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
			"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
			"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
			"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
			"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
			"Australia/Eucla|ACWST ACWDT|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
			"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
			"Australia/Lord_Howe|AEST LHST LHDT LHDT|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
			"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
			"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
			"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
			"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Easter|EMT EAST EASST EAST EASST|7h.s 70 60 60 50|0121212121212121212121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
			"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"EST|EST|50|0|",
			"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Etc/GMT+0|GMT|0|0|",
			"Etc/GMT+1|-01|10|0|",
			"Etc/GMT+10|-10|a0|0|",
			"Etc/GMT+11|-11|b0|0|",
			"Etc/GMT+12|-12|c0|0|",
			"Etc/GMT+2|-02|20|0|",
			"Etc/GMT+3|-03|30|0|",
			"Etc/GMT+4|-04|40|0|",
			"Etc/GMT+5|-05|50|0|",
			"Etc/GMT+6|-06|60|0|",
			"Etc/GMT+7|-07|70|0|",
			"Etc/GMT+8|-08|80|0|",
			"Etc/GMT+9|-09|90|0|",
			"Etc/GMT-1|+01|-10|0|",
			"Etc/GMT-10|+10|-a0|0|",
			"Etc/GMT-11|+11|-b0|0|",
			"Etc/GMT-12|+12|-c0|0|",
			"Etc/GMT-13|+13|-d0|0|",
			"Etc/GMT-14|+14|-e0|0|",
			"Etc/GMT-2|+02|-20|0|",
			"Etc/GMT-3|+03|-30|0|",
			"Etc/GMT-4|+04|-40|0|",
			"Etc/GMT-5|+05|-50|0|",
			"Etc/GMT-6|+06|-60|0|",
			"Etc/GMT-7|+07|-70|0|",
			"Etc/GMT-8|+08|-80|0|",
			"Etc/GMT-9|+09|-90|0|",
			"Etc/UCT|UCT|0|0|",
			"Etc/UTC|UTC|0|0|",
			"Europe/Amsterdam|AMT NST NEST NET CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
			"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
			"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
			"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
			"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
			"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
			"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
			"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
			"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
			"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
			"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
			"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
			"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
			"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
			"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
			"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|01010101010101010101010121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-28dd0 11A0 1go0 19A0 1co0 1dA0 b1A0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 iyo0 Rc0 18o0 1hc0 1io0 1a00 14o0 5aL0 MM0 1vc0 17A0 1i00 1bc0 1eo0 17d0 1in0 17A0 6hA0 10N0 XIL0 1a10 1in0 17d0 19X0 1cN0 1fz0 1a10 1fX0 1cp0 1cO0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
			"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
			"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
			"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
			"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
			"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
			"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
			"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
			"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810",
			"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
			"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
			"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
			"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
			"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
			"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
			"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
			"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
			"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
			"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
			"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
			"Europe/Zaporozhye|CUT EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
			"HST|HST|a0|0|",
			"Indian/Chagos|LMT IOT IOT|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
			"Indian/Christmas|CXT|-70|0||21e2",
			"Indian/Cocos|CCT|-6u|0||596",
			"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
			"Indian/Mahe|LMT SCT|-3F.M -40|01|-2yO3F.M|79e3",
			"Indian/Maldives|MMT MVT|-4S -50|01|-olgS|35e4",
			"Indian/Mauritius|LMT MUT MUST|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
			"Indian/Reunion|LMT RET|-3F.Q -40|01|-2mDDF.Q|84e4",
			"Pacific/Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0|14e3",
			"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
			"MST|MST|70|0|",
			"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Chatham|CHAST CHAST CHADT|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
			"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
			"Pacific/Apia|LMT WSST SST SDT WSDT WSST|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
			"Pacific/Bougainville|PGT JST BST|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
			"Pacific/Chuuk|CHUT|-a0|0||49e3",
			"Pacific/Efate|LMT VUT VUST|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
			"Pacific/Enderbury|PHOT PHOT PHOT|c0 b0 -d0|012|nIc0 B8n0|1",
			"Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0|483",
			"Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4",
			"Pacific/Funafuti|TVT|-c0|0||45e2",
			"Pacific/Galapagos|LMT ECT GALT|5W.o 50 60|012|-1yVS1.A 2dTz1.A|25e3",
			"Pacific/Gambier|LMT GAMT|8X.M 90|01|-2jof0.c|125",
			"Pacific/Guadalcanal|LMT SBT|-aD.M -b0|01|-2joyD.M|11e4",
			"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
			"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
			"Pacific/Kiritimati|LINT LINT LINT|aE a0 -e0|012|nIaE B8nk|51e2",
			"Pacific/Kosrae|KOST KOST|-b0 -c0|010|-AX0 1bdz0|66e2",
			"Pacific/Majuro|MHT MHT|-b0 -c0|01|-AX0|28e3",
			"Pacific/Marquesas|LMT MART|9i 9u|01|-2joeG|86e2",
			"Pacific/Pago_Pago|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0|37e2",
			"Pacific/Nauru|LMT NRT JST NRT|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
			"Pacific/Niue|NUT NUT NUT|bk bu b0|012|-KfME 17y0a|12e2",
			"Pacific/Norfolk|NMT NFT NFST NFT|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
			"Pacific/Noumea|LMT NCT NCST|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
			"Pacific/Palau|PWT|-90|0||21e3",
			"Pacific/Pitcairn|PNT PST|8u 80|01|18Vku|56",
			"Pacific/Pohnpei|PONT|-b0|0||34e3",
			"Pacific/Port_Moresby|PGT|-a0|0||25e4",
			"Pacific/Rarotonga|CKT CKHST CKT|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
			"Pacific/Tahiti|LMT TAHT|9W.g a0|01|-2joe1.I|18e4",
			"Pacific/Tarawa|GILT|-c0|0||29e3",
			"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3",
			"Pacific/Wake|WAKT|-c0|0||16e3",
			"Pacific/Wallis|WFT|-c0|0||94",
			"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
		],
		"links": [
			"Africa/Abidjan|Africa/Bamako",
			"Africa/Abidjan|Africa/Banjul",
			"Africa/Abidjan|Africa/Conakry",
			"Africa/Abidjan|Africa/Dakar",
			"Africa/Abidjan|Africa/Freetown",
			"Africa/Abidjan|Africa/Lome",
			"Africa/Abidjan|Africa/Nouakchott",
			"Africa/Abidjan|Africa/Ouagadougou",
			"Africa/Abidjan|Africa/Sao_Tome",
			"Africa/Abidjan|Africa/Timbuktu",
			"Africa/Abidjan|Atlantic/St_Helena",
			"Africa/Cairo|Egypt",
			"Africa/Johannesburg|Africa/Maseru",
			"Africa/Johannesburg|Africa/Mbabane",
			"Africa/Khartoum|Africa/Juba",
			"Africa/Lagos|Africa/Bangui",
			"Africa/Lagos|Africa/Brazzaville",
			"Africa/Lagos|Africa/Douala",
			"Africa/Lagos|Africa/Kinshasa",
			"Africa/Lagos|Africa/Libreville",
			"Africa/Lagos|Africa/Luanda",
			"Africa/Lagos|Africa/Malabo",
			"Africa/Lagos|Africa/Niamey",
			"Africa/Lagos|Africa/Porto-Novo",
			"Africa/Maputo|Africa/Blantyre",
			"Africa/Maputo|Africa/Bujumbura",
			"Africa/Maputo|Africa/Gaborone",
			"Africa/Maputo|Africa/Harare",
			"Africa/Maputo|Africa/Kigali",
			"Africa/Maputo|Africa/Lubumbashi",
			"Africa/Maputo|Africa/Lusaka",
			"Africa/Nairobi|Africa/Addis_Ababa",
			"Africa/Nairobi|Africa/Asmara",
			"Africa/Nairobi|Africa/Asmera",
			"Africa/Nairobi|Africa/Dar_es_Salaam",
			"Africa/Nairobi|Africa/Djibouti",
			"Africa/Nairobi|Africa/Kampala",
			"Africa/Nairobi|Africa/Mogadishu",
			"Africa/Nairobi|Indian/Antananarivo",
			"Africa/Nairobi|Indian/Comoro",
			"Africa/Nairobi|Indian/Mayotte",
			"Africa/Tripoli|Libya",
			"America/Adak|America/Atka",
			"America/Adak|US/Aleutian",
			"America/Anchorage|US/Alaska",
			"America/Argentina/Buenos_Aires|America/Buenos_Aires",
			"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
			"America/Argentina/Catamarca|America/Catamarca",
			"America/Argentina/Cordoba|America/Cordoba",
			"America/Argentina/Cordoba|America/Rosario",
			"America/Argentina/Jujuy|America/Jujuy",
			"America/Argentina/Mendoza|America/Mendoza",
			"America/Atikokan|America/Coral_Harbour",
			"America/Chicago|US/Central",
			"America/Curacao|America/Aruba",
			"America/Curacao|America/Kralendijk",
			"America/Curacao|America/Lower_Princes",
			"America/Denver|America/Shiprock",
			"America/Denver|Navajo",
			"America/Denver|US/Mountain",
			"America/Detroit|US/Michigan",
			"America/Edmonton|Canada/Mountain",
			"America/Fort_Wayne|America/Indiana/Indianapolis",
			"America/Fort_Wayne|America/Indianapolis",
			"America/Fort_Wayne|US/East-Indiana",
			"America/Halifax|Canada/Atlantic",
			"America/Havana|Cuba",
			"America/Indiana/Knox|America/Knox_IN",
			"America/Indiana/Knox|US/Indiana-Starke",
			"America/Jamaica|Jamaica",
			"America/Kentucky/Louisville|America/Louisville",
			"America/Los_Angeles|US/Pacific",
			"America/Los_Angeles|US/Pacific-New",
			"America/Manaus|Brazil/West",
			"America/Mazatlan|Mexico/BajaSur",
			"America/Mexico_City|Mexico/General",
			"America/New_York|US/Eastern",
			"America/Noronha|Brazil/DeNoronha",
			"America/Panama|America/Cayman",
			"America/Phoenix|US/Arizona",
			"America/Port_of_Spain|America/Anguilla",
			"America/Port_of_Spain|America/Antigua",
			"America/Port_of_Spain|America/Dominica",
			"America/Port_of_Spain|America/Grenada",
			"America/Port_of_Spain|America/Guadeloupe",
			"America/Port_of_Spain|America/Marigot",
			"America/Port_of_Spain|America/Montserrat",
			"America/Port_of_Spain|America/St_Barthelemy",
			"America/Port_of_Spain|America/St_Kitts",
			"America/Port_of_Spain|America/St_Lucia",
			"America/Port_of_Spain|America/St_Thomas",
			"America/Port_of_Spain|America/St_Vincent",
			"America/Port_of_Spain|America/Tortola",
			"America/Port_of_Spain|America/Virgin",
			"America/Regina|Canada/East-Saskatchewan",
			"America/Regina|Canada/Saskatchewan",
			"America/Rio_Branco|America/Porto_Acre",
			"America/Rio_Branco|Brazil/Acre",
			"America/Santiago|Chile/Continental",
			"America/Sao_Paulo|Brazil/East",
			"America/St_Johns|Canada/Newfoundland",
			"America/Tijuana|America/Ensenada",
			"America/Tijuana|America/Santa_Isabel",
			"America/Tijuana|Mexico/BajaNorte",
			"America/Toronto|America/Montreal",
			"America/Toronto|Canada/Eastern",
			"America/Vancouver|Canada/Pacific",
			"America/Whitehorse|Canada/Yukon",
			"America/Winnipeg|Canada/Central",
			"Asia/Ashgabat|Asia/Ashkhabad",
			"Asia/Bangkok|Asia/Phnom_Penh",
			"Asia/Bangkok|Asia/Vientiane",
			"Asia/Dhaka|Asia/Dacca",
			"Asia/Dubai|Asia/Muscat",
			"Asia/Ho_Chi_Minh|Asia/Saigon",
			"Asia/Hong_Kong|Hongkong",
			"Asia/Jerusalem|Asia/Tel_Aviv",
			"Asia/Jerusalem|Israel",
			"Asia/Kathmandu|Asia/Katmandu",
			"Asia/Kolkata|Asia/Calcutta",
			"Asia/Macau|Asia/Macao",
			"Asia/Makassar|Asia/Ujung_Pandang",
			"Asia/Nicosia|Europe/Nicosia",
			"Asia/Qatar|Asia/Bahrain",
			"Asia/Rangoon|Asia/Yangon",
			"Asia/Riyadh|Asia/Aden",
			"Asia/Riyadh|Asia/Kuwait",
			"Asia/Seoul|ROK",
			"Asia/Shanghai|Asia/Chongqing",
			"Asia/Shanghai|Asia/Chungking",
			"Asia/Shanghai|Asia/Harbin",
			"Asia/Shanghai|PRC",
			"Asia/Singapore|Singapore",
			"Asia/Taipei|ROC",
			"Asia/Tehran|Iran",
			"Asia/Thimphu|Asia/Thimbu",
			"Asia/Tokyo|Japan",
			"Asia/Ulaanbaatar|Asia/Ulan_Bator",
			"Asia/Urumqi|Asia/Kashgar",
			"Atlantic/Faroe|Atlantic/Faeroe",
			"Atlantic/Reykjavik|Iceland",
			"Australia/Adelaide|Australia/South",
			"Australia/Brisbane|Australia/Queensland",
			"Australia/Broken_Hill|Australia/Yancowinna",
			"Australia/Darwin|Australia/North",
			"Australia/Hobart|Australia/Tasmania",
			"Australia/Lord_Howe|Australia/LHI",
			"Australia/Melbourne|Australia/Victoria",
			"Australia/Perth|Australia/West",
			"Australia/Sydney|Australia/ACT",
			"Australia/Sydney|Australia/Canberra",
			"Australia/Sydney|Australia/NSW",
			"Etc/GMT+0|Etc/GMT",
			"Etc/GMT+0|Etc/GMT-0",
			"Etc/GMT+0|Etc/GMT0",
			"Etc/GMT+0|Etc/Greenwich",
			"Etc/GMT+0|GMT",
			"Etc/GMT+0|GMT+0",
			"Etc/GMT+0|GMT-0",
			"Etc/GMT+0|GMT0",
			"Etc/GMT+0|Greenwich",
			"Etc/UCT|UCT",
			"Etc/UTC|Etc/Universal",
			"Etc/UTC|Etc/Zulu",
			"Etc/UTC|UTC",
			"Etc/UTC|Universal",
			"Etc/UTC|Zulu",
			"Europe/Belgrade|Europe/Ljubljana",
			"Europe/Belgrade|Europe/Podgorica",
			"Europe/Belgrade|Europe/Sarajevo",
			"Europe/Belgrade|Europe/Skopje",
			"Europe/Belgrade|Europe/Zagreb",
			"Europe/Chisinau|Europe/Tiraspol",
			"Europe/Dublin|Eire",
			"Europe/Helsinki|Europe/Mariehamn",
			"Europe/Istanbul|Asia/Istanbul",
			"Europe/Istanbul|Turkey",
			"Europe/Lisbon|Portugal",
			"Europe/London|Europe/Belfast",
			"Europe/London|Europe/Guernsey",
			"Europe/London|Europe/Isle_of_Man",
			"Europe/London|Europe/Jersey",
			"Europe/London|GB",
			"Europe/London|GB-Eire",
			"Europe/Moscow|W-SU",
			"Europe/Oslo|Arctic/Longyearbyen",
			"Europe/Oslo|Atlantic/Jan_Mayen",
			"Europe/Prague|Europe/Bratislava",
			"Europe/Rome|Europe/San_Marino",
			"Europe/Rome|Europe/Vatican",
			"Europe/Warsaw|Poland",
			"Europe/Zurich|Europe/Busingen",
			"Europe/Zurich|Europe/Vaduz",
			"Pacific/Auckland|Antarctica/McMurdo",
			"Pacific/Auckland|Antarctica/South_Pole",
			"Pacific/Auckland|NZ",
			"Pacific/Chatham|NZ-CHAT",
			"Pacific/Chuuk|Pacific/Truk",
			"Pacific/Chuuk|Pacific/Yap",
			"Pacific/Easter|Chile/EasterIsland",
			"Pacific/Guam|Pacific/Saipan",
			"Pacific/Honolulu|Pacific/Johnston",
			"Pacific/Honolulu|US/Hawaii",
			"Pacific/Kwajalein|Kwajalein",
			"Pacific/Pago_Pago|Pacific/Midway",
			"Pacific/Pago_Pago|Pacific/Samoa",
			"Pacific/Pago_Pago|US/Samoa",
			"Pacific/Pohnpei|Pacific/Ponape"
		]
	};

/***/ },
/* 507 */,
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 72,
		"./af.js": 72,
		"./ar": 78,
		"./ar-dz": 73,
		"./ar-dz.js": 73,
		"./ar-ly": 74,
		"./ar-ly.js": 74,
		"./ar-ma": 75,
		"./ar-ma.js": 75,
		"./ar-sa": 76,
		"./ar-sa.js": 76,
		"./ar-tn": 77,
		"./ar-tn.js": 77,
		"./ar.js": 78,
		"./az": 79,
		"./az.js": 79,
		"./be": 80,
		"./be.js": 80,
		"./bg": 81,
		"./bg.js": 81,
		"./bn": 82,
		"./bn.js": 82,
		"./bo": 83,
		"./bo.js": 83,
		"./br": 84,
		"./br.js": 84,
		"./bs": 85,
		"./bs.js": 85,
		"./ca": 86,
		"./ca.js": 86,
		"./cs": 87,
		"./cs.js": 87,
		"./cv": 88,
		"./cv.js": 88,
		"./cy": 89,
		"./cy.js": 89,
		"./da": 90,
		"./da.js": 90,
		"./de": 92,
		"./de-at": 91,
		"./de-at.js": 91,
		"./de.js": 92,
		"./dv": 93,
		"./dv.js": 93,
		"./el": 94,
		"./el.js": 94,
		"./en-au": 95,
		"./en-au.js": 95,
		"./en-ca": 96,
		"./en-ca.js": 96,
		"./en-gb": 97,
		"./en-gb.js": 97,
		"./en-ie": 98,
		"./en-ie.js": 98,
		"./en-nz": 99,
		"./en-nz.js": 99,
		"./eo": 100,
		"./eo.js": 100,
		"./es": 102,
		"./es-do": 101,
		"./es-do.js": 101,
		"./es.js": 102,
		"./et": 103,
		"./et.js": 103,
		"./eu": 104,
		"./eu.js": 104,
		"./fa": 105,
		"./fa.js": 105,
		"./fi": 106,
		"./fi.js": 106,
		"./fo": 107,
		"./fo.js": 107,
		"./fr": 110,
		"./fr-ca": 108,
		"./fr-ca.js": 108,
		"./fr-ch": 109,
		"./fr-ch.js": 109,
		"./fr.js": 110,
		"./fy": 111,
		"./fy.js": 111,
		"./gd": 112,
		"./gd.js": 112,
		"./gl": 113,
		"./gl.js": 113,
		"./he": 114,
		"./he.js": 114,
		"./hi": 115,
		"./hi.js": 115,
		"./hr": 116,
		"./hr.js": 116,
		"./hu": 117,
		"./hu.js": 117,
		"./hy-am": 118,
		"./hy-am.js": 118,
		"./id": 119,
		"./id.js": 119,
		"./is": 120,
		"./is.js": 120,
		"./it": 121,
		"./it.js": 121,
		"./ja": 122,
		"./ja.js": 122,
		"./jv": 123,
		"./jv.js": 123,
		"./ka": 124,
		"./ka.js": 124,
		"./kk": 125,
		"./kk.js": 125,
		"./km": 126,
		"./km.js": 126,
		"./ko": 127,
		"./ko.js": 127,
		"./ky": 128,
		"./ky.js": 128,
		"./lb": 129,
		"./lb.js": 129,
		"./lo": 130,
		"./lo.js": 130,
		"./lt": 131,
		"./lt.js": 131,
		"./lv": 132,
		"./lv.js": 132,
		"./me": 133,
		"./me.js": 133,
		"./mi": 134,
		"./mi.js": 134,
		"./mk": 135,
		"./mk.js": 135,
		"./ml": 136,
		"./ml.js": 136,
		"./mr": 137,
		"./mr.js": 137,
		"./ms": 139,
		"./ms-my": 138,
		"./ms-my.js": 138,
		"./ms.js": 139,
		"./my": 140,
		"./my.js": 140,
		"./nb": 141,
		"./nb.js": 141,
		"./ne": 142,
		"./ne.js": 142,
		"./nl": 144,
		"./nl-be": 143,
		"./nl-be.js": 143,
		"./nl.js": 144,
		"./nn": 145,
		"./nn.js": 145,
		"./pa-in": 146,
		"./pa-in.js": 146,
		"./pl": 147,
		"./pl.js": 147,
		"./pt": 149,
		"./pt-br": 148,
		"./pt-br.js": 148,
		"./pt.js": 149,
		"./ro": 150,
		"./ro.js": 150,
		"./ru": 151,
		"./ru.js": 151,
		"./se": 152,
		"./se.js": 152,
		"./si": 153,
		"./si.js": 153,
		"./sk": 154,
		"./sk.js": 154,
		"./sl": 155,
		"./sl.js": 155,
		"./sq": 156,
		"./sq.js": 156,
		"./sr": 158,
		"./sr-cyrl": 157,
		"./sr-cyrl.js": 157,
		"./sr.js": 158,
		"./ss": 159,
		"./ss.js": 159,
		"./sv": 160,
		"./sv.js": 160,
		"./sw": 161,
		"./sw.js": 161,
		"./ta": 162,
		"./ta.js": 162,
		"./te": 163,
		"./te.js": 163,
		"./tet": 164,
		"./tet.js": 164,
		"./th": 165,
		"./th.js": 165,
		"./tl-ph": 166,
		"./tl-ph.js": 166,
		"./tlh": 167,
		"./tlh.js": 167,
		"./tr": 168,
		"./tr.js": 168,
		"./tzl": 169,
		"./tzl.js": 169,
		"./tzm": 171,
		"./tzm-latn": 170,
		"./tzm-latn.js": 170,
		"./tzm.js": 171,
		"./uk": 172,
		"./uk.js": 172,
		"./uz": 173,
		"./uz.js": 173,
		"./vi": 174,
		"./vi.js": 174,
		"./x-pseudo": 175,
		"./x-pseudo.js": 175,
		"./yo": 176,
		"./yo.js": 176,
		"./zh-cn": 177,
		"./zh-cn.js": 177,
		"./zh-hk": 178,
		"./zh-hk.js": 178,
		"./zh-tw": 179,
		"./zh-tw.js": 179
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 508;


/***/ },
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(420)
	
	/* script */
	__vue_exports__ = __webpack_require__(191)
	
	/* template */
	var __vue_template__ = __webpack_require__(643)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(419)
	
	/* script */
	__vue_exports__ = __webpack_require__(192)
	
	/* template */
	var __vue_template__ = __webpack_require__(642)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(451)
	
	/* script */
	__vue_exports__ = __webpack_require__(193)
	
	/* template */
	var __vue_template__ = __webpack_require__(673)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-68b8e797"
	
	module.exports = __vue_exports__


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(502)
	
	/* script */
	__vue_exports__ = __webpack_require__(194)
	
	/* template */
	var __vue_template__ = __webpack_require__(722)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f7851292"
	
	module.exports = __vue_exports__


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(494)
	
	/* script */
	__vue_exports__ = __webpack_require__(195)
	
	/* template */
	var __vue_template__ = __webpack_require__(714)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c71cc05e"
	
	module.exports = __vue_exports__


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(499)
	
	/* script */
	__vue_exports__ = __webpack_require__(196)
	
	/* template */
	var __vue_template__ = __webpack_require__(719)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d5220f64"
	
	module.exports = __vue_exports__


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(416)
	
	/* script */
	__vue_exports__ = __webpack_require__(197)
	
	/* template */
	var __vue_template__ = __webpack_require__(639)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2af068f2"
	
	module.exports = __vue_exports__


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(501)
	
	/* script */
	__vue_exports__ = __webpack_require__(198)
	
	/* template */
	var __vue_template__ = __webpack_require__(721)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f1b60bae"
	
	module.exports = __vue_exports__


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(484)
	
	/* script */
	__vue_exports__ = __webpack_require__(200)
	
	/* template */
	var __vue_template__ = __webpack_require__(705)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-adaf5e78"
	
	module.exports = __vue_exports__


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(496)
	
	/* script */
	__vue_exports__ = __webpack_require__(201)
	
	/* template */
	var __vue_template__ = __webpack_require__(716)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cb5bd67c"
	
	module.exports = __vue_exports__


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(413)
	
	/* script */
	__vue_exports__ = __webpack_require__(202)
	
	/* template */
	var __vue_template__ = __webpack_require__(636)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-23e74d86"
	
	module.exports = __vue_exports__


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(406)
	
	/* script */
	__vue_exports__ = __webpack_require__(203)
	
	/* template */
	var __vue_template__ = __webpack_require__(629)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-186f0ac6"
	
	module.exports = __vue_exports__


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(476)
	
	/* script */
	__vue_exports__ = __webpack_require__(204)
	
	/* template */
	var __vue_template__ = __webpack_require__(698)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-992ff5a6"
	
	module.exports = __vue_exports__


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(491)
	
	/* script */
	__vue_exports__ = __webpack_require__(205)
	
	/* template */
	var __vue_template__ = __webpack_require__(711)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c1a13126"
	
	module.exports = __vue_exports__


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(459)
	
	/* script */
	__vue_exports__ = __webpack_require__(206)
	
	/* template */
	var __vue_template__ = __webpack_require__(681)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6fdc83db"
	
	module.exports = __vue_exports__


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(207)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	
	module.exports = __vue_exports__


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(445)
	
	/* script */
	__vue_exports__ = __webpack_require__(208)
	
	/* template */
	var __vue_template__ = __webpack_require__(667)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57b44e60"
	
	module.exports = __vue_exports__


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(478)
	
	/* script */
	__vue_exports__ = __webpack_require__(209)
	
	/* template */
	var __vue_template__ = __webpack_require__(700)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(482)
	
	/* script */
	__vue_exports__ = __webpack_require__(210)
	
	/* template */
	var __vue_template__ = __webpack_require__(703)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a74f5b22"
	
	module.exports = __vue_exports__


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(400)
	
	/* script */
	__vue_exports__ = __webpack_require__(211)
	
	/* template */
	var __vue_template__ = __webpack_require__(623)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-11f7029e"
	
	module.exports = __vue_exports__


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(488)
	__webpack_require__(487)
	
	/* script */
	__vue_exports__ = __webpack_require__(212)
	
	/* template */
	var __vue_template__ = __webpack_require__(708)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b4f2c59c"
	
	module.exports = __vue_exports__


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(411)
	
	/* script */
	__vue_exports__ = __webpack_require__(213)
	
	/* template */
	var __vue_template__ = __webpack_require__(634)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-23696e35"
	
	module.exports = __vue_exports__


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(431)
	
	/* script */
	__vue_exports__ = __webpack_require__(214)
	
	/* template */
	var __vue_template__ = __webpack_require__(653)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-46797a08"
	
	module.exports = __vue_exports__


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(429)
	
	/* script */
	__vue_exports__ = __webpack_require__(215)
	
	/* template */
	var __vue_template__ = __webpack_require__(651)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-454bd832"
	
	module.exports = __vue_exports__


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(392)
	
	/* script */
	__vue_exports__ = __webpack_require__(216)
	
	/* template */
	var __vue_template__ = __webpack_require__(615)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0735523a"
	
	module.exports = __vue_exports__


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(452)
	
	/* script */
	__vue_exports__ = __webpack_require__(217)
	
	/* template */
	var __vue_template__ = __webpack_require__(674)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-68df3213"
	
	module.exports = __vue_exports__


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(404)
	
	/* script */
	__vue_exports__ = __webpack_require__(218)
	
	/* template */
	var __vue_template__ = __webpack_require__(627)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-182a9524"
	
	module.exports = __vue_exports__


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(448)
	
	/* script */
	__vue_exports__ = __webpack_require__(219)
	
	/* template */
	var __vue_template__ = __webpack_require__(670)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5e8229b3"
	
	module.exports = __vue_exports__


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(433)
	
	/* script */
	__vue_exports__ = __webpack_require__(220)
	
	/* template */
	var __vue_template__ = __webpack_require__(655)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-475fb218"
	
	module.exports = __vue_exports__


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(486)
	
	/* script */
	__vue_exports__ = __webpack_require__(221)
	
	/* template */
	var __vue_template__ = __webpack_require__(707)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b40dc9a6"
	
	module.exports = __vue_exports__


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(399)
	
	/* script */
	__vue_exports__ = __webpack_require__(223)
	
	/* template */
	var __vue_template__ = __webpack_require__(622)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-10972a7a"
	
	module.exports = __vue_exports__


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(414)
	
	/* script */
	__vue_exports__ = __webpack_require__(224)
	
	/* template */
	var __vue_template__ = __webpack_require__(637)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2596bf9f"
	
	module.exports = __vue_exports__


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(481)
	
	/* script */
	__vue_exports__ = __webpack_require__(225)
	
	/* template */
	var __vue_template__ = __webpack_require__(702)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a37665a8"
	
	module.exports = __vue_exports__


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(493)
	
	/* script */
	__vue_exports__ = __webpack_require__(226)
	
	/* template */
	var __vue_template__ = __webpack_require__(713)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c527efd0"
	
	module.exports = __vue_exports__


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(456)
	
	/* script */
	__vue_exports__ = __webpack_require__(227)
	
	/* template */
	var __vue_template__ = __webpack_require__(678)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6cc99756"
	
	module.exports = __vue_exports__


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(427)
	
	/* script */
	__vue_exports__ = __webpack_require__(228)
	
	/* template */
	var __vue_template__ = __webpack_require__(649)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-44effb9a"
	
	module.exports = __vue_exports__


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(453)
	
	/* script */
	__vue_exports__ = __webpack_require__(229)
	
	/* template */
	var __vue_template__ = __webpack_require__(675)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-690aa45f"
	
	module.exports = __vue_exports__


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(417)
	
	/* script */
	__vue_exports__ = __webpack_require__(230)
	
	/* template */
	var __vue_template__ = __webpack_require__(640)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2b089551"
	
	module.exports = __vue_exports__


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(466)
	
	/* script */
	__vue_exports__ = __webpack_require__(231)
	
	/* template */
	var __vue_template__ = __webpack_require__(688)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-79284055"
	
	module.exports = __vue_exports__


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(443)
	
	/* script */
	__vue_exports__ = __webpack_require__(232)
	
	/* template */
	var __vue_template__ = __webpack_require__(665)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-524262d2"
	
	module.exports = __vue_exports__


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(398)
	
	/* script */
	__vue_exports__ = __webpack_require__(233)
	
	/* template */
	var __vue_template__ = __webpack_require__(621)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-10941352"
	
	module.exports = __vue_exports__


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(471)
	
	/* script */
	__vue_exports__ = __webpack_require__(234)
	
	/* template */
	var __vue_template__ = __webpack_require__(693)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(396)
	
	/* script */
	__vue_exports__ = __webpack_require__(235)
	
	/* template */
	var __vue_template__ = __webpack_require__(619)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(498)
	
	/* script */
	__vue_exports__ = __webpack_require__(236)
	
	/* template */
	var __vue_template__ = __webpack_require__(718)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-d08560c4"
	
	module.exports = __vue_exports__


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(408)
	
	/* script */
	__vue_exports__ = __webpack_require__(237)
	
	/* template */
	var __vue_template__ = __webpack_require__(631)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1ffc54be"
	
	module.exports = __vue_exports__


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(462)
	
	/* script */
	__vue_exports__ = __webpack_require__(238)
	
	/* template */
	var __vue_template__ = __webpack_require__(684)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-74189120"
	
	module.exports = __vue_exports__


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(430)
	
	/* script */
	__vue_exports__ = __webpack_require__(239)
	
	/* template */
	var __vue_template__ = __webpack_require__(652)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-458a48bd"
	
	module.exports = __vue_exports__


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(454)
	
	/* script */
	__vue_exports__ = __webpack_require__(240)
	
	/* template */
	var __vue_template__ = __webpack_require__(676)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6a5c435a"
	
	module.exports = __vue_exports__


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(389)
	
	/* script */
	__vue_exports__ = __webpack_require__(241)
	
	/* template */
	var __vue_template__ = __webpack_require__(612)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-04395bdb"
	
	module.exports = __vue_exports__


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(475)
	
	/* script */
	__vue_exports__ = __webpack_require__(242)
	
	/* template */
	var __vue_template__ = __webpack_require__(697)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9575a10a"
	
	module.exports = __vue_exports__


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(388)
	
	/* script */
	__vue_exports__ = __webpack_require__(243)
	
	/* template */
	var __vue_template__ = __webpack_require__(611)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0087e392"
	
	module.exports = __vue_exports__


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(483)
	
	/* script */
	__vue_exports__ = __webpack_require__(245)
	
	/* template */
	var __vue_template__ = __webpack_require__(704)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-aa5b77c2"
	
	module.exports = __vue_exports__


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(480)
	__webpack_require__(479)
	
	/* script */
	__vue_exports__ = __webpack_require__(246)
	
	/* template */
	var __vue_template__ = __webpack_require__(701)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9d65126c"
	
	module.exports = __vue_exports__


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(455)
	
	/* script */
	__vue_exports__ = __webpack_require__(247)
	
	/* template */
	var __vue_template__ = __webpack_require__(677)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6c2b071b"
	
	module.exports = __vue_exports__


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(393)
	
	/* script */
	__vue_exports__ = __webpack_require__(248)
	
	/* template */
	var __vue_template__ = __webpack_require__(616)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-07665028"
	
	module.exports = __vue_exports__


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(463)
	
	/* script */
	__vue_exports__ = __webpack_require__(249)
	
	/* template */
	var __vue_template__ = __webpack_require__(685)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-751266a8"
	
	module.exports = __vue_exports__


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(403)
	
	/* script */
	__vue_exports__ = __webpack_require__(250)
	
	/* template */
	var __vue_template__ = __webpack_require__(626)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-16d853a3"
	
	module.exports = __vue_exports__


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(402)
	
	/* script */
	__vue_exports__ = __webpack_require__(252)
	
	/* template */
	var __vue_template__ = __webpack_require__(625)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-15d2d4a6"
	
	module.exports = __vue_exports__


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(405)
	
	/* script */
	__vue_exports__ = __webpack_require__(256)
	
	/* template */
	var __vue_template__ = __webpack_require__(628)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-184b6106"
	
	module.exports = __vue_exports__


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(407)
	
	/* script */
	__vue_exports__ = __webpack_require__(260)
	
	/* template */
	var __vue_template__ = __webpack_require__(630)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1c087cec"
	
	module.exports = __vue_exports__


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(449)
	
	/* script */
	__vue_exports__ = __webpack_require__(263)
	
	/* template */
	var __vue_template__ = __webpack_require__(671)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5f172a5e"
	
	module.exports = __vue_exports__


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(410)
	
	/* script */
	__vue_exports__ = __webpack_require__(264)
	
	/* template */
	var __vue_template__ = __webpack_require__(633)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2342f6ba"
	
	module.exports = __vue_exports__


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(425)
	
	/* script */
	__vue_exports__ = __webpack_require__(265)
	
	/* template */
	var __vue_template__ = __webpack_require__(647)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3be518f0"
	
	module.exports = __vue_exports__


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(492)
	
	/* script */
	__vue_exports__ = __webpack_require__(266)
	
	/* template */
	var __vue_template__ = __webpack_require__(712)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c4a62436"
	
	module.exports = __vue_exports__


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(418)
	
	/* script */
	__vue_exports__ = __webpack_require__(267)
	
	/* template */
	var __vue_template__ = __webpack_require__(641)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2b8a99c8"
	
	module.exports = __vue_exports__


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(409)
	
	/* script */
	__vue_exports__ = __webpack_require__(268)
	
	/* template */
	var __vue_template__ = __webpack_require__(632)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-21080740"
	
	module.exports = __vue_exports__


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(441)
	
	/* script */
	__vue_exports__ = __webpack_require__(269)
	
	/* template */
	var __vue_template__ = __webpack_require__(663)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e214286"
	
	module.exports = __vue_exports__


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(434)
	
	/* script */
	__vue_exports__ = __webpack_require__(270)
	
	/* template */
	var __vue_template__ = __webpack_require__(656)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-47bfadf6"
	
	module.exports = __vue_exports__


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(440)
	
	/* script */
	__vue_exports__ = __webpack_require__(271)
	
	/* template */
	var __vue_template__ = __webpack_require__(662)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4b1b781d"
	
	module.exports = __vue_exports__


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(422)
	
	/* script */
	__vue_exports__ = __webpack_require__(272)
	
	/* template */
	var __vue_template__ = __webpack_require__(645)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-313d8c6c"
	
	module.exports = __vue_exports__


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(500)
	
	/* script */
	__vue_exports__ = __webpack_require__(273)
	
	/* template */
	var __vue_template__ = __webpack_require__(720)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f137b702"
	
	module.exports = __vue_exports__


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(415)
	
	/* script */
	__vue_exports__ = __webpack_require__(274)
	
	/* template */
	var __vue_template__ = __webpack_require__(638)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-27dcf1a2"
	
	module.exports = __vue_exports__


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(428)
	
	/* script */
	__vue_exports__ = __webpack_require__(275)
	
	/* template */
	var __vue_template__ = __webpack_require__(650)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4515bcff"
	
	module.exports = __vue_exports__


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(446)
	
	/* script */
	__vue_exports__ = __webpack_require__(276)
	
	/* template */
	var __vue_template__ = __webpack_require__(668)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5919982a"
	
	module.exports = __vue_exports__


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(485)
	
	/* script */
	__vue_exports__ = __webpack_require__(277)
	
	/* template */
	var __vue_template__ = __webpack_require__(706)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b240b08a"
	
	module.exports = __vue_exports__


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(497)
	
	/* script */
	__vue_exports__ = __webpack_require__(278)
	
	/* template */
	var __vue_template__ = __webpack_require__(717)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cf273b88"
	
	module.exports = __vue_exports__


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(464)
	
	/* script */
	__vue_exports__ = __webpack_require__(279)
	
	/* template */
	var __vue_template__ = __webpack_require__(686)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-782ebcd8"
	
	module.exports = __vue_exports__


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(473)
	
	/* script */
	__vue_exports__ = __webpack_require__(280)
	
	/* template */
	var __vue_template__ = __webpack_require__(695)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8a5b3fb6"
	
	module.exports = __vue_exports__


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(460)
	
	/* script */
	__vue_exports__ = __webpack_require__(281)
	
	/* template */
	var __vue_template__ = __webpack_require__(682)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-70922982"
	
	module.exports = __vue_exports__


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(470)
	
	/* script */
	__vue_exports__ = __webpack_require__(282)
	
	/* template */
	var __vue_template__ = __webpack_require__(692)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-813cd6e2"
	
	module.exports = __vue_exports__


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(444)
	
	/* script */
	__vue_exports__ = __webpack_require__(283)
	
	/* template */
	var __vue_template__ = __webpack_require__(666)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-53cef9da"
	
	module.exports = __vue_exports__


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(412)
	
	/* script */
	__vue_exports__ = __webpack_require__(284)
	
	/* template */
	var __vue_template__ = __webpack_require__(635)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-23a11ef4"
	
	module.exports = __vue_exports__


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(438)
	
	/* script */
	__vue_exports__ = __webpack_require__(285)
	
	/* template */
	var __vue_template__ = __webpack_require__(660)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4a1a170a"
	
	module.exports = __vue_exports__


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(490)
	
	/* script */
	__vue_exports__ = __webpack_require__(286)
	
	/* template */
	var __vue_template__ = __webpack_require__(710)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b919b908"
	
	module.exports = __vue_exports__


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(432)
	
	/* script */
	__vue_exports__ = __webpack_require__(288)
	
	/* template */
	var __vue_template__ = __webpack_require__(654)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4685eb97"
	
	module.exports = __vue_exports__


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(442)
	
	/* script */
	__vue_exports__ = __webpack_require__(289)
	
	/* template */
	var __vue_template__ = __webpack_require__(664)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5217dbb6"
	
	module.exports = __vue_exports__


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(505)
	
	/* script */
	__vue_exports__ = __webpack_require__(290)
	
	/* template */
	var __vue_template__ = __webpack_require__(724)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-fef8777e"
	
	module.exports = __vue_exports__


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(489)
	
	/* script */
	__vue_exports__ = __webpack_require__(291)
	
	/* template */
	var __vue_template__ = __webpack_require__(709)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-b61d5958"
	
	module.exports = __vue_exports__


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(474)
	
	/* script */
	__vue_exports__ = __webpack_require__(292)
	
	/* template */
	var __vue_template__ = __webpack_require__(696)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-94a64d3c"
	
	module.exports = __vue_exports__


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(447)
	
	/* script */
	__vue_exports__ = __webpack_require__(293)
	
	/* template */
	var __vue_template__ = __webpack_require__(669)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5bf740b6"
	
	module.exports = __vue_exports__


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(495)
	
	/* script */
	__vue_exports__ = __webpack_require__(294)
	
	/* template */
	var __vue_template__ = __webpack_require__(715)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c805c06c"
	
	module.exports = __vue_exports__


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(390)
	
	/* script */
	__vue_exports__ = __webpack_require__(295)
	
	/* template */
	var __vue_template__ = __webpack_require__(613)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-04f7dead"
	
	module.exports = __vue_exports__


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(401)
	
	/* script */
	__vue_exports__ = __webpack_require__(296)
	
	/* template */
	var __vue_template__ = __webpack_require__(624)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-12ace08a"
	
	module.exports = __vue_exports__


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(426)
	
	/* script */
	__vue_exports__ = __webpack_require__(297)
	
	/* template */
	var __vue_template__ = __webpack_require__(648)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3dd03562"
	
	module.exports = __vue_exports__


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(421)
	
	/* script */
	__vue_exports__ = __webpack_require__(298)
	
	/* template */
	var __vue_template__ = __webpack_require__(644)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3131eb65"
	
	module.exports = __vue_exports__


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(465)
	
	/* script */
	__vue_exports__ = __webpack_require__(300)
	
	/* template */
	var __vue_template__ = __webpack_require__(687)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-786c25ad"
	
	module.exports = __vue_exports__


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(394)
	
	/* script */
	__vue_exports__ = __webpack_require__(301)
	
	/* template */
	var __vue_template__ = __webpack_require__(617)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-099caa84"
	
	module.exports = __vue_exports__


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(467)
	
	/* script */
	__vue_exports__ = __webpack_require__(302)
	
	/* template */
	var __vue_template__ = __webpack_require__(689)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-7b014e7c"
	
	module.exports = __vue_exports__


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(458)
	
	/* script */
	__vue_exports__ = __webpack_require__(303)
	
	/* template */
	var __vue_template__ = __webpack_require__(680)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6ed7fa5e"
	
	module.exports = __vue_exports__


/***/ },
/* 611 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    ref: "keyword",
	    staticClass: "keyword",
	    class: {
	      isNew: _vm.keyword.isNew, active: _vm.active, empty: !this.keyword.value
	    },
	    style: (_vm.style),
	    on: {
	      "mousedown": _vm.dragStart
	    }
	  }, [_vm._c('div', {
	    staticClass: "tools"
	  }, [_vm._c('i', {
	    staticClass: "fa fa-close",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.destroy($event)
	      }
	    }
	  })]), _vm._v(" "), _vm._c('i', {
	    staticClass: "resize-handle icon mdi mdi-texture",
	    on: {
	      "mousedown": function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        _vm.resizeStart($event)
	      }
	    }
	  }), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.keyword.value),
	      expression: "keyword.value"
	    }],
	    ref: "input",
	    domProps: {
	      "value": _vm._s(_vm.keyword.value)
	    },
	    on: {
	      "click": _vm.focus,
	      "change": _vm.change,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.keyword.value = $event.target.value
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 612 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-signup"
	  }, [_vm._c('form', {
	    staticClass: "login-form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.login($event)
	      }
	    }
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "autofocus": "",
	      "placeholder": "E-mail",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary"
	  }, [_vm._v("Login")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), (_vm.currentUser.errors) ? _vm._l((_vm.currentUser.errors), function(msg) {
	    return _vm._c('div', {
	      staticClass: "alert alert-danger alert-contrast alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])])
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ },
/* 613 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('nav', {
	    staticClass: "navbar navbar-fixed-top"
	  }, [_vm._c('div', {
	    staticClass: "container-fluid xs-p-0"
	  }, [_vm._c('div', {
	    staticClass: "navbar-logo"
	  }, [_vm._c('router-link', {
	    staticClass: "logo",
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/logo.png"
	    }
	  })])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "right-navbar"
	  }, [(_vm.currentUser.loggedIn) ? _vm._c('LoggedInLinks') : _vm._c('LoggedOutLinks')], 1), _vm._v(" "), (_vm.page.publicNav) ? _vm._c('div', {
	    staticClass: "public-nav"
	  }, [_vm._c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('ul', {
	    staticClass: "dropdown-menu nav",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_vm._l((_vm.navLinks), function(link) {
	    return _vm._c('li', [_vm._c('router-link', {
	      attrs: {
	        "to": {
	          name: link.routeName
	        }
	      }
	    }, [_vm._v(_vm._s(link.title))])], 1)
	  }), _vm._v(" "), _vm._c('li', [(!_vm.currentUser.loggedIn) ? _vm._c('LoggedOutLinks') : _vm._e()], 1)], 2)])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._c('div', {
	    staticClass: "bar1"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "bar2"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "bar3"
	  })])
	}]}

/***/ },
/* 614 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "signup"
	  }, [_vm._c('form', {
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.subscribe($event)
	      }
	    }
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "placeholder": "Your email",
	      "aria-label": "Your email here",
	      "name": "email",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": !_vm.email || _vm.status !== ''
	    }
	  }, [_vm._v("Sign up")])])])
	},staticRenderFns: []}

/***/ },
/* 615 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "check",
	    class: {
	      selected: _vm.selected
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateSelected()
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "icon"
	  }, [(!_vm.selected) ? _vm._c('i', {
	    staticClass: "far fa-square"
	  }) : _vm._e(), _vm._v(" "), (_vm.selected) ? _vm._c('i', {
	    staticClass: "fas fa-check-square"
	  }) : _vm._e()]), _vm._v(" "), _vm._c('span', [_vm._v(_vm._s(_vm.chapter.title))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })])
	},staticRenderFns: []}

/***/ },
/* 616 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Micro Notes"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('PanelBody', [_vm._c('code', [_vm._v("#todo - list of micro notes for chapter X? not sure actually let's discuss first. page may not be needed")])])], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ },
/* 617 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless",
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    }
	  }, [_vm._v("Continue To Dashboard")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-pt-50"
	  }, [_vm._v("\n      We've sent you an email confirmation for your account,"), _vm._c('br'), _vm._v("\n      if you haven't received it in your inbox "), _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._c('strong', [_vm._v("please let use know")])]), _vm._v("!\n    ")], 1), _vm._v(" "), _vm._c('p', [_vm._v("\n      Our service is free and we look forward to hearing any "), _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._c('strong', [_vm._v("feedback")])]), _vm._v(" you have.\n    ")], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('p', {
	    staticClass: "xs-pb-30 text-larger"
	  }, [_vm._v("\n      Thank You For Signing Up With CLEX!\n      "), _vm._c('br'), _vm._v("\n      You Are Now One Step Away From Starting Your Learning Experience.\n    ")])
	}]}

/***/ },
/* 618 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "ad-block"
	  }, [_vm._c('div', {
	    class: _vm.containerClass
	  }, [_vm._c('div', {
	    staticClass: "ad-wrap"
	  }, [_vm._c('Adsense', {
	    attrs: {
	      "data-ad-client": "ca-pub-4296186765472233",
	      "data-ad-slot": "8254553837"
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ },
/* 619 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-wrapper"
	  }, [_vm._c('navbar'), _vm._v(" "), _vm._c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 620 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "inner-banner"
	  }, [_vm._c('div', {
	    staticClass: "copy",
	    class: _vm.subText ? 'with-sub' : ''
	  }, [_vm._c('h1', {
	    staticClass: "serif"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subText) ? _vm._c('p', [_vm._v("\n      " + _vm._s(_vm.subText) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "bg"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": _vm.title
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_500.jpg',
	      "media": "(max-width: 500px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_800.jpg',
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_1200.jpg',
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_1600.jpg',
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_2000.jpg',
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": _vm.imageUrl + '_1600.jpg',
	      "alt": ""
	    }
	  })])], 1)])
	},staticRenderFns: []}

/***/ },
/* 621 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "container xs-pt-30 xs-pb-50"
	  }, [_vm._c('h1', {
	    staticClass: "serif"
	  }, [_vm._v("Terms and Conditions")]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('p', [_vm._v("\n      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut non condimentum est, porttitor semper lectus. Cras tincidunt pretium dapibus. Aliquam erat volutpat. Fusce varius augue lacus, et condimentum lacus congue in. Nam aliquam nisi ut nisl pharetra, ac feugiat eros tincidunt. Integer non scelerisque neque, a semper arcu. Etiam fermentum placerat arcu. Donec consectetur, purus quis ullamcorper tincidunt, orci erat placerat magna, ut molestie leo leo eu eros. Morbi ut tortor a ex maximus venenatis. Integer varius, arcu id ultricies malesuada, metus sem lobortis tortor, quis cursus tortor neque vel orci. Fusce feugiat ante blandit est hendrerit finibus. Nullam ultrices sit amet neque sit amet mattis. Nam lobortis nulla vel diam consectetur volutpat. Nam porttitor mattis diam, nec sodales nunc pulvinar non. Vivamus eget justo nisl. Nulla finibus odio odio, eu suscipit magna semper ac.\n    ")]), _vm._c('p', [_vm._v("\n      Maecenas pulvinar nisi sit amet ligula congue, imperdiet varius diam posuere. Vestibulum ac est vestibulum, ultrices erat et, accumsan purus. Suspendisse potenti. Phasellus condimentum lorem a quam tincidunt mattis. In pulvinar erat at arcu molestie, vitae mollis enim dapibus. Nulla arcu arcu, aliquet ut urna sit amet, tristique tristique erat. Cras eu metus ligula. Quisque elit ipsum, ornare eget quam sit amet, commodo aliquam diam. Cras feugiat lorem a sapien tincidunt, a molestie elit pretium. Curabitur molestie tellus eu consequat pulvinar.\n    ")]), _vm._c('p', [_vm._v("\n      Nunc gravida nulla arcu. Praesent id posuere felis. Mauris risus sapien, aliquet ut mollis sit amet, sollicitudin at velit. Etiam eget porta justo. Donec eget interdum sapien. Proin id diam elit. Sed aliquet lacus velit, a ultrices metus sagittis placerat. Pellentesque eu arcu est. Integer et ornare erat. Curabitur porta quam sed diam fermentum, ut condimentum tellus pretium. Phasellus in molestie nulla, sed pretium tortor.\n    ")])])])
	}]}

/***/ },
/* 622 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "wrap-blue banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 col-md-push-6  pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner2_400.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner2_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner2_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner2_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/about/banner2_800.jpg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 col-md-pull-6 banner-content-wrap"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            We are truly a learning company inside and out! Our goal is to provide the best learning resources and never stop improving, just like the learners we serve. Our ongoing research and development will ensure we deliver the tools that best serve your needs.\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank xs-full-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
	    staticClass: "hidden-xs col-sm-3"
	  }, [_vm._c('VerticalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  })], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row hidden visible-xs"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('HorizontalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  })], 1)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "wrap-black banner-with-copy bottom-banner"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner3_400.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner3_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner3_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner3_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/about/banner3_800.jpg",
	      "alt": ""
	    }
	  })])], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _vm._c('div', {
	    staticClass: "hidden-xs col-sm-3"
	  }, [_vm._c('VerticalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row hidden visible-xs"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('HorizontalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('h1', [_vm._v("Together "), _vm._c('br'), _vm._v("We Learn")])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-9 large-text"
	  }, [_vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          CLEX stands for "), _vm._c('strong', [_vm._v("Contextual Learning Experience")]), _vm._v(". True to our name, CLEX Software is a web-based study tool dedicated to improving an individual’s capacity for learning by utilizing an individually optimized methodology to maximize each user’s studying potential.\n          We allows learners to organize study materials into micro-notes, identify keywords in their lessons, and prioritize what you need to study.\n        ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          CLEX is all about bringing learners together through study communities.\n        ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          We give you the ability to challenge yourself using individualized study levels, that you can control. It's our mission that as learners advance through their studies, their confidence grows. CLEX combines content from multiple sources into organized modules and it’s accessible anywhere you go.\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._c('p', {
	    staticClass: "x-large-text"
	  }, [_vm._v("\n            CLEX offers a "), _vm._c('strong', [_vm._v("FREE")]), _vm._v(" study service that is results oriented for all students.\n          ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-9"
	  }, [_vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          CLEX is aware that the cost of post secondary education is very expensive and in order to make your life as stress free as possible, we are giving you CLEX for free at no charge with no obligation to purchase for as long as you need it. No three month trial like most service providers.\n        ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          CLEX PLUS will offer students the option to purchase additional learning modules, that will help provide further learning support on top of CLEX. It is our intention to keep our learning module prices as low as possible, no more than the cost of a hamburger.\n        ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          Should you purchase a module or two from us, "), _vm._c('strong', [_vm._v("CLEX will still remain free to use at all times")]), _vm._v(".\n        ")])])
	}]}

/***/ },
/* 623 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "score"
	  }, [_vm._c('h3', [_vm._v("You got " + _vm._s(_vm.percentScore) + "% correct.")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "sub"
	  }, [_vm._v("When do you want to re-study this micro-note?")])])
	},staticRenderFns: []}

/***/ },
/* 624 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "signup"
	  }, [_vm._c('form', {
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.subscribe($event)
	      }
	    }
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "placeholder": "Your email",
	      "aria-label": "Your email here",
	      "name": "email",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": !_vm.email || _vm.status !== ''
	    }
	  }, [_vm._v("Sign up")])])])
	},staticRenderFns: []}

/***/ },
/* 625 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-signup"
	  }, [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "splash-container"
	  }, [_vm._c('div', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
	    staticClass: "panel-body"
	  }, [_vm._c('span', {
	    staticClass: "splash-title xs-pb-20"
	  }, [_vm._v("Join our mailing list")]), _vm._v(" "), _vm._c('SubscribeForm', {
	    staticClass: "sub"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _vm._c('hr', {
	    staticStyle: {
	      "margin": "40px 0px"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "row text-center"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('p', [_vm._v("Looking to unsubscribe?")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "to": "/newsletter-unsubscribe"
	    }
	  }, [_vm._v("Unsubscribe")])], 1)])], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "panel-heading"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "102px"
	    },
	    attrs: {
	      "src": "/static/img/logo.png"
	    }
	  })])
	}]}

/***/ },
/* 626 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [_vm._c('li', [_vm._c('a', {
	    attrs: {
	      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
	    }
	  }, [_vm._v("Sign Up")])]), _vm._v(" "), _vm._c('li', [_vm._c('a', {
	    attrs: {
	      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
	    }
	  }, [_vm._v("Log In")])])])
	}]}

/***/ },
/* 627 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('Panel', {}, [_vm._c('PanelHeading', {
	    attrs: {
	      "title": "subject.title",
	      "subtitle": _vm.chapters.length + ' chapter' + (_vm.chapters.length > 1 ? 's' : '')
	    }
	  }, [_vm._c('div', {
	    slot: "title"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('span', {
	    staticClass: "expandButton",
	    on: {
	      "click": _vm.toggleExpanded
	    }
	  }, [_vm._v(_vm._s(_vm.subject.title))]), _vm._v(" "), _vm._c('span', {
	    staticClass: "expandButton",
	    on: {
	      "click": _vm.toggleExpanded
	    }
	  }, [(_vm.expanded) ? _vm._c('span', {
	    staticClass: "icon mdi mdi-chevron-down"
	  }) : _vm._c('span', {
	    staticClass: "icon mdi mdi-chevron-right"
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-default select-all",
	    on: {
	      "click": function($event) {
	        _vm.selectAll()
	      }
	    }
	  }, [_vm._v("Select all")])])])])]), _vm._v(" "), (_vm.expanded) ? _vm._c('PanelBody', _vm._l((_vm.chapters), function(chapter) {
	    return _vm._c('div', [_vm._c('ChapterRow', {
	      attrs: {
	        "chapter": chapter
	      }
	    })], 1)
	  })) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 628 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "page-head"
	  }, [_vm._t("top"), _vm._v(" "), _vm._c('h2', {
	    staticClass: "page-head-title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subtitle) ? _vm._c('p', {
	    staticClass: "page-head-description"
	  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 629 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('PageHeader', {
	    attrs: {
	      "title": 'Receive Study Notes'
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary xs-mt-0"
	  }, [(_vm.receivedShares.length > 0) ? _vm._c('PanelBody', {
	    staticClass: "xs-pt-20 xs-pb-20"
	  }, [_vm._l((_vm.receivedShares), function(share) {
	    return _vm._c('ReceiveChapterRow', {
	      attrs: {
	        "share": share
	      }
	    })
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "xs-pt-20"
	  }, [_vm._c('strong', [_vm._v("Import selected study notes to:")]), _vm._c('br'), _vm._v(" "), _vm._c('div', {
	    staticClass: "row xs-mt-10"
	  }, [(_vm.subjects && _vm.subjects.length && !_vm.newSubjectTitle) ? _vm._c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._c('label', {
	    attrs: {
	      "for": "lectureNoteSubject"
	    }
	  }, [_vm._v("Place in existing subject")]), _vm._v(" "), _vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedSubjectId),
	      expression: "selectedSubjectId"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "lectureNoteSubject"
	    },
	    on: {
	      "change": [function($event) {
	        _vm.selectedSubjectId = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, function($event) {
	        _vm.newSubjectTitle = ''
	      }]
	    }
	  }, [_vm._c('option'), _vm._v(" "), _vm._l((_vm.subjects), function(subject) {
	    return _vm._c('option', {
	      domProps: {
	        "value": subject.id
	      }
	    }, [_vm._v(_vm._s(subject.title))])
	  })], 2)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('label', {
	    attrs: {
	      "for": "newLectureNoteSubject"
	    }
	  }, [(_vm.subjects && _vm.subjects.length && !_vm.newSubjectTitle) ? _vm._c('span', [_vm._v("Or ")]) : _vm._e(), _vm._v("Create a new subject")]), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newSubjectTitle),
	      expression: "newSubjectTitle"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "newLectureNoteSubject",
	      "placeholder": "Subject Name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newSubjectTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newSubjectTitle = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "pull-right buttons"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-danger btn-xl",
	    attrs: {
	      "disabled": _vm.selectedShareImportIds.length <= 0 || _vm.saving
	    },
	    on: {
	      "click": function($event) {
	        _vm.declineSelected()
	      }
	    }
	  }, [_vm._v("Decline selected")]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary btn-xl",
	    attrs: {
	      "disabled": _vm.selectedShareImportIds.length <= 0 || !_vm.validSubject || _vm.saving
	    },
	    on: {
	      "click": function($event) {
	        _vm.importSelected()
	      }
	    }
	  }, [_vm._v("Import selected")]), _vm._v("  \n              ")])])], 2) : _vm._c('PanelBody', {
	    staticClass: "xs-pt-20 xs-pb-20"
	  }, [_vm._c('div', {
	    staticClass: "alert alert-warning"
	  }, [_vm._v("No study notes to import")])])], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ },
/* 630 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "edit-container"
	  }, [_vm._c('div', {
	    ref: "editable",
	    attrs: {
	      "contenteditable": ""
	    },
	    on: {
	      "input": _vm.onInput
	    }
	  }), _vm._v(" "), (_vm.showPlaceHolder) ? _vm._c('div', {
	    staticClass: "placeholder"
	  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 631 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Define Micro Notes"
	    }
	  }, [(_vm.lectureNote && _vm.microNotable()) ? _vm._c('a', {
	    staticClass: "btn btn-primary btn-lg",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.convertToMicroNotes($event)
	      }
	    },
	    slot: "top"
	  }, [_vm._c('i', {
	    staticClass: "fas fa-save"
	  }), _vm._v("   Create micro notes\n    ")]) : _vm._c('a', {
	    staticClass: "btn btn-default btn-lg disabled",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "href": "",
	      "disabled": ""
	    },
	    slot: "top"
	  }, [_vm._c('i', {
	    staticClass: "fas fa-save"
	  }), _vm._v("   Create micro notes\n    ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn btn-danger btn-lg",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    },
	    slot: "top"
	  }, [_vm._c('i', {
	    staticClass: "fas fa-arrow-left"
	  }), _vm._v("   Cancel\n    ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "pull-left",
	    staticStyle: {
	      "margin-top": "10px"
	    }
	  }, [_vm._c('Help', {
	    attrs: {
	      "showhelp": _vm.showHelp
	    }
	  }, [_vm._c('div', {
	    slot: "content"
	  }, [_vm._v("\n          Split your lecture notes into micro notes with the "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" button. Select keywords to be hidden/tested with the "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-key"
	  })]), _vm._v(" button."), _vm._c('br'), _vm._v("\n          Click an image and select "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-object-group"
	  })]), _vm._v(" to convert the image to a micro note. Image keywords can be set in the next stage."), _vm._c('br'), _vm._v("\n          Click "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-save"
	  }), _vm._v(" Create micro notes")]), _vm._v(" to save and proceed to micro note image editing.\n        ")])])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "text-right pull-right"
	  }, [(_vm.lectureNote) ? _vm._c('KeywordSettings', {
	    attrs: {
	      "chapterId": _vm.lectureNote.chapter_id
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row height-100"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12 height-100"
	  }, [(_vm.lectureNote) ? _vm._c('div', {
	    staticClass: "height-100-minus"
	  }, [(_vm.showReplaceWarning) ? _vm._c('div', {
	    staticClass: "bg-danger clearfix"
	  }, [_vm._c('p', {
	    staticClass: "pull-left"
	  }, [_vm._c('b', [_vm._v("Warning:")]), _vm._v(" You've created " + _vm._s(_vm.lectureNote.micro_note_count) + " micro notes based on this lecture note. Those micro notes will be deleted. Are you sure you want to proceed?\n            ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "pull-right"
	  }, [_vm._c('a', {
	    staticClass: "btn btn-default btn-sm",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.replaceMicroNotes($event)
	      }
	    }
	  }, [_vm._v("\n                Replace\n              ")]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn btn-default btn-sm btn-margin",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleReplaceWarning($event)
	      }
	    }
	  }, [_vm._v("\n                Cancel\n              ")])])]) : _vm._e(), _vm._v(" "), _vm._c('FroalaEditor', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.lectureNote.html),
	      expression: "lectureNote.html"
	    }],
	    ref: "editor",
	    attrs: {
	      "chapterId": _vm.lectureNote.chapter_id,
	      "config": _vm.froalaConfig,
	      "image-created-function": _vm.imageCreated
	    },
	    domProps: {
	      "value": (_vm.lectureNote.html)
	    },
	    on: {
	      "change": _vm.saveLectureNote,
	      "input": function($event) {
	        _vm.lectureNote.html = $event
	      }
	    }
	  }), _vm._v(" "), (_vm.lectureNote && _vm.microNotable()) ? _vm._c('a', {
	    staticClass: "btn btn-primary btn-lg",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.convertToMicroNotes($event)
	      }
	    },
	    slot: "top"
	  }, [_vm._c('i', {
	    staticClass: "fas fa-save"
	  }), _vm._v("   Create micro notes\n          ")]) : _vm._c('a', {
	    staticClass: "btn btn-default btn-lg disabled",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "href": "",
	      "disabled": ""
	    },
	    slot: "top"
	  }, [_vm._c('i', {
	    staticClass: "fas fa-save"
	  }), _vm._v("   Create micro notes\n          ")])], 1) : _vm._c('div', [_vm._c('LoadingIndicator')], 1)])])])], 1)
	},staticRenderFns: []}

/***/ },
/* 632 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-left-sidebar"
	  }, [_vm._c('div', {
	    staticClass: "left-sidebar-wrapper"
	  }, [_vm._c('a', {
	    staticClass: "left-sidebar-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Navigation")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "left-sidebar-spacer"
	  }, [_vm._c('div', {
	    staticClass: "left-sidebar-scroll"
	  }, [_vm._c('div', {
	    staticClass: "left-sidebar-content"
	  }, [_vm._c('ul', {
	    staticClass: "sidebar-elements"
	  }, [_vm._c('li', {
	    staticClass: "divider"
	  }, [_vm._v("Menu")]), _vm._v(" "), _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      },
	      "tag": "li"
	    }
	  }, [_vm._c('a', [_vm._c('i', {
	    staticClass: "icon fas fa-home"
	  }), _vm._c('span', [_vm._v("Subject Shelf")])])]), _vm._v(" "), (_vm.showImport) ? _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'importer'
	      },
	      "tag": "li"
	    }
	  }, [_vm._c('a', [_vm._c('i', {
	    staticClass: "icon fas fa-cloud-upload-alt"
	  }), _vm._c('span', [_vm._v("Import Lecture Notes")])])]) : _vm._e(), _vm._v(" "), (_vm.showImport) ? _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'exporter'
	      },
	      "tag": "li"
	    }
	  }, [_vm._c('a', [_vm._c('i', {
	    staticClass: "icon fas fa-file-export"
	  }), _vm._c('span', [_vm._v("Export Lecture Notes")])])]) : _vm._e(), _vm._v(" "), (_vm.receivedShares.length > 0) ? _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'receive-chapter'
	      },
	      "tag": "li"
	    }
	  }, [_vm._c('a', [_vm._c('i', {
	    staticClass: "icon fas fa-share-square"
	  }), _vm._c('span', [_vm._v("Shared Lecture Notes")])])]) : _vm._e(), _vm._v(" "), (_vm.showAdmin) ? _vm._c('li', {
	    staticClass: "divider"
	  }, [_vm._v("Admin")]) : _vm._e(), _vm._v(" "), (_vm.showAdmin) ? _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'ad-manager'
	      },
	      "tag": "li"
	    }
	  }, [_vm._c('a', [_vm._c('i', {
	    staticClass: "icon mdi mdi-view-dashboard"
	  }), _vm._c('span', [_vm._v("Manage Ads")])])]) : _vm._e(), _vm._v(" "), (_vm.showAdmin || _vm.showBlogger) ? _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-manager'
	      },
	      "tag": "li"
	    }
	  }, [_vm._c('a', [_vm._c('i', {
	    staticClass: "icon fas fa-font"
	  }), _vm._c('span', [_vm._v("Manage Blog")])])]) : _vm._e(), _vm._v(" "), (_vm.showAdmin) ? _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'user-manager'
	      },
	      "tag": "li"
	    }
	  }, [_vm._c('a', [_vm._c('i', {
	    staticClass: "icon fas fa-users"
	  }), _vm._c('span', [_vm._v("Manage Users")])])]) : _vm._e(), _vm._v(" "), (_vm.showAdmin) ? _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'user-activity-report'
	      },
	      "tag": "li"
	    }
	  }, [_vm._c('a', [_vm._c('i', {
	    staticClass: "icon fas fa-user-clock"
	  }), _vm._c('span', [_vm._v("User Activity Report")])])]) : _vm._e()], 1)])])]), _vm._v(" "), (_vm.studyProgressPercent || _vm.totalNotesCount) ? _vm._c('div', {
	    staticClass: "progress-widget"
	  }, [_vm._c('div', {
	    staticClass: "progress-data"
	  }, [_vm._c('span', {
	    staticClass: "progress-value"
	  }, [_vm._v(_vm._s(_vm.completedNotesCount) + "/" + _vm._s(_vm.totalNotesCount))]), _vm._c('span', {
	    staticClass: "name"
	  }, [_vm._v("Study Progress")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "progress"
	  }, [_vm._c('div', {
	    staticClass: "progress-bar progress-bar-primary",
	    class: {
	      'progress-bar-success': _vm.studyProgressPercent === 100
	    },
	    style: ('width: ' + _vm.studyProgressPercent + '%')
	  })])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ },
/* 633 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "panel-heading"
	  }, [_vm._t("top"), _vm._v(" "), _vm._t("title", [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subtitle) ? _vm._c('span', {
	    staticClass: "panel-subtitle"
	  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 634 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    attrs: {
	      "id": "studyIntervalButtons"
	    }
	  }, [_vm._c('div', {
	    staticClass: "btn-group btn-group-justified"
	  }, [_vm._c('a', {
	    staticClass: "btn btn-repeat btn-default btn-lg",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.setMicroNoteNextStudy(0)
	      }
	    }
	  }, [_vm._c('span', [_vm._v("Repeat - ")]), _vm._v("Now")]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn btn-hard btn-default btn-lg",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.setMicroNoteNextStudy(24)
	      }
	    }
	  }, [_vm._c('span', [_vm._v("Hard - ")]), _vm._v("1 Day")]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn btn-medium btn-default btn-lg",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.setMicroNoteNextStudy(72)
	      }
	    }
	  }, [_vm._c('span', [_vm._v("Good - ")]), _vm._v("3 Days")]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn btn-easy btn-default btn-lg",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.setMicroNoteNextStudy(168)
	      }
	    }
	  }, [_vm._c('span', [_vm._v("Easy - ")]), _vm._v("1 Week")])])])
	},staticRenderFns: []}

/***/ },
/* 635 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "container xs-pt-30 xs-pb-50"
	  }, [_vm._c('h1', {
	    staticClass: "serif"
	  }, [_vm._v("Feedback Form")]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('InquiryForm', {
	    attrs: {
	      "subject": "Feedback form"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 636 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('PageHeader', {
	    attrs: {
	      "title": 'Share ' + (_vm.chapter ? _vm.chapter.title : 'Chapter')
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary xs-mt-0"
	  }, [(_vm.chapter) ? _vm._c('PanelBody', {
	    staticClass: "xs-pt-20 xs-pb-20"
	  }, [_vm._c('div', {
	    staticClass: "xs-mb-20 text-bold"
	  }, [_vm._v("Enter the email address of the users you would like to share with.")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-3"
	  }, [_vm._c('label', {
	    staticClass: "sm-pt-10",
	    attrs: {
	      "for": "txtEmail"
	    }
	  }, [_vm._v("Search on email address")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-9"
	  }, [_vm._c('div', {
	    staticClass: "input-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchEmail),
	      expression: "searchEmail"
	    }],
	    staticClass: "form-control pull-left",
	    attrs: {
	      "type": "email",
	      "id": "txtEmail",
	      "placeholder": "enter email address"
	    },
	    domProps: {
	      "value": _vm._s(_vm.searchEmail)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchEmail = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "input-group-addon"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-primary btn-xl",
	    attrs: {
	      "disabled": !_vm.emailValid || _vm.searching
	    },
	    on: {
	      "click": function($event) {
	        _vm.searchUser()
	      }
	    }
	  }, [_vm._v("Search")])])]), _vm._v(" "), (_vm.userSearchResults.length > 0) ? _vm._c('div', {
	    staticClass: "search-results"
	  }, [_vm._c('table', _vm._l((_vm.userSearchResults), function(user) {
	    return _vm._c('tr', [_vm._c('td', {
	      staticClass: "email"
	    }, [_vm._v(_vm._s(user.email))]), _vm._v(" "), _vm._c('td', {
	      staticStyle: {
	        "width": "50px"
	      }
	    }, [_vm._c('button', {
	      staticClass: "btn btn-primary btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.addEmail(user)
	        }
	      }
	    }, [_vm._c('i', {
	      staticClass: "fas fa-plus"
	    })])])])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.showNoResultsMessage) ? _vm._c('div', {
	    staticClass: "search-results no-results"
	  }, [_vm._v("\n                  No users found with this email address.\n                ")]) : _vm._e()])]), _vm._v(" "), (_vm.sharingEmails.length > 0) ? _vm._c('div', [_vm._c('hr'), _vm._v(" "), _vm._c('strong', [_vm._v("Sharing '" + _vm._s(_vm.chapter.title) + "' with:")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row sharing-emails"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('table', _vm._l((_vm.sharingEmails), function(user) {
	    return _vm._c('tr', [_vm._c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _vm._c('td', [_vm._c('button', {
	      staticClass: "btn btn-danger btn-sm",
	      on: {
	        "click": function($event) {
	          _vm.removeEmail(user)
	        }
	      }
	    }, [_vm._c('i', {
	      staticClass: "fas fa-times"
	    })])])])
	  }))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('button', {
	    staticClass: "pull-right btn btn-primary btn-xl",
	    attrs: {
	      "disabled": _vm.sharingEmails.length <= 0
	    },
	    on: {
	      "click": function($event) {
	        _vm.share()
	      }
	    }
	  }, [_vm._v("Share with " + _vm._s(_vm.sharingEmails.length) + " user" + _vm._s(_vm.sharingEmails.length > 1 ? 's' : ''))])])])]) : _vm._e()]) : _vm._c('PanelBody', {
	    staticClass: "xs-pt-20 xs-pb-20"
	  }, [_vm._c('div', {
	    staticClass: "alert alert-warning"
	  }, [_vm._v("No chapter selected")])])], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ },
/* 637 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "wrap-blue banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-push-6 col-md-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/advertise/banner2_400.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/advertise/banner2_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/advertise/banner2_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/advertise/banner2_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/advertise/banner2_800.jpg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-pull-6 col-md-6 banner-content-wrap"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            Part of our mission is bringing people together who love to learn! Come be a part of it and see what CLEX advertising has to offer. We can serve your brand’s ads either directly on our secure platform or from your preferred third-party provider (Google, Bing, etc.).\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank xs-full-width",
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._v("Become A Partner Today")])], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "ptb-100 text-center ad-content"
	  }, [_vm._c('div', {
	    staticClass: "inner"
	  }, [_vm._c('p'), _vm._c('h2', {
	    staticClass: "xs-mb-50"
	  }, [_vm._v("As Seen On...")]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-mb-50 large-text"
	  }, [_vm._v("We can achieve much more when we learn together. Become part of our team as an Advertising Partner.")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-border-primary",
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._v("Become A Partner Today")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row xs-pt-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('HorizontalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  })], 1)])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('h1', [_vm._v("Become "), _vm._c('br'), _vm._v("A Partner")])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row xs-mb-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 xs-p-10"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/advertise/google.png",
	      "alt": "Google",
	      "title": "Google"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 xs-p-10"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/advertise/bing.gif",
	      "alt": "Bing",
	      "title": "Bing"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 xs-p-10"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/advertise/Taboola.png",
	      "alt": "Taboola",
	      "title": "Taboola"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 xs-p-10"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/advertise/Yahoo.png",
	      "alt": "Yahoo",
	      "title": "Yahoo"
	    }
	  })])])
	}]}

/***/ },
/* 638 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return (!_vm.deleted) ? _vm._c('div', {
	    staticClass: "comment"
	  }, [_vm._c('div', {
	    staticClass: "avatar"
	  }, [(!_vm.currentUser || _vm.currentUser.id != _vm.comment.user_id) ? _vm._c('i', {
	    staticClass: "fas fa-user-circle"
	  }) : _vm._c('img', {
	    attrs: {
	      "src": "/static/img/avatar.png",
	      "alt": "Avatar"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "body"
	  }, [_vm._c('div', {
	    staticClass: "head"
	  }, [(!_vm.currentUser || _vm.currentUser.id != _vm.comment.user_id) ? _vm._c('strong', [_vm._v(_vm._s(_vm.comment.user_first_name) + " " + _vm._s(_vm.comment.user_last_name))]) : _vm._c('strong', [_vm._v("You")]), _vm._v(" "), _vm._c('span', {
	    staticStyle: {
	      "margin-left": "20px"
	    }
	  }, [_vm._v(_vm._s(_vm.friendlyDate))]), _vm._v(" "), (_vm.showDelete) ? _vm._c('button', {
	    staticClass: "btn btn-danger btn-sm pull-right",
	    on: {
	      "click": function($event) {
	        _vm.deleteComment()
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-trash"
	  }), _vm._v("   Delete")]) : _vm._e()]), _vm._v(" "), _vm._c('div', {
	    staticClass: "text"
	  }, [_vm._c('strong', [_vm._v("\"")]), _vm._v(_vm._s(_vm.comment.body)), _vm._c('strong', [_vm._v("\"")])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 639 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Manage Users",
	      "subtitle": ""
	    }
	  }), _vm._v(" "), _vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 xs-p-40"
	  }, [_vm._c('p', [_vm._c('strong', [_vm._v("Download user CSVs")])]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary btn-xl",
	    attrs: {
	      "disabled": _vm.saving
	    },
	    on: {
	      "click": function($event) {
	        _vm.downloadUsers()
	      }
	    }
	  }, [_vm._v("Download registered users")]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-warning btn-xl",
	    attrs: {
	      "disabled": _vm.saving
	    },
	    on: {
	      "click": function($event) {
	        _vm.downloadSubs()
	      }
	    }
	  }, [_vm._v("Download newsletter subscribers")])])])])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 640 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "container-fluid footer"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-4 text-center xs-mb-30 "
	  }, [_vm._c('span', [_vm._v("We'd love to hear from you")]), _vm._c('br'), _vm._v(" "), _vm._c('div', {
	    staticClass: "footer-nav xs-mt-20"
	  }, [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._v("Contact us")]), _vm._v(" |\n        "), _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'feedback-form'
	      }
	    }
	  }, [_vm._v("Feedback form")])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-4 text-right xs-mb-30"
	  }, [_vm._c('span', [_vm._v("Join our mailing list")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _vm._c('SubscribeForm', {
	    staticClass: "sub"
	  })], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 text-right"
	  }, [_vm._v("\n      © Copyright CLEX " + _vm._s(_vm.year) + "\n    ")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row text-center"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 title-text  xs-pb-50"
	  }, [_vm._v("\n      Learn Smarter, Organize Notes, Remember Everything. Get Started With Us, "), _vm._c('strong', [_vm._v("For Free!")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row text-center"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 xs-pb-50"
	  }, [_vm._c('a', {
	    staticClass: "btn-pub btn-pub-default",
	    attrs: {
	      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
	    }
	  }, [_vm._v("Sign Up For Free")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-md-4 xs-mb-30"
	  }, [_vm._c('span', [_vm._v("Follow Us")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "social-links"
	  }, [_vm._c('a', {
	    attrs: {
	      "href": "https://facebook.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/facebook2.png"
	    }
	  })]), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://twitter.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/twitter2.png"
	    }
	  })]), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://instagram.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/instagram2.png"
	    }
	  })]), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://youtube.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/youtube2.png"
	    }
	  })]), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://linkedin.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/linkedin2.png"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "footer-nav"
	  }, [_vm._c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.websitepolicies.com/policies/view/ppLviGYs"
	    }
	  }, [_vm._v("Terms & conditions")]), _vm._v(" |\n        "), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://www.iubenda.com/privacy-policy/71921731/legal",
	      "target": "_blank"
	    }
	  }, [_vm._v("Privacy Policy")])])])
	}]}

/***/ },
/* 641 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "dynamic-table"
	  }, [_vm._c('table', {
	    staticClass: "table table-striped"
	  }, [_vm._c('thead', [_vm._c('tr', [_vm._l((_vm.cols), function(col) {
	    return _vm._c('th', [_vm._c('span', {
	      class: {
	        'sort': (_vm.sort.by === col.prop)
	      },
	      on: {
	        "click": function($event) {
	          _vm.changeSort(col.prop)
	        }
	      }
	    }, [_vm._v(_vm._s(col.name))]), _vm._v(" "), (_vm.sort.by === col.prop && _vm.sort.direction === 'desc') ? _vm._c('i', {
	      staticClass: "fas fa-sort-amount-up"
	    }) : _vm._e(), _vm._v(" "), (_vm.sort.by === col.prop && _vm.sort.direction === 'asc') ? _vm._c('i', {
	      staticClass: "fas fa-sort-amount-down"
	    }) : _vm._e()])
	  }), _vm._v(" "), (_vm.onClick) ? _vm._c('td') : _vm._e()], 2)]), _vm._v(" "), _vm._c('tbody', [_vm._l((_vm.rowData), function(row) {
	    return (_vm.rowData.length > 0) ? _vm._c('tr', [_vm._l((row.data), function(col) {
	      return _vm._c('td', [_vm._v("\n          " + _vm._s(col) + "\n        ")])
	    }), _vm._v(" "), _vm._c('td', {
	      staticClass: "text-right",
	      on: {
	        "click": function($event) {
	          _vm.onClick(row.id)
	        }
	      }
	    }, [_vm._m(0, true)])], 2) : _vm._e()
	  }), _vm._v(" "), (_vm.rowData.length <= 0) ? _vm._c('tr', [_vm._c('td', {
	    staticClass: "text-center xs-p-20",
	    attrs: {
	      "colspan": _vm.cols.length + (_vm.onClick ? 1 : 0)
	    }
	  }, [_vm._v("\n          No records to show\n        ")])]) : _vm._e()], 2), _vm._v(" "), (_vm.paging.show) ? _vm._c('tfoot', [_vm._c('tr', [_vm._c('td', {
	    staticClass: "xs-pt-20 xs-pb-20",
	    attrs: {
	      "colspan": _vm.cols.length + (_vm.onClick ? 1 : 0)
	    }
	  }, [_vm._c('ul', {
	    staticClass: "paging text-center"
	  }, [_vm._c('li', [_vm._c('a', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "disabled": _vm.paging.pageNum <= 1
	    },
	    on: {
	      "click": _vm.prevPage
	    }
	  }, [_vm._c('i', {
	    staticClass: "mdi mdi-chevron-left"
	  })])]), _vm._v(" "), _vm._l((_vm.paging.numPages), function(p) {
	    return _vm._c('li', [_vm._c('a', {
	      staticClass: "btn btn-default",
	      class: {
	        'btn-primary': _vm.paging.pageNum === p
	      },
	      on: {
	        "click": function($event) {
	          _vm.changePage(p)
	        }
	      }
	    }, [_vm._v(_vm._s(p))])])
	  }), _vm._v(" "), _vm._c('li', [_vm._c('a', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "disabled": _vm.paging.pageNum >= _vm.paging.numPages
	    },
	    on: {
	      "click": _vm.nextPage
	    }
	  }, [_vm._c('i', {
	    staticClass: "mdi mdi-chevron-right"
	  })])])], 2)])])]) : _vm._e()], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('button', {
	    staticClass: "btn btn-primary"
	  }, [_vm._c('i', {
	    staticClass: "fas fa-edit"
	  })])
	}]}

/***/ },
/* 642 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-wrapper be-error be-error-404"
	  }, [_vm._c('navbar'), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "error-container"
	  }, [_vm._c('div', {
	    staticClass: "error-number"
	  }, [_vm._v("404")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "error-description"
	  }, [_vm._v("Whoops, something went wrong!")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "error-goback-text"
	  }, [_vm._v("Please try again or contact us if the problem continues.")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "error-goback-button"
	  }, [_vm._c('a', {
	    staticClass: "btn btn-xl btn-primary",
	    attrs: {
	      "href": "/"
	    }
	  }, [_vm._v("Let's go home")])])])
	}]}

/***/ },
/* 643 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._c('router-view')], 1)
	},staticRenderFns: []}

/***/ },
/* 644 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "edit-container"
	  }, [_vm._c('div', {
	    ref: "editable",
	    attrs: {
	      "contenteditable": ""
	    },
	    on: {
	      "input": _vm.onInput
	    }
	  }), _vm._v(" "), (_vm.showPlaceHolder) ? _vm._c('div', {
	    staticClass: "placeholder"
	  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 645 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('tr', [_vm._c('td', {
	    staticClass: "hidden-xs"
	  }), _vm._v(" "), _vm._c('td', {
	    staticClass: "cell-detail",
	    class: {
	      editingTitle: _vm.editingTitle
	    }
	  }, [(_vm.editingTitle) ? _vm._c('form', {
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.finishEditingTitle($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "input-group input-group-sm"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newTitle),
	      expression: "newTitle"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "on-click-away",
	      rawName: "v-on-click-away",
	      value: (_vm.cancelEditingTitle),
	      expression: "cancelEditingTitle"
	    }],
	    staticClass: "form-control input-sm",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newTitle)
	    },
	    on: {
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "esc", 27)) { return; }
	        _vm.cancelEditingTitle($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._m(0)])]) : _vm._c('div', [_vm._c('span', {
	    on: {
	      "dblclick": _vm.startEditingTitle
	    }
	  }, [_vm._v("\n        " + _vm._s(_vm.chapter.title) + "\n        ")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "cell-detail-description"
	  }, [_vm._v("\n        " + _vm._s(_vm.activeMicroNoteCount || 0) + "\n        Micro Note" + _vm._s((_vm.activeMicroNoteCount || 0) === 1 ? '' : 's') + "\n      ")])])]), _vm._v(" "), (_vm.studyProgressPercent === 100) ? _vm._c('td', {
	    staticClass: "milestone"
	  }, [_vm._c('span', {
	    staticClass: "completed"
	  }, [_vm._v(_vm._s(_vm.studyProgressPercent) + "%")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "version"
	  }, [_vm._v("Complete!")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "progress"
	  }, [_vm._c('div', {
	    staticClass: "progress-bar progress-bar-success",
	    style: ('width: ' + _vm.studyProgressPercent + '%')
	  })])]) : _vm._c('td', {
	    staticClass: "milestone"
	  }, [_vm._c('span', {
	    staticClass: "completed"
	  }, [_vm._v(_vm._s(_vm.studyProgressPercent) + "%")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "version"
	  }, [_vm._v(_vm._s(_vm.unstudiedMicroNotesCount) + " remaining")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "progress"
	  }, [_vm._c('div', {
	    staticClass: "progress-bar progress-bar-primary",
	    style: ('width: ' + _vm.studyProgressPercent + '%')
	  })])]), _vm._v(" "), _vm._c('td', {
	    staticClass: "hidden-xs"
	  }), _vm._v(" "), _vm._c('td', {
	    staticClass: "cell-detail hidden-xs"
	  }, [_vm._c('small', [_vm._v(_vm._s(_vm.friendlyLastStudiedAt))])]), _vm._v(" "), _vm._c('td', {
	    staticClass: "text-right"
	  }, [_vm._c('div', {
	    staticClass: "btn-group btn-hspace"
	  }, [(_vm.chapter.micro_notes_count && _vm.studyProgressPercent < 100) ? _vm._c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": {
	        name: 'chapter-studier',
	        params: {
	          chapterId: _vm.chapter.id
	        }
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "icon mdi mdi-play-circle-outline"
	  }), _vm._v(" Study")]) : _vm._e(), _vm._v(" "), (_vm.showActions) ? _vm._c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_vm._v("Actions "), _vm._c('span', {
	    staticClass: "icon-dropdown mdi mdi-chevron-down"
	  })]) : _vm._e(), _vm._v(" "), (_vm.showActions) ? _vm._c('ul', {
	    staticClass: "dropdown-menu pull-right",
	    attrs: {
	      "role": "menu"
	    }
	  }, [(_vm.chapter.micro_notes_count) ? _vm._c('li', [_vm._c('router-link', {
	    staticClass: "tooltip-custom",
	    attrs: {
	      "to": {
	        name: 'micro-note-editor',
	        params: {
	          chapterId: _vm.chapter.id
	        }
	      }
	    }
	  }, [_vm._v("\n          Edit Micro Notes\n           "), _vm._c('div', {
	    staticClass: "popup"
	  }, [_vm._v("\n              Edit existing micronotes\n           ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "carret"
	  })])], 1) : _vm._e(), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
	    staticClass: "tooltip-custom",
	    attrs: {
	      "to": {
	        name: 'micro-note-creator',
	        params: {
	          chapterId: _vm.chapter.id
	        }
	      }
	    }
	  }, [_vm._v("\n          Create Micro Notes\n          "), _vm._c('div', {
	    staticClass: "popup"
	  }, [_vm._v("Create additional micro notes"), _vm._c('br'), _vm._v("from imported lecture note")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "carret"
	  })])], 1), _vm._v(" "), _vm._c('li', {
	    staticClass: "divider"
	  }), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'share-chapter',
	        params: {
	          chapterId: _vm.chapter.id
	        }
	      }
	    }
	  }, [_vm._v("Share")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.exportChapter(_vm.chapter)
	      }
	    }
	  }, [_vm._v("Export")])]), _vm._v(" "), _vm._c('li', [_vm._c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deleteChapter(_vm.chapter)
	      }
	    }
	  }, [_vm._v("Delete")])])]) : _vm._e()], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('span', {
	    staticClass: "input-group-btn"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Save")])])
	}]}

/***/ },
/* 646 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post",
	      "action": "https://clex.us14.list-manage.com/subscribe/post?u=624cbedc0908f255feb4c2185&id=ff86017695"
	    }
	  }, [_vm._c('div', {
	    staticClass: "form-horizontal"
	  }, [_vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "name",
	      "name": "MMERGE3",
	      "type": "text",
	      "placeholder": "Your name*"
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "email",
	      "name": "EMAIL",
	      "type": "email",
	      "placeholder": "Your Email*"
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "telephone",
	      "name": "PHONENUMBE",
	      "type": "tel",
	      "placeholder": "Your Phone Number"
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "subject",
	      "name": "SUBJECT",
	      "type": "text",
	      "placeholder": "Subject*"
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('textarea', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "message",
	      "name": "MMERGE5",
	      "placeholder": "Message"
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "xs-pt-10 submit"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-border-primary btn-pub-primary fixed-width xs-full-width",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Submit")])])])])
	}]}

/***/ },
/* 647 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "instructions"
	  }, [_vm._c('div', {
	    staticClass: "title",
	    class: _vm.showInstructions ? '' : 'closed',
	    on: {
	      "click": function($event) {
	        _vm.showInstructions = !_vm.showInstructions
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-info-circle"
	  }), _vm._v(" " + _vm._s(_vm.showInstructions ? 'Hide' : 'Show') + " hints & tips\n  ")]), _vm._v(" "), (_vm.showInstructions) ? _vm._c('div', {
	    staticClass: "content"
	  }, [_vm._t("content")], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 648 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "notfications"
	  }, [_vm._c('ul', [_vm._l((_vm.allNotifications), function(n) {
	    return _vm._c('li', {
	      staticClass: "notification"
	    }, [_vm._c('router-link', {
	      attrs: {
	        "to": {
	          name: n.navLocation
	        }
	      }
	    }, [_vm._v(_vm._s(n.message))]), _vm._v(" "), (_vm.showDelete === true) ? _vm._c('span', {
	      on: {
	        "click": function($event) {
	          _vm.removeNotification(n)
	        }
	      }
	    }, [_vm._c('i', {
	      staticClass: "fas fa-times"
	    })]) : _vm._e()], 1)
	  }), _vm._v(" "), (_vm.allNotifications.length > 0) ? _vm._c('li', {
	    staticClass: "clear-all notification",
	    on: {
	      "click": function($event) {
	        _vm.removeAllNotifications()
	      }
	    }
	  }, [_vm._v("Cleare all notifications")]) : _vm._c('li', {
	    staticClass: "xs-p-20"
	  }, [_vm._v("No new notifications")])], 2)])
	},staticRenderFns: []}

/***/ },
/* 649 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "wrap-black banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/features/banner1_800.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/features/banner1_800.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/features/banner1_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/features/banner1_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/features/banner1_800.jpg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "features-row"
	  }, [_vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._c('div', {
	    staticClass: "row text-center xs-mt-50"
	  }, [_vm._c('div', {
	    staticClass: "col"
	  }, [_vm._c('video-player', {
	    attrs: {
	      "src": "/static/video/demo.mp4",
	      "reference": "homeVideo"
	    }
	  })], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "hidden-sm hidden-xs xs-pt-50"
	  }, [_vm._c('HorizontalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  })], 1)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._c('div', {
	    staticClass: "features-row"
	  }, [_vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._c('div', {
	    staticClass: "xs-pt-50"
	  }, [_vm._c('HorizontalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  })], 1)])]), _vm._v(" "), _vm._m(6)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6  banner-content-wrap"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._c('h1', [_vm._v("CLEX "), _vm._c('br'), _vm._v("Features")]), _vm._v(" "), _vm._c('p', [_vm._v("\n            What really sets us apart is our most outstanding feature. CLEX starts users off with easier study content which progressively gets more challenging.\n            This increased challenge uniquely matches the learning speed of each individual, maximizing their learning potential.\n          ")]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
	    attrs: {
	      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
	    }
	  }, [_vm._v("Sign Up for Free")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row feature xs-mb-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 pic text-center"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-01.svg",
	      "alt": "Use micro notes to help you focus on your studies"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 xs-pt-30"
	  }, [_vm._c('h2', [_vm._v("\n            Micro notes\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Use micro notes to help you focus on your studies.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row feature"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-push-6 pic text-center"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-02.svg",
	      "alt": "Build word banks to help you improve your memorization skills"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-pull-6 xs-pt-30"
	  }, [_vm._c('h2', [_vm._v("\n            Word banks\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Build word banks to help you improve your memorization skills.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "bg-slide text-center features-col"
	  }, [_vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 xs-mb-50 md-mb-0 pic"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-03.svg",
	      "alt": "Challenge Yourself"
	    }
	  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Challenge Yourself\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Set your own study challenge levels for "), _vm._c('br'), _vm._v("each lecture note.")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 pic"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-04.svg",
	      "alt": "Shared Learning"
	    }
	  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Shared learning\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Share learning notes with your"), _vm._c('br'), _vm._v(" class mates.")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row feature xs-mb-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 pic text-center"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-05.svg",
	      "alt": "Schedule Studying"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6  xs-pt-30"
	  }, [_vm._c('h2', [_vm._v("\n            Schedule Studying\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Set your own testing dates to match your study schedule.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row feature"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-push-6 pic text-center"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-06.svg",
	      "alt": "Study Anywhere"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-pull-6 xs-pt-30"
	  }, [_vm._c('h2', [_vm._v("\n            Study Anywhere\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Test your knowledge at your own pace on any device at any time.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center features-col"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 xs-mb-50 md-mb-0 pic"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-07.svg",
	      "alt": "Secure Studying"
	    }
	  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Secure Studying\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Create your own secure personal"), _vm._c('br'), _vm._v(" student account.")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 pic"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-08.svg",
	      "alt": "Cloud Storage"
	    }
	  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Cloud Storage\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Store all your study notes in one"), _vm._c('br'), _vm._v(" secure location.")])])])])])
	}]}

/***/ },
/* 650 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "comments"
	  }, [_vm._c('div', {
	    staticClass: "row xs-mb-30"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [_vm._c('h3', {
	    staticClass: "pull-left xs-m-0"
	  }, [_vm._v("Comments "), (_vm.comments.length > 0) ? _vm._c('span', {
	    staticStyle: {
	      "font-size": "70%"
	    }
	  }, [_vm._v("(" + _vm._s(_vm.filteredComments.length) + ")")]) : _vm._e()])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [(!_vm.currentUser.loggedIn) ? _vm._c('router-link', {
	    staticClass: "btn btn-default pull-right",
	    attrs: {
	      "to": {
	        name: 'login',
	        query: {
	          redirect: '/blog-article/' + _vm.articleId
	        }
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-sign-in-alt"
	  }), _vm._v("   Login to comment")]) : _vm._e()], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), (_vm.currentUser.loggedIn) ? _vm._c('div', {
	    staticClass: "write"
	  }, [_vm._c('div', {
	    staticClass: "input"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('Editable', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.commentText),
	      expression: "commentText"
	    }],
	    attrs: {
	      "placeholder": "Write a public comment..."
	    },
	    domProps: {
	      "value": (_vm.commentText)
	    },
	    on: {
	      "input": function($event) {
	        _vm.commentText = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "buttons text-right"
	  }, [(!_vm.status) ? _vm._c('button', {
	    staticClass: "btn btn-primary xs-ml-20",
	    attrs: {
	      "disabled": !_vm.commentText
	    },
	    on: {
	      "click": function($event) {
	        _vm.submit()
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "far fa-comment"
	  }), _vm._v("   Submit")]) : _vm._c('button', {
	    staticClass: "btn btn-default xs-ml-20",
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v("Submitting...")])])]) : _vm._e(), _vm._v(" "), (_vm.filteredComments.length > 0) ? _vm._c('div', _vm._l((_vm.filteredComments), function(comment) {
	    return _vm._c('BlogComment', {
	      attrs: {
	        "show-delete": _vm.showDelete,
	        "comment": comment,
	        "blogArticleId": _vm.articleId
	      }
	    })
	  })) : _vm._c('div', {
	    staticClass: "xs-pt-30"
	  }, [_vm._v("\n    There are no comments for this article.\n  ")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "avatar"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/avatar.png",
	      "alt": "Avatar"
	    }
	  })])
	}]}

/***/ },
/* 651 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('span', {
	    staticClass: "word-wrapper"
	  }, [_vm._c('span', {
	    staticClass: "word",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.select($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.word))])])
	},staticRenderFns: []}

/***/ },
/* 652 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [(_vm.currentUser.errors) ? _vm._c('div', _vm._l((_vm.currentUser.errors), function(msg) {
	    return _vm._c('div', {
	      staticClass: "alert alert-contrast alert-danger alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])])
	  })) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "autofocus": "",
	      "placeholder": "Your E-mail",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-pt-20"
	  }, [_vm._v("We will send you an email with a password reset link.")]), _vm._v(" "), (_vm.showSuccess) ? _vm._c('div', {
	    staticClass: "alert alert-success"
	  }, [_vm._v("We've sent you an email with a password reset link. Please check your emails for instructions.")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group xs-pt-10"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width",
	    attrs: {
	      "disabled": !_vm.credentials.email || _vm.saving
	    }
	  }, [_vm._v(_vm._s(_vm.saving ? 'Please wait...' : 'Submit'))])]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-pt-30 footer-link"
	  }, [_vm._v("Don't have a account? "), _vm._c('router-link', {
	    attrs: {
	      "to": "/signup"
	    }
	  }, [_vm._c('strong', [_vm._v("Sign up now")])]), _vm._v(".")], 1), _vm._v(" "), _vm._c('p', {
	    staticClass: "footer-link"
	  }, [_vm._v("Forgot your password? "), _vm._c('router-link', {
	    attrs: {
	      "to": "/forgot-password"
	    }
	  }, [_vm._c('strong', [_vm._v("Reset password")])]), _vm._v(".")], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('p', {
	    staticClass: "xs-pb-20"
	  }, [_vm._v("\n          Forgot Your Password?"), _vm._c('br'), _vm._v("\n          Please Enter Your Email Address Below.\n        ")])
	}]}

/***/ },
/* 653 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    attrs: {
	      "id": "wordbank"
	    }
	  }, [_vm._c('h4', [_vm._v("Select a word")]), _vm._v(" "), _vm._l((_vm.words), function(word) {
	    return _vm._c('WordbankWord', {
	      attrs: {
	        "word": word
	      }
	    })
	  })], 2)
	},staticRenderFns: []}

/***/ },
/* 654 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-wrapper"
	  }, [_vm._c('navbar'), _vm._v(" "), _vm._c('router-view'), _vm._v(" "), _vm._c('footer-nav')], 1)
	},staticRenderFns: []}

/***/ },
/* 655 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('PanelBody', [_vm._c('div', {
	    staticClass: "processing"
	  }, [_vm._c('div', {
	    staticClass: "icon"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/logo-icon.png"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "text"
	  }, [_vm._c('h2', [_vm._v("Processing" + _vm._s(_vm.message))]), _vm._v(" "), _vm._c('p', [_vm._v("\n                Your file is being processed. Please "), _vm._c('strong', [_vm._v("do not refresh this page")]), _vm._v("."), _vm._c('br'), _vm._v("\n                You will be redirected shortly to create your lecture notes.\n              ")])])])])], 1)], 1)])])
	},staticRenderFns: []}

/***/ },
/* 656 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless",
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    }
	  }, [_vm._v("Continue To Dashboard")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-pt-50"
	  }, [_vm._v("\n      We've sent you an email confirmation for your account,"), _vm._c('br'), _vm._v("\n      if you haven't received it in your inbox "), _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._c('strong', [_vm._v("please let use know")])]), _vm._v("!\n    ")], 1), _vm._v(" "), _vm._c('p', [_vm._v("\n      Our service is free and we look forward to hearing any "), _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._c('strong', [_vm._v("feedback")])]), _vm._v(" you have.\n    ")], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('p', {
	    staticClass: "xs-pb-30 text-larger"
	  }, [_vm._v("\n      Thank You For Signing Up With CLEX!\n      "), _vm._c('br'), _vm._v("\n      You Are Now One Step Away From Starting Your Learning Experience.\n    ")])
	}]}

/***/ },
/* 657 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('form', {
	    staticClass: "dropzone",
	    attrs: {
	      "action": _vm.url,
	      "id": _vm.id
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 658 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "froala-editor"
	  })
	},staticRenderFns: []}

/***/ },
/* 659 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "loading"
	  }, [_vm._c('span', [_vm._v(_vm._s(_vm.displaytext))]), _vm._v(" "), _vm._m(0)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "inner"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/brain.svg"
	    }
	  })])
	}]}

/***/ },
/* 660 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "container-fluid footer"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
	    staticClass: "row text-center"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 xs-pb-50"
	  }, [_vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-default",
	    attrs: {
	      "to": {
	        name: 'signup'
	      }
	    }
	  }, [_vm._v("Sign Up For Free")])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-4 text-center xs-mb-30 "
	  }, [_vm._c('span', [_vm._v("We'd love to hear from you")]), _vm._c('br'), _vm._v(" "), _vm._c('div', {
	    staticClass: "footer-nav xs-mt-20"
	  }, [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._v("Contact us")]), _vm._v(" |\n        "), _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'feedback-form'
	      }
	    }
	  }, [_vm._v("Feedback form")])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-4 text-right xs-mb-30"
	  }, [_vm._c('span', [_vm._v("Join our mailing list")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _vm._c('SubscribeForm', {
	    staticClass: "sub"
	  })], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._m(2), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 text-right"
	  }, [_vm._v("\n      © Copyright CLEX " + _vm._s(_vm.year) + "\n    ")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row text-center"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 title-text  xs-pb-50"
	  }, [_vm._v("\n      Learn Smarter, Organize Notes, Remember Everything. Get Started With Us, "), _vm._c('strong', [_vm._v("For Free!")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-md-4 xs-mb-30"
	  }, [_vm._c('span', [_vm._v("Follow Us")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "social-links"
	  }, [_vm._c('a', {
	    attrs: {
	      "href": "https://facebook.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/facebook2.png"
	    }
	  })]), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://twitter.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/twitter2.png"
	    }
	  })]), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://instagram.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/instagram2.png"
	    }
	  })]), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://youtube.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/youtube2.png"
	    }
	  })]), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://linkedin.com",
	      "target": "_blank"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/linkedin2.png"
	    }
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "footer-nav"
	  }, [_vm._c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://www.websitepolicies.com/policies/view/ppLviGYs"
	    }
	  }, [_vm._v("Terms & conditions")]), _vm._v(" |\n        "), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://www.iubenda.com/privacy-policy/71921731/legal",
	      "target": "_blank"
	    }
	  }, [_vm._v("Privacy Policy")])])])
	}]}

/***/ },
/* 661 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('nav', {
	    staticClass: "navbar navbar-fixed-top"
	  }, [_vm._c('div', {
	    staticClass: "container-fluid xs-p-0"
	  }, [_vm._c('div', {
	    staticClass: "navbar-logo"
	  }, [_vm._c('router-link', {
	    staticClass: "logo",
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/logo.png"
	    }
	  })])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "right-navbar"
	  }, [(_vm.currentUser.loggedIn) ? _vm._c('LoggedInLinks') : _vm._c('LoggedOutLinks')], 1), _vm._v(" "), (_vm.page.publicNav) ? _vm._c('div', {
	    staticClass: "public-nav"
	  }, [_vm._c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('ul', {
	    staticClass: "dropdown-menu nav",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_vm._l((_vm.navLinks), function(link) {
	    return _vm._c('li', [_vm._c('router-link', {
	      attrs: {
	        "to": {
	          name: link.routeName
	        }
	      }
	    }, [_vm._v(_vm._s(link.title))])], 1)
	  }), _vm._v(" "), _vm._c('li', [(!_vm.currentUser.loggedIn) ? _vm._c('LoggedOutLinks') : _vm._e()], 1)], 2)])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._c('div', {
	    staticClass: "bar1"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "bar2"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "bar3"
	  })])
	}]}

/***/ },
/* 662 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [(_vm.allNotifications.length > 0) ? _vm._c('div', {
	    staticClass: "notification-panel"
	  }, [_vm._c('div', {
	    staticClass: "container-fluid xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('div', {
	    staticClass: "xs-pl-10 xs-pr-10"
	  }, [_vm._c('h3', [_vm._v("Notifications")]), _vm._v(" "), _vm._c('NotificationList', {
	    attrs: {
	      "show-delete": true
	    }
	  })], 1)])])])]) : _vm._e(), _vm._v(" "), _vm._c('PageHeader', {
	    attrs: {
	      "title": "Subject Shelf",
	      "subtitle": "Organize your study material"
	    }
	  }, [(_vm.showImport) ? _vm._c('router-link', {
	    staticClass: "btn btn-primary",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "to": {
	        name: 'importer'
	      }
	    },
	    slot: "top"
	  }, [_vm._c('i', {
	    staticClass: "icon mdi mdi-cloud-upload"
	  }), _vm._v("  Import Notes\n    ")]) : _vm._e()], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [(!_vm.subjects || !_vm.subjects.length) ? _vm._c('Panel', [_vm._c('PanelBody', [(!_vm.subjects) ? _vm._c('p', [_vm._c('LoadingIndicator')], 1) : (!_vm.subjects.length) ? _vm._c('div', [(_vm.showImport) ? _vm._c('div', [_vm._c('h3', [_vm._v("Welcome to CLEX")]), _vm._v("\n                This is where all your subjects and lecture notes will display."), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn btn-primary btn-lg",
	    attrs: {
	      "to": {
	        name: 'importer'
	      }
	    }
	  }, [_vm._v("Import your first Lecture Note")])], 1) : _vm._e(), _vm._v(" "), (!_vm.showImport) ? _vm._c('div', [_vm._c('h3', [_vm._v("Welcome to CLEX")]), _vm._v("\n                Your course materials will display here once your school has uploaded study notes.\n              ")]) : _vm._e()]) : _vm._e()])], 1) : _vm._c('div', _vm._l((_vm.subjects), function(subject) {
	    return _vm._c('div', [_vm._c('SubjectShelfSubject', {
	      attrs: {
	        "subject": subject
	      }
	    })], 1)
	  }))], 1)])])], 1)
	},staticRenderFns: []}

/***/ },
/* 663 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 signup-content xs-mb-50 md-mb-50"
	  }, [_vm._c('h1', [_vm._v("Sign Up")]), _vm._v(" "), _vm._c('p', [_vm._v("\n          CLEX is aware that the cost of post secondary education is very expensive, and in order to make your life as stress free as possible,\n          we are giving you CLEX for free at no charge, with no obligation to purchase for as long as you need it. No three month trial like most service providers.\n        ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 signup-form-wrap"
	  }, [_vm._c('div', {
	    staticClass: "signup-form"
	  }, [_vm._c('p', [_vm._v("Please enter your information to sign up for CLEX")]), _vm._v(" "), _vm._l((_vm.currentUser.errors), function(msg) {
	    return (_vm.currentUser.errors) ? _vm._c('div', {
	      staticClass: "alert alert-contrast alert-danger alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])]) : _vm._e()
	  }), _vm._v(" "), _vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.register($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.first_name),
	      expression: "newUser.first_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "autofocus": "",
	      "name": "first_name",
	      "type": "text",
	      "placeholder": "Your First Name",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.first_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.first_name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.last_name),
	      expression: "newUser.last_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "last_name",
	      "type": "text",
	      "placeholder": "Your Last Name",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.last_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.last_name = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.email),
	      expression: "newUser.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "placeholder": "Your E-mail",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.email = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.password),
	      expression: "newUser.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.password_confirmation),
	      expression: "newUser.password_confirmation"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password_confirmation",
	      "type": "password",
	      "placeholder": "Re-enter Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.password_confirmation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.password_confirmation = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 form-group"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedSchoolId),
	      expression: "selectedSchoolId"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": [function($event) {
	        _vm.selectedSchoolId = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, _vm.schoolChanged]
	    }
	  }, [_vm._c('option', {
	    domProps: {
	      "value": 0
	    }
	  }, [_vm._v("-- Select School (Optional) --")]), _vm._v(" "), _vm._l((_vm.schools), function(school) {
	    return _vm._c('option', {
	      domProps: {
	        "value": school.id
	      }
	    }, [_vm._v(_vm._s(school.name))])
	  })], 2)])]), _vm._v(" "), (_vm.selectedSchoolId > 0) ? _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 form-group"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.course_id),
	      expression: "newUser.course_id"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.newUser.course_id = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_vm._c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("-- Select Course --")]), _vm._v(" "), _vm._l((_vm.allCourses), function(course) {
	    return _vm._c('option', {
	      domProps: {
	        "value": course.id
	      }
	    }, [_vm._v(_vm._s(course.name))])
	  })], 2)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 form-group"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.role),
	      expression: "newUser.role"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.newUser.role = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.roles), function(role) {
	    return _vm._c('option', {
	      domProps: {
	        "value": role.id
	      }
	    }, [_vm._v(_vm._s(role.name))])
	  }))])]) : _vm._e(), _vm._v(" "), (_vm.currentUser.showSuccess) ? _vm._c('div', {
	    staticClass: "alert alert-success"
	  }, [_vm._v("We've sent you an email with a confirmation link. Please check your emails for instructions.")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group xs-pt-10 row"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_vm._c('router-link', {
	    staticClass: "login-link",
	    attrs: {
	      "to": "/login"
	    }
	  }, [_vm._v("Have an account? "), _vm._c('strong', [_vm._v("Log in")]), _vm._v(".")])], 1)])])], 2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width"
	  }, [_vm._v("Sign Up")])])
	}]}

/***/ },
/* 664 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [(_vm.currentUser.errors) ? _vm._c('div', _vm._l((_vm.currentUser.errors), function(msg) {
	    return _vm._c('div', {
	      staticClass: "alert alert-contrast alert-danger alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])])
	  })) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "autofocus": "",
	      "placeholder": "Your E-mail",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-pt-20"
	  }, [_vm._v("We will send you an email with a password reset link.")]), _vm._v(" "), (_vm.showSuccess) ? _vm._c('div', {
	    staticClass: "alert alert-success"
	  }, [_vm._v("We've sent you an email with a password reset link. Please check your emails for instructions.")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group xs-pt-10"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width",
	    attrs: {
	      "disabled": !_vm.credentials.email || _vm.saving
	    }
	  }, [_vm._v(_vm._s(_vm.saving ? 'Please wait...' : 'Submit'))])]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-pt-30 footer-link"
	  }, [_vm._v("Don't have a account? "), _vm._c('router-link', {
	    attrs: {
	      "to": "/signup"
	    }
	  }, [_vm._c('strong', [_vm._v("Sign up now")])]), _vm._v(".")], 1), _vm._v(" "), _vm._c('p', {
	    staticClass: "footer-link"
	  }, [_vm._v("Forgot your password? "), _vm._c('router-link', {
	    attrs: {
	      "to": "/forgot-password"
	    }
	  }, [_vm._c('strong', [_vm._v("Reset password")])]), _vm._v(".")], 1)])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('p', {
	    staticClass: "xs-pb-20"
	  }, [_vm._v("\n          Forgot Your Password?"), _vm._c('br'), _vm._v("\n          Please Enter Your Email Address Below.\n        ")])
	}]}

/***/ },
/* 665 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "container xs-pt-30 xs-pb-50"
	  }, [_vm._c('h1', {
	    staticClass: "serif"
	  }, [_vm._v("Privacy Policy")]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('p', [_vm._v("\n      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut non condimentum est, porttitor semper lectus. Cras tincidunt pretium dapibus. Aliquam erat volutpat. Fusce varius augue lacus, et condimentum lacus congue in. Nam aliquam nisi ut nisl pharetra, ac feugiat eros tincidunt. Integer non scelerisque neque, a semper arcu. Etiam fermentum placerat arcu. Donec consectetur, purus quis ullamcorper tincidunt, orci erat placerat magna, ut molestie leo leo eu eros. Morbi ut tortor a ex maximus venenatis. Integer varius, arcu id ultricies malesuada, metus sem lobortis tortor, quis cursus tortor neque vel orci. Fusce feugiat ante blandit est hendrerit finibus. Nullam ultrices sit amet neque sit amet mattis. Nam lobortis nulla vel diam consectetur volutpat. Nam porttitor mattis diam, nec sodales nunc pulvinar non. Vivamus eget justo nisl. Nulla finibus odio odio, eu suscipit magna semper ac.\n    ")]), _vm._c('p', [_vm._v("\n      Maecenas pulvinar nisi sit amet ligula congue, imperdiet varius diam posuere. Vestibulum ac est vestibulum, ultrices erat et, accumsan purus. Suspendisse potenti. Phasellus condimentum lorem a quam tincidunt mattis. In pulvinar erat at arcu molestie, vitae mollis enim dapibus. Nulla arcu arcu, aliquet ut urna sit amet, tristique tristique erat. Cras eu metus ligula. Quisque elit ipsum, ornare eget quam sit amet, commodo aliquam diam. Cras feugiat lorem a sapien tincidunt, a molestie elit pretium. Curabitur molestie tellus eu consequat pulvinar.\n    ")]), _vm._v(" "), _vm._c('p', [_vm._v("\n      Nunc gravida nulla arcu. Praesent id posuere felis. Mauris risus sapien, aliquet ut mollis sit amet, sollicitudin at velit. Etiam eget porta justo. Donec eget interdum sapien. Proin id diam elit. Sed aliquet lacus velit, a ultrices metus sagittis placerat. Pellentesque eu arcu est. Integer et ornare erat. Curabitur porta quam sed diam fermentum, ut condimentum tellus pretium. Phasellus in molestie nulla, sed pretium tortor.\n    ")])])])
	}]}

/***/ },
/* 666 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "wrap-black banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/features/banner1_800.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/features/banner1_800.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/features/banner1_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/features/banner1_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/features/banner1_800.jpg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6  banner-content-wrap"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            What really sets us apart is our most outstanding feature. CLEX starts users off with easier study content which progressively gets more challenging.\n            This increased challenge uniquely matches the learning speed of each individual, maximizing their learning potential.\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'signup'
	      }
	    }
	  }, [_vm._v("Sign Up for Free")])], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "features-row"
	  }, [_vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._c('AdBlock', {
	    staticClass: "hidden-sm hidden-xs",
	    attrs: {
	      "slot-id": 2,
	      "count": 1
	    }
	  })], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._c('div', {
	    staticClass: "features-row"
	  }, [_vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._c('AdBlock', {
	    staticClass: "hidden-sm hidden-xs",
	    attrs: {
	      "slot-id": 2,
	      "count": 1
	    }
	  })], 1)]), _vm._v(" "), _vm._m(6)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('h1', [_vm._v("CLEX "), _vm._c('br'), _vm._v("Features")])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row feature xs-mb-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 pic text-center"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-01.svg",
	      "alt": "Use micro notes to help you focus on your studies"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 xs-pt-30"
	  }, [_vm._c('h2', [_vm._v("\n            Micro notes\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Use micro notes to help you focus on your studies.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row feature"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-push-6 pic text-center"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-02.svg",
	      "alt": "Build word banks to help you improve your memorization skills"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-pull-6 xs-pt-30"
	  }, [_vm._c('h2', [_vm._v("\n            Word banks\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Build word banks to help you improve your memorization skills.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "bg-slide text-center features-col"
	  }, [_vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._c('div', {
	    staticClass: "row xs-mb-50 xs-pb-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 xs-mb-50 md-mb-0 pic"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-03.svg",
	      "alt": "Challenge Yourself"
	    }
	  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Challenge Yourself\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Set your own study challenge levels for "), _vm._c('br'), _vm._v("each lecture note.")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 pic"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-04.svg",
	      "alt": "Shared Learning"
	    }
	  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Shared learning\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Share learning notes with your"), _vm._c('br'), _vm._v(" class mates.")])])]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn-pub btn-pub-primary video-btn fixed-width xs-full-width",
	    attrs: {
	      "href": "https://vimeo.com/204826626",
	      "target": "_blank"
	    }
	  }, [_vm._v("Watch Our Video")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row feature xs-mb-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 pic text-center"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-05.svg",
	      "alt": "Schedule Studying"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6  xs-pt-30"
	  }, [_vm._c('h2', [_vm._v("\n            Schedule Studying\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Set your own testing dates to match your study schedule.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row feature"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-push-6 pic text-center"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-06.svg",
	      "alt": "Study Anywhere"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-pull-6 xs-pt-30"
	  }, [_vm._c('h2', [_vm._v("\n            Study Anywhere\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Test your knowledge at your own pace on any device at any time.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center features-col"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 xs-mb-50 md-mb-0 pic"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-07.svg",
	      "alt": "Secure Studying"
	    }
	  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Secure Studying\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Create your own secure personal"), _vm._c('br'), _vm._v(" student account.")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 pic"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/features/Features_Icons-08.svg",
	      "alt": "Cloud Storage"
	    }
	  }), _vm._v(" "), _vm._c('h2', [_vm._v("\n            Cloud Storage\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("Store all your study notes in one"), _vm._c('br'), _vm._v(" secure location.")])])])])])
	}]}

/***/ },
/* 667 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('span', [(!_vm.revealAnswers) ? _vm._c('span', {
	    directives: [{
	      name: "scroll-in-view-when",
	      rawName: "v-scroll-in-view-when",
	      value: (_vm.active),
	      expression: "active"
	    }],
	    staticClass: "clex-keyword",
	    class: {
	      active: _vm.active, answered: _vm.answered
	    },
	    style: (_vm.style),
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.select($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.visibleContent))]) : _vm._c('span', {
	    staticClass: "clex-keyword answer",
	    class: {
	      correct: _vm.answerIsCorrect, wrong: !_vm.answerIsCorrect
	    },
	    style: (_vm.style),
	    domProps: {
	      "innerHTML": _vm._s(_vm.answerDiff)
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 668 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "article-list"
	  }, [(_vm.heroPost) ? _vm._c('div', {
	    staticClass: "hero-post"
	  }, [_vm._c('div', {
	    staticClass: "wrap-black banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [(_vm.heroImg) ? _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "pic",
	    style: ('background-image:url(' + _vm.heroImg + ');')
	  }, [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.heroPost.id
	        }
	      }
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 banner-content-wrap",
	    class: _vm.heroImg ? 'col-sm-6' : ''
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._c('h1', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.heroPost.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.heroPost.title))])], 1), _vm._v(" "), _vm._c('p', [_vm._v("\n              " + _vm._s(_vm.heroContent) + "\n            ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.heroPost.id
	        }
	      }
	    }
	  }, [_vm._v("\n              Read More")])], 1)])])])]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "container-fluid sub-articles"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.showList), function(article) {
	    return _vm._c('BlogListArticle', {
	      attrs: {
	        "article": article
	      }
	    })
	  }))]), _vm._v(" "), (_vm.showList.length < _vm.blogPosts.length) ? _vm._c('div', {
	    staticClass: "text-center"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-blank",
	    on: {
	      "click": function($event) {
	        _vm.loadMore()
	      }
	    }
	  }, [_vm._v("Load More Articles")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 669 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('ul', {
	    staticClass: "nav navbar-right be-user-nav"
	  }, [_vm._c('li', {
	    staticClass: "dropdown"
	  }, [(_vm.allNotifications.length > 0) ? _vm._c('a', {
	    staticClass: "notifications",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-bell"
	  }), _vm._v(" "), _vm._c('span', {
	    staticClass: "notification-count"
	  }, [_vm._v(_vm._s(_vm.allNotifications.length))])]) : _vm._c('a', {
	    staticClass: "notifications",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._c('i', {
	    staticClass: "far fa-bell"
	  })]), _vm._v(" "), _vm._c('ul', {
	    staticClass: "dropdown-menu",
	    staticStyle: {
	      "width": "300px"
	    },
	    attrs: {
	      "role": "menu"
	    }
	  }, [_vm._c('li', [_vm._c('NotificationList', {
	    attrs: {
	      "show-delete": false
	    }
	  })], 1)])]), _vm._v(" "), _vm._c('li', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_vm._c('li', [_vm._c('div', {
	    staticClass: "user-info"
	  }, [_vm._c('div', {
	    staticClass: "user-name"
	  }, [_vm._v(_vm._s(_vm.currentUser.email))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "user-position online"
	  }, [_vm._v("Available")])])]), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-home"
	  }), _vm._v(" Subject Shelf")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'user-account'
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-face"
	  }), _vm._v(" Account")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'user-settings'
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-settings"
	  }), _vm._v(" Settings")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logout($event)
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-power"
	  }), _vm._v(" Logout")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/avatar.png",
	      "alt": "Avatar"
	    }
	  })])
	}]}

/***/ },
/* 670 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('PageHeader', {
	    attrs: {
	      "title": "File Importer",
	      "subtitle": "Import a PDF or CLEX file to convert into Micro Notes"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('PanelBody', [_vm._c('div', {
	    staticClass: "row xs-mb-50 xs-mt-20"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-4 col-xl-2 xs-pt-0 sm-pt-10"
	  }, [_vm._c('span', {}, [_vm._v("Type of file to import:")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-8 col-xl-4 xs-pt-10 sm-pt-0"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-xl xs-mr-10",
	    class: _vm.importType === 'pdf' ? 'btn-outline-primary' : 'btn-outline-default',
	    on: {
	      "click": function($event) {
	        _vm.importType = 'pdf'
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "far",
	    class: _vm.importType === 'pdf' ? 'fa-check-square' : 'fa-square'
	  }), _vm._v(" Import a PDF")]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-xl",
	    class: _vm.importType === 'clex' ? 'btn-outline-primary' : 'btn-outline-default',
	    on: {
	      "click": function($event) {
	        _vm.importType = 'clex'
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "far",
	    class: _vm.importType === 'clex' ? 'fa-check-square' : 'fa-square'
	  }), _vm._v(" Import CLEX file")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "text-primary import-other-link",
	    style: (_vm.showOther ? 'text-decoration:underline;' : ''),
	    on: {
	      "click": _vm.toggleOther
	    }
	  }, [_vm._v("Import other file types")]), _vm._v(" "), (_vm.showOther) ? _vm._c('div', {
	    staticClass: "import-other"
	  }, [_vm._c('p', [_vm._v("\n                    Upload other file types to Google Drive to convert to PDF."), _vm._c('br'), _vm._v(" "), _vm._c('a', {
	    attrs: {
	      "href": "https://support.google.com/drive/answer/37603?hl=en",
	      "target": "_blank"
	    }
	  }, [_vm._v("Click here to see what types of files can be uploaded to Google Drive.")])]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "href": "https://drive.google.com/drive/my-drive",
	      "target": "_blank"
	    }
	  }, [_vm._v("Go to my Google Drive")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "text-muted xs-mb-0 xs-mt-10"
	  }, [_vm._v("Note: You will need to log in to your Google account.")])]) : _vm._e()])]), _vm._v(" "), (_vm.importType === 'pdf') ? _vm._c('div', {
	    staticClass: "row"
	  }, [(_vm.subjects && _vm.subjects.length && !_vm.newSubjectTitle) ? _vm._c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._c('label', {
	    attrs: {
	      "for": "lectureNoteSubject"
	    }
	  }, [_vm._v("Place in existing subject")]), _vm._v(" "), _vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedSubjectTitle),
	      expression: "selectedSubjectTitle"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "lectureNoteSubject"
	    },
	    on: {
	      "change": function($event) {
	        _vm.selectedSubjectTitle = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_vm._c('option'), _vm._v(" "), _vm._l((_vm.subjects), function(subject) {
	    return _vm._c('option', {
	      domProps: {
	        "value": subject.title
	      }
	    }, [_vm._v(_vm._s(subject.title))])
	  })], 2)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('label', {
	    attrs: {
	      "for": "newLectureNoteSubject"
	    }
	  }, [(_vm.subjects && _vm.subjects.length && !_vm.newSubjectTitle) ? _vm._c('span', [_vm._v("Or ")]) : _vm._e(), _vm._v("Create a new subject")]), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newSubjectTitle),
	      expression: "newSubjectTitle"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "newLectureNoteSubject",
	      "placeholder": "Subject Name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newSubjectTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newSubjectTitle = $event.target.value
	      }
	    }
	  })])])]) : _vm._e(), _vm._v(" "), (_vm.showCourses) ? _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('label', {
	    attrs: {
	      "for": "courses"
	    }
	  }, [_vm._v("Select a Course")]), _vm._v(" "), _vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.course_id),
	      expression: "course_id"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "courses"
	    },
	    on: {
	      "change": function($event) {
	        _vm.course_id = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, [_vm._c('option', {
	    domProps: {
	      "value": null
	    }
	  }, [_vm._v("-- Select Course --")]), _vm._v(" "), _vm._l((_vm.allCourses), function(course) {
	    return _vm._c('option', {
	      domProps: {
	        "value": course.id
	      }
	    }, [_vm._v(_vm._s(course.name))])
	  })], 2)])])]) : _vm._e(), _vm._v(" "), (_vm.validSubject && _vm.importType === 'pdf') ? _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('label', {
	    attrs: {
	      "for": "newLectureNoteFirstPage"
	    }
	  }, [_vm._v("First PDF Page to Import")]), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newLectureNoteFirstPage),
	      expression: "newLectureNoteFirstPage"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "id": "newLectureNoteFirstPage",
	      "placeholder": "Optional"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newLectureNoteFirstPage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newLectureNoteFirstPage = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('label', {
	    attrs: {
	      "for": "newLectureNoteLastPage"
	    }
	  }, [_vm._v("Last PDF Page to Import")]), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newLectureNoteLastPage),
	      expression: "newLectureNoteLastPage"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "min": "0",
	      "id": "newLectureNoteLastPage",
	      "placeholder": "Optional"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newLectureNoteLastPage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newLectureNoteLastPage = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-md-3"
	  }, [(!_vm.validPageNums) ? _vm._c('div', {
	    staticClass: "alert alert-warning",
	    staticStyle: {
	      "margin-top": "27px",
	      "padding": "10px"
	    }
	  }, [_vm._v("Please enter valid values.")]) : _vm._e()])]) : (_vm.importType === 'pdf') ? _vm._c('div', {
	    staticClass: "alert alert-warning"
	  }, [_vm._c('i', {
	    staticClass: "fas fa-exclamation-triangle"
	  }), _vm._v("   Please select or create a subject to continue")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('div', [(_vm.importType === 'pdf') ? _vm._c('h4', [_vm._c('b', [_vm._v("Importing to:")]), _vm._v(" " + _vm._s(_vm.newSubjectTitle || _vm.selectedSubjectTitle))]) : _vm._c('h4', [_vm._c('b', [_vm._v("Select an exported .CLEX file")])]), _vm._v(" "), (_vm.roundedUploadProgressPercentage > 0) ? _vm._c('div', {
	    staticClass: "progress"
	  }, [_vm._c('div', {
	    staticClass: "progress-bar progress-bar-success progress-bar-striped active",
	    style: ('width: ' + _vm.roundedUploadProgressPercentage + '%'),
	    attrs: {
	      "role": "progressbar",
	      "aria-valuenow": _vm.roundedUploadProgressPercentage,
	      "aria-valuemin": "0",
	      "aria-valuemax": "100"
	    }
	  }, [_vm._v("\n                      " + _vm._s(_vm.fileName) + " - \n                      "), (_vm.roundedUploadProgressPercentage == 100) ? _vm._c('span', [_vm._v("Processing...")]) : _vm._c('span', [_vm._v(" " + _vm._s(_vm.roundedUploadProgressPercentage) + "%")])])]) : _vm._c('Dropzone', {
	    staticClass: "dropzone",
	    attrs: {
	      "id": "pdfUploadDropzone",
	      "url": "https://httpbin.org/post",
	      "autoProcessQueue": false,
	      "useCustomDropzoneOptions": true,
	      "dropzoneOptions": {
	        'dictDefaultMessage': ('<div class="icon"><span class="mdi mdi-cloud-upload"></span></div><h3>Drag and drop import files here</h3><span class="note">(Or click anywhere to select files)</span>'),
	        'acceptedFiles': 'application/pdf,.clex',
	        'previewTemplate': '<span></span>',
	      }
	    },
	    on: {
	      "vdropzone-fileAdded": _vm.createLectureNote
	    }
	  })], 1)])])])], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ },
/* 671 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "panel-body"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 672 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "switch",
	    class: _vm.switchBool === false ? 'switch-off' : 'switch-on',
	    on: {
	      "click": _vm.toggle
	    }
	  }, [_vm._c('div', {
	    staticClass: "block"
	  }), _vm._c('span', [_vm._v(_vm._s(_vm.switchBool === false ? _vm.offText : _vm.onText))])])
	},staticRenderFns: []}

/***/ },
/* 673 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Manage Ads",
	      "subtitle": ""
	    }
	  }, [_vm._c('button', {
	    staticClass: "btn btn-primary",
	    staticStyle: {
	      "float": "right",
	      "margin-top": "10px"
	    },
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#createModal"
	    },
	    on: {
	      "click": _vm.openCreateModal
	    },
	    slot: "top"
	  }, [_vm._c('i', {
	    staticClass: "icon mdi mdi-plus"
	  }), _vm._v("  Create Ad\n          ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('div', {
	    staticClass: "filters"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "form-group form-group-sm row"
	  }, [_vm._c('label', {
	    staticClass: "col-form-label col-xs-4 control-label"
	  }, [_vm._v("Status")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedStatus),
	      expression: "selectedStatus"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.selectedStatus = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.statusFilters), function(option) {
	    return _vm._c('option', {
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v("\n                        " + _vm._s(option) + "\n                      ")])
	  }))])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "form-group form-group-sm row"
	  }, [_vm._c('label', {
	    staticClass: "col-form-label col-xs-4 control-label"
	  }, [_vm._v("Company")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedCompany),
	      expression: "selectedCompany"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.selectedCompany = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.companyFilters), function(option) {
	    return _vm._c('option', {
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v("\n                        " + _vm._s(option) + "\n                      ")])
	  }))])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "form-group form-group-sm row"
	  }, [_vm._c('label', {
	    staticClass: "col-form-label col-xs-4 control-label"
	  }, [_vm._v("Page")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedPage),
	      expression: "selectedPage"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.selectedPage = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.pageFilters), function(option) {
	    return _vm._c('option', {
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v("\n                        " + _vm._s(option) + "\n                      ")])
	  }))])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "form-group form-group-sm"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchTerm),
	      expression: "searchTerm"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search title..."
	    },
	    domProps: {
	      "value": _vm._s(_vm.searchTerm)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchTerm = $event.target.value
	      }
	    }
	  })])])])]), _vm._v(" "), _vm._c('DynamicTable', {
	    attrs: {
	      "data": _vm.filteredData,
	      "fields": _vm.fields,
	      "onClick": _vm.editRecord,
	      "defaultSort": 'title'
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "settings-container"
	  })], 1)], 1)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": "createModal",
	      "tabindex": "-1",
	      "role": "dialog",
	      "aria-labelledby": "exampleModalLabel",
	      "aria-hidden": "true"
	    }
	  }, [_vm._c('div', {
	    staticClass: "modal-dialog modal-lg",
	    attrs: {
	      "role": "document"
	    }
	  }, [_vm._c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._v(" "), (_vm.selectedAd) ? _vm._c('div', {
	    staticClass: "modal-body"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtTitle"
	    }
	  }, [_vm._v("Title")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAd.title),
	      expression: "selectedAd.title"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtTitle"
	    },
	    domProps: {
	      "value": _vm._s(_vm.selectedAd.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.selectedAd.title = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtUrl"
	    }
	  }, [_vm._v("Link URL")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAd.url),
	      expression: "selectedAd.url"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtUrl"
	    },
	    domProps: {
	      "value": _vm._s(_vm.selectedAd.url)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.selectedAd.url = $event.target.value
	      }
	    }
	  })])])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtCompany"
	    }
	  }, [_vm._v("New Company")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAd.company),
	      expression: "selectedAd.company"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtCompany"
	    },
	    domProps: {
	      "value": _vm._s(_vm.selectedAd.company)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.selectedAd.company = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "ddlCompany"
	    }
	  }, [_vm._v("Or existing")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.companySelect),
	      expression: "companySelect"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "ddlCompany"
	    },
	    on: {
	      "change": [function($event) {
	        _vm.companySelect = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }, _vm.companyChanged]
	    }
	  }, _vm._l((_vm.companyFilters), function(option) {
	    return _vm._c('option', [_vm._v("\n                      " + _vm._s(option) + "\n                    ")])
	  }))])])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtStart"
	    }
	  }, [_vm._v("Start Date")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('datepicker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAd.start),
	      expression: "selectedAd.start"
	    }],
	    attrs: {
	      "format": "yyyy-MM-dd",
	      "name": "startDate",
	      "input-class": "form-control",
	      "disabled-dates": _vm.disabledDates
	    },
	    domProps: {
	      "value": (_vm.selectedAd.start)
	    },
	    on: {
	      "input": function($event) {
	        _vm.selectedAd.start = $event
	      }
	    }
	  })], 1)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtEnd"
	    }
	  }, [_vm._v("End Date")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('datepicker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAd.end),
	      expression: "selectedAd.end"
	    }],
	    attrs: {
	      "format": "yyyy-MM-dd",
	      "name": "endDate",
	      "input-class": "form-control",
	      "disabled-dates": _vm.disabledDates
	    },
	    domProps: {
	      "value": (_vm.selectedAd.end)
	    },
	    on: {
	      "input": function($event) {
	        _vm.selectedAd.end = $event
	      }
	    }
	  })], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtPage"
	    }
	  }, [_vm._v("Display Page")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAd.displayPage),
	      expression: "selectedAd.displayPage"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "txtPage"
	    },
	    on: {
	      "change": function($event) {
	        _vm.selectedAd.displayPage = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.pageFilters), function(option) {
	    return _vm._c('option', [_vm._v("\n                      " + _vm._s(option) + "\n                    ")])
	  }))])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtSlot"
	    }
	  }, [_vm._v("Slot ID")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAd.slotID),
	      expression: "selectedAd.slotID"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "number",
	      "min": "1",
	      "id": "txtSlot"
	    },
	    domProps: {
	      "value": _vm._s(_vm.selectedAd.slotID)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.selectedAd.slotID = _vm._n($event.target.value)
	      },
	      "blur": function($event) {
	        _vm.$forceUpdate()
	      }
	    }
	  })])])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtStatus"
	    }
	  }, [_vm._v("Status")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAd.status),
	      expression: "selectedAd.status"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "txtStatus"
	    },
	    on: {
	      "change": function($event) {
	        _vm.selectedAd.status = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.statusFilters), function(option) {
	    return _vm._c('option', [_vm._v("\n                      " + _vm._s(option) + "\n                    ")])
	  }))])])])]), _vm._v(" "), _vm._c('hr'), _vm._v(" "), _vm._c('p', [_vm._c('strong', [_vm._v("Suggested size (px):")]), _vm._v(" " + _vm._s(_vm.imageSize) + " - "), _vm._c('a', {
	    attrs: {
	      "href": "https://support.google.com/adsense/answer/6002621?hl=en",
	      "target": "_blank"
	    }
	  }, [_vm._v("More info")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-9"
	  }, [_vm._c('input', {
	    attrs: {
	      "type": "file",
	      "name": "image"
	    },
	    on: {
	      "change": _vm.imageAdded
	    }
	  }), _vm._v(" "), (_vm.imageLoading) ? _vm._c('div', {
	    staticClass: "loading"
	  }, [_vm._c('LoadingIndicator')], 1) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "image-preview"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": _vm.selectedAd.image
	    }
	  })])])])])]), _vm._v(" "), (_vm.errors.length > 0) ? _vm._c('div', {
	    staticClass: "alert alert-danger"
	  }, [_vm._v("\n            Please correct the following errors:\n            "), _vm._c('ul', _vm._l((_vm.errors), function(e) {
	    return _vm._c('li', [_vm._v(_vm._s(e))])
	  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "modal-footer"
	  }, [(_vm.selectedAd && _vm.selectedAd.id) ? _vm._c('button', {
	    staticClass: "btn btn-danger pull-left",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.deleteAd
	    }
	  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-secondary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Close")]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "disabled": _vm.imageLoading
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Save")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "modal-header"
	  }, [_vm._c('h3', {
	    staticClass: "modal-title",
	    attrs: {
	      "id": "exampleModalLabel"
	    }
	  }, [_vm._v("Ad details")])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 col-form-label"
	  }, [_vm._c('strong', [_vm._v("Select image")])])
	}]}

/***/ },
/* 674 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('PageHeader', {
	    attrs: {
	      "title": "File Export",
	      "subtitle": "Export Micro Notes to share or import at a later date"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('PanelBody', [(!_vm.subjects || !_vm.subjects.length) ? _vm._c('div', [(!_vm.subjects) ? _vm._c('p', [_vm._c('LoadingIndicator')], 1) : (!_vm.subjects.length) ? _vm._c('div', [_vm._c('p', [_vm._c('br'), _vm._c('em', [_vm._v("You have no study material yet.")]), _vm._v(" "), _vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'importer'
	      }
	    }
	  }, [_vm._v("Upload your first Lecture Note now.")])], 1)]) : _vm._e()]) : _vm._c('div', _vm._l((_vm.subjects), function(subject) {
	    return _vm._c('div', [_vm._c('SubjectRow', {
	      attrs: {
	        "subject": subject
	      }
	    })], 1)
	  })), _vm._v(" "), _vm._c('div', {
	    staticClass: "button-bar"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-primary btn-xl pull-right",
	    attrs: {
	      "disabled": _vm.microNotesForSelectedChapters.length <= 0 || _vm.status !== ''
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.exportChapter($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.status === '' ? 'Export file' : 'Exporting...'))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "active-toggle"
	  }, [_vm._c('span', {
	    staticClass: "lbl"
	  }, [_vm._v("Include inactive micro notes:")]), _vm._v(" "), _vm._c('BoolSwitch', {
	    attrs: {
	      "toggle-bool": _vm.includeInactive,
	      "toggle-function": _vm.toggleInactive,
	      "on-text": "Yes",
	      "off-text": "No"
	    }
	  })], 1)])])], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ },
/* 675 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "container xs-pt-30 xs-pb-50"
	  }, [_vm._c('h1', {
	    staticClass: "serif"
	  }, [_vm._v("Feedback Form")]), _vm._v(" "), _vm._c('br'), _vm._v(" "), _vm._c('InquiryForm', {
	    attrs: {
	      "subject": "Feedback form"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 676 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('p', {
	    staticClass: "xs-pb-30"
	  }, [_vm._v("Welcome back! Please enter your information.")]), _vm._v(" "), _vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.login($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "autofocus": "",
	      "placeholder": "Your E-mail",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.currentUser.errors) ? _vm._c('div', _vm._l((_vm.currentUser.errors), function(msg) {
	    return _vm._c('div', {
	      staticClass: "alert alert-contrast alert-danger alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])])
	  })) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-pt-30 footer-link"
	  }, [_vm._v("Don't have a account? "), _vm._c('router-link', {
	    attrs: {
	      "to": "/signup"
	    }
	  }, [_vm._c('strong', [_vm._v("Sign up now")])]), _vm._v(".")], 1), _vm._v(" "), _vm._c('p', {
	    staticClass: "footer-link"
	  }, [_vm._v("Forgot your password? "), _vm._c('router-link', {
	    attrs: {
	      "to": "/forgot-password"
	    }
	  }, [_vm._c('strong', [_vm._v("Reset password")])]), _vm._v(".")], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "form-group xs-pt-20"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width"
	  }, [_vm._v("Log In")])])
	}]}

/***/ },
/* 677 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [(!_vm.microNote) ? _vm._c('LoadingIndicator') : (!_vm.microNote.micro_note_images || _vm.microNote.micro_note_images.length <= 0) ? _vm._c('div', [_vm._c('div', {
	    staticClass: "alert alert-danger",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-close-circle-o"
	  }), _vm._v(" Failed to load micro note image\n    ")])]) : _vm._c('div', [_vm._c('div', {
	    staticClass: "image-container",
	    class: {
	      creating: _vm.dragCoords
	    }
	  }, [(_vm.newKeyword) ? _vm._c('ImageKeyword', {
	    attrs: {
	      "scale": _vm.scale,
	      "keyword": _vm.newKeyword
	    }
	  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.newKeywordsArray), function(keyword) {
	    return _vm._c('ImageKeyword', {
	      attrs: {
	        "activeKeywordId": _vm.activeKeywordId,
	        "onDelete": _vm.handleDeleteKeyword,
	        "onUpdate": _vm.handleUpdateKeyword,
	        "onClick": _vm.handleKeywordClick,
	        "scale": _vm.scale,
	        "keyword": keyword
	      }
	    })
	  }), _vm._v(" "), _vm._c('img', {
	    ref: "image",
	    attrs: {
	      "src": _vm.microNote.micro_note_images[0].image_url
	    },
	    on: {
	      "mousedown": [function($event) {
	        $event.preventDefault();
	        _vm.createKeywordStart($event)
	      }, function($event) {
	        $event.preventDefault();
	        $event.stopPropagation();
	        if ($event.target !== $event.currentTarget) { return; }
	        _vm.handleImageClick($event)
	      }]
	    }
	  })], 2), _vm._v(" "), _vm._c('p', {
	    staticClass: "text-muted xs-mt-20"
	  }, [_vm._v(_vm._s(_vm.statusMessage))])])], 1)
	},staticRenderFns: []}

/***/ },
/* 678 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "wrap-black banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-push-6 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            Please feel free to contact us with any questions or concerns you might have. We're happy to help you out!\n            Please use this form provided and we will get back to you shortly. If you'd like to learn more about our services check out our features page.\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-pull-6 col-sm-6 pic"
	  }, [_vm._c('InquiryForm', {
	    attrs: {
	      "subject": "General Inquiry"
	    }
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('h1', [_vm._v("Contact "), _vm._c('br'), _vm._v("Us")])
	}]}

/***/ },
/* 679 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "inner-banner"
	  }, [_vm._c('div', {
	    staticClass: "copy",
	    class: _vm.subText ? 'with-sub' : ''
	  }, [_vm._c('h1', {
	    staticClass: "serif"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.subText) ? _vm._c('p', [_vm._v("\n      " + _vm._s(_vm.subText) + "\n    ")]) : _vm._e()]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "bg"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": _vm.title
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_500.jpg',
	      "media": "(max-width: 500px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_800.jpg',
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_1200.jpg',
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_1600.jpg',
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": _vm.imageUrl + '_2000.jpg',
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": _vm.imageUrl + '_1600.jpg',
	      "alt": ""
	    }
	  })])], 1)])
	},staticRenderFns: []}

/***/ },
/* 680 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Settings",
	      "subtitle": "Configure how you study"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "sm-p-30 xs-pt-30 xs-pb-30 xs-pl-10 xs-pr-10"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-6 col-form-label",
	    attrs: {
	      "for": "OrderMicronotesBy"
	    }
	  }, [_vm._v("Order micro notes by")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedMicroNoteOrder),
	      expression: "selectedMicroNoteOrder"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "OrderMicronotesBy"
	    },
	    on: {
	      "change": function($event) {
	        _vm.selectedMicroNoteOrder = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.microNoteOrderOptions), function(option) {
	    return _vm._c('option', {
	      domProps: {
	        "value": option.value
	      }
	    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                      ")])
	  }))])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-6 col-form-label",
	    attrs: {
	      "for": "AllowSharing"
	    }
	  }, [_vm._v("Allow sharing")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [_vm._c('div', {
	    staticClass: "pull-left"
	  }, [_vm._c('BoolSwitch', {
	    attrs: {
	      "toggle-bool": _vm.AllowSharing,
	      "toggle-function": _vm.toggleSharing,
	      "on-text": "On",
	      "off-text": "Off"
	    }
	  })], 1)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-6 col-form-label",
	    attrs: {
	      "for": "AllowSharing"
	    }
	  }, [_vm._v("Receive system notifications")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [_vm._c('div', {
	    staticClass: "pull-left"
	  }, [_vm._c('BoolSwitch', {
	    staticClass: "pull-left",
	    attrs: {
	      "toggle-bool": _vm.notifications,
	      "toggle-function": _vm.toggleNotifications,
	      "on-text": "On",
	      "off-text": "Off"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), (!_vm.notifications) ? _vm._c('div', {
	    staticClass: "text-danger xs-mt-10"
	  }, [_vm._v("Warning: You will not receive any system emails (shared lecture notes, blog comments, etc.)")]) : _vm._e()], 1)])])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 text-right"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-primary btn-lg",
	    on: {
	      "click": _vm.saveSettings
	    }
	  }, [_vm._v("Save")])])])])], 1)], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 681 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrapper"
	  }, [_vm._c('PageHeader', {
	    attrs: {
	      "title": _vm.chapter ? ("Study " + (_vm.chapter.title)) : 'Loading...'
	    }
	  }, [_vm._c('ol', {
	    staticClass: "breadcrumb pull-left",
	    staticStyle: {
	      "margin-top": "0"
	    }
	  }, [_vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "icon mdi mdi-arrow-left"
	  }), _vm._v("  Home")])], 1)]), _vm._v(" "), (_vm.microNotes && _vm.microNotes.length) ? _vm._c('div', {
	    staticStyle: {
	      "float": "right"
	    }
	  }, [_vm._c('KeywordSettings', {
	    staticClass: "pull-right",
	    attrs: {
	      "chapterId": _vm.chapter.chapter_id
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "email-filters-right  text-right pull-right xs-mr-10"
	  }, [_vm._c('span', {
	    staticClass: "email-pagination-indicator"
	  }, [_vm._v(_vm._s(_vm.microNotes.length) + " remaining ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "btn-group email-pagination-nav"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.previousMicroNote($event)
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "mdi mdi-chevron-left"
	  })]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.nextMicroNote($event)
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "mdi mdi-chevron-right"
	  })])])])], 1) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "chapterStudier main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default"
	  }, [(!_vm.chapter || !_vm.microNotes) ? _vm._c('PanelBody', [_vm._c('LoadingIndicator')], 1) : (!_vm.chapter.micro_notes_count) ? _vm._c('PanelBody', [_vm._c('div', {
	    staticClass: "sm-mt-20 alert alert-primary alert-icon alert-icon-border",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._c('div', {
	    staticClass: "icon"
	  }, [_vm._c('span', {
	    staticClass: "mdi mdi-info-outline"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "message"
	  }, [_vm._c('strong', [_vm._v("Empty!")]), _vm._v(" This chapter has no micro notes.\n              ")])])]) : (!_vm.microNotes.length) ? _vm._c('PanelBody', [_vm._c('div', {
	    staticClass: "sm-mt-20 alert alert-success alert-icon alert-icon-border",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._c('div', {
	    staticClass: "icon"
	  }, [_vm._c('span', {
	    staticClass: "mdi mdi-info-outline"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "message"
	  }, [_vm._c('strong', [_vm._v("Good!")]), _vm._v(" You've finished studying the micro notes in this chapter.\n              ")])]), _vm._v(" "), _vm._c('p', [_vm._c('img', {
	    attrs: {
	      "src": _vm.successImageUrl
	    }
	  })])]) : _vm._c('div', [(_vm.microNote && _vm.microNote.micro_note_type === 'image') ? _vm._c('MicroNoteImageStudier', {
	    attrs: {
	      "microNote": _vm.microNote
	    }
	  }) : _vm._c('MicroNoteStudier', {
	    attrs: {
	      "microNote": _vm.microNote
	    }
	  }), _vm._v(" "), _vm._c('BottomShelf', {
	    attrs: {
	      "microNote": _vm.microNote,
	      "chapter": _vm.chapter
	    }
	  })], 1)], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ },
/* 682 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('BlogList'), _vm._v(" "), _vm._c('AdBlock', {
	    attrs: {
	      "slot-id": 1,
	      "count": 1,
	      "containerClass": 'container xs-pb-30',
	      "ad-area-override": "public"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 683 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "ad-block"
	  }, [_vm._c('div', {
	    class: _vm.containerClass
	  }, [_vm._c('div', {
	    staticClass: "ad-wrap"
	  }, [_vm._c('InArticleAdsense', {
	    attrs: {
	      "data-ad-client": "ca-pub-4296186765472233",
	      "data-ad-slot": "5176485427"
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ },
/* 684 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('PanelHeading', {
	    attrs: {
	      "title": "Lecture Notes",
	      "subtitle": "Lecture Notes can be converted to Micro Notes for studying"
	    }
	  }), _vm._v(" "), _vm._c('PanelBody', [_vm._c('code', [_vm._v("#todo list them with links to editor to edit content")]), _vm._v(" "), _vm._c('h3', [_vm._v("Lecture notes")]), _vm._v("\n            " + _vm._s(_vm.lectureNotes) + "\n\n          ")])], 1)], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 685 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('ul', {
	    staticClass: "nav navbar-right be-user-nav"
	  }, [_vm._c('li', {
	    staticClass: "dropdown"
	  }, [(_vm.allNotifications.length > 0) ? _vm._c('a', {
	    staticClass: "notifications",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-bell"
	  }), _vm._v(" "), _vm._c('span', {
	    staticClass: "notification-count"
	  }, [_vm._v(_vm._s(_vm.allNotifications.length))])]) : _vm._c('a', {
	    staticClass: "notifications",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._c('i', {
	    staticClass: "far fa-bell"
	  })]), _vm._v(" "), _vm._c('ul', {
	    staticClass: "dropdown-menu",
	    staticStyle: {
	      "width": "300px"
	    },
	    attrs: {
	      "role": "menu"
	    }
	  }, [_vm._c('li', [_vm._c('NotificationList', {
	    attrs: {
	      "show-delete": false
	    }
	  })], 1)])]), _vm._v(" "), _vm._c('li', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('ul', {
	    staticClass: "dropdown-menu",
	    attrs: {
	      "role": "menu"
	    }
	  }, [_vm._c('li', [_vm._c('div', {
	    staticClass: "user-info"
	  }, [_vm._c('div', {
	    staticClass: "user-name"
	  }, [_vm._v(_vm._s(_vm.currentUser.email))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "user-position online"
	  }, [_vm._v("Available")])])]), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-home"
	  }), _vm._v(" Subject Shelf")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'user-account'
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-face"
	  }), _vm._v(" Account")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'user-settings'
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-settings"
	  }), _vm._v(" Settings")])], 1), _vm._v(" "), _vm._c('li', [_vm._c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logout($event)
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "icon mdi mdi-power"
	  }), _vm._v(" Logout")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "dropdown",
	      "role": "button",
	      "aria-expanded": "false"
	    }
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/avatar.png",
	      "alt": "Avatar"
	    }
	  })])
	}]}

/***/ },
/* 686 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "wrap-blue banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-push-6 col-md-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/advertise/banner2_400.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/advertise/banner2_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/advertise/banner2_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/advertise/banner2_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/advertise/banner2_800.jpg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-pull-6 col-md-6 banner-content-wrap"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            Part of our mission is bringing people together who love to learn! Come be a part of it and see what CLEX advertising has to offer. We can serve your brand’s ads either directly on our secure platform or from your preferred third-party provider (Google, Bing, etc.).\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank xs-full-width",
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._v("Become A Partner Today")])], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "ptb-100 text-center ad-content"
	  }, [_vm._c('div', {
	    staticClass: "inner"
	  }, [_vm._c('p'), _vm._c('h2', {
	    staticClass: "xs-mb-50"
	  }, [_vm._v("As Seen On...")]), _vm._v(" "), _vm._c('p'), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-mb-50 large-text"
	  }, [_vm._v("We can achieve much more when we learn together. Become part of our team as an Advertising Partner.")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-border-primary",
	    attrs: {
	      "to": {
	        name: 'contact-us'
	      }
	    }
	  }, [_vm._v("Become A Partner Today")])], 1), _vm._v(" "), _vm._c('AdBlock', {
	    attrs: {
	      "slot-id": 2,
	      "count": 1,
	      "containerClass": '',
	      "ad-area-override": "public"
	    }
	  })], 1), _vm._v(" "), _vm._c('AdBlock', {
	    attrs: {
	      "slot-id": 1,
	      "count": 1,
	      "containerClass": 'container xs-pb-30',
	      "ad-area-override": "public"
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('h1', [_vm._v("Become "), _vm._c('br'), _vm._v("A Partner")])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row xs-mb-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 xs-p-10"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/advertise/google.png",
	      "alt": "Google",
	      "title": "Google"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 xs-p-10"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/advertise/bing.gif",
	      "alt": "Bing",
	      "title": "Bing"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 xs-p-10"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/advertise/Taboola.png",
	      "alt": "Taboola",
	      "title": "Taboola"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-3 xs-p-10"
	  }, [_vm._c('img', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "src": "/static/img/advertise/Yahoo.png",
	      "alt": "Yahoo",
	      "title": "Yahoo"
	    }
	  })])])
	}]}

/***/ },
/* 687 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 signup-content xs-mb-50 md-mb-50"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n          CLEX is aware that the cost of post secondary education is very expensive, and in order to make your life as stress free as possible,\n          we are giving you CLEX for free at no charge, with no obligation to purchase for as long as you need it. No three month trial like most service providers.\n        ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 signup-form-wrap"
	  }, [_vm._c('div', {
	    staticClass: "signup-form"
	  }, [_vm._c('p', [_vm._v("Please enter your information to sign up for CLEX, for free!")]), _vm._v(" "), _vm._l((_vm.currentUser.errors), function(msg) {
	    return (_vm.currentUser.errors) ? _vm._c('div', {
	      staticClass: "alert alert-contrast alert-danger alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])]) : _vm._e()
	  }), _vm._v(" "), _vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.register($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.first_name),
	      expression: "newUser.first_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "autofocus": "",
	      "name": "first_name",
	      "type": "text",
	      "placeholder": "Your First Name",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.first_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.first_name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.last_name),
	      expression: "newUser.last_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "last_name",
	      "type": "text",
	      "placeholder": "Your Last Name",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.last_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.last_name = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.email),
	      expression: "newUser.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "placeholder": "Your E-mail",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.email = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.password),
	      expression: "newUser.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.password = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newUser.password_confirmation),
	      expression: "newUser.password_confirmation"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password_confirmation",
	      "type": "password",
	      "placeholder": "Re-enter Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newUser.password_confirmation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newUser.password_confirmation = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.currentUser.showSuccess) ? _vm._c('div', {
	    staticClass: "alert alert-success"
	  }, [_vm._v("We've sent you an email with a confirmation link. Please check your emails for instructions.")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group xs-pt-10 row"
	  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_vm._c('router-link', {
	    staticClass: "login-link",
	    attrs: {
	      "to": "/login"
	    }
	  }, [_vm._v("Have an account? "), _vm._c('strong', [_vm._v("Log in")]), _vm._v(".")])], 1)])])], 2)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('h1', [_vm._v("Sign Up "), _vm._c('br'), _vm._v("For Free")])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width"
	  }, [_vm._v("Sign Up")])])
	}]}

/***/ },
/* 688 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home"
	  }, [_vm._c('div', {
	    staticClass: "banner"
	  }, [_vm._c('div', {
	    staticClass: "copy"
	  }, [_vm._c('h1', {
	    staticClass: "x-large-text weight500"
	  }, [_vm._v("Better Grades, Less Effort.")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n        CLEX helps improve grades by organizing notes to prioritize and focus studying.\n        This simple, easy-to-use software provides a flexible approach to learning.\n      ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "buttons"
	  }, [_vm._c('a', {
	    staticClass: "btn-pub btn-pub-blank signup-btn fixed-width xs-full-width",
	    attrs: {
	      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
	    }
	  }, [_vm._v("Sign Up for Free")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "btn-pub btn-pub-primary video-btn fixed-width xs-full-width",
	    staticStyle: {
	      "cursor": "pointer"
	    },
	    attrs: {
	      "target": "_blank"
	    },
	    on: {
	      "click": _vm.scrollToVideo
	    }
	  }, [_vm._v("Watch Our Video")])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "bg"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_500.jpg",
	      "media": "(max-width: 500px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_800.jpg",
	      "media": "(min-width: 501px) and (max-width: 767px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_1200.jpg",
	      "media": "(min-width: 768px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_1600.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_2000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/home/banner6_1600.jpg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "container key-features ptb-100"
	  }, [_vm._c('div', {
	    staticClass: "row text-center xs-mb-50"
	  }, [_vm._c('div', {
	    staticClass: "col"
	  }, [_vm._c('video-player', {
	    attrs: {
	      "src": "/static/video/demo.mp4",
	      "reference": "homeVideo"
	    }
	  })], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "wrap-blue banner-with-copy testimonial"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-push-sm-6 col-sm-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner7_400.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner7_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner7_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner7_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/home/banner7_800.jpg",
	      "alt": ""
	    }
	  })])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-push-sm-6 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._c('p', [_vm._v("\n            “As a devoted student of the University of British Columbia I study continuously.\n            CLEX allows me to organize my studies and create micro-notes for each of my courses.\n            By using this method I was able to be more focused, and better prepared for each of my examinations which ultimately improved my grades”\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "name weight500"
	  }, [_vm._v("- Billy, University of British Columbia")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._c('div', {
	    staticClass: "bottom-banner"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner8_600.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner8_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner8_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner8_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/home/banner8_800.jpg",
	      "alt": ""
	    }
	  })])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 "
	  }, [_vm._c('div', {
	    staticClass: "banner-text"
	  }, [_vm._c('h2', {
	    staticClass: "xs-mb-30 weight500"
	  }, [_vm._v("Take the stress out of studying")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-mb-30"
	  }, [_vm._v("\n            We believe learning should be an engaging and rewarding experience. CLEX is\n            designed with your brain in mind so you can get back to enjoying the subject you’re passionate about!\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank xs-mb-30 fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "row text-center"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._c('div', {
	    staticClass: "feature"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-01.png",
	      "alt": "Learn Smarter"
	    }
	  }), _vm._v(" "), _vm._c('h2', {
	    staticClass: "xs-mt-50 xs-mb-30"
	  }, [_vm._v("Learn Smarter")])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._c('div', {
	    staticClass: "feature"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-02.png",
	      "alt": "Organize Notes"
	    }
	  }), _vm._v(" "), _vm._c('h2', {
	    staticClass: "xs-mt-50 xs-mb-30"
	  }, [_vm._v("Organize Notes")])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._c('div', {
	    staticClass: "feature"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-03.png",
	      "alt": "Remember Everything"
	    }
	  }), _vm._v(" "), _vm._c('h2', {
	    staticClass: "xs-mt-50 xs-mb-30"
	  }, [_vm._v("Remember Everything")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "features ptb-80"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('div', {
	    staticClass: "text-center"
	  }, [_vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-04.png",
	      "alt": "Focus studying"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("Focus studying")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-05.png",
	      "alt": "Access everywhere"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("Access everywhere")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-06.png",
	      "alt": "Keywords search"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("Keywords search")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-07.png",
	      "alt": "Micro-notes"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("Micro-notes")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-08.png",
	      "alt": "One-click import"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("One-click import")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row xs-pt-30"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_vm._c('a', {
	    staticClass: "btn-pub btn-pub-border-primary fixed-width",
	    attrs: {
	      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
	    }
	  }, [_vm._v("Sign Up for Free")])])])])])
	}]}

/***/ },
/* 689 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Account",
	      "subtitle": "Update your user information"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "sm-p-30 xs-pt-30 xs-pb-30 xs-pl-10 xs-pr-10"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-12 col-sm-6 col-form-label",
	    attrs: {
	      "for": "txtName"
	    }
	  }, [_vm._v("Name")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.firstName),
	      expression: "user.firstName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtName",
	      "placeholder": "First name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.firstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.firstName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.lastName),
	      expression: "user.lastName"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtLName",
	      "placeholder": "Last name"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.lastName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.lastName = $event.target.value
	      }
	    }
	  })])])])])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-12 col-sm-6 col-form-label",
	    attrs: {
	      "for": "txtEmail"
	    }
	  }, [_vm._v("Email address")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "email",
	      "id": "txtEmail"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.email = $event.target.value
	      }
	    }
	  })])])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-12 col-sm-6 col-form-label",
	    attrs: {
	      "for": "txtNewPass"
	    }
	  }, [_vm._v("New password")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "txtNewPass"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-12 col-sm-6 col-form-label",
	    attrs: {
	      "for": "txtConfirmPass"
	    }
	  }, [_vm._v("Confirm password")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password_confirmation),
	      expression: "user.password_confirmation"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "password",
	      "id": "txtConfirmPass"
	    },
	    domProps: {
	      "value": _vm._s(_vm.user.password_confirmation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.user.password_confirmation = $event.target.value
	      }
	    }
	  })])])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 text-right"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-primary btn-lg",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v("Save")])])])])], 1)], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 690 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "notfications"
	  }, [_vm._c('ul', [_vm._l((_vm.allNotifications), function(n) {
	    return _vm._c('li', {
	      staticClass: "notification"
	    }, [_vm._c('router-link', {
	      attrs: {
	        "to": {
	          name: n.navLocation
	        }
	      }
	    }, [_vm._v(_vm._s(n.message))]), _vm._v(" "), (_vm.showDelete === true) ? _vm._c('span', {
	      on: {
	        "click": function($event) {
	          _vm.removeNotification(n)
	        }
	      }
	    }, [_vm._c('i', {
	      staticClass: "fas fa-times"
	    })]) : _vm._e()], 1)
	  }), _vm._v(" "), (_vm.allNotifications.length > 0) ? _vm._c('li', {
	    staticClass: "clear-all notification",
	    on: {
	      "click": function($event) {
	        _vm.removeAllNotifications()
	      }
	    }
	  }, [_vm._v("Cleare all notifications")]) : _vm._c('li', {
	    staticClass: "xs-p-20"
	  }, [_vm._v("No new notifications")])], 2)])
	},staticRenderFns: []}

/***/ },
/* 691 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "comments"
	  }, [_vm._c('div', {
	    staticClass: "row xs-mb-30"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [_vm._c('h3', {
	    staticClass: "pull-left xs-m-0"
	  }, [_vm._v("Comments "), (_vm.comments.length > 0) ? _vm._c('span', {
	    staticStyle: {
	      "font-size": "70%"
	    }
	  }, [_vm._v("(" + _vm._s(_vm.filteredComments.length) + ")")]) : _vm._e()])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6"
	  }, [(!_vm.currentUser.loggedIn) ? _vm._c('router-link', {
	    staticClass: "btn btn-default pull-right",
	    attrs: {
	      "to": {
	        name: 'login',
	        query: {
	          redirect: '/blog-article/' + _vm.articleId
	        }
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-sign-in-alt"
	  }), _vm._v("   Login to comment")]) : _vm._e()], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), (_vm.currentUser.loggedIn) ? _vm._c('div', {
	    staticClass: "write"
	  }, [_vm._c('div', {
	    staticClass: "input"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('Editable', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.commentText),
	      expression: "commentText"
	    }],
	    attrs: {
	      "placeholder": "Write a public comment..."
	    },
	    domProps: {
	      "value": (_vm.commentText)
	    },
	    on: {
	      "input": function($event) {
	        _vm.commentText = $event
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "buttons text-right"
	  }, [(!_vm.status) ? _vm._c('button', {
	    staticClass: "btn btn-primary xs-ml-20",
	    attrs: {
	      "disabled": !_vm.commentText
	    },
	    on: {
	      "click": function($event) {
	        _vm.submit()
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "far fa-comment"
	  }), _vm._v("   Submit")]) : _vm._c('button', {
	    staticClass: "btn btn-default xs-ml-20",
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._v("Submitting...")])])]) : _vm._e(), _vm._v(" "), (_vm.filteredComments.length > 0) ? _vm._c('div', _vm._l((_vm.filteredComments), function(comment) {
	    return _vm._c('BlogComment', {
	      attrs: {
	        "show-delete": _vm.showDelete,
	        "comment": comment,
	        "blogArticleId": _vm.articleId
	      }
	    })
	  })) : _vm._c('div', {
	    staticClass: "xs-pt-30"
	  }, [_vm._v("\n    There are no comments for this article.\n  ")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "avatar"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/avatar.png",
	      "alt": "Avatar"
	    }
	  })])
	}]}

/***/ },
/* 692 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "wrap-black banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-push-6 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            Please feel free to contact us with any questions or concerns you might have. We're happy to help you out!\n            Please use this form provided and we will get back to you shortly. If you'd like to learn more about our services check out our features page.\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-pull-6 col-sm-6 pic"
	  }, [_vm._c('InquiryForm', {
	    attrs: {
	      "subject": "General Inquiry"
	    }
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('h1', [_vm._v("Contact "), _vm._c('br'), _vm._v("Us")])
	}]}

/***/ },
/* 693 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-wrapper be-fixed-sidebar app-layout"
	  }, [_vm._c('navbar'), _vm._v(" "), (_vm.page.sidebarOpen) ? _vm._c('sidebar') : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "be-content"
	  }, [_vm._c('div', {
	    class: _vm.page.adArea ? 'ad-container' : ''
	  }, [_vm._c('div', {
	    staticClass: "left"
	  }, [_vm._c('router-view')], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "right"
	  }, [(_vm.page.adArea) ? _vm._c('VerticalAd', {
	    key: _vm.currentRoute,
	    attrs: {
	      "containerClass": ''
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.page.adArea) ? _vm._c('VerticalAd', {
	    key: _vm.currentRoute,
	    attrs: {
	      "containerClass": ''
	    }
	  }) : _vm._e()], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clear"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "bottom-ad xs-p-20 xs-mb-20"
	  }, [_vm._c('HorizontalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  })], 1)])], 1)
	},staticRenderFns: []}

/***/ },
/* 694 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "video-player"
	  }, [_vm._c('video', {
	    ref: _vm.reference,
	    attrs: {
	      "width": "100%",
	      "controls": "",
	      "id": _vm.reference
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "src": _vm.src,
	      "type": "video/mp4"
	    }
	  }), _vm._v("\n    Your browser does not support the video tag.\n  ")])])
	},staticRenderFns: []}

/***/ },
/* 695 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [(_vm.image) ? _vm._c('div', {
	    staticClass: "banner",
	    style: ('background-image:url(' + _vm.image + ');')
	  }) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "container sm-pt-50 xs-pb-50"
	  }, [(_vm.blogArticle) ? _vm._c('div', {
	    staticClass: "article"
	  }, [_vm._c('h1', {
	    staticClass: "weight500 x-large-text xs-mb-20 md-mb-50"
	  }, [_vm._v(_vm._s(_vm.blogArticle.title))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "date large-text xs-mb-20 md-mb-50"
	  }, [_vm._v("\n          " + _vm._s(_vm.blogArticle.created_at_formatted) + "\n        ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-9"
	  }, [_vm._c('div', {
	    staticClass: "article-content"
	  }, [_vm._c('div', {
	    staticClass: "content text-justify  large-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.blogArticle.content)
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "xs-mt-50 xs-mb-50 text-center"
	  }, [_vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-border-primary xs-full-width",
	    attrs: {
	      "to": {
	        name: 'blog'
	      }
	    }
	  }, [_vm._v("Back To Posts")])], 1), _vm._v(" "), _vm._c('AdBlock', {
	    attrs: {
	      "slot-id": 1,
	      "count": 1,
	      "containerClass": '',
	      "ad-area-override": "public"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "row xs-mt-50",
	    attrs: {
	      "id": "comments"
	    }
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('BlogCommentsList', {
	    attrs: {
	      "comments": _vm.blogArticle.comments,
	      "articleId": _vm.blogArticle.id
	    }
	  })], 1)])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "hidden-sm hidden-xs col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "wrap-blue xs-mb-50 signup-block large-text"
	  }, [_vm._c('span', {
	    staticClass: "weight500"
	  }, [_vm._v("Learn Smarter, Organize Notes, Remember Everything.")]), _vm._c('br'), _vm._c('br'), _vm._v("\n              Get Started With Us, For Free!"), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank",
	    attrs: {
	      "to": {
	        name: 'signup'
	      }
	    }
	  }, [_vm._v("Sign Up Today")])], 1), _vm._v(" "), _vm._c('AdBlock', {
	    attrs: {
	      "slot-id": 2,
	      "count": 1,
	      "containerClass": '',
	      "ad-area-override": "public"
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "wrap-black xs-mt-50 signup-block large-text"
	  }, [_vm._c('span', {
	    staticClass: "weight500"
	  }, [_vm._v("Learn Smarter, Organize Notes, Remember Everything.")]), _vm._c('br'), _vm._c('br'), _vm._v("\n              Get Started With Us, For Free!"), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank",
	    attrs: {
	      "to": {
	        name: 'signup'
	      }
	    }
	  }, [_vm._v("Sign Up Today")])], 1)], 1)])]) : _vm._c('div', [_vm._c('LoadingIndicator')], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 696 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [(_vm.valid) ? _vm._c('div', [_vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.confirmPassword),
	      expression: "credentials.confirmPassword"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Confirm Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.confirmPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.confirmPassword = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.currentUser.errors) ? _vm._c('div', _vm._l((_vm.currentUser.errors), function(msg) {
	    return _vm._c('div', {
	      staticClass: "alert alert-contrast alert-danger alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])])
	  })) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group xs-pt-10"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width",
	    attrs: {
	      "disabled": !_vm.credentials.password || !_vm.credentials.confirmPassword || _vm.saving
	    }
	  }, [_vm._v(_vm._s(_vm.saving ? 'Please wait...' : 'Submit'))])])])]) : _vm._c('div', [_vm._c('div', {
	    staticClass: "panel-body"
	  }, [_vm._c('div', {
	    staticClass: "alert alert-contrast alert-danger alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._c('div', {
	    staticClass: "message"
	  }, [_vm._v("Invalid password reset link")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('p', {
	    staticClass: "xs-pb-20"
	  }, [_vm._v("\n          Reset Password."), _vm._c('br'), _vm._v("\n          Enter a new password below.\n        ")])
	}]}

/***/ },
/* 697 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [(_vm.valid) ? _vm._c('div', [_vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.confirmPassword),
	      expression: "credentials.confirmPassword"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Confirm Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.confirmPassword)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.confirmPassword = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.currentUser.errors) ? _vm._c('div', _vm._l((_vm.currentUser.errors), function(msg) {
	    return _vm._c('div', {
	      staticClass: "alert alert-contrast alert-danger alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])])
	  })) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group xs-pt-10"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width",
	    attrs: {
	      "disabled": !_vm.credentials.password || !_vm.credentials.confirmPassword || _vm.saving
	    }
	  }, [_vm._v(_vm._s(_vm.saving ? 'Please wait...' : 'Submit'))])])])]) : _vm._c('div', [_vm._c('div', {
	    staticClass: "panel-body"
	  }, [_vm._c('div', {
	    staticClass: "alert alert-contrast alert-danger alert-dismissible",
	    attrs: {
	      "role": "alert"
	    }
	  }, [_vm._c('div', {
	    staticClass: "message"
	  }, [_vm._v("Invalid password reset link")])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('p', {
	    staticClass: "xs-pb-20"
	  }, [_vm._v("\n          Reset Password."), _vm._c('br'), _vm._v("\n          Enter a new password below.\n        ")])
	}]}

/***/ },
/* 698 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "share",
	    class: {
	      selected: _vm.selected
	    },
	    on: {
	      "click": function($event) {
	        _vm.updateSelected()
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "icon"
	  }, [(!_vm.selected) ? _vm._c('i', {
	    staticClass: "far fa-square"
	  }) : _vm._e(), _vm._v(" "), (_vm.selected) ? _vm._c('i', {
	    staticClass: "fas fa-check-square"
	  }) : _vm._e()]), _vm._v(" "), _vm._c('span', [_vm._c('strong', [_vm._v(_vm._s(_vm.share.sender_email))]), _vm._v(" has shared their study notes '"), _vm._c('strong', [_vm._v(_vm._s(_vm.share.chapter_name))]), _vm._v("' with you.")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })])
	},staticRenderFns: []}

/***/ },
/* 699 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "keyword-settings"
	  }, [_vm._c('div', {
	    staticClass: "dropdown open"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "id": "keywordSettingsDropdownMenuButton",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    },
	    on: {
	      "click": _vm.toggleDropdown
	    }
	  }, [_vm._c('i', {
	    staticClass: "fa fa-key",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }), _vm._v(" Edit keyword settings\n    ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "dropdown-menu dropdown-menu-right",
	    style: ([_vm.dropdownVisible ? {
	      'display': 'block'
	    } : {
	      'display': 'none'
	    }]),
	    attrs: {
	      "aria-labelledby": "keywordSettingsDropdownMenuButton",
	      "id": "divShowKeywordSettings"
	    }
	  }, [_vm._c('strong', [_vm._v("Select a keyword difficulty")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "text-right close-btn",
	    on: {
	      "click": _vm.toggleDropdown
	    }
	  }, [_vm._c('i', {
	    staticClass: "fa fa-times",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "options"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.keywordDifficulty),
	      expression: "keywordDifficulty",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "radKeywordDifficultyEasy",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.keywordDifficulty, _vm._n("1"))
	    },
	    on: {
	      "change": function($event) {
	        _vm.saveChapter(1)
	      },
	      "click": function($event) {
	        _vm.keywordDifficulty = _vm._n("1")
	      }
	    }
	  }), _vm._v(" "), _vm._c('label', {
	    attrs: {
	      "for": "radKeywordDifficultyEasy"
	    }
	  }, [_vm._v("Easy")]), _vm._c('br'), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.keywordDifficulty),
	      expression: "keywordDifficulty",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "radKeywordDifficultyMod",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.keywordDifficulty, _vm._n("2"))
	    },
	    on: {
	      "change": function($event) {
	        _vm.saveChapter(2)
	      },
	      "click": function($event) {
	        _vm.keywordDifficulty = _vm._n("2")
	      }
	    }
	  }), _vm._v(" "), _vm._c('label', {
	    attrs: {
	      "for": "radKeywordDifficultyMod"
	    }
	  }, [_vm._v("Moderate")]), _vm._c('br'), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.number",
	      value: (_vm.keywordDifficulty),
	      expression: "keywordDifficulty",
	      modifiers: {
	        "number": true
	      }
	    }],
	    attrs: {
	      "type": "radio",
	      "id": "radKeywordDifficultyDif",
	      "value": "3"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.keywordDifficulty, _vm._n("3"))
	    },
	    on: {
	      "change": function($event) {
	        _vm.saveChapter(3)
	      },
	      "click": function($event) {
	        _vm.keywordDifficulty = _vm._n("3")
	      }
	    }
	  }), _vm._v(" "), _vm._c('label', {
	    attrs: {
	      "for": "radKeywordDifficultyDif"
	    }
	  }, [_vm._v("Difficult")])]), _vm._v(" "), _vm._c('hr'), _vm._v("\n      " + _vm._s(_vm.description)), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('strong', [_vm._v("Example:")]), _vm._c('br'), _vm._v("\n      'Cerebral Edema' =  "), _vm._c('span', {
	    staticClass: "clex-keyword"
	  }, [_vm._v(_vm._s(_vm.example))])])])])
	},staticRenderFns: []}

/***/ },
/* 700 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('span', [(!_vm.revealAnswers) ? _vm._c('span', {
	    directives: [{
	      name: "scroll-in-view-when",
	      rawName: "v-scroll-in-view-when",
	      value: (_vm.active),
	      expression: "active"
	    }],
	    staticClass: "clex-keyword",
	    class: {
	      active: _vm.active, answered: _vm.answered
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.select($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.visibleContent))]) : _vm._c('span', {
	    staticClass: "clex-keyword answer",
	    class: {
	      correct: _vm.answerIsCorrect, wrong: !_vm.answerIsCorrect
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.answerDiff)
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 701 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('PageHeader', {
	    attrs: {
	      "title": _vm.chapter ? 'Edit \'' + _vm.chapter.title + (_vm.editType === 'image' ? '\' Images' : '\' Micro Notes') : 'Loading...'
	    }
	  }, [(_vm.microNotes && _vm.microNotes.length) ? _vm._c('div', {
	    staticClass: "email-filters-right  text-right xs-mt-10",
	    staticStyle: {
	      "float": "right",
	      "width": "100%"
	    }
	  }, [_vm._c('ol', {
	    staticClass: "breadcrumb",
	    staticStyle: {
	      "margin-top": "3px",
	      "float": "left"
	    }
	  }, [_vm._c('li', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "icon mdi mdi-arrow-left"
	  }), _vm._v("  Home")])], 1)]), _vm._v(" "), _vm._c('span', {
	    staticClass: "email-pagination-indicator"
	  }, [_vm._v(_vm._s(_vm.currentMicroNoteIndex + 1) + " of " + _vm._s(_vm.microNotes.length) + " ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "btn-group email-pagination-nav text-right"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "title": "Previous micro note"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.previousMicroNote($event)
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "mdi mdi-chevron-left"
	  }), _vm._c('span', {
	    staticClass: "xs-hide"
	  }, [_vm._v(" Prev")])]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "title": "Next micro note"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.nextMicroNote($event)
	      }
	    }
	  }, [_vm._c('span', {
	    staticClass: "xs-hide"
	  }, [_vm._v("Next ")]), _vm._c('i', {
	    staticClass: "mdi mdi-chevron-right"
	  })])]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button",
	      "title": "Add new micro note"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addMicroNote($event)
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-plus",
	    staticStyle: {
	      "font-size": "14px"
	    }
	  }), _vm._v(" Add"), _vm._c('span', {
	    staticClass: "xs-hide"
	  }, [_vm._v(" micro note")])]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "type": "button",
	      "title": "Delete this micro note"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleDeleteWarning($event)
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-trash",
	    staticStyle: {
	      "font-size": "14px"
	    }
	  }), _vm._v(" Delete"), _vm._c('span', {
	    staticClass: "xs-hide"
	  }, [_vm._v(" micro note")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "pull-left text-left"
	  }, [_vm._c('div', [_vm._c('Help', [_vm._c('div', {
	    slot: "content"
	  }, [(_vm.editType !== 'image') ? _vm._c('div', [_vm._v("\n                Split your lecture notes into micro notes with the "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" button. Select keywords to be hidden/tested with the "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-key"
	  })]), _vm._v(" button."), _vm._c('br'), _vm._v("\n                Click an image and select "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-object-group"
	  })]), _vm._v(" to convert the image to a micro note. Image keywords can be set in the next stage."), _vm._c('br'), _vm._v("\n                Click "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-save"
	  }), _vm._v(" Create micro notes")]), _vm._v(" to save and proceed to micro note image editing.\n              ")]) : _vm._e(), _vm._v("\n              To create image keywords, click and drag on the image to create a keyword area then type in your keyword."), _vm._c('br'), _vm._v("\n              You can re-size or move image keywords once created."), _vm._c('br'), _vm._v("\n              Jump to the next/previous micro note with "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('i', {
	    staticClass: "mdi mdi-chevron-left"
	  })]), _vm._v(" and "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('i', {
	    staticClass: "mdi mdi-chevron-right"
	  })]), _vm._v(". "), _vm._c('strong', [_vm._v("Changes are saved automatically")])])])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "pull-right"
	  }, [_vm._c('div', {
	    staticClass: "active-toggle"
	  }, [_vm._c('span', {
	    staticClass: "lbl"
	  }, [_vm._v("Micro note is:")]), _vm._v(" "), _vm._c('BoolSwitch', {
	    attrs: {
	      "toggle-bool": _vm.microNoteActive,
	      "toggle-function": _vm.toggleActive,
	      "on-text": "On",
	      "off-text": "Off"
	    }
	  })], 1), _vm._v(" "), _vm._c('KeywordSettings', {
	    staticClass: "xs-mt-10",
	    attrs: {
	      "chapterId": _vm.microNote.chapter_id
	    }
	  })], 1)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), (_vm.showDeleteWarning) ? _vm._c('div', {
	    staticClass: "bg-danger clearfix"
	  }, [_vm._c('p', {
	    staticClass: "pull-left"
	  }, [_vm._v("\n        Are you sure you want to delete this micro note?\n      ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "pull-right"
	  }, [_vm._c('a', {
	    staticClass: "btn btn-default btn-sm",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deleteMicroNote($event)
	      }
	    }
	  }, [_vm._v("\n          Delete\n        ")]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn btn-default btn-sm btn-margin",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleDeleteWarning($event)
	      }
	    }
	  }, [_vm._v("\n          Cancel\n        ")])])]) : _vm._e()]), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [(!_vm.chapter || !_vm.microNotes || !_vm.microNotes.length || !_vm.microNote) ? _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', [_vm._c('PanelBody', [(!_vm.chapter) ? _vm._c('LoadingIndicator') : (!_vm.microNotes || !_vm.microNotes.length) ? _vm._c('p', [_vm._c('em', [_vm._v("There are no micro notes in this chapter.")])]) : (!_vm.microNote) ? _vm._c('p', [_vm._c('em', [_vm._v("Micro note not found.")])]) : _vm._e()], 1)], 1)], 1)]) : (_vm.microNote.micro_note_type === 'html') ? _vm._c('div', {
	    staticClass: "row height-100"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12 height-100"
	  }, [_vm._c('div', {
	    staticClass: "height-100"
	  }, [_vm._c('FroalaEditor', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newHtml),
	      expression: "newHtml"
	    }],
	    ref: "editor",
	    attrs: {
	      "chapterId": _vm.microNote.chapter_id,
	      "config": _vm.froalaConfig
	    },
	    domProps: {
	      "value": (_vm.newHtml)
	    },
	    on: {
	      "change": _vm.saveMicroNote,
	      "input": function($event) {
	        _vm.newHtml = $event
	      }
	    }
	  }), _vm._v(" "), _vm._c('p', {
	    staticClass: "text-muted"
	  }, [_vm._v(_vm._s(_vm.statusMessage))])], 1)])]) : _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default"
	  }, [_vm._c('PanelBody', {
	    staticStyle: {
	      "padding": "20px",
	      "text-align": "center"
	    }
	  }, [_vm._c('MicroNoteImageEditor', {
	    attrs: {
	      "microNote": _vm.microNote
	    }
	  })], 1)], 1)], 1)])])], 1)
	},staticRenderFns: []}

/***/ },
/* 702 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [(_vm.image) ? _vm._c('div', {
	    staticClass: "banner",
	    style: ('background-image:url(' + _vm.image + ');')
	  }) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "container sm-pt-50 xs-pb-50"
	  }, [(_vm.blogArticle) ? _vm._c('div', {
	    staticClass: "article"
	  }, [_vm._c('h1', {
	    staticClass: "weight500 x-large-text xs-mb-20 md-mb-50"
	  }, [_vm._v(_vm._s(_vm.blogArticle.title))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "date large-text xs-mb-20 md-mb-50"
	  }, [_vm._v("\n          " + _vm._s(_vm.blogArticle.created_at_formatted) + "\n        ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-9"
	  }, [_vm._c('div', {
	    staticClass: "article-content"
	  }, [_vm._c('div', {
	    staticClass: "content text-justify  large-text",
	    domProps: {
	      "innerHTML": _vm._s(_vm.blogArticle.content)
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "xs-mt-50 xs-mb-50 text-center"
	  }, [_vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-border-primary xs-full-width",
	    attrs: {
	      "to": {
	        name: 'blog'
	      }
	    }
	  }, [_vm._v("Back To Posts")])], 1), _vm._v(" "), _vm._c('HorizontalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "row xs-mt-50",
	    attrs: {
	      "id": "comments"
	    }
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('BlogCommentsList', {
	    attrs: {
	      "comments": _vm.blogArticle.comments,
	      "articleId": _vm.blogArticle.id
	    }
	  })], 1)])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "hidden-sm hidden-xs col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "wrap-blue xs-mb-50 signup-block large-text"
	  }, [_vm._c('span', {
	    staticClass: "weight500"
	  }, [_vm._v("Learn Smarter, Organize Notes, Remember Everything.")]), _vm._c('br'), _vm._c('br'), _vm._v("\n              Get Started With Us, For Free!"), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank",
	    attrs: {
	      "to": {
	        name: 'signup'
	      }
	    }
	  }, [_vm._v("Sign Up Today")])], 1), _vm._v(" "), _vm._c('VerticalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "wrap-black xs-mt-50 signup-block large-text"
	  }, [_vm._c('span', {
	    staticClass: "weight500"
	  }, [_vm._v("Learn Smarter, Organize Notes, Remember Everything.")]), _vm._c('br'), _vm._c('br'), _vm._v("\n              Get Started With Us, For Free!"), _vm._c('br'), _vm._c('br'), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank",
	    attrs: {
	      "to": {
	        name: 'signup'
	      }
	    }
	  }, [_vm._v("Sign Up Today")])], 1)], 1)])]) : _vm._c('div', [_vm._c('LoadingIndicator')], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 703 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return (_vm.microNote) ? _vm._c('div', [_vm._c('div', {
	    staticClass: "panel-body",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.handleClick($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "microNoteImageStudier"
	  }, [_vm._c('div', {
	    staticClass: "image-container"
	  }, [_vm._l((_vm.keywords), function(keyword) {
	    return _vm._c('ImageKeyword', {
	      attrs: {
	        "scale": _vm.scale,
	        "keywordId": keyword.id
	      }
	    })
	  }), _vm._v(" "), (_vm.microNote.micro_note_images) ? _vm._c('img', {
	    ref: "image",
	    attrs: {
	      "src": _vm.microNote.micro_note_images[0].image_url
	    }
	  }) : _vm._e()], 2)])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 704 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Define Micro Notes"
	    }
	  }, [_vm._c('div', {
	    staticClass: "pull-right"
	  }, [(_vm.chapter && _vm.microNotable()) ? _vm._c('a', {
	    staticClass: "btn btn-primary btn-lg",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleReplaceWarning($event)
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-save"
	  }), _vm._v("   Save changes\n      ")]) : (_vm.chapter) ? _vm._c('a', {
	    staticClass: "btn btn-primary btn-lg disabled",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "href": "",
	      "disabled": ""
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-save"
	  }), _vm._v("   Save changes\n      ")]) : _vm._e(), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn btn-danger btn-lg",
	    staticStyle: {
	      "float": "right",
	      "margin-left": "10px"
	    },
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-arrow-left"
	  }), _vm._v("   Cancel\n      ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "text-right pull-right xs-mt-5 xs-mb-10"
	  }, [(_vm.chapter) ? _vm._c('KeywordSettings', {
	    attrs: {
	      "chapterId": _vm.chapter.chapter_id
	    }
	  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "pull-left"
	  }, [_vm._c('Help', [_vm._c('div', {
	    slot: "content"
	  }, [_vm._v("\n          Split your lecture notes into micro notes with the "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-minus"
	  })]), _vm._v(" button. Select keywords to be hidden/tested with the "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-key"
	  })]), _vm._v(" button."), _vm._c('br'), _vm._v("\n          Click an image and select "), _vm._c('span', {
	    staticClass: "btn btn-default"
	  }, [_vm._c('span', {
	    staticClass: "fa fa-object-group"
	  })]), _vm._v(" to convert the image to a micro note. Image keywords can be set in the next stage."), _vm._c('br')])])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "main-content container-fluid xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "row height-100"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12 height-100"
	  }, [(_vm.chapter) ? _vm._c('div', {
	    staticClass: "height-100-minus"
	  }, [(_vm.showReplaceWarning) ? _vm._c('div', {
	    staticClass: "bg-danger clearfix"
	  }, [_vm._c('p', {
	    staticClass: "pull-left"
	  }, [_vm._c('b', [_vm._v("Warning:")]), _vm._v(" You've created " + _vm._s(_vm.microNotes.length) + " micro notes based on this chapter. Those micro notes will be replaced. Are you sure you want to proceed?\n            ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "pull-right"
	  }, [_vm._c('a', {
	    staticClass: "btn btn-default btn-sm",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.replaceMicroNotes($event)
	      }
	    }
	  }, [_vm._v("\n                Replace\n              ")]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn btn-default btn-sm btn-margin",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleReplaceWarning($event)
	      }
	    }
	  }, [_vm._v("\n                Cancel\n              ")])])]) : _vm._e(), _vm._v(" "), (!_vm.saving) ? _vm._c('FroalaEditor', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.html),
	      expression: "html"
	    }],
	    ref: "editor",
	    attrs: {
	      "chapterId": _vm.chapter.id,
	      "config": _vm.froalaConfig
	    },
	    domProps: {
	      "value": (_vm.html)
	    },
	    on: {
	      "input": function($event) {
	        _vm.html = $event
	      }
	    }
	  }) : _vm._c('LoadingIndicator', {
	    attrs: {
	      "text": "Saving..."
	    }
	  }), _vm._v(" "), _vm._c('p', {
	    staticClass: "text-muted"
	  }, [_vm._v(_vm._s(_vm.statusMessage))])], 1) : _vm._c('div', [_vm._c('LoadingIndicator')], 1)])])])], 1)
	},staticRenderFns: []}

/***/ },
/* 705 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "article-list"
	  }, [(_vm.heroPost) ? _vm._c('div', {
	    staticClass: "hero-post"
	  }, [_vm._c('div', {
	    staticClass: "wrap-black banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [(_vm.heroImg) ? _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "pic",
	    style: ('background-image:url(' + _vm.heroImg + ');')
	  }, [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.heroPost.id
	        }
	      }
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1)]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 banner-content-wrap",
	    class: _vm.heroImg ? 'col-sm-6' : ''
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._c('h1', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.heroPost.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.heroPost.title))])], 1), _vm._v(" "), _vm._c('p', [_vm._v("\n              " + _vm._s(_vm.heroContent) + "\n            ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.heroPost.id
	        }
	      }
	    }
	  }, [_vm._v("\n              Read More\n            ")])], 1)])])])]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "container-fluid sub-articles"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.showList), function(article) {
	    return _vm._c('BlogListArticle', {
	      attrs: {
	        "article": article
	      }
	    })
	  }))])])
	},staticRenderFns: []}

/***/ },
/* 706 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-4"
	  }, [_vm._c('div', {
	    staticClass: "article text-center"
	  }, [_vm._c('div', {
	    staticClass: "image",
	    style: (_vm.image ? 'background-image:url(' + _vm.image + ');' : '')
	  }, [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.article.id
	        }
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "article-content",
	    class: _vm.image ? '' : 'no-image'
	  }, [_vm._c('h2', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.article.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.article.title))])], 1), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v(_vm._s(_vm.content))])]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-border-primary fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.article.id
	        }
	      }
	    }
	  }, [_vm._v("\n      Read More\n    ")])], 1)])
	},staticRenderFns: []}

/***/ },
/* 707 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('PanelHeading', {
	    attrs: {
	      "title": "Lecture notes imported",
	      "subtitle": "Your notes were imported successfully. Where to now?"
	    }
	  }), _vm._v(" "), _vm._c('PanelBody', [_vm._c('div', {
	    staticClass: "row ptb-50"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('router-link', {
	    staticClass: "btn btn-primary btn-xl xs-mr-20 sm-mr-50",
	    attrs: {
	      "to": {
	        name: 'subject-shelf'
	      }
	    }
	  }, [_vm._v("Return to subject shelf")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "import-link",
	    attrs: {
	      "to": {
	        name: 'importer'
	      }
	    }
	  }, [_vm._v("Import another file")])], 1)]), _vm._v(" "), (_vm.showSummary) ? _vm._c('div', {
	    staticClass: "row ptb-50 xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('h3', [_vm._v("Import summary")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "summary-row"
	  }, [_vm._c('strong', {
	    staticClass: "summary-name pull-left"
	  }, [_vm._v("Subjects added:")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.subjects_added))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "summary-row"
	  }, [_vm._c('strong', {
	    staticClass: "summary-name pull-left"
	  }, [_vm._v("Subjects skipped:")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.subjects_skipped))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "summary-row"
	  }, [_vm._c('strong', {
	    staticClass: "summary-name pull-left"
	  }, [_vm._v("Chapters added:")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.chapters_added))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "summary-row"
	  }, [_vm._c('strong', {
	    staticClass: "summary-name pull-left"
	  }, [_vm._v("Chapters skipped:")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.chapters_skipped))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "summary-row"
	  }, [_vm._c('strong', {
	    staticClass: "summary-name pull-left"
	  }, [_vm._v("Micronotes added:")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.micronotes_added))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "summary-row"
	  }, [_vm._c('strong', {
	    staticClass: "summary-name pull-left"
	  }, [_vm._v("Micronotes skipped:")]), _vm._v(" "), _vm._c('span', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.micronotes_skipped))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })])])]) : _vm._e()])], 1)], 1)])])
	},staticRenderFns: []}

/***/ },
/* 708 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "panel-body",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.handleClick($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "microNoteStudier"
	  }, [_vm._c('div', {
	    staticClass: "html"
	  }, [(_vm.microNote) ? _vm._c('DynamicRenderer', {
	    ref: "html",
	    attrs: {
	      "html": _vm.microNote.html
	    }
	  }) : _vm._e()], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 709 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-signup"
	  }, [_vm._c('form', {
	    staticClass: "login-form",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.login($event)
	      }
	    }
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "autofocus": "",
	      "placeholder": "E-mail",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary"
	  }, [_vm._v("Login")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  }), _vm._v(" "), (_vm.currentUser.errors) ? _vm._l((_vm.currentUser.errors), function(msg) {
	    return _vm._c('div', {
	      staticClass: "alert alert-danger alert-contrast alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])])
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ },
/* 710 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home"
	  }, [_vm._c('div', {
	    staticClass: "banner"
	  }, [_vm._c('div', {
	    staticClass: "copy"
	  }, [_vm._c('h1', {
	    staticClass: "x-large-text weight500"
	  }, [_vm._v("Better Grades, Less Effort.")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n        CLEX helps improve grades by organizing notes to prioritize and focus studying.\n        This simple, easy-to-use software provides a flexible approach to learning.\n      ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "buttons"
	  }, [_vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank signup-btn fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'signup'
	      }
	    }
	  }, [_vm._v("Sign Up for Free")]), _vm._v(" "), _vm._c('a', {
	    staticClass: "btn-pub btn-pub-primary video-btn fixed-width xs-full-width",
	    attrs: {
	      "href": "https://vimeo.com/204826626",
	      "target": "_blank"
	    }
	  }, [_vm._v("Watch Our Video")])], 1)]), _vm._v(" "), _vm._c('div', {
	    staticClass: "bg"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_500.jpg",
	      "media": "(max-width: 500px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_800.jpg",
	      "media": "(min-width: 501px) and (max-width: 767px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_1200.jpg",
	      "media": "(min-width: 768px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_1600.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner6_2000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/home/banner6_1600.jpg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._c('div', {
	    staticClass: "wrap-blue banner-with-copy testimonial"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-push-sm-6 col-sm-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner7_400.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner7_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner7_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner7_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/home/banner7_800.jpg",
	      "alt": ""
	    }
	  })])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-push-sm-6 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._c('p', [_vm._v("\n            “CLEX helped me reach new heights and accomplish the education of my dreams. After\n            studying with micro-notes, I got better grades!”\n          ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "name weight500"
	  }, [_vm._v("- Claire, Vancouver")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "features ptb-80"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
	    staticClass: "row xs-pt-30"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 text-center"
	  }, [_vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-border-primary fixed-width",
	    attrs: {
	      "to": {
	        name: 'signup'
	      }
	    }
	  }, [_vm._v("Sign Up for Free")])], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "bottom-banner"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner8_600.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner8_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner8_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/home/banner8_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/home/banner8_800.jpg",
	      "alt": ""
	    }
	  })])], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 "
	  }, [_vm._c('div', {
	    staticClass: "banner-text"
	  }, [_vm._c('h2', {
	    staticClass: "xs-mb-30 weight500"
	  }, [_vm._v("Take the stress out of studying")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-mb-30"
	  }, [_vm._v("\n            We believe learning should be an engaging and rewarding experience. CLEX is\n            designed with your brain in mind so you can get back to enjoying the subject you’re passionate about!\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank xs-mb-30 fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1)])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "container key-features ptb-100"
	  }, [_vm._c('div', {
	    staticClass: "row text-center"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._c('div', {
	    staticClass: "feature"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-01.png",
	      "alt": "Learn Smarter"
	    }
	  }), _vm._v(" "), _vm._c('h2', {
	    staticClass: "xs-mt-50 xs-mb-30"
	  }, [_vm._v("Learn Smarter")])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._c('div', {
	    staticClass: "feature"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-02.png",
	      "alt": "Organize Notes"
	    }
	  }), _vm._v(" "), _vm._c('h2', {
	    staticClass: "xs-mt-50 xs-mb-30"
	  }, [_vm._v("Organize Notes")])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-4"
	  }, [_vm._c('div', {
	    staticClass: "feature"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-03.png",
	      "alt": "Remember Everything"
	    }
	  }), _vm._v(" "), _vm._c('h2', {
	    staticClass: "xs-mt-50 xs-mb-30"
	  }, [_vm._v("Remember Everything")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "text-center"
	  }, [_vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-04.png",
	      "alt": "Focus studying"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("Focus studying")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-05.png",
	      "alt": "Access everywhere"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("Access everywhere")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-06.png",
	      "alt": "Keywords search"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("Keywords search")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-07.png",
	      "alt": "Micro-notes"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("Micro-notes")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "feature xs-pb-50"
	  }, [_vm._c('img', {
	    attrs: {
	      "src": "/static/img/icons/home/Homepage_Icons-08.png",
	      "alt": "One-click import"
	    }
	  }), _vm._v(" "), _vm._c('h3', [_vm._v("One-click import")])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })])
	}]}

/***/ },
/* 711 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "visible",
	    class: _vm.microNoteIsCompleted && _vm.showButtons ? 'score-container' : 'wordbank-container',
	    attrs: {
	      "id": "bottomShelf"
	    }
	  }, [_vm._c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.microNoteIsCompleted) ? _vm._c('div', [(_vm.showButtons) ? _vm._c('div', [_vm._c('MicroNoteScore'), _vm._v(" "), _vm._c('StudyIntervalButtons', {
	    attrs: {
	      "microNote": _vm.microNote
	    }
	  })], 1) : _vm._c('div', {
	    staticClass: "continue"
	  }, [_vm._c('h3', [_vm._v("Ready to continue?")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "btn-group"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.previousMicroNote($event)
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "mdi mdi-chevron-left"
	  }), _vm._v("   Previous")]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.nextMicroNote($event)
	      }
	    }
	  }, [_vm._v("Next   "), _vm._c('i', {
	    staticClass: "mdi mdi-chevron-right"
	  })])])])]) : _vm._e()]), _vm._v(" "), (!_vm.microNoteIsCompleted) ? _vm._c('div', {
	    staticClass: "wordbank-wrapper"
	  }, [_vm._c('div', {
	    staticClass: "wordbank-toggle"
	  }, [_vm._c('span', {
	    staticClass: "lbl"
	  }, [_vm._v("Word bank")]), _vm._v(" "), _vm._c('BoolSwitch', {
	    attrs: {
	      "toggle-bool": _vm.wordbankVisible,
	      "toggle-function": _vm.toggleWordbank,
	      "on-text": "On",
	      "off-text": "Off"
	    }
	  })], 1), _vm._v(" "), (_vm.wordbankVisible) ? _vm._c('Wordbank', {
	    attrs: {
	      "words": _vm.wordbankWords
	    }
	  }) : _vm._e()], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 712 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "panel"
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ },
/* 713 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('BlogList'), _vm._v(" "), _vm._c('div', {
	    staticClass: "xs-pb-30 container"
	  }, [_vm._c('HorizontalAd', {
	    attrs: {
	      "containerClass": ''
	    }
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ },
/* 714 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Edit Blog Post",
	      "subtitle": ""
	    }
	  }), _vm._v(" "), _vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary xs-p-20"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-6 col-sm-3 col-lg-2 col-form-label",
	    attrs: {
	      "for": "txtTitle"
	    }
	  }, [_vm._v("Blog post title")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6 col-sm-9 col-lg-10"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.articleDetails.title),
	      expression: "articleDetails.title"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtTitle"
	    },
	    domProps: {
	      "value": _vm._s(_vm.articleDetails.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.articleDetails.title = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-6 col-sm-3 col-lg-2 col-form-label",
	    attrs: {
	      "for": "txtMetaTitle"
	    }
	  }, [_vm._v("Meta title")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6 col-sm-9 col-lg-10"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.articleDetails.meta_title),
	      expression: "articleDetails.meta_title"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtMetaTitle"
	    },
	    domProps: {
	      "value": _vm._s(_vm.articleDetails.meta_title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.articleDetails.meta_title = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-6 col-sm-3 col-lg-2 col-form-label",
	    attrs: {
	      "for": "txtMetaDescription"
	    }
	  }, [_vm._v("Meta description")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6 col-sm-9 col-lg-10"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.articleDetails.meta_desc),
	      expression: "articleDetails.meta_desc"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtMetaDescription"
	    },
	    domProps: {
	      "value": _vm._s(_vm.articleDetails.meta_desc)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.articleDetails.meta_desc = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-6 col-lg-4 col-form-label",
	    attrs: {
	      "for": "txtAuthor"
	    }
	  }, [_vm._v("Author")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6 col-lg-8"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.articleDetails.author),
	      expression: "articleDetails.author"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "id": "txtAuthor"
	    },
	    domProps: {
	      "value": _vm._s(_vm.articleDetails.author)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.articleDetails.author = $event.target.value
	      }
	    }
	  })])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-6 col-lg-4 col-form-label",
	    attrs: {
	      "for": "chkNotify"
	    }
	  }, [_vm._v("Notify admin on create")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-6 col-lg-8"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.articleDetails.notify),
	      expression: "articleDetails.notify"
	    }],
	    staticClass: "checkbox",
	    attrs: {
	      "type": "checkbox",
	      "id": "chkNotify"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.articleDetails.notify) ? _vm._i(_vm.articleDetails.notify, null) > -1 : (_vm.articleDetails.notify)
	    },
	    on: {
	      "click": function($event) {
	        var $$a = _vm.articleDetails.notify,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$c) {
	            $$i < 0 && (_vm.articleDetails.notify = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.articleDetails.notify = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.articleDetails.notify = $$c
	        }
	      }
	    }
	  })])])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row height-100"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 height-100"
	  }, [_vm._c('div', {
	    staticClass: "height-100"
	  }, [_vm._c('FroalaEditor', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.articleDetails.content),
	      expression: "articleDetails.content"
	    }],
	    ref: "editor",
	    attrs: {
	      "config": _vm.froalaConfig
	    },
	    domProps: {
	      "value": (_vm.articleDetails.content)
	    },
	    on: {
	      "input": function($event) {
	        _vm.articleDetails.content = $event
	      }
	    }
	  })], 1)])]), _vm._v(" "), (!_vm.valid) ? _vm._c('div', {
	    staticClass: "alert alert-warning xs-mt-20"
	  }, [_vm._v("\n            Please fill in all fields above.\n          ")]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "save xs-pt-20"
	  }, [_vm._c('router-link', {
	    staticClass: "btn btn-xl",
	    attrs: {
	      "to": {
	        name: 'blog-manager'
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "icon mdi mdi-arrow-left"
	  }), _vm._v("  Back")]), _vm._v(" "), _vm._c('button', {
	    staticClass: "btn btn-primary btn-xl pull-right xs-ml-10",
	    attrs: {
	      "disabled": _vm.status !== '' || !_vm.valid
	    },
	    on: {
	      "click": function($event) {
	        _vm.save()
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-save"
	  }), _vm._v("   Save")]), _vm._v(" "), (_vm.blogArticle && _vm.blogArticle.id > 0) ? _vm._c('button', {
	    staticClass: "btn btn-danger btn-xl pull-right xs-ml-10",
	    attrs: {
	      "disabled": _vm.status !== ''
	    },
	    on: {
	      "click": function($event) {
	        _vm.deletePost()
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-trash"
	  }), _vm._v("  Delete")]) : _vm._e(), _vm._v(" "), _vm._c('span', {
	    staticClass: "pull-right xs-mr-10 xs-p-10 text-bold text-muted",
	    staticStyle: {
	      "font-size": "15px"
	    }
	  }, [_vm._v(_vm._s(_vm.status))]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })], 1), _vm._v(" "), _vm._c('hr'), _vm._v(" "), (_vm.blogArticle) ? _vm._c('BlogCommentsList', {
	    attrs: {
	      "comments": _vm.blogArticle.comments,
	      "show-delete": true,
	      "articleId": _vm.blogArticle.id
	    }
	  }) : _vm._e()], 1)], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 715 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('ul', {
	    staticClass: "nav navbar-nav navbar-right"
	  }, [_vm._c('li', [_vm._c('a', {
	    attrs: {
	      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
	    }
	  }, [_vm._v("Sign Up")])]), _vm._v(" "), _vm._c('li', [_vm._c('a', {
	    attrs: {
	      "href": "https://mailchi.mp/3bf25cf56493/signup-for-landing-page"
	    }
	  }, [_vm._v("Log In")])])])
	}]}

/***/ },
/* 716 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-4"
	  }, [_vm._c('div', {
	    staticClass: "article text-center"
	  }, [_vm._c('div', {
	    staticClass: "image",
	    style: (_vm.image ? 'background-image:url(' + _vm.image + ');' : '')
	  }, [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.article.id
	        }
	      }
	    }
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "article-content",
	    class: _vm.image ? '' : 'no-image'
	  }, [_vm._c('h2', [_vm._c('router-link', {
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.article.id
	        }
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.article.title))])], 1), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v(_vm._s(_vm.content))])]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-border-primary fixed-width xs-full-width",
	    attrs: {
	      "to": {
	        name: 'blog-article',
	        params: {
	          id: _vm.article.id
	        }
	      }
	    }
	  }, [_vm._v("\n      Read More\n    ")])], 1)])
	},staticRenderFns: []}

/***/ },
/* 717 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "home-body"
	  }, [_vm._c('div', {
	    staticClass: "wrap-blue banner-with-copy"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 col-md-push-6  pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner2_400.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner2_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner2_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner2_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/about/banner2_800.jpg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "overlay"
	  })], 1), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-md-6 col-md-pull-6 banner-content-wrap"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._m(0), _vm._v(" "), _vm._c('p', [_vm._v("\n            We are truly a learning company inside and out! Our goal is to provide the best learning resources and never stop improving, just like the learners we serve. Our ongoing research and development will ensure we deliver the tools that best serve your needs.\n          ")]), _vm._v(" "), _vm._c('router-link', {
	    staticClass: "btn-pub btn-pub-blank xs-full-width",
	    attrs: {
	      "to": {
	        name: 'features'
	      }
	    }
	  }, [_vm._v("Learn More")])], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
	    staticClass: "hidden-xs col-sm-3"
	  }, [_vm._c('AdBlock', {
	    attrs: {
	      "slot-id": 2,
	      "count": 1
	    }
	  })], 1)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "wrap-black banner-with-copy bottom-banner"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 pic"
	  }, [_vm._c('picture', {
	    attrs: {
	      "title": ""
	    }
	  }, [_vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner3_400.jpg",
	      "media": "(min-width: 501px) and (max-width: 800px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner3_600.jpg",
	      "media": "(min-width: 801px) and (max-width: 1200px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner3_800.jpg",
	      "media": "(min-width: 1201px) and (max-width: 1600px)"
	    }
	  }), _vm._v(" "), _vm._c('source', {
	    attrs: {
	      "srcset": "/static/img/about/banner3_1000.jpg",
	      "media": "(min-width: 1601px)"
	    }
	  }), _vm._v(" "), _vm._c('img', {
	    attrs: {
	      "src": "/static/img/about/banner3_800.jpg",
	      "alt": ""
	    }
	  })])], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "container ptb-100"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._m(3), _vm._v(" "), _vm._c('div', {
	    staticClass: "hidden-xs sm-col-3"
	  }, [_vm._c('AdBlock', {
	    attrs: {
	      "slot-id": 2,
	      "count": 1
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('h1', [_vm._v("Together "), _vm._c('br'), _vm._v("We Learn")])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-9 large-text"
	  }, [_vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          CLEX stands for "), _vm._c('strong', [_vm._v("Contextual Learning Experience")]), _vm._v(". True to our name, CLEX Software is a web-based study tool dedicated to improving an individual’s capacity for learning by utilizing an individually optimized methodology to maximize each user’s studying potential.\n          We allows learners to organize study materials into micro-notes, identify keywords in their lessons, and prioritize what you need to study.\n        ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          CLEX is all about bringing learners together through study communities.\n        ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          We give you the ability to challenge yourself using individualized study levels, that you can control. It's our mission that as learners advance through their studies, their confidence grows. CLEX combines content from multiple sources into organized modules and it’s accessible anywhere you go.\n        ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6"
	  }, [_vm._c('div', {
	    staticClass: "banner-copy"
	  }, [_vm._c('p', {
	    staticClass: "x-large-text"
	  }, [_vm._v("\n            CLEX offers a "), _vm._c('strong', [_vm._v("FREE")]), _vm._v(" study service that is results oriented for all students.\n          ")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-9"
	  }, [_vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          CLEX is aware that the cost of post secondary education is very expensive and in order to make your life as stress free as possible, we are giving you CLEX for free at no charge with no obligation to purchase for as long as you need it. No three month trial like most service providers.\n        ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          CLEX PLUS will offer students the option to purchase additional learning modules, that will help provide further learning support on top of CLEX. It is our intention to keep our learning module prices as low as possible, no more than the cost of a hamburger. \n        ")]), _vm._v(" "), _vm._c('p', {
	    staticClass: "large-text"
	  }, [_vm._v("\n          Should you purchase a module or two from us, "), _vm._c('strong', [_vm._v("CLEX will still remain free to use at all times")]), _vm._v(".\n        ")])])
	}]}

/***/ },
/* 718 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "be-wrapper"
	  }, [_vm._c('navbar'), _vm._v(" "), _vm._c('router-view'), _vm._v(" "), _vm._c('footer-nav')], 1)
	},staticRenderFns: []}

/***/ },
/* 719 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('PageHeader', {
	    attrs: {
	      "title": "User Activity Report",
	      "subtitle": ""
	    }
	  }), _vm._v(" "), _vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('div', {
	    staticClass: "row  xs-p-40"
	  }, [_vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtStart"
	    }
	  }, [_vm._v("Start Date")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('datepicker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.startDate),
	      expression: "startDate"
	    }],
	    attrs: {
	      "format": "yyyy-MM-dd",
	      "name": "startDate",
	      "input-class": "form-control"
	    },
	    domProps: {
	      "value": (_vm.startDate)
	    },
	    on: {
	      "input": function($event) {
	        _vm.startDate = $event
	      }
	    }
	  })], 1)])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-sm-12 col-md-6"
	  }, [_vm._c('div', {
	    staticClass: "setting form-group row form-group-sm"
	  }, [_vm._c('label', {
	    staticClass: "col-xs-4 col-form-label",
	    attrs: {
	      "for": "txtEnd"
	    }
	  }, [_vm._v("End Date")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('datepicker', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.endDate),
	      expression: "endDate"
	    }],
	    attrs: {
	      "format": "yyyy-MM-dd",
	      "name": "endDate",
	      "input-class": "form-control"
	    },
	    domProps: {
	      "value": (_vm.endDate)
	    },
	    on: {
	      "input": function($event) {
	        _vm.endDate = $event
	      }
	    }
	  })], 1)])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "row xs-p-40 xs-pt-0"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-primary btn-xl",
	    attrs: {
	      "disabled": _vm.saving
	    },
	    on: {
	      "click": function($event) {
	        _vm.downloadReport()
	      }
	    }
	  }, [_vm._v("Download User Activity Report")])])])])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 720 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('Panel', {
	    staticClass: "panel-border"
	  }, [_vm._c('PanelHeading', [_vm._c('div', {
	    slot: "title"
	  }, [(_vm.editingTitle) ? _vm._c('form', {
	    staticStyle: {
	      "max-width": "250px"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.finishEditingTitle($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "input-group input-group-sm"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newTitle),
	      expression: "newTitle"
	    }, {
	      name: "focus",
	      rawName: "v-focus"
	    }, {
	      name: "on-click-away",
	      rawName: "v-on-click-away",
	      value: (_vm.cancelEditingTitle),
	      expression: "cancelEditingTitle"
	    }],
	    staticClass: "form-control input-sm",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm._s(_vm.newTitle)
	    },
	    on: {
	      "keyup": function($event) {
	        if (_vm._k($event.keyCode, "esc", 27)) { return; }
	        _vm.cancelEditingTitle($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._c('span', {
	    staticClass: "input-group-btn"
	  }, [_vm._c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Save")])])])]) : _vm._c('div', [_vm._c('span', {
	    on: {
	      "dblclick": _vm.startEditingTitle
	    }
	  }, [_vm._v(_vm._s(_vm.subject.title))]), _vm._v(" "), _vm._c('span', {
	    staticClass: "expandButton",
	    on: {
	      "click": _vm.toggleExpanded
	    }
	  }, [(_vm.expanded) ? _vm._c('span', {
	    staticClass: "icon mdi mdi-chevron-down"
	  }) : _vm._c('span', {
	    staticClass: "icon mdi mdi-chevron-right"
	  })]), _vm._v(" "), _vm._c('span', {
	    staticClass: "panel-subtitle"
	  }, [_vm._v(_vm._s(((_vm.chapters.length) + " Chapter" + (_vm.chapters.length === 1 ? '' : 's'))))])])])]), _vm._v(" "), (_vm.expanded) ? _vm._c('PanelBody', [(!_vm.chapters.length) ? _vm._c('div', [_vm._c('p', [_vm._c('em', [_vm._v("This subject is empty.")])]), _vm._v(" "), (_vm.showActions) ? _vm._c('p', [_vm._c('a', {
	    attrs: {
	      "href": ""
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deleteSubject(_vm.subject)
	      }
	    }
	  }, [_vm._v("Delete subject")])]) : _vm._e()]) : _vm._c('div', [_vm._c('table', {
	    staticClass: "table"
	  }, [_vm._c('thead', [_vm._c('tr', [_vm._c('th', {
	    staticClass: "hidden-xs",
	    staticStyle: {
	      "width": "5%"
	    }
	  }), _vm._v(" "), _vm._c('th', {
	    staticStyle: {
	      "width": "25%"
	    }
	  }, [_vm._v("Chapter")]), _vm._v(" "), _vm._c('th', {
	    staticStyle: {
	      "width": "20%"
	    }
	  }, [_vm._v("Study Progress")]), _vm._v(" "), _vm._c('th', {
	    staticClass: "hidden-xs",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v(" ")]), _vm._v(" "), _vm._c('th', {
	    staticClass: "hidden-xs",
	    staticStyle: {
	      "width": "10%"
	    }
	  }, [_vm._v("Last Studied")]), _vm._v(" "), _vm._c('th', {
	    staticStyle: {
	      "width": "20%"
	    }
	  })])]), _vm._v(" "), _vm._c('tbody', _vm._l((_vm.chapters), function(chapter) {
	    return _vm._c('SubjectShelfChapterRow', {
	      attrs: {
	        "chapter": chapter
	      }
	    })
	  }))])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 721 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return (!_vm.deleted) ? _vm._c('div', {
	    staticClass: "comment"
	  }, [_vm._c('div', {
	    staticClass: "avatar"
	  }, [(!_vm.currentUser || _vm.currentUser.id != _vm.comment.user_id) ? _vm._c('i', {
	    staticClass: "fas fa-user-circle"
	  }) : _vm._c('img', {
	    attrs: {
	      "src": "/static/img/avatar.png",
	      "alt": "Avatar"
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "body"
	  }, [_vm._c('div', {
	    staticClass: "head"
	  }, [(!_vm.currentUser || _vm.currentUser.id != _vm.comment.user_id) ? _vm._c('strong', [_vm._v(_vm._s(_vm.comment.user_first_name) + " " + _vm._s(_vm.comment.user_last_name))]) : _vm._c('strong', [_vm._v("You")]), _vm._v(" "), _vm._c('span', {
	    staticStyle: {
	      "margin-left": "20px"
	    }
	  }, [_vm._v(_vm._s(_vm.friendlyDate))]), _vm._v(" "), (_vm.showDelete) ? _vm._c('button', {
	    staticClass: "btn btn-danger btn-sm pull-right",
	    on: {
	      "click": function($event) {
	        _vm.deleteComment()
	      }
	    }
	  }, [_vm._c('i', {
	    staticClass: "fas fa-trash"
	  }), _vm._v("   Delete")]) : _vm._e()]), _vm._v(" "), _vm._c('div', {
	    staticClass: "text"
	  }, [_vm._c('strong', [_vm._v("\"")]), _vm._v(_vm._s(_vm.comment.body)), _vm._c('strong', [_vm._v("\"")])])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 722 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', [_vm._c('div', {
	    staticClass: "main-content container-fluid"
	  }, [_vm._c('div', {
	    staticClass: "row"
	  }, [_vm._c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._c('PageHeader', {
	    attrs: {
	      "title": "Manage Blog Posts",
	      "subtitle": ""
	    }
	  }, [_vm._c('router-link', {
	    staticClass: "btn btn-primary",
	    staticStyle: {
	      "float": "right",
	      "margin-top": "10px"
	    },
	    attrs: {
	      "to": {
	        name: 'blog-post-edit'
	      }
	    },
	    slot: "top"
	  }, [_vm._c('i', {
	    staticClass: "icon mdi mdi-plus"
	  }), _vm._v("  Create Blog Post\n          ")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })], 1), _vm._v(" "), _vm._c('Panel', {
	    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
	  }, [_vm._c('div', {
	    staticClass: "filters"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "form-group form-group-sm row"
	  }, [_vm._c('label', {
	    staticClass: "col-form-label col-xs-4 control-label"
	  }, [_vm._v("Author")]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-8"
	  }, [_vm._c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedAuthor),
	      expression: "selectedAuthor"
	    }],
	    staticClass: "form-control",
	    on: {
	      "change": function($event) {
	        _vm.selectedAuthor = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        })[0]
	      }
	    }
	  }, _vm._l((_vm.authorFilters), function(option) {
	    return _vm._c('option', {
	      domProps: {
	        "value": option
	      }
	    }, [_vm._v("\n                        " + _vm._s(option) + "\n                      ")])
	  }))])])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "col-xs-12 col-sm-6 col-md-3"
	  }, [_vm._c('div', {
	    staticClass: "form-group form-group-sm"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchTerm),
	      expression: "searchTerm"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search title..."
	    },
	    domProps: {
	      "value": _vm._s(_vm.searchTerm)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchTerm = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "clearfix"
	  })]), _vm._v(" "), _vm._c('DynamicTable', {
	    attrs: {
	      "data": _vm.filteredData,
	      "fields": _vm.fields,
	      "onClick": _vm.editRecord,
	      "defaultSort": 'title'
	    }
	  }), _vm._v(" "), _vm._c('div', {
	    staticClass: "settings-container"
	  })], 1)], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 723 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.contact($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "form-horizontal"
	  }, [_vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.values.name),
	      expression: "values.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "name",
	      "name": "name",
	      "type": "text",
	      "placeholder": "Your name*"
	    },
	    domProps: {
	      "value": _vm._s(_vm.values.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.values.name = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.values.email),
	      expression: "values.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "email",
	      "name": "email",
	      "type": "email",
	      "placeholder": "Your Email*"
	    },
	    domProps: {
	      "value": _vm._s(_vm.values.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.values.email = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.values.telephone),
	      expression: "values.telephone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "telephone",
	      "name": "telephone",
	      "type": "tel",
	      "placeholder": "Your Phone Number"
	    },
	    domProps: {
	      "value": _vm._s(_vm.values.telephone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.values.telephone = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.values.subject),
	      expression: "values.subject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "subject",
	      "name": "subject",
	      "type": "text",
	      "placeholder": "Subject*"
	    },
	    domProps: {
	      "value": _vm._s(_vm.values.subject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.values.subject = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group row"
	  }, [_vm._c('div', {
	    staticClass: "col-xs-12"
	  }, [_vm._c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.values.body),
	      expression: "values.body"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "message",
	      "name": "message",
	      "placeholder": "Message"
	    },
	    domProps: {
	      "value": _vm._s(_vm.values.body)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.values.body = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.errors.length) ? _vm._c('div', {
	    staticClass: "alert alert-danger"
	  }, [_vm._c('ul', _vm._l((_vm.errors), function(error) {
	    return _vm._c('li', [_vm._v(_vm._s(error))])
	  }))]) : _vm._e(), _vm._v(" "), _vm._c('div', {
	    staticClass: "xs-pt-10 submit"
	  }, [_vm._c('vue-recaptcha', {
	    ref: "recaptcha",
	    attrs: {
	      "sitekey": _vm.sitekey
	    },
	    on: {
	      "verify": _vm.onCaptchaVerified,
	      "expired": _vm.onCaptchaExpired
	    }
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-border-primary btn-pub-primary fixed-width xs-full-width",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.status === 'submitting',
	      "data-sitekey": "6Lfh7YQUAAAAAFFo97nwwFbBJcN02XSKS_DxC8Vx"
	    }
	  }, [_vm._v("Submit")])])], 1)])])
	},staticRenderFns: []}

/***/ },
/* 724 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "wrap-black text-center"
	  }, [_vm._c('div', {
	    staticClass: "container"
	  }, [_vm._c('p', {
	    staticClass: "xs-pb-30"
	  }, [_vm._v("Welcome back! Please enter your information.")]), _vm._v(" "), _vm._c('form', {
	    staticClass: "form-pub",
	    attrs: {
	      "method": "post"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.login($event)
	      }
	    }
	  }, [_vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "autofocus": "",
	      "placeholder": "Your E-mail",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _vm._c('div', {
	    staticClass: "form-group"
	  }, [_vm._c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password",
	      "autocomplete": "off",
	      "required": "required"
	    },
	    domProps: {
	      "value": _vm._s(_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.credentials.password = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), (_vm.currentUser.errors) ? _vm._c('div', _vm._l((_vm.currentUser.errors), function(msg) {
	    return _vm._c('div', {
	      staticClass: "alert alert-contrast alert-danger alert-dismissible",
	      attrs: {
	        "role": "alert"
	      }
	    }, [_vm._c('div', {
	      staticClass: "message"
	    }, [_vm._v(_vm._s(msg))])])
	  })) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._c('p', {
	    staticClass: "xs-pt-30 footer-link"
	  }, [_vm._v("Don't have a account? "), _vm._c('router-link', {
	    attrs: {
	      "to": "/signup"
	    }
	  }, [_vm._c('strong', [_vm._v("Sign up now")])]), _vm._v(".")], 1), _vm._v(" "), _vm._c('p', {
	    staticClass: "footer-link"
	  }, [_vm._v("Forgot your password? "), _vm._c('router-link', {
	    attrs: {
	      "to": "/forgot-password"
	    }
	  }, [_vm._c('strong', [_vm._v("Reset password")])]), _vm._v(".")], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
	  return _vm._c('div', {
	    staticClass: "form-group xs-pt-20"
	  }, [_vm._c('button', {
	    staticClass: "btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width"
	  }, [_vm._v("Log In")])])
	}]}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.15ae41951eaed5091aae.js